// @ts-nocheck
import { emptyApi as api } from './emptyApi';
export const addTagTypes = [
  'subscriptions-controller',
  'migration-ovi-controller',
  'support-ticket-controller',
  'alerts-controller',
  'registrations-controller',
  'email-frequency-controller',
  'asset-controller',
  'batch-boarding-vehicle-summary-migration-controller',
  'vehicle-boarding-workflow-session-migration-controller',
  'gm-vehicle-migration-controller',
  'connectivity-provider-migration-controller',
  'claimed-onstar-migration-controller',
  'onstar-support-status-migration-controller',
  'remote-command-controller',
  'verified-vehicle-controller',
  'ovi-vehicle-migration-controller',
  'batch-boarding-vehicles-controller',
  'vehicle-list-overview-controller',
  'asset-view-controller',
  'vehicle-diagnostics-list-controller',
  'battery-readiness-report-view-controller',
  'admin-controller',
  'dashboard-view-controller',
  'vehicle-boarding-workflow-session-controller',
  'asset-readiness-report-view-controller',
  'restart-connectivity-controller',
  'vehicles-ownership-controller',
  'connectivity-controller',
  'vehicle-field-action-view-controller',
  'event-subscriptions-controller',
  'tire-readiness-report-view-controller',
  'patch-asset-controller',
  'image-controller',
  'azure-ai-search-controller',
  'Vehicles',
  'Asset',
  'vehicle-boarding-profile-controller',
  'compliance-report-view-controller',
  'audit-export-controller',
  'demo-controller',
  'product-catalog-controller',
  'home-charge-reimbursements-controller',
  'reimbursements-reports-controller',
  'fleet-utility-rate-settings-controller',
  'reimbursements-export-and-reports-controller',
  'charge-station-controller',
  'feedback-image-upload-controller',
  'feedback-controller',
  'vehicle-enrollment-controller',
  'org-enrollment-controller',
  'gmf-controller',
  'fleetio-controller',
  'geofence-offboard-controller',
  'geofence-controller',
  'order-controller',
  'organization-v-2-controller',
  'fleets-v-2-controller',
  'enrollment-controller',
  'migration-controller',
  'caps-controller',
  'hubs-v-2-controller',
  'peripheral-webhook-controller',
  'recording-availability-controller',
  'clips-controller',
  'peripheral-controller',
  'boarding-controller',
  'fleet-camera-peripheral-controller',
  'netradyne-controller',
  'reports-controller',
  'user-report-filters-controller',
  'rules-controller',
  'safety-center-controller-v-2',
  'event-settings-controller',
  'driver-score-controller',
  'fleet-score-controller',
  'trips-controller',
  'safety-center-controller',
  'trusted-devices-controller',
  'org-app-identity-controller',
  'app-identity-controller',
  'profile-v-1-controller',
  'codes-controller',
  'sso-controller',
  'otp-controller',
  'mfa-controller',
  'organization-offboard-controller',
  'driver-profile-controller',
  'invite-controller',
  'token-enrichment-controller',
  'Profile',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      updateSubscriptionByIdVersion2: build.mutation<
        UpdateSubscriptionByIdVersion2ApiResponse,
        UpdateSubscriptionByIdVersion2ApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2022-07-01/subscriptions/me/${queryArg.subscriptionId}`,
          method: 'PUT',
          body: queryArg.subscriptionUpdateDto,
        }),
        invalidatesTags: ['subscriptions-controller'],
      }),
      getEventSubscriptions: build.query<
        GetEventSubscriptionsApiResponse,
        GetEventSubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2026-09-22/subscriptions/me`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['subscriptions-controller'],
      }),
      validateOviPersonChannels: build.mutation<
        ValidateOviPersonChannelsApiResponse,
        ValidateOviPersonChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2026-07-14/migration/ovi/personChannels/validate`,
          method: 'POST',
          body: queryArg.validateOviPersonChannelsRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      listOviPersonChannels: build.query<
        ListOviPersonChannelsApiResponse,
        ListOviPersonChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2026-06-16/migration/ovi/personChannels`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviPersonId: queryArg.oviPersonId,
            oviPersonChannelId: queryArg.oviPersonChannelId,
            organizationId: queryArg.organizationId,
            profileId: queryArg.profileId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncOviPersonChannels: build.mutation<
        SyncOviPersonChannelsApiResponse,
        SyncOviPersonChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2026-06-16/migration/ovi/personChannels`,
          method: 'POST',
          body: queryArg.syncOviPersonChannelsRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      submitTicket: build.mutation<SubmitTicketApiResponse, SubmitTicketApiArg>(
        {
          query: (queryArg) => ({
            url: `/alerts/2026-02-10/support/ticket`,
            method: 'POST',
            body: queryArg.supportTicketRequest,
          }),
          invalidatesTags: ['support-ticket-controller'],
        }
      ),
      unpinAlert: build.mutation<UnpinAlertApiResponse, UnpinAlertApiArg>({
        query: (queryArg) => ({
          url: `/alerts/2025-09-23/${queryArg.id}/unpin`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['alerts-controller'],
      }),
      pinAlert: build.mutation<PinAlertApiResponse, PinAlertApiArg>({
        query: (queryArg) => ({
          url: `/alerts/2025-09-23/${queryArg.id}/pin`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['alerts-controller'],
      }),
      updateAllAlertsToReadAsync: build.mutation<
        UpdateAllAlertsToReadAsyncApiResponse,
        UpdateAllAlertsToReadAsyncApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-09-23/me/read`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['alerts-controller'],
      }),
      dismissAlertV20250909: build.mutation<
        DismissAlertV20250909ApiResponse,
        DismissAlertV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-09-09/${queryArg.id}/dismiss`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['alerts-controller'],
      }),
      updateNoiseThresholdByOrganization: build.mutation<
        UpdateNoiseThresholdByOrganizationApiResponse,
        UpdateNoiseThresholdByOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-07-29/subscriptions/organization/noiseThreshold`,
          method: 'POST',
          body: queryArg.noiseThresholdUpdate,
        }),
        invalidatesTags: ['subscriptions-controller'],
      }),
      updateSubscriptionToggle: build.mutation<
        UpdateSubscriptionToggleApiResponse,
        UpdateSubscriptionToggleApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-05-20/subscriptions/batchToggle`,
          method: 'POST',
          body: queryArg.body,
          params: {
            active: queryArg.active,
          },
        }),
        invalidatesTags: ['subscriptions-controller'],
      }),
      addSubscriptionsToUser: build.mutation<
        AddSubscriptionsToUserApiResponse,
        AddSubscriptionsToUserApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2021-11-15/subscriptions`,
          method: 'POST',
          body: queryArg.subscriptionDto,
        }),
        invalidatesTags: ['subscriptions-controller'],
      }),
      getAllUserSubscriptions: build.query<
        GetAllUserSubscriptionsApiResponse,
        GetAllUserSubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2021-11-15/subscriptions/me`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        providesTags: ['subscriptions-controller'],
      }),
      getRegistrationsForUser: build.query<
        GetRegistrationsForUserApiResponse,
        GetRegistrationsForUserApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2021-11-15/registrations`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        providesTags: ['registrations-controller'],
      }),
      processPendingEmails: build.query<
        ProcessPendingEmailsApiResponse,
        ProcessPendingEmailsApiArg
      >({
        query: () => ({ url: `/alerts/emails/process` }),
        providesTags: ['email-frequency-controller'],
      }),
      getAlertsByVin: build.query<
        GetAlertsByVinApiResponse,
        GetAlertsByVinApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2026-03-24/vehicle/${queryArg.vin}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            dismissed: queryArg.dismissed,
          },
        }),
        providesTags: ['alerts-controller'],
      }),
      getSubscriptions: build.query<
        GetSubscriptionsApiResponse,
        GetSubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-11-18/subscriptions/me`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            category: queryArg.category,
            subscriptionPoolId: queryArg.subscriptionPoolId,
          },
        }),
        providesTags: ['subscriptions-controller'],
      }),
      getPinnedAlertsForCurrentUser: build.query<
        GetPinnedAlertsForCurrentUserApiResponse,
        GetPinnedAlertsForCurrentUserApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-09-09/pinned`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
          },
        }),
        providesTags: ['alerts-controller'],
      }),
      getAlertsAndGroupsForCurrentUser: build.query<
        GetAlertsAndGroupsForCurrentUserApiResponse,
        GetAlertsAndGroupsForCurrentUserApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-09-09/me`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            dismissed: queryArg.dismissed,
          },
        }),
        providesTags: ['alerts-controller'],
      }),
      getAlertsByGroupId: build.query<
        GetAlertsByGroupIdApiResponse,
        GetAlertsByGroupIdApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-09-09/group/${queryArg.groupId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            dismissed: queryArg.dismissed,
          },
        }),
        providesTags: ['alerts-controller'],
      }),
      getAlertsForCurrentUser: build.query<
        GetAlertsForCurrentUserApiResponse,
        GetAlertsForCurrentUserApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2025-01-28/me`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
          },
        }),
        providesTags: ['alerts-controller'],
      }),
      deleteSubscription: build.mutation<
        DeleteSubscriptionApiResponse,
        DeleteSubscriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/alerts/2021-11-15/subscriptions/me/${queryArg.subscriptionId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['subscriptions-controller'],
      }),
      updateAsset: build.mutation<UpdateAssetApiResponse, UpdateAssetApiArg>({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['asset-controller'],
      }),
      deleteAsset: build.mutation<DeleteAssetApiResponse, DeleteAssetApiArg>({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['asset-controller'],
      }),
      updateSummary: build.mutation<
        UpdateSummaryApiResponse,
        UpdateSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-03-24/batchBoardingVehicleSummary/summaries/${queryArg.summaryId}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'batch-boarding-vehicle-summary-migration-controller',
        ],
      }),
      updateSession: build.mutation<
        UpdateSessionApiResponse,
        UpdateSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/vehicleBoardingSession/sessions/${queryArg.sessionId}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'vehicle-boarding-workflow-session-migration-controller',
        ],
      }),
      updateVehicle: build.mutation<
        UpdateVehicleApiResponse,
        UpdateVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/gmVehicle/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['gm-vehicle-migration-controller'],
      }),
      updateVehicle1: build.mutation<
        UpdateVehicle1ApiResponse,
        UpdateVehicle1ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/connectivityProvider/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['connectivity-provider-migration-controller'],
      }),
      updateVehicle2: build.mutation<
        UpdateVehicle2ApiResponse,
        UpdateVehicle2ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/claimedOnstar/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['claimed-onstar-migration-controller'],
      }),
      updateVehicleBatch: build.mutation<
        UpdateVehicleBatchApiResponse,
        UpdateVehicleBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/claimedOnstar/vehicles/batch`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['claimed-onstar-migration-controller'],
      }),
      updateVehicle3: build.mutation<
        UpdateVehicle3ApiResponse,
        UpdateVehicle3ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/migration/2025-09-23/onstarSupportStatus/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['onstar-support-status-migration-controller'],
      }),
      executeRemoteCommandsMfa: build.mutation<
        ExecuteRemoteCommandsMfaApiResponse,
        ExecuteRemoteCommandsMfaApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/mfa/2025-05-20/remotecommands/${queryArg.commandType}/${queryArg.command}/${queryArg.vin}`,
          method: 'POST',
          body: queryArg.otpPayload,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'X-Device-Fingerprint': queryArg['X-Device-Fingerprint'],
            'User-Agent': queryArg['User-Agent'],
          },
        }),
        invalidatesTags: ['remote-command-controller'],
      }),
      listVerifiedVehicles: build.mutation<
        ListVerifiedVehiclesApiResponse,
        ListVerifiedVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-06-02/boarding/verifiedVehicles/list`,
          method: 'POST',
          body: queryArg.verifiedVehiclesListRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['verified-vehicle-controller'],
      }),
      listMigratedVehicles: build.query<
        ListMigratedVehiclesApiResponse,
        ListMigratedVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-05-19/migration/ovi/vehicles`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviVehicleId: queryArg.oviVehicleId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            assetId: queryArg.assetId,
            size: queryArg.size,
          },
        }),
        providesTags: ['ovi-vehicle-migration-controller'],
      }),
      syncVehicles: build.mutation<SyncVehiclesApiResponse, SyncVehiclesApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/2026-05-19/migration/ovi/vehicles`,
            method: 'POST',
            body: queryArg.syncOviVehiclesRequest,
            headers: {
              'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
            },
          }),
          invalidatesTags: ['ovi-vehicle-migration-controller'],
        }
      ),
      subscriptionOnboardVehicles: build.mutation<
        SubscriptionOnboardVehiclesApiResponse,
        SubscriptionOnboardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-05-05/boarding/subscriptions/onboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            subscriptionState: queryArg.subscriptionState,
            subscriptionOrgId: queryArg.subscriptionOrgId,
            planCode: queryArg.planCode,
            serviceCodes: queryArg.serviceCodes,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      subscriptionOffboardVehicles: build.mutation<
        SubscriptionOffboardVehiclesApiResponse,
        SubscriptionOffboardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-05-05/boarding/subscriptions/offboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportVehicleListOverviewCsvFromSearch: build.mutation<
        ExportVehicleListOverviewCsvFromSearchApiResponse,
        ExportVehicleListOverviewCsvFromSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-03-10/views/vehicleOverviewList/export`,
          method: 'POST',
          body: queryArg.vehicleOverviewSearchRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      bulkGetVehicleBasicInfo: build.mutation<
        BulkGetVehicleBasicInfoApiResponse,
        BulkGetVehicleBasicInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-02-10/vehicles/basicInfo`,
          method: 'POST',
          body: queryArg.bulkGetVehicleBasicInfoRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      getVehicleOverviewList: build.query<
        GetVehicleOverviewListApiResponse,
        GetVehicleOverviewListApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-01-27/views/vehicleOverviewList`,
          method: 'POST',
          body: queryArg.vehicleOverviewSearchRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      exportVehicleDiagnosticsList: build.mutation<
        ExportVehicleDiagnosticsListApiResponse,
        ExportVehicleDiagnosticsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-01-13/views/vehicleDiagnosticsList/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['vehicle-diagnostics-list-controller'],
      }),
      getAssetBatteryReadinessV20260113: build.mutation<
        GetAssetBatteryReadinessV20260113ApiResponse,
        GetAssetBatteryReadinessV20260113ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-01-13/views/batteryReadinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['battery-readiness-report-view-controller'],
      }),
      exportAssetBatteryReadinessCsvV20260113: build.mutation<
        ExportAssetBatteryReadinessCsvV20260113ApiResponse,
        ExportAssetBatteryReadinessCsvV20260113ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2026-01-13/views/batteryReadinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
          },
        }),
        invalidatesTags: ['battery-readiness-report-view-controller'],
      }),
      getVehiclesWithDriversAndPeripheralsUsingBdQuery: build.mutation<
        GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiResponse,
        GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-12-30/views/vehicles-with-drivers-and-peripherals`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      probeVehicle: build.mutation<ProbeVehicleApiResponse, ProbeVehicleApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/2025-12-30/admin/vehicles/${queryArg.vin}/probe`,
            method: 'POST',
          }),
          invalidatesTags: ['admin-controller'],
        }
      ),
      getVehiclesWithDriversAndPeripherals: build.mutation<
        GetVehiclesWithDriversAndPeripheralsApiResponse,
        GetVehiclesWithDriversAndPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-12-16/views/vehicles-with-drivers-and-peripherals`,
          method: 'POST',
          body: queryArg.vehiclesWithDriversAndPeripheralsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
          },
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      changeFleetForVehicles: build.mutation<
        ChangeFleetForVehiclesApiResponse,
        ChangeFleetForVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-12-16/bulkChangeFleet`,
          method: 'POST',
          body: queryArg.changeFleetRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      cancelBatch: build.mutation<CancelBatchApiResponse, CancelBatchApiArg>({
        query: (queryArg) => ({
          url: `/assets/2025-12-02/boarding/batches/${queryArg.batchId}/cancel`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportVehicleListOverviewCsv: build.mutation<
        ExportVehicleListOverviewCsvApiResponse,
        ExportVehicleListOverviewCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-11-18/views/vehicleOverviewList/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      getVehicleOverviewList1: build.mutation<
        GetVehicleOverviewList1ApiResponse,
        GetVehicleOverviewList1ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-11-04/views/vehicleOverviewList`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      getVehicleDiagnosticsList: build.query<
        GetVehicleDiagnosticsListApiResponse,
        GetVehicleDiagnosticsListApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-11-04/views/vehicleDiagnosticsList`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['vehicle-diagnostics-list-controller'],
      }),
      exportVehicleDiagnosticsListV20251104: build.mutation<
        ExportVehicleDiagnosticsListV20251104ApiResponse,
        ExportVehicleDiagnosticsListV20251104ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-11-04/views/vehicleDiagnosticsList/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['vehicle-diagnostics-list-controller'],
      }),
      exportPendingConnectionVehicles: build.mutation<
        ExportPendingConnectionVehiclesApiResponse,
        ExportPendingConnectionVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-10-07/views/pendingConnectionVehicles/export`,
          method: 'POST',
          body: queryArg.pendingVehicleExportRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            fan: queryArg.fan,
            stationId: queryArg.stationId,
            pendingConnectionStatuses: queryArg.pendingConnectionStatuses,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        invalidatesTags: ['dashboard-view-controller'],
      }),
      exportPendingOnboardingVehicles: build.mutation<
        ExportPendingOnboardingVehiclesApiResponse,
        ExportPendingOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-10-07/boarding/vehicles/pending/export`,
          method: 'POST',
          body: queryArg.pendingVehicleExportRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            size: queryArg.size,
            status: queryArg.status,
            reviewReasons: queryArg.reviewReasons,
            fan: queryArg.fan,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            stationId: queryArg.stationId,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      refreshBatchSummary: build.mutation<
        RefreshBatchSummaryApiResponse,
        RefreshBatchSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches/${queryArg.batchId}/refresh`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      getAssetReadinessV20250909: build.mutation<
        GetAssetReadinessV20250909ApiResponse,
        GetAssetReadinessV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-09/views/readinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      exportAssetReadinessCsvV20250909: build.mutation<
        ExportAssetReadinessCsvV20250909ApiResponse,
        ExportAssetReadinessCsvV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-09/views/readinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      exportAssetFluidReadinessCsvV20250909: build.mutation<
        ExportAssetFluidReadinessCsvV20250909ApiResponse,
        ExportAssetFluidReadinessCsvV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-09/views/fluidReadinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      getAssetBatteryReadinessV20250909: build.mutation<
        GetAssetBatteryReadinessV20250909ApiResponse,
        GetAssetBatteryReadinessV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-09/views/batteryReadinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['battery-readiness-report-view-controller'],
      }),
      migratePreviouslyConnectedVehicleToConnectivity: build.mutation<
        MigratePreviouslyConnectedVehicleToConnectivityApiResponse,
        MigratePreviouslyConnectedVehicleToConnectivityApiArg
      >({
        query: () => ({
          url: `/assets/2025-08-26/connectivity/restart/migrate`,
          method: 'POST',
        }),
        invalidatesTags: ['restart-connectivity-controller'],
      }),
      getBatchIgnitionStatus: build.mutation<
        GetBatchIgnitionStatusApiResponse,
        GetBatchIgnitionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-12/views/vehicleIgnitionStatuses`,
          method: 'POST',
          body: queryArg.vehicleIgnitionStatusBatchRequest,
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      archiveVehicleBoardingSession: build.mutation<
        ArchiveVehicleBoardingSessionApiResponse,
        ArchiveVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-12/boarding/vehicles/${queryArg.vin}/sessions/${queryArg.sessionId}/archive`,
          method: 'POST',
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      sendConnectivityRestartRequest: build.mutation<
        SendConnectivityRestartRequestApiResponse,
        SendConnectivityRestartRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-07-29/admin/connectivity/restart`,
          method: 'POST',
          body: queryArg.restartConnectivityRequest,
          params: {
            connectivityRestartRequest: queryArg.connectivityRestartRequest,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      retryOnboardingVehicles: build.mutation<
        RetryOnboardingVehiclesApiResponse,
        RetryOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-07-15/onboarding/vehicles/ownership/retry`,
          method: 'POST',
          body: queryArg.retryOnboardingVehicleBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      triggerSearchIndexRefresh: build.mutation<
        TriggerSearchIndexRefreshApiResponse,
        TriggerSearchIndexRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-07-15/admin/vehicles/searchIndexRefresh`,
          method: 'POST',
          body: queryArg.body,
          params: {
            assetIds: queryArg.assetIds,
            batchSize: queryArg.batchSize,
            typeToRefresh: queryArg.typeToRefresh,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      cancelSessions: build.mutation<
        CancelSessionsApiResponse,
        CancelSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-06-17/connectivity/session/cancel`,
          method: 'POST',
          body: queryArg.cancelConnectivitySessionRequest,
        }),
        invalidatesTags: ['connectivity-controller'],
      }),
      getMapAssetDetails: build.query<
        GetMapAssetDetailsApiResponse,
        GetMapAssetDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-04-08/views/mapsVehicleList`,
          method: 'POST',
          body: queryArg.vehicleListMapsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getMapLocationSummary: build.query<
        GetMapLocationSummaryApiResponse,
        GetMapLocationSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-04-08/views/mapsLocationSummary`,
          method: 'POST',
          body: queryArg.vehicleLocationMapsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      terminateVehicleBoardingSession: build.mutation<
        TerminateVehicleBoardingSessionApiResponse,
        TerminateVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-03-26/boarding/vehicles/${queryArg.vin}/sessions/${queryArg.sessionId}/terminate`,
          method: 'POST',
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      batchOffBoardVehicles: build.mutation<
        BatchOffBoardVehiclesApiResponse,
        BatchOffBoardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-03-11/boarding/vehicles/offboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            remoteProvider: queryArg.remoteProvider,
            telemetryProvider: queryArg.telemetryProvider,
            uploadType: queryArg.uploadType,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      refreshVehicleData: build.mutation<
        RefreshVehicleDataApiResponse,
        RefreshVehicleDataApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-25/admin/vehicles/refresh`,
          method: 'POST',
          body: queryArg.vehicleDataRefreshRequest,
          params: {
            dryRun: queryArg.dryRun,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      triggerAddCapabilitiesEvent: build.mutation<
        TriggerAddCapabilitiesEventApiResponse,
        TriggerAddCapabilitiesEventApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-25/admin/triggerAssetCapabilitiesEvent`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            organizationId: queryArg.organizationId,
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            assetIds: queryArg.assetIds,
            batchSize: queryArg.batchSize,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      batchOnboardVehiclesV2: build.mutation<
        BatchOnboardVehiclesV2ApiResponse,
        BatchOnboardVehiclesV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-01-14/boarding/vehicles/onboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'X-Boarding-Connection-Policy':
              queryArg['X-Boarding-Connection-Policy'],
          },
          params: {
            remoteProvider: queryArg.remoteProvider,
            telemetryProvider: queryArg.telemetryProvider,
            uploadType: queryArg.uploadType,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      triggerEvent: build.mutation<TriggerEventApiResponse, TriggerEventApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/2025-01-01/triggerAssetCreationEvent`,
            method: 'POST',
            body: queryArg.body,
            params: {
              assetIds: queryArg.assetIds,
            },
          }),
          invalidatesTags: ['asset-controller'],
        }
      ),
      getActiveFieldActionVehicleSummary: build.mutation<
        GetActiveFieldActionVehicleSummaryApiResponse,
        GetActiveFieldActionVehicleSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-12-04/fieldactions/vehicleSummary`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            vehicleFieldActionSummaryRequest:
              queryArg.vehicleFieldActionSummaryRequest,
          },
        }),
        invalidatesTags: ['vehicle-field-action-view-controller'],
      }),
      getAssetReadinessV20241203: build.mutation<
        GetAssetReadinessV20241203ApiResponse,
        GetAssetReadinessV20241203ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-12-03/views/readinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      rejectVehicleProofOfOwnership: build.mutation<
        RejectVehicleProofOfOwnershipApiResponse,
        RejectVehicleProofOfOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-11-11/onboarding/vehicles/ownership/reject`,
          method: 'POST',
          body: queryArg.vehicleOwnershipOperationBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      confirmVehicleProofOfOwnership: build.mutation<
        ConfirmVehicleProofOfOwnershipApiResponse,
        ConfirmVehicleProofOfOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-11-11/onboarding/vehicles/ownership/confirm`,
          method: 'POST',
          body: queryArg.vehicleOwnershipOperationBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      getFieldActionSummaryReport: build.mutation<
        GetFieldActionSummaryReportApiResponse,
        GetFieldActionSummaryReportApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-10-23/fieldactions/vehicleFieldActionReport`,
          method: 'POST',
          body: queryArg.vehicleFieldActionReportRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['vehicle-field-action-view-controller'],
      }),
      upsertAsset: build.mutation<UpsertAssetApiResponse, UpsertAssetApiArg>({
        query: (queryArg) => ({
          url: `/assets/2024-07-31/upsert`,
          method: 'POST',
          body: queryArg.body,
          params: {
            isReEnrolling: queryArg.isReEnrolling,
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      getAssetsByPage: build.mutation<
        GetAssetsByPageApiResponse,
        GetAssetsByPageApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2023-03-14/views/enhancements`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      doSubscribeV2: build.mutation<
        DoSubscribeV2ApiResponse,
        DoSubscribeV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2022-05-24/eventsubscriptions`,
          method: 'POST',
          body: queryArg.eventSubscriptionRequestV2,
        }),
        invalidatesTags: ['event-subscriptions-controller'],
      }),
      getAssetWithTireReadiness: build.mutation<
        GetAssetWithTireReadinessApiResponse,
        GetAssetWithTireReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/views/tireReadinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        invalidatesTags: ['tire-readiness-report-view-controller'],
      }),
      searchAssets: build.mutation<SearchAssetsApiResponse, SearchAssetsApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/2021-11-15/searches`,
            method: 'POST',
            body: queryArg.bdPageRequest,
          }),
          invalidatesTags: ['asset-controller'],
        }
      ),
      updateProtectedFieldsForAsset: build.mutation<
        UpdateProtectedFieldsForAssetApiResponse,
        UpdateProtectedFieldsForAssetApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/admin/${queryArg.pathAssetId}`,
          method: 'POST',
          body: queryArg.protectedFieldsUpdateRequest,
          headers: {
            assetId: queryArg.headerAssetId,
          },
          params: {
            request: queryArg.request,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      patchVehicleProbe: build.mutation<
        PatchVehicleProbeApiResponse,
        PatchVehicleProbeApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-12-02/vehicles/${queryArg.vin}/probe`,
          method: 'PATCH',
          body: queryArg.vehicleProbe,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      resetOwnership: build.mutation<
        ResetOwnershipApiResponse,
        ResetOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-04-08/reset/ownership/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateVehicleJson,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      patchVehicleInfoFields: build.mutation<
        PatchVehicleInfoFieldsApiResponse,
        PatchVehicleInfoFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-25/vehicle/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateVehicleJson,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      updateConfiguration: build.mutation<
        UpdateConfigurationApiResponse,
        UpdateConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15`,
          method: 'PATCH',
          body: queryArg.updateConfigurationJson,
          params: {
            filters: queryArg.filters,
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      listSummaries: build.query<ListSummariesApiResponse, ListSummariesApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/migration/2026-03-24/batchBoardingVehicleSummary/summaries`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['batch-boarding-vehicle-summary-migration-controller'],
        }
      ),
      listSessions: build.query<ListSessionsApiResponse, ListSessionsApiArg>({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/vehicleBoardingSession/sessions`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: [
          'vehicle-boarding-workflow-session-migration-controller',
        ],
      }),
      listVehicles: build.query<ListVehiclesApiResponse, ListVehiclesApiArg>({
        query: (queryArg) => ({
          url: `/assets/migration/2026-02-24/gmVehicle/vehicles`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ['gm-vehicle-migration-controller'],
      }),
      listVehicles1: build.query<ListVehicles1ApiResponse, ListVehicles1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/migration/2026-02-24/connectivityProvider/vehicles`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['connectivity-provider-migration-controller'],
        }
      ),
      listVehicles2: build.query<ListVehicles2ApiResponse, ListVehicles2ApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/migration/2026-02-24/claimedOnstar/vehicles`,
            params: {
              pageSize: queryArg.pageSize,
            },
          }),
          providesTags: ['claimed-onstar-migration-controller'],
        }
      ),
      listVehicles3: build.query<ListVehicles3ApiResponse, ListVehicles3ApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/migration/2025-09-23/onstarSupportStatus/vehicles`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              onstarSupportStatus: queryArg.onstarSupportStatus,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['onstar-support-status-migration-controller'],
        }
      ),
      getVehicleImageUrl: build.query<
        GetVehicleImageUrlApiResponse,
        GetVehicleImageUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/image/${queryArg.vin}/2025-07-30`,
        }),
        providesTags: ['image-controller'],
      }),
      getVehicleImageUrlWithParams: build.query<
        GetVehicleImageUrlWithParamsApiResponse,
        GetVehicleImageUrlWithParamsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-12-16/${queryArg.vin}/image`,
          params: {
            size: queryArg.size,
            angle: queryArg.angle,
            isTransparentBackground: queryArg.isTransparentBackground,
          },
        }),
        providesTags: ['asset-controller'],
      }),
      getPropulsionSummary: build.query<
        GetPropulsionSummaryApiResponse,
        GetPropulsionSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-10-07/views/propulsionSummary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      listBatchSummaries: build.query<
        ListBatchSummariesApiResponse,
        ListBatchSummariesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            createdBy: queryArg.createdBy,
            status: queryArg.status,
            boardingType: queryArg.boardingType,
            size: queryArg.size,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      getBatchSummaryById: build.query<
        GetBatchSummaryByIdApiResponse,
        GetBatchSummaryByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      getBatchSessionsById: build.query<
        GetBatchSessionsByIdApiResponse,
        GetBatchSessionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches/${queryArg.batchId}/sessions`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            vin: queryArg.vin,
            status: queryArg.status,
            size: queryArg.size,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      getAssets20250923BoardingBatchesByBatchIdExtended: build.query<
        GetAssets20250923BoardingBatchesByBatchIdExtendedApiResponse,
        GetAssets20250923BoardingBatchesByBatchIdExtendedApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches/${queryArg.batchId}/extended`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportBatchVehiclesToCsv: build.query<
        ExportBatchVehiclesToCsvApiResponse,
        ExportBatchVehiclesToCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-09-23/boarding/batches/${queryArg.batchId}/export`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            vin: queryArg.vin,
            status: queryArg.status,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      listPendingConnectionVehicles: build.query<
        ListPendingConnectionVehiclesApiResponse,
        ListPendingConnectionVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-26/views/pendingConnectionVehicles`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            fan: queryArg.fan,
            stationId: queryArg.stationId,
            pendingConnectionStatuses: queryArg.pendingConnectionStatuses,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getOilLifeSummaryMetricsV20250826: build.query<
        GetOilLifeSummaryMetricsV20250826ApiResponse,
        GetOilLifeSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-26/views/oilLifeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getDiagnosticsSummaryMetricsV20250826: build.query<
        GetDiagnosticsSummaryMetricsV20250826ApiResponse,
        GetDiagnosticsSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-26/views/diagnosticDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getConnectivityStatusDashboardSummaryMetricsV20250826: build.query<
        GetConnectivityStatusDashboardSummaryMetricsV20250826ApiResponse,
        GetConnectivityStatusDashboardSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-26/views/connectivityStatusDashboardSummary`,
          headers: {
            orgId: queryArg.orgId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getChargeSummaryMetricsV20250826: build.query<
        GetChargeSummaryMetricsV20250826ApiResponse,
        GetChargeSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-26/views/chargeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getSummaryOfBoardingSessions: build.query<
        GetSummaryOfBoardingSessionsApiResponse,
        GetSummaryOfBoardingSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-08-12/boarding/batch/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      searchAsset: build.query<SearchAssetApiResponse, SearchAssetApiArg>({
        query: (queryArg) => ({
          url: `/assets/2025-07-29/asset-joint-index/search`,
          params: {
            searchText: queryArg.searchText,
            top: queryArg.top,
            skip: queryArg.skip,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            filters: queryArg.filters,
            fieldsToSelect: queryArg.fieldsToSelect,
            queryType: queryArg.queryType,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getVehiclesWithDrivers: build.query<
        GetVehiclesWithDriversApiResponse,
        GetVehiclesWithDriversApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-06-17/vehicles/withDrivers`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['header_cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vehicleSearchKeyword: queryArg.vehicleSearchKeyword,
            page: queryArg.page,
            'cs-continuation-token': queryArg['query_cs-continuation-token'],
          },
        }),
        providesTags: ['Vehicles'],
      }),
      listVehicleBoardingSessions: build.query<
        ListVehicleBoardingSessionsApiResponse,
        ListVehicleBoardingSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-05-21/boarding/vehicleBoardingSessions`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            batchId: queryArg.batchId,
            organizationId: queryArg.organizationId,
            size: queryArg.size,
            sessionType: queryArg.sessionType,
            vin: queryArg.vin,
            token: queryArg.token,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getOilLifeSummaryMetrics: build.query<
        GetOilLifeSummaryMetricsApiResponse,
        GetOilLifeSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-05-06/views/oilLifeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getDiagnosticsSummaryMetrics: build.query<
        GetDiagnosticsSummaryMetricsApiResponse,
        GetDiagnosticsSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-05-06/views/diagnosticDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getConnectivityStatusSummaryMetrics: build.query<
        GetConnectivityStatusSummaryMetricsApiResponse,
        GetConnectivityStatusSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-05-06/views/connectivityStatusDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getChargeLevelSummaryMetrics: build.query<
        GetChargeLevelSummaryMetricsApiResponse,
        GetChargeLevelSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-05-06/views/chargeLevelDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getVehiclesBasicDetails: build.query<
        GetVehiclesBasicDetailsApiResponse,
        GetVehiclesBasicDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-04-08/views/vehiclesBasicDetails`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vins: queryArg.vins,
            name: queryArg.name,
            licensePlate: queryArg.licensePlate,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      searchAsset1: build.query<SearchAsset1ApiResponse, SearchAsset1ApiArg>({
        query: (queryArg) => ({
          url: `/assets/2025-03-11-BETA/search`,
          params: {
            searchText: queryArg.searchText,
            top: queryArg.top,
            skip: queryArg.skip,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            filters: queryArg.filters,
            queryType: queryArg.queryType,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      listIncompleteOnboardingVehicles: build.query<
        ListIncompleteOnboardingVehiclesApiResponse,
        ListIncompleteOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-25/boarding/vehicles/incomplete`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            reason: queryArg.reason,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getAssetsList: build.query<GetAssetsListApiResponse, GetAssetsListApiArg>(
        {
          query: (queryArg) => ({
            url: `/assets/2025-02-11/views/vehicleList`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              size: queryArg.size,
              propulsionTypes: queryArg.propulsionTypes,
              vin: queryArg.vin,
              name: queryArg.name,
              licensePlate: queryArg.licensePlate,
            },
          }),
          providesTags: ['asset-view-controller'],
        }
      ),
      getVehicleIgnitionStatus: build.query<
        GetVehicleIgnitionStatusApiResponse,
        GetVehicleIgnitionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-11/views/vehicleIgnitionStatus/${queryArg.vin}`,
        }),
        providesTags: ['asset-view-controller'],
      }),
      getAssetStatusWithFiltering: build.query<
        GetAssetStatusWithFilteringApiResponse,
        GetAssetStatusWithFilteringApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-11/views/status/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            statuses: queryArg.statuses,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      listPendingOnboardingVehicles: build.query<
        ListPendingOnboardingVehiclesApiResponse,
        ListPendingOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-02-11/boarding/vehicles/pending`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            status: queryArg.status,
            vin: queryArg.vin,
            reviewReasons: queryArg.reviewReasons,
            fan: queryArg.fan,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            stationId: queryArg.stationId,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      executeRemoteCommands: build.query<
        ExecuteRemoteCommandsApiResponse,
        ExecuteRemoteCommandsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2025-01-14/remotecommands/${queryArg.commandType}/${queryArg.command}/${queryArg.vin}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['remote-command-controller'],
      }),
      getChargeLevelDashboardSummary: build.query<
        GetChargeLevelDashboardSummaryApiResponse,
        GetChargeLevelDashboardSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-11-06/views/chargeLevelDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getFieldActionsForVin: build.query<
        GetFieldActionsForVinApiResponse,
        GetFieldActionsForVinApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-09-11/fieldactions/lookup/${queryArg.vin}`,
        }),
        providesTags: ['vehicle-field-action-view-controller'],
      }),
      getAssets20240717ByAssetIdInternal: build.query<
        GetAssets20240717ByAssetIdInternalApiResponse,
        GetAssets20240717ByAssetIdInternalApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-07-17/${queryArg.assetId}/internal`,
          headers: {
            'cs-session-token': queryArg['cs-session-token'],
          },
        }),
        providesTags: ['Asset'],
      }),
      getVehicleBoardingProfile: build.query<
        GetVehicleBoardingProfileApiResponse,
        GetVehicleBoardingProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-06-10/boarding/vehicles/${queryArg.vin}`,
        }),
        providesTags: ['vehicle-boarding-profile-controller'],
      }),
      getCurrentVehicleBoardingSession: build.query<
        GetCurrentVehicleBoardingSessionApiResponse,
        GetCurrentVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-06-10/boarding/vehicles/${queryArg.vin}/sessions/current`,
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getVehicleBoardingSessionBySessionId: build.query<
        GetVehicleBoardingSessionBySessionIdApiResponse,
        GetVehicleBoardingSessionBySessionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-06-10/boarding/vehicleBoardingSessions/${queryArg.sessionId}`,
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getOrganizationIdByAssetId: build.query<
        GetOrganizationIdByAssetIdApiResponse,
        GetOrganizationIdByAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2024-05-10/asset/${queryArg.assetId}/organization`,
        }),
        providesTags: ['asset-controller'],
      }),
      getOrganizationAssetCountSummary: build.query<
        GetOrganizationAssetCountSummaryApiResponse,
        GetOrganizationAssetCountSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2023-11-22/views/assetCountSummary`,
          params: {
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getAssetByIdWithFan: build.query<
        GetAssetByIdWithFanApiResponse,
        GetAssetByIdWithFanApiArg
      >({
        query: (queryArg) => ({ url: `/assets/2023-11-21/${queryArg.id}` }),
        providesTags: ['asset-controller'],
      }),
      getComplianceReportV2: build.query<
        GetComplianceReportV2ApiResponse,
        GetComplianceReportV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2023-03-14/views/complianceReport`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            params: queryArg.params,
          },
        }),
        providesTags: ['compliance-report-view-controller'],
      }),
      getDashboardMetrics: build.query<
        GetDashboardMetricsApiResponse,
        GetDashboardMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/views/orgDashboard`,
          headers: {
            orgId: queryArg.orgId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getMapListItems: build.query<
        GetMapListItemsApiResponse,
        GetMapListItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/views/maplistitems`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            filters: queryArg.filters,
            size: queryArg.size,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getAssetWithi8NDetails: build.query<
        GetAssetWithi8NDetailsApiResponse,
        GetAssetWithi8NDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/assets/2021-11-15/views/enhancements/${queryArg.id}`,
        }),
        providesTags: ['asset-view-controller'],
      }),
      postAudit20250603ExportSync: build.mutation<
        PostAudit20250603ExportSyncApiResponse,
        PostAudit20250603ExportSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/audit/2025-06-03/export/sync`,
          method: 'POST',
          body: queryArg.auditExportRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['audit-export-controller'],
      }),
      fetchOrganizationName: build.query<
        FetchOrganizationNameApiResponse,
        FetchOrganizationNameApiArg
      >({
        query: (queryArg) => ({
          url: `/audit/2025-06-03/${queryArg.organizationId}`,
        }),
        providesTags: ['demo-controller'],
      }),
      fetchFleet: build.query<FetchFleetApiResponse, FetchFleetApiArg>({
        query: (queryArg) => ({
          url: `/audit/2025-06-03/${queryArg.organizationId}/fleet/${queryArg.fleetId}`,
        }),
        providesTags: ['demo-controller'],
      }),
      demo: build.query<DemoApiResponse, DemoApiArg>({
        query: () => ({ url: `/audit/2025-06-03/demo` }),
        providesTags: ['demo-controller'],
      }),
      createProduct: build.mutation<
        CreateProductApiResponse,
        CreateProductApiArg
      >({
        query: (queryArg) => ({
          url: `/catalog/2024-06-01`,
          method: 'POST',
          body: queryArg.createProductDto,
        }),
        invalidatesTags: ['product-catalog-controller'],
      }),
      getProducts: build.mutation<GetProductsApiResponse, GetProductsApiArg>({
        query: (queryArg) => ({
          url: `/catalog/2024-06-01/products`,
          method: 'POST',
          body: queryArg.productListDto,
        }),
        invalidatesTags: ['product-catalog-controller'],
      }),
      createFeature: build.mutation<
        CreateFeatureApiResponse,
        CreateFeatureApiArg
      >({
        query: (queryArg) => ({
          url: `/catalog/2024-06-01/features`,
          method: 'POST',
          body: queryArg.createFeatureDto,
        }),
        invalidatesTags: ['product-catalog-controller'],
      }),
      sunsetProduct: build.mutation<
        SunsetProductApiResponse,
        SunsetProductApiArg
      >({
        query: (queryArg) => ({
          url: `/catalog/2024-06-01/products/sunset`,
          method: 'PATCH',
          body: queryArg.sunsetRequestDto,
        }),
        invalidatesTags: ['product-catalog-controller'],
      }),
      getProductById: build.query<
        GetProductByIdApiResponse,
        GetProductByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/catalog/2024-06-01/products/${queryArg.productId}`,
        }),
        providesTags: ['product-catalog-controller'],
      }),
      updateHomeChargeReimbursementRecordUtilityRate: build.mutation<
        UpdateHomeChargeReimbursementRecordUtilityRateApiResponse,
        UpdateHomeChargeReimbursementRecordUtilityRateApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/update-hcr-utility-rate`,
          method: 'POST',
          body: queryArg.updateReimbursementUtilityRateRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            distancePreference: queryArg.distancePreference,
          },
        }),
        invalidatesTags: ['home-charge-reimbursements-controller'],
      }),
      updateDriverUtilityRate: build.mutation<
        UpdateDriverUtilityRateApiResponse,
        UpdateDriverUtilityRateApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/update-driver-utility-rate`,
          method: 'POST',
          body: queryArg.updateDriverUtilityPlanRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['home-charge-reimbursements-controller'],
      }),
      createFormattedChargeReimbursementsForReports: build.mutation<
        CreateFormattedChargeReimbursementsForReportsApiResponse,
        CreateFormattedChargeReimbursementsForReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/formatted-reports/reimbursements`,
          method: 'POST',
          body: queryArg.reportDataRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['reimbursements-reports-controller'],
      }),
      createStreamedReportRecordsForHomeChargeReimbursement: build.mutation<
        CreateStreamedReportRecordsForHomeChargeReimbursementApiResponse,
        CreateStreamedReportRecordsForHomeChargeReimbursementApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/formatted-reports/reimbursements/stream`,
          method: 'POST',
          body: queryArg.reportDataRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['reimbursements-reports-controller'],
      }),
      createOrUpdateFleetUtilityRateSettings: build.mutation<
        CreateOrUpdateFleetUtilityRateSettingsApiResponse,
        CreateOrUpdateFleetUtilityRateSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/fleet-utility-rate-settings`,
          method: 'POST',
          body: queryArg.createOrUpdateFleetUtilityRateSettingsDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['fleet-utility-rate-settings-controller'],
      }),
      exportSelectedOrAllHomeChargeReimbursementRecords: build.mutation<
        ExportSelectedOrAllHomeChargeReimbursementRecordsApiResponse,
        ExportSelectedOrAllHomeChargeReimbursementRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-specified-reimbursements/${queryArg.driverId}`,
          method: 'POST',
          body: queryArg.reimbursementExportRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timeZoneId: queryArg.timeZoneId,
            pluginTimeAfterUTC: queryArg.pluginTimeAfterUtc,
            pluginTimeBeforeUTC: queryArg.pluginTimeBeforeUtc,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        invalidatesTags: ['reimbursements-export-and-reports-controller'],
      }),
      exportSelectedHomeChargeReimbursementRecords: build.mutation<
        ExportSelectedHomeChargeReimbursementRecordsApiResponse,
        ExportSelectedHomeChargeReimbursementRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-selected-reimbursements/${queryArg.driverId}`,
          method: 'POST',
          body: queryArg.reimbursementExportRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timeZoneId: queryArg.timeZoneId,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        invalidatesTags: ['reimbursements-export-and-reports-controller'],
      }),
      exportSelectedHomeChargeReimbursementRecordsForCurrentDriver:
        build.mutation<
          ExportSelectedHomeChargeReimbursementRecordsForCurrentDriverApiResponse,
          ExportSelectedHomeChargeReimbursementRecordsForCurrentDriverApiArg
        >({
          query: (queryArg) => ({
            url: `/evcharge/2025-08-26/export-selected-reimbursements-current-driver`,
            method: 'POST',
            body: queryArg.reimbursementExportRequestDto,
            headers: {
              'cs-organization': queryArg['cs-organization'],
            },
            params: {
              timeZoneId: queryArg.timeZoneId,
              distanceUnit: queryArg.distanceUnit,
              temperatureUnit: queryArg.temperatureUnit,
            },
          }),
          invalidatesTags: ['reimbursements-export-and-reports-controller'],
        }),
      searchChargingStationsForDriver: build.query<
        SearchChargingStationsForDriverApiResponse,
        SearchChargingStationsForDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-11-04/driver/charge-stations/search`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            searchCenterLatitude: queryArg.searchCenterLatitude,
            searchCenterLongitude: queryArg.searchCenterLongitude,
            searchTerm: queryArg.searchTerm,
            chargingGrades: queryArg.chargingGrades,
            availabilities: queryArg.availabilities,
            plugTypes: queryArg.plugTypes,
            providerIds: queryArg.providerIds,
            size: queryArg.size,
            searchRadiusInKilometers: queryArg.searchRadiusInKilometers,
            continuationToken: queryArg.continuationToken,
          },
        }),
        providesTags: ['charge-station-controller'],
      }),
      search: build.query<SearchApiResponse, SearchApiArg>({
        query: (queryArg) => ({
          url: `/evcharge/2025-11-04/charge-stations/search`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            searchCenterLatitude: queryArg.searchCenterLatitude,
            searchCenterLongitude: queryArg.searchCenterLongitude,
            searchTerm: queryArg.searchTerm,
            chargingGrades: queryArg.chargingGrades,
            availabilities: queryArg.availabilities,
            plugTypes: queryArg.plugTypes,
            providerIds: queryArg.providerIds,
            size: queryArg.size,
            searchRadiusInKilometers: queryArg.searchRadiusInKilometers,
          },
        }),
        providesTags: ['charge-station-controller'],
      }),
      getFleetUtilityRateSettings: build.query<
        GetFleetUtilityRateSettingsApiResponse,
        GetFleetUtilityRateSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/fleet-utility-rate-settings/${queryArg.fleetId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleet-utility-rate-settings-controller'],
      }),
      removeFleetUtilityRateSettings: build.mutation<
        RemoveFleetUtilityRateSettingsApiResponse,
        RemoveFleetUtilityRateSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/fleet-utility-rate-settings/${queryArg.fleetId}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['fleet-utility-rate-settings-controller'],
      }),
      exportSingleHomeChargeReimbursementRecord: build.query<
        ExportSingleHomeChargeReimbursementRecordApiResponse,
        ExportSingleHomeChargeReimbursementRecordApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-single-reimbursement/${queryArg.driverId}/${queryArg.chargeSessionId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timeZoneId: queryArg.timeZoneId,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        providesTags: ['reimbursements-export-and-reports-controller'],
      }),
      exportSingleHomeChargeReimbursementRecordForCurrentDriver: build.query<
        ExportSingleHomeChargeReimbursementRecordForCurrentDriverApiResponse,
        ExportSingleHomeChargeReimbursementRecordForCurrentDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-single-reimbursement-current-driver/${queryArg.chargeSessionId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            timeZoneId: queryArg.timeZoneId,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        providesTags: ['reimbursements-export-and-reports-controller'],
      }),
      exportHomeChargeReimbursementRecords: build.query<
        ExportHomeChargeReimbursementRecordsApiResponse,
        ExportHomeChargeReimbursementRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-reimbursements/${queryArg.driverId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            pluginTimeAfterUTC: queryArg.pluginTimeAfterUtc,
            pluginTimeBeforeUTC: queryArg.pluginTimeBeforeUtc,
            timeZoneId: queryArg.timeZoneId,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        providesTags: ['reimbursements-export-and-reports-controller'],
      }),
      exportHomeChargeReimbursementRecordsForCurrentDriver: build.query<
        ExportHomeChargeReimbursementRecordsForCurrentDriverApiResponse,
        ExportHomeChargeReimbursementRecordsForCurrentDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/export-reimbursements-current-driver`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            pluginTimeAfterUTC: queryArg.pluginTimeAfterUtc,
            pluginTimeBeforeUTC: queryArg.pluginTimeBeforeUtc,
            timeZoneId: queryArg.timeZoneId,
            distanceUnit: queryArg.distanceUnit,
            temperatureUnit: queryArg.temperatureUnit,
          },
        }),
        providesTags: ['reimbursements-export-and-reports-controller'],
      }),
      getHomeChargingHistoryRecords: build.query<
        GetHomeChargingHistoryRecordsApiResponse,
        GetHomeChargingHistoryRecordsApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement/${queryArg.driverId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pluginTimeAfterUTC: queryArg.pluginTimeAfterUtc,
            pluginTimeBeforeUTC: queryArg.pluginTimeBeforeUtc,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      getChargingHistorySummaryForDriver: build.query<
        GetChargingHistorySummaryForDriverApiResponse,
        GetChargingHistorySummaryForDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement/${queryArg.driverId}/${queryArg.chargeSessionId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            distancePreference: queryArg.distancePreference,
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      getDriverUtilityPlanCard: build.query<
        GetDriverUtilityPlanCardApiResponse,
        GetDriverUtilityPlanCardApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement/utility-plan/${queryArg.driverId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      getHomeChargingHistoryRecordsForCurrentDriver: build.query<
        GetHomeChargingHistoryRecordsForCurrentDriverApiResponse,
        GetHomeChargingHistoryRecordsForCurrentDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement-current-driver`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pluginTimeAfterUTC: queryArg.pluginTimeAfterUtc,
            pluginTimeBeforeUTC: queryArg.pluginTimeBeforeUtc,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      getChargingHistorySummaryForCurrentDriver: build.query<
        GetChargingHistorySummaryForCurrentDriverApiResponse,
        GetChargingHistorySummaryForCurrentDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement-current-driver/${queryArg.chargeSessionId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            distancePreference: queryArg.distancePreference,
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      getDriverUtilityPlanCardForCurrentDriver: build.query<
        GetDriverUtilityPlanCardForCurrentDriverApiResponse,
        GetDriverUtilityPlanCardForCurrentDriverApiArg
      >({
        query: (queryArg) => ({
          url: `/evcharge/2025-08-26/charging-reimbursement-current-driver/utility-plan`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['home-charge-reimbursements-controller'],
      }),
      downloadFeedbackImage: build.query<
        DownloadFeedbackImageApiResponse,
        DownloadFeedbackImageApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback/2026-04-21/images`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            blobName: queryArg.blobName,
          },
        }),
        providesTags: ['feedback-image-upload-controller'],
      }),
      uploadFeedbackImage: build.mutation<
        UploadFeedbackImageApiResponse,
        UploadFeedbackImageApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback/2026-04-21/images`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['feedback-image-upload-controller'],
      }),
      createFeedback: build.mutation<
        CreateFeedbackApiResponse,
        CreateFeedbackApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback/2026-03-24`,
          method: 'POST',
          body: queryArg.feedbackCreateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['feedback-controller'],
      }),
      listFeedbacks: build.query<ListFeedbacksApiResponse, ListFeedbacksApiArg>(
        {
          query: (queryArg) => ({
            url: `/feedback/2026-03-24/list`,
            method: 'POST',
            body: queryArg.feedbackListRequest,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-continuation-token': queryArg['cs-continuation-token'],
              Authorization: queryArg.authorization,
            },
            params: {
              pageSize: queryArg.pageSize,
            },
          }),
          providesTags: ['feedback-controller'],
        }
      ),
      createJiraTicketForFeedback: build.mutation<
        CreateJiraTicketForFeedbackApiResponse,
        CreateJiraTicketForFeedbackApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback/2026-03-24/jira-ticket`,
          method: 'POST',
          body: queryArg.createJiraTicketRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['feedback-controller'],
      }),
      updateFeedbackStatus: build.mutation<
        UpdateFeedbackStatusApiResponse,
        UpdateFeedbackStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/feedback/2026-03-24/status`,
          method: 'PATCH',
          body: queryArg.feedbackStatusUpdateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['feedback-controller'],
      }),
      enrollOrUnenrollVehicles: build.mutation<
        EnrollOrUnenrollVehiclesApiResponse,
        EnrollOrUnenrollVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/vehicle-enrollments/${queryArg.providerCode}`,
          method: 'POST',
          body: queryArg.enrollVehiclesRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      getEligibleVehicles: build.mutation<
        GetEligibleVehiclesApiResponse,
        GetEligibleVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/vehicle-enrollments/${queryArg.providerCode}/eligible-vehicles`,
          method: 'POST',
          body: queryArg.eligibleVehiclesRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      findVins: build.mutation<FindVinsApiResponse, FindVinsApiArg>({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/vehicle-enrollments/vins`,
          method: 'POST',
          body: queryArg.vehicleEnrollmentVinsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      createOrgEnrollment: build.mutation<
        CreateOrgEnrollmentApiResponse,
        CreateOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/org-enrollments`,
          method: 'POST',
          body: queryArg.createOrgEnrollmentRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      validateCredentials: build.mutation<
        ValidateCredentialsApiResponse,
        ValidateCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/org-enrollments/validate-credentials`,
          method: 'POST',
          body: queryArg.validateCredentialsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      getVehicleDetails: build.mutation<
        GetVehicleDetailsApiResponse,
        GetVehicleDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/gmf/vehicles/details`,
          method: 'POST',
          body: queryArg.gmfVehicleDetailsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      lookupAuthorizedUser: build.mutation<
        LookupAuthorizedUserApiResponse,
        LookupAuthorizedUserApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/gmf/organizations/users/lookup`,
          method: 'POST',
          body: queryArg.gmfAuthorizedUserLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      lookupServices: build.mutation<
        LookupServicesApiResponse,
        LookupServicesApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/gmf/organizations/services/lookup`,
          method: 'POST',
          body: queryArg.gmfServiceLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      lookupOrganization: build.mutation<
        LookupOrganizationApiResponse,
        LookupOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/gmf/organizations/lookup`,
          method: 'POST',
          body: queryArg.gmfOrganizationLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      validateLineOfCredit: build.mutation<
        ValidateLineOfCreditApiResponse,
        ValidateLineOfCreditApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/gmf/organizations/line-of-credit/validate`,
          method: 'POST',
          body: queryArg.gmfLineOfCreditRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      verifyEnrollment: build.mutation<
        VerifyEnrollmentApiResponse,
        VerifyEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/fleetio/verify-enrollment`,
          method: 'POST',
          body: queryArg.fleetioVerifyEnrollmentRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['fleetio-controller'],
      }),
      createBulkJob: build.mutation<
        CreateBulkJobApiResponse,
        CreateBulkJobApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/fleetio/bulk-jobs`,
          method: 'POST',
          body: queryArg.fleetioBulkJobRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['fleetio-controller'],
      }),
      getVehiclesEnrollmentView: build.mutation<
        GetVehiclesEnrollmentViewApiResponse,
        GetVehiclesEnrollmentViewApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/enrollment/${queryArg.providerCode}/vehicles-enrollment-view`,
          method: 'POST',
          body: queryArg.vehiclesEnrollmentViewRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      getVehicleEnrollmentBatch: build.query<
        GetVehicleEnrollmentBatchApiResponse,
        GetVehicleEnrollmentBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/vehicle-enrollments/${queryArg.providerCode}/batches/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['vehicle-enrollment-controller'],
      }),
      getAllEligibleVins: build.query<
        GetAllEligibleVinsApiResponse,
        GetAllEligibleVinsApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/vehicle-enrollments/${queryArg.providerCode}/all-eligible-vins`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['vehicle-enrollment-controller'],
      }),
      listProviders: build.query<ListProvidersApiResponse, ListProvidersApiArg>(
        {
          query: (queryArg) => ({
            url: `/fleet-prtnrs/2026-09-22/providers`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
            },
          }),
          providesTags: ['org-enrollment-controller'],
        }
      ),
      providerIntegrationsStatus: build.query<
        ProviderIntegrationsStatusApiResponse,
        ProviderIntegrationsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/providers/integrations-status`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            providerCode: queryArg.providerCode,
          },
        }),
        providesTags: ['org-enrollment-controller'],
      }),
      getOrgEnrollment: build.query<
        GetOrgEnrollmentApiResponse,
        GetOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/org-enrollments/${queryArg.providerCode}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['org-enrollment-controller'],
      }),
      unlinkOrgEnrollment: build.mutation<
        UnlinkOrgEnrollmentApiResponse,
        UnlinkOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/org-enrollments/${queryArg.providerCode}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      getCurrentUser: build.query<
        GetCurrentUserApiResponse,
        GetCurrentUserApiArg
      >({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/fleetio/me`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
      getBulkJob: build.query<GetBulkJobApiResponse, GetBulkJobApiArg>({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/fleetio/bulk-jobs/${queryArg.jobId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
      getAccounts: build.query<GetAccountsApiResponse, GetAccountsApiArg>({
        query: (queryArg) => ({
          url: `/fleet-prtnrs/2026-09-22/fleetio/accounts`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
      countRemainingOf: build.query<
        CountRemainingOfApiResponse,
        CountRemainingOfApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2026-10-20/organizations/${queryArg.organizationId}/offboard`,
        }),
        providesTags: ['geofence-offboard-controller'],
      }),
      softDeleteNextPageOf: build.mutation<
        SoftDeleteNextPageOfApiResponse,
        SoftDeleteNextPageOfApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2026-10-20/organizations/${queryArg.organizationId}/offboard`,
          method: 'POST',
        }),
        invalidatesTags: ['geofence-offboard-controller'],
      }),
      listOviBoundaries: build.query<
        ListOviBoundariesApiResponse,
        ListOviBoundariesApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2026-09-08/migration/ovi/boundaries`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviBoundaryId: queryArg.oviBoundaryId,
            id: queryArg.id,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncBoundaries: build.mutation<
        SyncBoundariesApiResponse,
        SyncBoundariesApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2026-09-08/migration/ovi/boundaries`,
          method: 'POST',
          body: queryArg.syncOviBoundariesRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      validateBoundaries: build.mutation<
        ValidateBoundariesApiResponse,
        ValidateBoundariesApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2026-09-08/migration/ovi/boundaries/validate`,
          method: 'POST',
          body: queryArg.validateOviBoundariesRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      getGeofenceCountByRuleIds: build.mutation<
        GetGeofenceCountByRuleIdsApiResponse,
        GetGeofenceCountByRuleIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-10-07/countByRules`,
          method: 'POST',
          body: queryArg.ruleGeofenceCountRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['geofence-controller'],
      }),
      createGeofence: build.mutation<
        CreateGeofenceApiResponse,
        CreateGeofenceApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-09-23`,
          method: 'POST',
          body: queryArg.geofenceCreateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['geofence-controller'],
      }),
      fetchGeofences: build.query<
        FetchGeofencesApiResponse,
        FetchGeofencesApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-09-23/list`,
          method: 'POST',
          body: queryArg.geofenceRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            includeRules: queryArg.includeRules,
          },
        }),
        providesTags: ['geofence-controller'],
      }),
      deleteGeofence: build.mutation<
        DeleteGeofenceApiResponse,
        DeleteGeofenceApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-10-07/${queryArg.geofenceId}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['geofence-controller'],
      }),
      updateGeofence: build.mutation<
        UpdateGeofenceApiResponse,
        UpdateGeofenceApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-10-07/${queryArg.geofenceId}`,
          method: 'PATCH',
          body: queryArg.geofenceUpdateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['geofence-controller'],
      }),
      assignRuleIdsToGeofence: build.mutation<
        AssignRuleIdsToGeofenceApiResponse,
        AssignRuleIdsToGeofenceApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-10-07/${queryArg.geofenceId}/ruleAssignment`,
          method: 'PATCH',
          body: queryArg.assignRulesRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['geofence-controller'],
      }),
      getGeofencesIdAndNameByRuleId: build.query<
        GetGeofencesIdAndNameByRuleIdApiResponse,
        GetGeofencesIdAndNameByRuleIdApiArg
      >({
        query: (queryArg) => ({
          url: `/geofence/2025-10-07/rules/${queryArg.ruleId}/summary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['geofence-controller'],
      }),
      getOrdersV20260505: build.mutation<
        GetOrdersV20260505ApiResponse,
        GetOrdersV20260505ApiArg
      >({
        query: (queryArg) => ({
          url: `/ordertracking/2026-05-05/orders/list`,
          method: 'POST',
          body: queryArg.ordersListV20260505Dto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      exportOrdersV20260505: build.mutation<
        ExportOrdersV20260505ApiResponse,
        ExportOrdersV20260505ApiArg
      >({
        query: (queryArg) => ({
          url: `/ordertracking/2026-05-05/orders/export`,
          method: 'POST',
          body: queryArg.ordersExportV20260505Dto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      autoImport: build.mutation<AutoImportApiResponse, AutoImportApiArg>({
        query: (queryArg) => ({
          url: `/ordertracking/2026-04-07/auto-import`,
          method: 'POST',
          body: queryArg.autoImportRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      addOrders: build.mutation<AddOrdersApiResponse, AddOrdersApiArg>({
        query: (queryArg) => ({
          url: `/ordertracking/2024-06-01/orders`,
          method: 'POST',
          body: queryArg.orderCodesDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      getOrders: build.mutation<GetOrdersApiResponse, GetOrdersApiArg>({
        query: (queryArg) => ({
          url: `/ordertracking/2024-06-01/orders/list`,
          method: 'POST',
          body: queryArg.ordersListDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      exportOrders: build.mutation<ExportOrdersApiResponse, ExportOrdersApiArg>(
        {
          query: (queryArg) => ({
            url: `/ordertracking/2024-06-01/orders/export`,
            method: 'POST',
            body: queryArg.ordersListDto,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          invalidatesTags: ['order-controller'],
        }
      ),
      deleteOrders: build.mutation<DeleteOrdersApiResponse, DeleteOrdersApiArg>(
        {
          query: (queryArg) => ({
            url: `/ordertracking/2024-06-01/orders/bulkremove`,
            method: 'POST',
            body: queryArg.removeCodesDto,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          invalidatesTags: ['order-controller'],
        }
      ),
      getOrderFilters: build.query<
        GetOrderFiltersApiResponse,
        GetOrderFiltersApiArg
      >({
        query: (queryArg) => ({
          url: `/ordertracking/2026-05-05/orders/filters`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        providesTags: ['order-controller'],
      }),
      getOrderCount: build.query<GetOrderCountApiResponse, GetOrderCountApiArg>(
        {
          query: (queryArg) => ({
            url: `/ordertracking/2026-04-07/orders/count`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
            },
            params: {
              fan: queryArg.fan,
              afterTimestamp: queryArg.afterTimestamp,
              afterTimeInterval: queryArg.afterTimeInterval,
            },
          }),
          providesTags: ['order-controller'],
        }
      ),
      getOrder: build.query<GetOrderApiResponse, GetOrderApiArg>({
        query: (queryArg) => ({
          url: `/ordertracking/2024-06-01/orders/${queryArg.orderCode}`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        providesTags: ['order-controller'],
      }),
      getOrderSummary: build.query<
        GetOrderSummaryApiResponse,
        GetOrderSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/ordertracking/2024-06-01/orders/summary`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
          },
        }),
        providesTags: ['order-controller'],
      }),
      softDeleteOrders: build.mutation<
        SoftDeleteOrdersApiResponse,
        SoftDeleteOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/ordertracking/2026-04-21/orders`,
          method: 'DELETE',
          body: queryArg.softDeleteRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['order-controller'],
      }),
      updateVerificationStatus: build.mutation<
        UpdateVerificationStatusApiResponse,
        UpdateVerificationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-06-02/admin/${queryArg.orgId}/verification-status`,
          method: 'PUT',
          body: queryArg.verificationStatusUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      getAutoOnboardingSettings: build.query<
        GetAutoOnboardingSettingsApiResponse,
        GetAutoOnboardingSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-05-19/${queryArg.orgId}/settings/auto-onboarding`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      updateAutoOnboardingSettings: build.mutation<
        UpdateAutoOnboardingSettingsApiResponse,
        UpdateAutoOnboardingSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-05-19/${queryArg.orgId}/settings/auto-onboarding`,
          method: 'PUT',
          body: queryArg.autoOnboardingSettingsUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateFleetV20250114: build.mutation<
        UpdateFleetV20250114ApiResponse,
        UpdateFleetV20250114ApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/${queryArg.organizationId}/fleets/${queryArg.fleetId}`,
          method: 'PUT',
          body: queryArg.fleetUpdateRequestV20250115,
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      updateOrganizationV20241204: build.mutation<
        UpdateOrganizationV20241204ApiResponse,
        UpdateOrganizationV20241204ApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2024-12-04/${queryArg.orgId}`,
          method: 'PUT',
          body: queryArg.organizationUpdateRequestV20241204,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateOrganizationV20230717: build.mutation<
        UpdateOrganizationV20230717ApiResponse,
        UpdateOrganizationV20230717ApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2023-07-17/${queryArg.orgId}`,
          method: 'PUT',
          body: queryArg.organizationUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      updateFleetsByOrganizationIdAndFleetId: build.mutation<
        UpdateFleetsByOrganizationIdAndFleetIdApiResponse,
        UpdateFleetsByOrganizationIdAndFleetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.orgId}/fleets/${queryArg.fleetId}`,
          method: 'PUT',
          body: queryArg.fleetUpdateRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      lookupEnrollment: build.mutation<
        LookupEnrollmentApiResponse,
        LookupEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-05-19/enrollment/lookup`,
          method: 'POST',
          body: queryArg.enrollmentUnifiedLookupRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      syncOviBusinessAccount: build.mutation<
        SyncOviBusinessAccountApiResponse,
        SyncOviBusinessAccountApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-05-05/migration/ovi/accounts/${queryArg.accountId}`,
          method: 'POST',
          body: queryArg.syncOviBusinessAccountRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-controller'],
      }),
      getOrganizationsInfoV20260120: build.mutation<
        GetOrganizationsInfoV20260120ApiResponse,
        GetOrganizationsInfoV20260120ApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2026-01-13/view`,
          method: 'POST',
          body: queryArg.organizationViewRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      lookupOrganizationByInfo: build.mutation<
        LookupOrganizationByInfoApiResponse,
        LookupOrganizationByInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-07-15/lookup`,
          method: 'POST',
          body: queryArg.organizationLookupRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      lookupOrganizationByRawAddressInfo: build.mutation<
        LookupOrganizationByRawAddressInfoApiResponse,
        LookupOrganizationByRawAddressInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-07-15/lookup-raw-address`,
          method: 'POST',
          body: queryArg.organizationLookupRequestRawAddress,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollAutomatic: build.mutation<
        EnrollAutomaticApiResponse,
        EnrollAutomaticApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-07-15/enroll`,
          method: 'POST',
          body: queryArg.odiMatchConfirmation,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollForReview: build.mutation<
        EnrollForReviewApiResponse,
        EnrollForReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-07-15/enroll-no-match`,
          method: 'POST',
          body: queryArg.enrollNoMatchRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      acceptTerms: build.mutation<AcceptTermsApiResponse, AcceptTermsApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2025-02-11/${queryArg.orgId}/terms`,
          method: 'POST',
          body: queryArg.termsRequestV20250211,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      enrollAsCustomer: build.mutation<
        EnrollAsCustomerApiResponse,
        EnrollAsCustomerApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/enroll`,
          method: 'POST',
          body: queryArg.enrollmentRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      declineEnrollment: build.mutation<
        DeclineEnrollmentApiResponse,
        DeclineEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/admin/enrollments/${queryArg.id}/decline`,
          method: 'POST',
          body: queryArg.enrollmentDeclineRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      approveEnrollment: build.mutation<
        ApproveEnrollmentApiResponse,
        ApproveEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/admin/enrollments/${queryArg.id}/approve`,
          method: 'POST',
          params: {
            skipAdminCreation: queryArg.skipAdminCreation,
          },
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      enrollAsAdmin: build.mutation<
        EnrollAsAdminApiResponse,
        EnrollAsAdminApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/admin/enroll`,
          method: 'POST',
          body: queryArg.adminEnrollmentRequest,
        }),
        invalidatesTags: ['enrollment-controller'],
      }),
      updateOrgDefaultFleet: build.mutation<
        UpdateOrgDefaultFleetApiResponse,
        UpdateOrgDefaultFleetApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2024-12-17/${queryArg.id}/defaultFleet`,
          method: 'POST',
          body: queryArg.updateDefaultFleetRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      createFleet: build.mutation<CreateFleetApiResponse, CreateFleetApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2024-09-26/${queryArg.organizationId}/fleets`,
          method: 'POST',
          body: queryArg.fleetCreateRequestV20240926,
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      checkIfFleetConfigHasChanged: build.mutation<
        CheckIfFleetConfigHasChangedApiResponse,
        CheckIfFleetConfigHasChangedApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}/configs`,
          method: 'POST',
          body: queryArg.configChangeCheckRequest,
          params: {
            action: queryArg.action,
          },
        }),
        invalidatesTags: ['fleets-v-2-controller'],
      }),
      getOrganizationsInfo: build.mutation<
        GetOrganizationsInfoApiResponse,
        GetOrganizationsInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/view`,
          method: 'POST',
          body: queryArg.organizationViewRequest,
        }),
        invalidatesTags: ['organization-v-2-controller'],
      }),
      getOrganizationFanDetails: build.query<
        GetOrganizationFanDetailsApiResponse,
        GetOrganizationFanDetailsApiArg
      >({
        query: () => ({ url: `/organizations/2026-04-21/fans` }),
        providesTags: ['organization-v-2-controller'],
      }),
      checkEnrollmentInvite: build.query<
        CheckEnrollmentInviteApiResponse,
        CheckEnrollmentInviteApiArg
      >({
        query: () => ({ url: `/organizations/2025-12-16/enrollment-invite` }),
        providesTags: ['enrollment-controller'],
      }),
      getOrganizationByOrgId: build.query<
        GetOrganizationByOrgIdApiResponse,
        GetOrganizationByOrgIdApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2025-01-14/${queryArg.orgId}`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllFleets: build.query<GetAllFleetsApiResponse, GetAllFleetsApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2024-12-17/${queryArg.organizationId}/fleets`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            size: queryArg.size,
            fleetName: queryArg.fleetName,
          },
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getFleetById: build.query<GetFleetByIdApiResponse, GetFleetByIdApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2024-12-17/${queryArg.organizationId}/fleets/${queryArg.fleetId}`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getAllOrganizations: build.query<
        GetAllOrganizationsApiResponse,
        GetAllOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2024-11-20`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            name: queryArg.name,
            fan: queryArg.fan,
            email: queryArg.email,
            statuses: queryArg.statuses,
            size: queryArg.size,
          },
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrgById: build.query<GetOrgByIdApiResponse, GetOrgByIdApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2024-11-20/${queryArg.id}`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getCapDetails: build.query<GetCapDetailsApiResponse, GetCapDetailsApiArg>(
        {
          query: (queryArg) => ({
            url: `/organizations/2024-10-08/caps`,
            headers: {
              'x-bd-organization': queryArg['x-bd-organization'],
            },
          }),
          providesTags: ['caps-controller'],
        }
      ),
      getDocument: build.query<GetDocumentApiResponse, GetDocumentApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2024-10-08/caps/pdfs/${queryArg.documentId}`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        providesTags: ['caps-controller'],
      }),
      getAllOrganizationsWithType: build.query<
        GetAllOrganizationsWithTypeApiResponse,
        GetAllOrganizationsWithTypeApiArg
      >({
        query: () => ({ url: `/organizations/2023-07-17` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationByIdWithType: build.query<
        GetOrganizationByIdWithTypeApiResponse,
        GetOrganizationByIdWithTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2023-07-17/${queryArg.id}`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getFleetByIdV2: build.query<
        GetFleetByIdV2ApiResponse,
        GetFleetByIdV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2023-05-09/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getAllOrganizations1: build.query<
        GetAllOrganizations1ApiResponse,
        GetAllOrganizations1ApiArg
      >({
        query: () => ({ url: `/organizations/2021-11-15` }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllHubs: build.query<GetAllHubsApiResponse, GetAllHubsApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getHubById: build.query<GetHubByIdApiResponse, GetHubByIdApiArg>({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getAllFleets1: build.query<GetAllFleets1ApiResponse, GetAllFleets1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets`,
          }),
          providesTags: ['fleets-v-2-controller'],
        }
      ),
      getFleetById1: build.query<GetFleetById1ApiResponse, GetFleetById1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}`,
          }),
          providesTags: ['fleets-v-2-controller'],
        }
      ),
      getFleetChildren: build.query<
        GetFleetChildrenApiResponse,
        GetFleetChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/fleets/${queryArg.fleetId}/children`,
        }),
        providesTags: ['fleets-v-2-controller'],
      }),
      getHubChildren: build.query<
        GetHubChildrenApiResponse,
        GetHubChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.organizationId}/hubs/${queryArg.hubId}/children`,
        }),
        providesTags: ['hubs-v-2-controller'],
      }),
      getOrganizationChildren: build.query<
        GetOrganizationChildrenApiResponse,
        GetOrganizationChildrenApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.orgId}/children`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationById: build.query<
        GetOrganizationByIdApiResponse,
        GetOrganizationByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.id}`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getOrganizationStatsById: build.query<
        GetOrganizationStatsByIdApiResponse,
        GetOrganizationStatsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.id}/stats`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getAllFleetsByOrganizationId: build.query<
        GetAllFleetsByOrganizationIdApiResponse,
        GetAllFleetsByOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/organizations/2021-11-15/${queryArg.id}/fleets`,
        }),
        providesTags: ['organization-v-2-controller'],
      }),
      getTopLevelOrganizations: build.query<
        GetTopLevelOrganizationsApiResponse,
        GetTopLevelOrganizationsApiArg
      >({
        query: () => ({ url: `/organizations/2021-11-15/tenants` }),
        providesTags: ['organization-v-2-controller'],
      }),
      processSurfsightOrderUpdateWebhook: build.mutation<
        ProcessSurfsightOrderUpdateWebhookApiResponse,
        ProcessSurfsightOrderUpdateWebhookApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/webhooks/2026-06-16/surfsight/order-updates`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['peripheral-webhook-controller'],
      }),
      processSurfsightWebhookPayload: build.mutation<
        ProcessSurfsightWebhookPayloadApiResponse,
        ProcessSurfsightWebhookPayloadApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/webhooks/2025-03-26/surfsight`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'X-Surfsight-Signature': queryArg['X-Surfsight-Signature'],
          },
        }),
        invalidatesTags: ['peripheral-webhook-controller'],
      }),
      fetchRecordingAvailability: build.mutation<
        FetchRecordingAvailabilityApiResponse,
        FetchRecordingAvailabilityApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/recording-availability/2026-05-05/${queryArg.peripheralId}/refresh`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['recording-availability-controller'],
      }),
      retryClip: build.mutation<RetryClipApiResponse, RetryClipApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/clips/2026-05-05/${queryArg.clipId}/retry`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['clips-controller'],
      }),
      getClips: build.query<GetClipsApiResponse, GetClipsApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/clips/2026-04-07`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            searchKeyword: queryArg.searchKeyword,
            startDateTime: queryArg.startDateTime,
            endDateTime: queryArg.endDateTime,
            timeWindowField: queryArg.timeWindowField,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
          },
        }),
        providesTags: ['clips-controller'],
      }),
      createClip: build.mutation<CreateClipApiResponse, CreateClipApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/clips/2026-04-07`,
          method: 'POST',
          body: queryArg.createClipRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['clips-controller'],
      }),
      retryActivatePeripherals: build.mutation<
        RetryActivatePeripheralsApiResponse,
        RetryActivatePeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-06-30/retry-activate`,
          method: 'POST',
          body: queryArg.activatePeripheralsRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      exportPeripherals: build.mutation<
        ExportPeripheralsApiResponse,
        ExportPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-06-30/export`,
          method: 'POST',
          body: queryArg.exportPeripheralsRequestDto,
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      processOrderUpdate: build.mutation<
        ProcessOrderUpdateApiResponse,
        ProcessOrderUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-06-30/admin/order-updates`,
          method: 'POST',
          body: queryArg.jsonNode,
          params: {
            vendor: queryArg.vendor,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      cleanPeripheral: build.mutation<
        CleanPeripheralApiResponse,
        CleanPeripheralApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-06-30/admin/clean-peripheral`,
          method: 'POST',
          body: queryArg.cleanPeripheralAdminRequest,
        }),
        invalidatesTags: ['admin-controller'],
      }),
      processPlugEvent: build.mutation<
        ProcessPlugEventApiResponse,
        ProcessPlugEventApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-06-30/admin/adapter-plug-events`,
          method: 'POST',
          body: queryArg.adapterPlugEventAdminRequest,
        }),
        invalidatesTags: ['admin-controller'],
      }),
      activatePeripherals: build.mutation<
        ActivatePeripheralsApiResponse,
        ActivatePeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-02-24/activate`,
          method: 'POST',
          body: queryArg.activatePeripheralsRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      getPeripheralsByVins: build.mutation<
        GetPeripheralsByVinsApiResponse,
        GetPeripheralsByVinsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2025-12-16/search`,
          method: 'POST',
          body: queryArg.getPeripheralsByVinsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            type: queryArg['type'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      transferPeripherals: build.mutation<
        TransferPeripheralsApiResponse,
        TransferPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2025-09-09/organization-transfer`,
          method: 'POST',
          body: queryArg.organizationTransferRequest,
        }),
        invalidatesTags: ['boarding-controller'],
      }),
      unlinkVehicle: build.mutation<
        UnlinkVehicleApiResponse,
        UnlinkVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2024-11-06/${queryArg.id}/unlink-vehicle`,
          method: 'POST',
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      moveFleet: build.mutation<MoveFleetApiResponse, MoveFleetApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/2024-11-06/move-fleet`,
          method: 'POST',
          body: queryArg.moveFleetRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      linkToVehicle: build.mutation<
        LinkToVehicleApiResponse,
        LinkToVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2024-10-23/${queryArg.id}/link-vehicle`,
          method: 'POST',
          body: queryArg.linkToVehicleRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['peripheral-controller'],
      }),
      batchOnboardPeripherals: build.mutation<
        BatchOnboardPeripheralsApiResponse,
        BatchOnboardPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2024-10-08/onboard`,
          method: 'POST',
          body: queryArg.body,
          params: {
            organizationId: queryArg.organizationId,
            type: queryArg['type'],
          },
        }),
        invalidatesTags: ['boarding-controller'],
      }),
      updateSettings: build.mutation<
        UpdateSettingsApiResponse,
        UpdateSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/2025-03-12/settings`,
          method: 'PATCH',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['fleet-camera-peripheral-controller'],
      }),
      getAccessToken: build.query<
        GetAccessTokenApiResponse,
        GetAccessTokenApiArg
      >({
        query: () => ({
          url: `/peripherals/netradyne/access-token/2025-02-12-BETA`,
        }),
        providesTags: ['netradyne-controller'],
      }),
      getRecordingsByMonth: build.query<
        GetRecordingsByMonthApiResponse,
        GetRecordingsByMonthApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/recording-availability/2026-04-21/${queryArg.peripheralId}/by-month/${queryArg.yearMonth}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezoneOffset: queryArg.timezoneOffset,
          },
        }),
        providesTags: ['recording-availability-controller'],
      }),
      getRecordingsByDate: build.query<
        GetRecordingsByDateApiResponse,
        GetRecordingsByDateApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/recording-availability/2026-04-21/${queryArg.peripheralId}/by-date/${queryArg.localDate}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezoneOffset: queryArg.timezoneOffset,
          },
        }),
        providesTags: ['recording-availability-controller'],
      }),
      getMediaInternal: build.query<
        GetMediaInternalApiResponse,
        GetMediaInternalApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/events/${queryArg.eventId}/2025-07-02/media`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            mediaType: queryArg.mediaType,
            cameraPosition: queryArg.cameraPosition,
          },
        }),
        providesTags: ['fleet-camera-peripheral-controller'],
      }),
      getMedia: build.query<GetMediaApiResponse, GetMediaApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/events/${queryArg.eventId}/2025-03-26/media`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            mediaType: queryArg.mediaType,
            cameraPosition: queryArg.cameraPosition,
          },
        }),
        providesTags: ['fleet-camera-peripheral-controller'],
      }),
      getClipDetails: build.query<
        GetClipDetailsApiResponse,
        GetClipDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/clips/2026-04-07/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['clips-controller'],
      }),
      getCameraAssignments: build.query<
        GetCameraAssignmentsApiResponse,
        GetCameraAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/2026-04-07/assignments`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            searchKeyword: queryArg.searchKeyword,
          },
        }),
        providesTags: ['fleet-camera-peripheral-controller'],
      }),
      getSettings: build.query<GetSettingsApiResponse, GetSettingsApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/2025-03-26/settings`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['fleet-camera-peripheral-controller'],
      }),
      getPeripheralStatusCounts: build.query<
        GetPeripheralStatusCountsApiResponse,
        GetPeripheralStatusCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-05-19/status-counts`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            type: queryArg['type'],
            fleetIds: queryArg.fleetIds,
          },
        }),
        providesTags: ['peripheral-controller'],
      }),
      getOrderById: build.query<GetOrderByIdApiResponse, GetOrderByIdApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/2026-05-05/orders/${queryArg.orderId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['order-controller'],
      }),
      getAdapterSupportedFeatures: build.query<
        GetAdapterSupportedFeaturesApiResponse,
        GetAdapterSupportedFeaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-05-05/adapter-supported-features/${queryArg.vin}`,
        }),
        providesTags: ['peripheral-controller'],
      }),
      getPeripheralById: build.query<
        GetPeripheralByIdApiResponse,
        GetPeripheralByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2026-04-21/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['peripheral-controller'],
      }),
      getPeripherals: build.query<
        GetPeripheralsApiResponse,
        GetPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2024-10-08`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            serialNumber: queryArg.serialNumber,
            imei: queryArg.imei,
            type: queryArg['type'],
            make: queryArg.make,
            model: queryArg.model,
            vin: queryArg.vin,
            hasAttachedVIN: queryArg.hasAttachedVin,
            isPrePaid: queryArg.isPrePaid,
            status: queryArg.status,
            licensePlate: queryArg.licensePlate,
            attachedVehicleName: queryArg.attachedVehicleName,
            lastCommunicatedDateStart: queryArg.lastCommunicatedDateStart,
            lastCommunicatedDateEnd: queryArg.lastCommunicatedDateEnd,
            firmware: queryArg.firmware,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            size: queryArg.size,
          },
        }),
        providesTags: ['peripheral-controller'],
      }),
      getBatchEntity: build.query<
        GetBatchEntityApiResponse,
        GetBatchEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/peripherals/2024-10-08/batch-statuses/${queryArg.id}`,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        providesTags: ['boarding-controller'],
      }),
      deleteClip: build.mutation<DeleteClipApiResponse, DeleteClipApiArg>({
        query: (queryArg) => ({
          url: `/peripherals/fleet-cameras/clips/2026-05-05/${queryArg.clipId}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['clips-controller'],
      }),
      updateReportMetadata: build.mutation<
        UpdateReportMetadataApiResponse,
        UpdateReportMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/2025-10-21/metadata/${queryArg.reportId}`,
          method: 'PUT',
          body: queryArg.reportMetadataRequestBodyDto,
        }),
        invalidatesTags: ['reports-controller'],
      }),
      createOrUpdateUserReportFilters: build.mutation<
        CreateOrUpdateUserReportFiltersApiResponse,
        CreateOrUpdateUserReportFiltersApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/2025-12-16/user-filters/save`,
          method: 'POST',
          body: queryArg.userDefinedFilterDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['user-report-filters-controller'],
      }),
      exportReport: build.mutation<ExportReportApiResponse, ExportReportApiArg>(
        {
          query: (queryArg) => ({
            url: `/reports/2025-10-21/${queryArg.reportType}/export`,
            method: 'POST',
            body: queryArg.reportExportRequestBodyDto,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
            },
          }),
          invalidatesTags: ['reports-controller'],
        }
      ),
      exportReportCsv: build.mutation<
        ExportReportCsvApiResponse,
        ExportReportCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/2025-10-21/${queryArg.reportType}/export-csv`,
          method: 'POST',
          body: queryArg.reportExportRequestBodyDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['reports-controller'],
      }),
      createReportMetadata: build.mutation<
        CreateReportMetadataApiResponse,
        CreateReportMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/2025-10-21/metadata`,
          method: 'POST',
          body: queryArg.reportMetadataRequestBodyDto,
        }),
        invalidatesTags: ['reports-controller'],
      }),
      getFilterData: build.query<GetFilterDataApiResponse, GetFilterDataApiArg>(
        {
          query: (queryArg) => ({
            url: `/reports/2025-12-16/user-filters/${queryArg.userId}`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
            },
          }),
          providesTags: ['user-report-filters-controller'],
        }
      ),
      getReports: build.query<GetReportsApiResponse, GetReportsApiArg>({
        query: (queryArg) => ({
          url: `/reports/2025-10-21/report-types`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['reports-controller'],
      }),
      adminExportReportCsv: build.mutation<
        AdminExportReportCsvApiResponse,
        AdminExportReportCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/2026-02-24/${queryArg.reportType}/export-csv`,
          method: 'POST',
          body: queryArg.reportExportRequestBodyDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['reports-controller'],
      }),
      updateRule: build.mutation<UpdateRuleApiResponse, UpdateRuleApiArg>({
        query: (queryArg) => ({
          url: `/rules/2025-10-07`,
          method: 'PUT',
          body: queryArg.updateRuleRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['rules-controller'],
      }),
      createRule: build.mutation<CreateRuleApiResponse, CreateRuleApiArg>({
        query: (queryArg) => ({
          url: `/rules/2025-10-07`,
          method: 'POST',
          body: queryArg.createRuleRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['rules-controller'],
      }),
      listOviAlertRules: build.query<
        ListOviAlertRulesApiResponse,
        ListOviAlertRulesApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2026-08-25/migration/ovi/alertRules`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviAlertRuleId: queryArg.oviAlertRuleId,
            ruleId: queryArg.ruleId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncAlertRules: build.mutation<
        SyncAlertRulesApiResponse,
        SyncAlertRulesApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2026-08-25/migration/ovi/alertRules`,
          method: 'POST',
          body: queryArg.syncOviAlertRulesRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      validateAlertRules: build.mutation<
        ValidateAlertRulesApiResponse,
        ValidateAlertRulesApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2026-08-25/migration/ovi/alertRules/validate`,
          method: 'POST',
          body: queryArg.validateOviAlertRulesRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      getRuleListByCategoryAndEvent: build.query<
        GetRuleListByCategoryAndEventApiResponse,
        GetRuleListByCategoryAndEventApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2026-02-10/list`,
          method: 'POST',
          body: queryArg.ruleFilterRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['rules-controller'],
      }),
      getRulesByIds: build.mutation<
        GetRulesByIdsApiResponse,
        GetRulesByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2025-10-07/list`,
          method: 'POST',
          body: queryArg.getRulesRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['rules-controller'],
      }),
      getUnassignedRules: build.mutation<
        GetUnassignedRulesApiResponse,
        GetUnassignedRulesApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2025-10-07/listWithGeofenceCount`,
          method: 'POST',
          body: queryArg.getListWithGeofenceCountRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            assignedFleetId: queryArg.assignedFleetId,
            excludeOrgWideRules: queryArg.excludeOrgWideRules,
          },
        }),
        invalidatesTags: ['rules-controller'],
      }),
      getRulesWithSubscriptions: build.query<
        GetRulesWithSubscriptionsApiResponse,
        GetRulesWithSubscriptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/rules/2025-10-07/listWithSubscriptions`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            category: queryArg.category,
          },
        }),
        providesTags: ['rules-controller'],
      }),
      deleteRule: build.mutation<DeleteRuleApiResponse, DeleteRuleApiArg>({
        query: (queryArg) => ({
          url: `/rules/2025-10-07/${queryArg.ruleId}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['rules-controller'],
      }),
      retrieveSafetyEventsByTripIds: build.mutation<
        RetrieveSafetyEventsByTripIdsApiResponse,
        RetrieveSafetyEventsByTripIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-03-24/events/trips`,
          method: 'POST',
          body: queryArg.safetyTripEventsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['safety-center-controller-v-2'],
      }),
      getVehicleSettings: build.query<
        GetVehicleSettingsApiResponse,
        GetVehicleSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/vehicles/2026-01-27/settings`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['event-settings-controller'],
      }),
      updateVehicleSettings: build.mutation<
        UpdateVehicleSettingsApiResponse,
        UpdateVehicleSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/vehicles/2026-01-27/settings`,
          method: 'PATCH',
          body: queryArg.eventSettingsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['event-settings-controller'],
      }),
      retrieveEmergencyEventSummary: build.query<
        RetrieveEmergencyEventSummaryApiResponse,
        RetrieveEmergencyEventSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-08-25/events/emer-summary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventsV2: build.query<
        RetrieveSafetyEventsV2ApiResponse,
        RetrieveSafetyEventsV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-03-24/events`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            driverId: queryArg.driverId,
            searchKeyword: queryArg.searchKeyword,
            hasMedia: queryArg.hasMedia,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventDetailsById: build.query<
        RetrieveSafetyEventDetailsByIdApiResponse,
        RetrieveSafetyEventDetailsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-03-24/events/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      retrieveSafetyEventsForSelfV2: build.query<
        RetrieveSafetyEventsForSelfV2ApiResponse,
        RetrieveSafetyEventsForSelfV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-03-24/events/me`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            searchKeyword: queryArg.searchKeyword,
            hasMedia: queryArg.hasMedia,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller-v-2'],
      }),
      getDriverScoreDetailsForSelf: build.query<
        GetDriverScoreDetailsForSelfApiResponse,
        GetDriverScoreDetailsForSelfApiArg
      >({
        query: () => ({ url: `/safety/2026-03-10/driver-scores/me` }),
        providesTags: ['driver-score-controller'],
      }),
      getVehicleScores: build.query<
        GetVehicleScoresApiResponse,
        GetVehicleScoresApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-02-24/vehicle-scores`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            vinSearch: queryArg.vinSearch,
            minScore: queryArg.minScore,
            maxScore: queryArg.maxScore,
            excludeNoScore: queryArg.excludeNoScore,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getDriverScoresSummary: build.query<
        GetDriverScoresSummaryApiResponse,
        GetDriverScoresSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2026-02-24/driver-scores-summary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getScore: build.query<GetScoreApiResponse, GetScoreApiArg>({
        query: (queryArg) => ({
          url: `/safety/2025-11-18/fleet-performances`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['fleet-score-controller'],
      }),
      getDriverScores: build.query<
        GetDriverScoresApiResponse,
        GetDriverScoresApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2025-11-04/driver-scores`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            driverNameSearch: queryArg.driverNameSearch,
            minScore: queryArg.minScore,
            maxScore: queryArg.maxScore,
            minRank: queryArg.minRank,
            maxRank: queryArg.maxRank,
            excludeNoScore: queryArg.excludeNoScore,
            sortOrder: queryArg.sortOrder,
            sortBy: queryArg.sortBy,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      getDriverScoreDetails: build.query<
        GetDriverScoreDetailsApiResponse,
        GetDriverScoreDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/safety/2025-11-04/driver-scores/${queryArg.driverScoreId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-score-controller'],
      }),
      processTrips: build.query<ProcessTripsApiResponse, ProcessTripsApiArg>({
        query: (queryArg) => ({
          url: `/trips/2025-04-08/routes`,
          method: 'POST',
          body: queryArg.tripRoutesRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['trips-controller'],
      }),
      getTripEvents: build.query<GetTripEventsApiResponse, GetTripEventsApiArg>(
        {
          query: (queryArg) => ({
            url: `/trips/2025-04-08/events`,
            method: 'POST',
            body: queryArg.tripEventsRequestDto,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
            },
          }),
          providesTags: ['trips-controller'],
        }
      ),
      getRawSafetyEventDetails: build.query<
        GetRawSafetyEventDetailsApiResponse,
        GetRawSafetyEventDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/2025-12-02/${queryArg.tripId}/safety-center/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller'],
      }),
      getRawSafetyEvents: build.query<
        GetRawSafetyEventsApiResponse,
        GetRawSafetyEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/2025-12-02/safety-center`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            driverId: queryArg.driverId,
            searchKeyword: queryArg.searchKeyword,
            hasMedia: queryArg.hasMedia,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller'],
      }),
      getSafetyEventDetails: build.query<
        GetSafetyEventDetailsApiResponse,
        GetSafetyEventDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/2025-10-07/${queryArg.tripId}/safety-center/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['safety-center-controller'],
      }),
      getSafetyEvents: build.query<
        GetSafetyEventsApiResponse,
        GetSafetyEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/2025-10-07/safety-center`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            startEventDateTime: queryArg.startEventDateTime,
            endEventDateTime: queryArg.endEventDateTime,
            eventTypes: queryArg.eventTypes,
            driverId: queryArg.driverId,
            searchKeyword: queryArg.searchKeyword,
            size: queryArg.size,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['safety-center-controller'],
      }),
      getTripSummaries: build.query<
        GetTripSummariesApiResponse,
        GetTripSummariesApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/2025-04-08/summaries`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            vin: queryArg.vin,
            tripsStartedAfter: queryArg.tripsStartedAfter,
            tripsStartedBefore: queryArg.tripsStartedBefore,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['trips-controller'],
      }),
      revokeTrustedDevice: build.mutation<
        RevokeTrustedDeviceApiResponse,
        RevokeTrustedDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/users/devices/2025-03-25/${queryArg.id}`,
          method: 'PUT',
        }),
        invalidatesTags: ['trusted-devices-controller'],
      }),
      updateOrgLevelAppIdentity: build.mutation<
        UpdateOrgLevelAppIdentityApiResponse,
        UpdateOrgLevelAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-11-18/organizations/${queryArg.organizationId}/apps/${queryArg.profileId}`,
          method: 'PUT',
          body: queryArg.orgAppUpdateRequest,
        }),
        invalidatesTags: ['org-app-identity-controller'],
      }),
      updateAppIdentity: build.mutation<
        UpdateAppIdentityApiResponse,
        UpdateAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-11-04/apps/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.appUpdateRequest,
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      deleteAppIdentity: build.mutation<
        DeleteAppIdentityApiResponse,
        DeleteAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-11-04/apps/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      updateProfileCustomPermissions: build.mutation<
        UpdateProfileCustomPermissionsApiResponse,
        UpdateProfileCustomPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2023-10-10/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.profileUpdateRequestV20231010,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      resetAppSecret: build.mutation<
        ResetAppSecretApiResponse,
        ResetAppSecretApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2023-03-14/apps/${queryArg.id}/secrets/${queryArg.secretType}`,
          method: 'PUT',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      getProfileById: build.query<
        GetProfileByIdApiResponse,
        GetProfileByIdApiArg
      >({
        query: (queryArg) => ({ url: `/users/2021-11-15/${queryArg.id}` }),
        providesTags: ['profile-v-1-controller'],
      }),
      updateUserProfileV1: build.mutation<
        UpdateUserProfileV1ApiResponse,
        UpdateUserProfileV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2021-11-15/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.profileUpdateJson,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      updateMyLegalDocs: build.mutation<
        UpdateMyLegalDocsApiResponse,
        UpdateMyLegalDocsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2021-11-15/me/terms-and-conditions`,
          method: 'PUT',
          body: queryArg.legalRequestJson,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      updateIdentityIdByUserCode: build.mutation<
        UpdateIdentityIdByUserCodeApiResponse,
        UpdateIdentityIdByUserCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2021-11-15/devicecodes/${queryArg.userCode}`,
          method: 'PUT',
        }),
        invalidatesTags: ['codes-controller'],
      }),
      checkTenantAssociation: build.mutation<
        CheckTenantAssociationApiResponse,
        CheckTenantAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/users/sso/2024-07-18/validateDomain`,
          method: 'POST',
          body: queryArg.tenantUserCheck,
        }),
        invalidatesTags: ['sso-controller'],
      }),
      verifyOtp: build.mutation<VerifyOtpApiResponse, VerifyOtpApiArg>({
        query: (queryArg) => ({
          url: `/users/otp/2025-03-25/verify`,
          method: 'POST',
          body: queryArg.otpVerifyRequest,
        }),
        invalidatesTags: ['otp-controller'],
      }),
      sendOtp: build.mutation<SendOtpApiResponse, SendOtpApiArg>({
        query: () => ({ url: `/users/otp/2025-03-25/send`, method: 'POST' }),
        invalidatesTags: ['otp-controller'],
      }),
      verifyMfa: build.mutation<VerifyMfaApiResponse, VerifyMfaApiArg>({
        query: (queryArg) => ({
          url: `/users/mfa/2025-03-25/verify`,
          method: 'POST',
          body: queryArg.mfaRequest,
        }),
        invalidatesTags: ['mfa-controller'],
      }),
      offboardOrganizationUsers: build.mutation<
        OffboardOrganizationUsersApiResponse,
        OffboardOrganizationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-08-11/organizations/${queryArg.organizationId}/offboard`,
          method: 'POST',
          headers: {
            'cs-idempotency-key': queryArg['cs-idempotency-key'],
          },
        }),
        invalidatesTags: ['organization-offboard-controller'],
      }),
      showGettingStarted: build.mutation<
        ShowGettingStartedApiResponse,
        ShowGettingStartedApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-07-28/${queryArg.profileId}/start/show`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      dismissGettingStarted: build.mutation<
        DismissGettingStartedApiResponse,
        DismissGettingStartedApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-07-28/${queryArg.profileId}/start/dismiss`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      markAppSpaceViewed: build.mutation<
        MarkAppSpaceViewedApiResponse,
        MarkAppSpaceViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-07-28/${queryArg.profileId}/spaces/${queryArg.space}/viewed`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      validateOviVehicleSchedules: build.mutation<
        ValidateOviVehicleSchedulesApiResponse,
        ValidateOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-07-14/migration/ovi/vehicleSchedules/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviVehicleSchedulesRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      validateOviPersons: build.mutation<
        ValidateOviPersonsApiResponse,
        ValidateOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-30/migration/ovi/persons/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviPersonsRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      activateOviPersons: build.mutation<
        ActivateOviPersonsApiResponse,
        ActivateOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-16/migration/ovi/persons/activate`,
          method: 'POST',
          body: queryArg.activateUsersRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      listOviVehicleSchedules: build.query<
        ListOviVehicleSchedulesApiResponse,
        ListOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-02/migration/ovi/vehicleSchedules`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviVehicleId: queryArg.oviVehicleId,
            oviPersonId: queryArg.oviPersonId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            assetId: queryArg.assetId,
            driverId: queryArg.driverId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncOviVehicleSchedules: build.mutation<
        SyncOviVehicleSchedulesApiResponse,
        SyncOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-02/migration/ovi/vehicleSchedules`,
          method: 'POST',
          body: queryArg.syncOviVehicleSchedulesRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      listOviPersons: build.query<
        ListOviPersonsApiResponse,
        ListOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-02/migration/ovi/persons`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviPersonId: queryArg.oviPersonId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            userId: queryArg.userId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncOviPersons: build.mutation<
        SyncOviPersonsApiResponse,
        SyncOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-06-02/migration/ovi/persons`,
          method: 'POST',
          body: queryArg.syncOviPersonsRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      bulkGetDrivers: build.mutation<
        BulkGetDriversApiResponse,
        BulkGetDriversApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-02-10/drivers/bulk-get`,
          method: 'POST',
          body: queryArg.bulkGetDriversRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      createProfileCustomPermissions: build.mutation<
        CreateProfileCustomPermissionsApiResponse,
        CreateProfileCustomPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-11-18/organizations/apps`,
          method: 'POST',
          body: queryArg.orgAppCreateRequest,
        }),
        invalidatesTags: ['org-app-identity-controller'],
      }),
      assignVehicle: build.mutation<
        AssignVehicleApiResponse,
        AssignVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-07-15/drivers/${queryArg.driverId}/assign-vehicle`,
          method: 'POST',
          body: queryArg.driverVehicleAssignmentRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      unassignVehicles: build.mutation<
        UnassignVehiclesApiResponse,
        UnassignVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-07-15/drivers/bulk-unassign-vehicles`,
          method: 'POST',
          body: queryArg.driverVehicleBulkUnassignRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      createApp: build.mutation<CreateAppApiResponse, CreateAppApiArg>({
        query: (queryArg) => ({
          url: `/users/2025-07-01/apps`,
          method: 'POST',
          body: queryArg.appCreateRequest,
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      getDriverProfiles: build.query<
        GetDriverProfilesApiResponse,
        GetDriverProfilesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-06-17/drivers`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetIds: queryArg.fleetIds,
            name: queryArg.name,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      createDriverProfile: build.mutation<
        CreateDriverProfileApiResponse,
        CreateDriverProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-06-17/drivers`,
          method: 'POST',
          body: queryArg.driverProfileCreateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      recordLastSignedIn: build.mutation<
        RecordLastSignedInApiResponse,
        RecordLastSignedInApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-01-28/login`,
          method: 'POST',
          body: queryArg.recordLastSignedInRequest,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      createAdministrativeUser: build.mutation<
        CreateAdministrativeUserApiResponse,
        CreateAdministrativeUserApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-01-28/admin`,
          method: 'POST',
          body: queryArg.createAdminUserProfileRequest,
        }),
        invalidatesTags: ['admin-controller'],
      }),
      cancelInvites: build.mutation<
        CancelInvitesApiResponse,
        CancelInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2024-12-17/invites/cancel`,
          method: 'POST',
          body: queryArg.cancelInvitesRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      resendInvites: build.mutation<
        ResendInvitesApiResponse,
        ResendInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2024-11-29/invites/resend`,
          method: 'POST',
          body: queryArg.resendInvitesRequestDto,
          headers: {
            'x-suppress-notification': queryArg['x-suppress-notification'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      acceptInvite: build.mutation<AcceptInviteApiResponse, AcceptInviteApiArg>(
        {
          query: (queryArg) => ({
            url: `/users/2024-11-20/invite/accept`,
            method: 'POST',
            body: queryArg.legalRequest,
          }),
          invalidatesTags: ['invite-controller'],
        }
      ),
      inviteUsers: build.mutation<InviteUsersApiResponse, InviteUsersApiArg>({
        query: (queryArg) => ({
          url: `/users/2024-10-21/invites`,
          method: 'POST',
          body: queryArg.inviteUsersRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-suppress-notification': queryArg['x-suppress-notification'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      enrichToken: build.mutation<EnrichTokenApiResponse, EnrichTokenApiArg>({
        query: (queryArg) => ({
          url: `/users/2024-10-08/enrichForSso`,
          method: 'POST',
          body: queryArg.tokenEnrichForSsoRequest,
        }),
        invalidatesTags: ['token-enrichment-controller'],
      }),
      enrichToken1: build.mutation<EnrichToken1ApiResponse, EnrichToken1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/users/2024-07-31/enrichForCdi`,
            method: 'POST',
            body: queryArg.tokenEnrichForCdiRequest,
          }),
          invalidatesTags: ['token-enrichment-controller'],
        }
      ),
      resetAllAppSecrets: build.mutation<
        ResetAllAppSecretsApiResponse,
        ResetAllAppSecretsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2023-03-14/apps/${queryArg.id}/secrets`,
          method: 'POST',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      generateDeviceCode: build.mutation<
        GenerateDeviceCodeApiResponse,
        GenerateDeviceCodeApiArg
      >({
        query: () => ({ url: `/users/2021-11-15/devicecodes`, method: 'POST' }),
        invalidatesTags: ['codes-controller'],
      }),
      getIdentityIdByDeviceCode: build.mutation<
        GetIdentityIdByDeviceCodeApiResponse,
        GetIdentityIdByDeviceCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2021-11-15/devicecodes/identityId`,
          method: 'POST',
          body: queryArg.retrieveIdentityIdRequest,
        }),
        invalidatesTags: ['codes-controller'],
      }),
      getDriverProfileById: build.query<
        GetDriverProfileByIdApiResponse,
        GetDriverProfileByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-06-17/drivers/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      updateDriverProfile: build.mutation<
        UpdateDriverProfileApiResponse,
        UpdateDriverProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-06-17/drivers/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.driverProfileUpdateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      listTrustedDevices: build.query<
        ListTrustedDevicesApiResponse,
        ListTrustedDevicesApiArg
      >({
        query: () => ({ url: `/users/devices/2025-03-25` }),
        providesTags: ['trusted-devices-controller'],
      }),
      getOffboardStatus: build.query<
        GetOffboardStatusApiResponse,
        GetOffboardStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-08-11/organizations/${queryArg.organizationId}/offboard/${queryArg.jobId}`,
        }),
        providesTags: ['organization-offboard-controller'],
      }),
      retrieveResourceCounts: build.query<
        RetrieveResourceCountsApiResponse,
        RetrieveResourceCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2026-07-28/${queryArg.profileId}/resources/count`,
          params: {
            fleetId: queryArg.fleetId,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      getCustomPermissions: build.query<
        GetCustomPermissionsApiResponse,
        GetCustomPermissionsApiArg
      >({
        query: () => ({ url: `/users/2026-02-24/apps/customPermissions` }),
        providesTags: ['app-identity-controller'],
      }),
      getAppIdentities: build.query<
        GetAppIdentitiesApiResponse,
        GetAppIdentitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-10-07/apps`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            email: queryArg.email,
            clientId: queryArg.clientId,
          },
        }),
        providesTags: ['app-identity-controller'],
      }),
      findDriversByVins: build.query<
        FindDriversByVinsApiResponse,
        FindDriversByVinsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-06-17/drivers/byVins`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            vins: queryArg.vins,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      searchUserProfiles: build.query<
        SearchUserProfilesApiResponse,
        SearchUserProfilesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-02-11`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetIds: queryArg.fleetIds,
            statuses: queryArg.statuses,
            roles: queryArg.roles,
            inviteStatuses: queryArg.inviteStatuses,
            name: queryArg.name,
            email: queryArg.email,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findProfilesByOrgIdAndEmail: build.query<
        FindProfilesByOrgIdAndEmailApiResponse,
        FindProfilesByOrgIdAndEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-01-14`,
          params: {
            organizationId: queryArg.organizationId,
            email: queryArg.email,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      getCdiUserProfile: build.query<
        GetCdiUserProfileApiResponse,
        GetCdiUserProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2024-09-30/cdi/${queryArg.cdiProfileId}`,
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findAllProfilesBeta: build.query<
        FindAllProfilesBetaApiResponse,
        FindAllProfilesBetaApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2023-09-25-BETA`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            filters: queryArg.filters,
            size: queryArg.size,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findAllProfilesBy: build.query<
        FindAllProfilesByApiResponse,
        FindAllProfilesByApiArg
      >({
        query: () => ({ url: `/users/2021-11-15` }),
        providesTags: ['profile-v-1-controller'],
      }),
      getContactInfo: build.query<
        GetContactInfoApiResponse,
        GetContactInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2021-11-15/${queryArg.id}/contactInfo`,
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      getUsers20211115Me: build.query<
        GetUsers20211115MeApiResponse,
        GetUsers20211115MeApiArg
      >({
        query: () => ({ url: `/users/2021-11-15/me` }),
        providesTags: ['Profile'],
      }),
      deleteAdministrativeUser: build.mutation<
        DeleteAdministrativeUserApiResponse,
        DeleteAdministrativeUserApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-10-07/admin/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['admin-controller'],
      }),
      deleteUserProfile: build.mutation<
        DeleteUserProfileApiResponse,
        DeleteUserProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/users/2025-05-06/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as clientApi };
export type UpdateSubscriptionByIdVersion2ApiResponse =
  /** status 200 OK */ GmResponseCommonSubscriptionDto;
export type UpdateSubscriptionByIdVersion2ApiArg = {
  /** Unique identifying subscription ID. */
  subscriptionId: string;
  subscriptionUpdateDto: SubscriptionUpdateDto;
};
export type GetEventSubscriptionsApiResponse =
  /** status 200 OK */ GmResponseCommonListCategorySubscriptionsResponse;
export type GetEventSubscriptionsApiArg = {
  /** The organization ID associated with the subscriptions. */
  'cs-organization': string;
  body: CategoryEventRequestDto[][];
};
export type ValidateOviPersonChannelsApiResponse =
  /** status 200 Validation completed successfully */ GmResponseCommonValidateOviPersonChannelsResponse;
export type ValidateOviPersonChannelsApiArg = {
  validateOviPersonChannelsRequest: ValidateOviPersonChannelsRequest;
};
export type ListOviPersonChannelsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageMigratedPersonChannel;
export type ListOviPersonChannelsApiArg = {
  /** OVI business account ID filter */
  oviAccountId?: string;
  /** OVI person ID filter */
  oviPersonId?: string;
  /** OVI person channel ID filter */
  oviPersonChannelId?: string;
  /** CSP organization ID filter */
  organizationId?: string;
  /** CSP user profile ID filter */
  profileId?: string;
  /** Max number of items per page for pagination */
  size?: number;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type SyncOviPersonChannelsApiResponse =
  /** status 200 Sync completed successfully */ GmResponseCommonSyncOviPersonChannelsResponse;
export type SyncOviPersonChannelsApiArg = {
  'FORCE-CHANGE'?: boolean;
  syncOviPersonChannelsRequest: SyncOviPersonChannelsRequest;
};
export type SubmitTicketApiResponse =
  /** status 200 Ticket submitted successfully */ GmResponseCommonSupportTicketResponse;
export type SubmitTicketApiArg = {
  supportTicketRequest: SupportTicketRequest;
};
export type UnpinAlertApiResponse =
  /** status 200 Successfully updated the pin state of the alert. */ GmResponseCommon;
export type UnpinAlertApiArg = {
  /** The id of the alert to unpin. */
  id: string;
  /** Organization ID that the user belongs to */
  'cs-organization': string;
};
export type PinAlertApiResponse =
  /** status 200 Successfully updated the pin state of the alert. */ GmResponseCommon;
export type PinAlertApiArg = {
  /** The id of the alert to pin. */
  id: string;
  /** Organization ID that the user belongs to */
  'cs-organization': string;
};
export type UpdateAllAlertsToReadAsyncApiResponse =
  /** status 200 Successfully marked all alerts as read. */ GmResponseCommon;
export type UpdateAllAlertsToReadAsyncApiArg = {
  /** The organization ID that the user belongs to. */
  'cs-organization': string;
};
export type DismissAlertV20250909ApiResponse =
  /** status 200 Successfully dismissed the alert. */ GmResponseCommon;
export type DismissAlertV20250909ApiArg = {
  /** The id of the SINGLE alert to dismiss. */
  id: string;
  /** Organization ID that the user belongs to */
  'cs-organization': string;
};
export type UpdateNoiseThresholdByOrganizationApiResponse =
  /** status 200 Successfully updated noise threshold for all subscriptions in the organization. */ GmResponseCommonNoiseThresholdResponse;
export type UpdateNoiseThresholdByOrganizationApiArg = {
  noiseThresholdUpdate: NoiseThresholdUpdate;
};
export type UpdateSubscriptionToggleApiResponse =
  /** status 200 Successfully updated the state of the subscriptions toggle. */ GmResponseCommon;
export type UpdateSubscriptionToggleApiArg = {
  /** Whether the subscriptions toggle is active or not. */
  active: boolean;
  body: string[];
};
export type AddSubscriptionsToUserApiResponse =
  /** status 200 OK */ GmResponseCommonSubscriptionDto;
export type AddSubscriptionsToUserApiArg = {
  subscriptionDto: SubscriptionDto;
};
export type GetAllUserSubscriptionsApiResponse =
  /** status 200 OK */ GmResponseCommonBdSubscriptionPage;
export type GetAllUserSubscriptionsApiArg = {
  bdPageRequest: BdPageRequest;
};
export type GetRegistrationsForUserApiResponse =
  /** status 200 OK */ GmResponseCommonBdRegistrationPage;
export type GetRegistrationsForUserApiArg = {
  bdPageRequest: BdPageRequest;
};
export type ProcessPendingEmailsApiResponse =
  /** status 200 Pending emails processing completed successfully */ GmResponseCommonString;
export type ProcessPendingEmailsApiArg = void;
export type GetAlertsByVinApiResponse =
  /** status 200 Successfully retrieved alerts for the specified vehicle. */ GmResponseCommonGmPageAlertResponse;
export type GetAlertsByVinApiArg = {
  /** The VIN of the vehicle to retrieve alerts for. */
  vin: string;
  /** The organization ID that the user belongs to. */
  'cs-organization': string;
  /** Continuation token to be used to navigate to the next page */
  'cs-continuation-token'?: string;
  /** Number of alerts to return */
  size?: number;
  /**
                        true if only dismissed alerts should be returned,
                        false if only active alerts should be returned,
                        null if all alerts should be returned.
                     */
  dismissed?: boolean;
};
export type GetSubscriptionsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageSubscriptionDto;
export type GetSubscriptionsApiArg = {
  /** The organization ID associated with the subscriptions. */
  'cs-organization': string;
  /** The continuation token for pagination. */
  'cs-continuation-token'?: string;
  /** The number of subscriptions to return per page. */
  size?: number;
  /** Filter subscriptions by category. */
  category?: string;
  /** Filter subscriptions by subscription pool IDs. */
  subscriptionPoolId?: string;
};
export type GetPinnedAlertsForCurrentUserApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageAlertResponse;
export type GetPinnedAlertsForCurrentUserApiArg = {
  /** Number of pinned alerts to return */
  size?: number;
  /** Organization ID that the user belongs to */
  'cs-organization': string;
  /** Continuation token to be used to navigate to the next page */
  'cs-continuation-token'?: string;
};
export type GetAlertsAndGroupsForCurrentUserApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageAlertRecord;
export type GetAlertsAndGroupsForCurrentUserApiArg = {
  /** Number of alerts to return */
  size?: number;
  /**
                        true if only dismissed alerts should be returned,
                        false if only active alerts should be returned (for feed view),
                        null if all alerts should be returned (for notifications center view).
                     */
  dismissed?: boolean;
  /** Organization ID that the user belongs to */
  'cs-organization': string;
  /** Continuation token to retrieve the next page */
  'cs-continuation-token'?: string;
};
export type GetAlertsByGroupIdApiResponse =
  /** status 200 Successfully retrieved alerts for the specified group ID. */ GmResponseCommonGmPageAlertResponse;
export type GetAlertsByGroupIdApiArg = {
  /** The ID of the group to retrieve alerts for. */
  groupId: string;
  /** The organization ID that the user belongs to. */
  'cs-organization': string;
  /** Continuation token to be used to navigate to the next page */
  'cs-continuation-token'?: string;
  /** Number of alerts to return */
  size?: number;
  /**
                        true if only dismissed alerts should be returned,
                        false if only active alerts should be returned (for feed view),
                        null if all alerts should be returned (for notifications center view).
                     */
  dismissed?: boolean;
};
export type GetAlertsForCurrentUserApiResponse =
  /** status 200 OK */ GmResponseCommonAlertsPaginatedResponse;
export type GetAlertsForCurrentUserApiArg = {
  /** Number of alerts to return */
  size?: number;
  /** Continuation token to be used to navigate to the next page */
  'cs-continuation-token'?: string;
};
export type DeleteSubscriptionApiResponse =
  /** status 200 Successfully deleted subscription. */ GmResponseCommon;
export type DeleteSubscriptionApiArg = {
  /** A unique identifying subscription ID. */
  subscriptionId: string;
};
export type UpdateAssetApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type UpdateAssetApiArg = {
  /** Asset's identification. */
  id: string;
  body: UpdateVehicleJson | UpsertVehicleJson;
};
export type DeleteAssetApiResponse = /** status 200 OK */ GmResponseCommonEmpty;
export type DeleteAssetApiArg = {
  /** Asset's identification. */
  id: string;
};
export type UpdateSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateBatchBoardingSummaryResponse;
export type UpdateSummaryApiArg = {
  summaryId: string;
};
export type UpdateSessionApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateBoardingSessionResponse;
export type UpdateSessionApiArg = {
  sessionId: string;
};
export type UpdateVehicleApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateVehicleGmVehicleResponse20260224;
export type UpdateVehicleApiArg = {
  vin: string;
};
export type UpdateVehicle1ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateConnectivityProviderResponse;
export type UpdateVehicle1ApiArg = {
  vin: string;
};
export type UpdateVehicle2ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateClaimedOnstarResponse;
export type UpdateVehicle2ApiArg = {
  vin: string;
};
export type UpdateVehicleBatchApiResponse =
  /** status 200 OK */ GmResponseCommonListUpdateClaimedOnstarResponse;
export type UpdateVehicleBatchApiArg = {
  body: string[];
};
export type UpdateVehicle3ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateVehicleOnStarSupportStatusResponse;
export type UpdateVehicle3ApiArg = {
  vin: string;
};
export type ExecuteRemoteCommandsMfaApiResponse =
  /** status 200 OK */ GmResponseCommonOptionalRemoteCommandResponse;
export type ExecuteRemoteCommandsMfaApiArg = {
  /**     The type of command to be executed. Permissible values are:
        - engine
        - door
        - alert
        - ignition
     */
  commandType: 'ENGINE' | 'DOOR' | 'ALERT' | 'IGNITION' | 'VEHICLE';
  /**     The specific action to be performed. Permissible values by command type:
        - engine: start, cancel
        - door: lock, unlock
        - alert: start, cancel
        - ignition: enable, disable
     */
  command:
    | 'START'
    | 'CANCEL'
    | 'LOCK'
    | 'UNLOCK'
    | 'ENABLE'
    | 'DISABLE'
    | 'CONNECT';
  /** VIN of the vehicle on which the command is to be executed. */
  vin: string;
  /** The organization Id. */
  'cs-organization': string;
  /** Unique device fingerprint used for step-up MFA and trusted device recognition. */
  'X-Device-Fingerprint'?: any;
  /** Client application or browser identifier used for trusted device identification. */
  'User-Agent'?: any;
  /** OTP payload for step-up MFA verification. */
  otpPayload: OtpPayload;
};
export type ListVerifiedVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonVerifiedVehiclesListResponse;
export type ListVerifiedVehiclesApiArg = {
  /** UUID of the requesting organization. */
  'cs-organization': string;
  verifiedVehiclesListRequest: VerifiedVehiclesListRequest;
};
export type ListMigratedVehiclesApiResponse =
  /** status 200 Successfully listed migrated OVI vehicles. */ GmResponseCommonGmPageMigratedVehicleDto;
export type ListMigratedVehiclesApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviVehicleId?: string;
  organizationId?: string;
  fleetId?: string;
  assetId?: string;
  size?: number;
  'cs-continuation-token'?: string;
};
export type SyncVehiclesApiResponse =
  /** status 200 Successfully synced OVI vehicles. */ GmResponseCommonSyncOviVehiclesResponse;
export type SyncVehiclesApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  syncOviVehiclesRequest: SyncOviVehiclesRequest;
};
export type SubscriptionOnboardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type SubscriptionOnboardVehiclesApiArg = {
  /** The boarding organization ID. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  /** Desired subscription state: ACTIVE or INACTIVE. May be null or omitted to
    skip subscription management. */
  subscriptionState?: 'ACTIVE' | 'INACTIVE';
  /** Subscription organization ID. Required when subscriptionState is ACTIVE or INACTIVE. */
  subscriptionOrgId?: string;
  /** API plan code. Required only when subscriptionState is ACTIVE. */
  planCode?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  /** List of API service codes. Used only when subscriptionState is ACTIVE. */
  serviceCodes?: (
    | 'DTC_NOTIFICATION'
    | 'EV_PHEV_DATA'
    | 'HARD_ACCELERATION'
    | 'HARD_BRAKE'
    | 'INCAB_ALERTS'
    | 'PREDELIVERY'
    | 'TELEMETRY'
  )[];
  body: {
    file: Blob;
  };
};
export type SubscriptionOffboardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type SubscriptionOffboardVehiclesApiArg = {
  /** The boarding organization ID. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  body: {
    file: Blob;
  };
};
export type ExportVehicleListOverviewCsvFromSearchApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleListOverviewCsvFromSearchApiArg = {
  /** The organization Id. */
  'cs-organization'?: string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  timezone?: string;
  vehicleOverviewSearchRequest: VehicleOverviewSearchRequest;
};
export type BulkGetVehicleBasicInfoApiResponse =
  /** status 200 OK */ GmResponseCommonMapStringVehicleBasicInfoResponse;
export type BulkGetVehicleBasicInfoApiArg = {
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id (optional). */
  'cs-fleet'?: string;
  bulkGetVehicleBasicInfoRequest: BulkGetVehicleBasicInfoRequest;
};
export type GetVehicleOverviewListApiResponse =
  /** status 200 OK */ GmResponseCommonAzureAiSearchResponseVehicleOverviewSearchResult;
export type GetVehicleOverviewListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  vehicleOverviewSearchRequest: VehicleOverviewSearchRequest;
};
export type ExportVehicleDiagnosticsListApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleDiagnosticsListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  timezone?: string;
  bdPageRequest: BdPageRequest;
};
export type GetAssetBatteryReadinessV20260113ApiResponse =
  /** status 200 OK */ GmResponseCommonBatteryReadinessItemsResponsePageV20250211;
export type GetAssetBatteryReadinessV20260113ApiArg = {
  /** The organization ID. */
  'cs-organization'?: string;
  /** The fleet ID. */
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetBatteryReadinessCsvV20260113ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetBatteryReadinessCsvV20260113ApiArg = {
  /** The organization ID. */
  'cs-organization'?: string;
  /** The fleet ID. */
  'cs-fleet'?: string;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  bdPageRequest: BdPageRequest;
};
export type GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiResponse =
  /** status 200 OK */ GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse;
export type GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  bdPageRequest: BdPageRequest;
};
export type ProbeVehicleApiResponse =
  /** status 200 Success */ GmResponseCommonBoolean;
export type ProbeVehicleApiArg = {
  /** The VIN of a vehicle to probe */
  vin: string;
};
export type GetVehiclesWithDriversAndPeripheralsApiResponse =
  /** status 200 OK */ GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse;
export type GetVehiclesWithDriversAndPeripheralsApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items to return (default 20). */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  vehiclesWithDriversAndPeripheralsRequest: VehiclesWithDriversAndPeripheralsRequest;
};
export type ChangeFleetForVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonChangeFleetResponse;
export type ChangeFleetForVehiclesApiArg = {
  'cs-organization': string;
  changeFleetRequest: ChangeFleetRequest;
};
export type CancelBatchApiResponse =
  /** status 200 OK */ GmResponseCommonCancelBatchResponse;
export type CancelBatchApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the batch to cancel. */
  batchId: string;
};
export type ExportVehicleListOverviewCsvApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleListOverviewCsvApiArg = {
  /** The organization Id. */
  'cs-organization'?: string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  timezone?: string;
  bdPageRequest: BdPageRequest;
};
export type GetVehicleOverviewList1ApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleListOverview;
export type GetVehicleOverviewList1ApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type GetVehicleDiagnosticsListApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleDiagnosticsList;
export type GetVehicleDiagnosticsListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportVehicleDiagnosticsListV20251104ApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleDiagnosticsListV20251104ApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  timezone?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportPendingConnectionVehiclesApiResponse =
  /** status 200 OK */ string;
export type ExportPendingConnectionVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: any;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar account owner email ID. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) FAN (Factory Assigned Number). */
  fan?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by pending connection statuses. */
  pendingConnectionStatuses?: (
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'CONNECTION_FAILURE'
    | 'NOT_DEFINED'
  )[];
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  pendingVehicleExportRequest: PendingVehicleExportRequest;
};
export type ExportPendingOnboardingVehiclesApiResponse =
  /** status 200 OK */ string;
export type ExportPendingOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by status. */
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  /** Filter by request review reasons. */
  reviewReasons?: (
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE'
  )[];
  /** Filter by (partial) FAN. */
  fan?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar email. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  pendingVehicleExportRequest: PendingVehicleExportRequest;
};
export type RefreshBatchSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type RefreshBatchSummaryApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch to refresh. */
  batchId: string;
};
export type GetAssetReadinessV20250909ApiResponse =
  /** status 200 OK */ GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
export type GetAssetReadinessV20250909ApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetReadinessCsvV20250909ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetReadinessCsvV20250909ApiArg = {
  /** The organization ID. */
  'x-bd-organization'?: any;
  /** The fleet ID. */
  'x-bd-fleet'?: any;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetFluidReadinessCsvV20250909ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetFluidReadinessCsvV20250909ApiArg = {
  /** The organization ID. */
  'x-bd-organization'?: any;
  /** The fleet ID. */
  'x-bd-fleet'?: any;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type GetAssetBatteryReadinessV20250909ApiResponse =
  /** status 200 OK */ GmResponseCommonBatteryReadinessItemsResponsePageV20250211;
export type GetAssetBatteryReadinessV20250909ApiArg = {
  /** The organization ID. */
  'cs-organization'?: string;
  /** The fleet ID. */
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type MigratePreviouslyConnectedVehicleToConnectivityApiResponse =
  /** status 200 OK */ GmResponseCommonRestartConnectivityResponse;
export type MigratePreviouslyConnectedVehicleToConnectivityApiArg = void;
export type GetBatchIgnitionStatusApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListIgnitionStatusResponse;
export type GetBatchIgnitionStatusApiArg = {
  /** JSON payload containing a list of vehicle VINs. */
  vehicleIgnitionStatusBatchRequest: VehicleIgnitionStatusBatchRequest;
};
export type ArchiveVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type ArchiveVehicleBoardingSessionApiArg = {
  /** Boarding session ID */
  sessionId: string;
  vin: string;
};
export type SendConnectivityRestartRequestApiResponse =
  /** status 200 Success */ GmResponseCommonRestartConnectivityResponse;
export type SendConnectivityRestartRequestApiArg = {
  /** Contains list of vins to process and their connectivity types. */
  connectivityRestartRequest?: any;
  restartConnectivityRequest: RestartConnectivityRequest;
};
export type RetryOnboardingVehiclesApiResponse =
  /** status 202 Accepted */ GmResponseCommonRetryOnboardingVehicleBatchResponse;
export type RetryOnboardingVehiclesApiArg = {
  /** JSON payload containing a list of vehicle VINs. */
  retryOnboardingVehicleBatchRequest: RetryOnboardingVehicleBatchRequest;
};
export type TriggerSearchIndexRefreshApiResponse =
  /** status 200 Success */ GmResponseCommonVoid;
export type TriggerSearchIndexRefreshApiArg = {
  /** List of asset IDs to refresh in the search index */
  assetIds?: any;
  /** Batch size for processing the asset IDs */
  batchSize?: number;
  /** Type of data to refresh: DETAILS (asset metadata), TELEMETRY (status fields), or ALL (both). Default: DETAILS */
  typeToRefresh?: 'METADATA' | 'TELEMETRY' | 'ALL';
  body: string[];
};
export type CancelSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonCancelConnectivitySessionResponse;
export type CancelSessionsApiArg = {
  cancelConnectivitySessionRequest: CancelConnectivitySessionRequest;
};
export type GetMapAssetDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleListMapsResponse;
export type GetMapAssetDetailsApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  'cs-continuation-token'?: string;
  vehicleListMapsRequest: VehicleListMapsRequest;
};
export type GetMapLocationSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleLocationMapsResponse;
export type GetMapLocationSummaryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  'cs-fleet'?: string;
  vehicleLocationMapsRequest: VehicleLocationMapsRequest;
};
export type TerminateVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type TerminateVehicleBoardingSessionApiArg = {
  /** Boarding session ID */
  sessionId: string;
  vin: string;
};
export type BatchOffBoardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type BatchOffBoardVehiclesApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The provider of the asset remote commands. */
  remoteProvider?: string;
  /** The provider of the asset telemetry data. */
  telemetryProvider?: string;
  /** The type of upload: 'MANUAL' or 'FILE'. Defaults to 'MANUAL'. */
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  body: {
    file: Blob;
  };
};
export type RefreshVehicleDataApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleDataRefreshResponse;
export type RefreshVehicleDataApiArg = {
  /** Dry run mode. If true, the refresh will be simulated and intended changes are logged
    without making actual changes.
     */
  dryRun?: boolean;
  vehicleDataRefreshRequest: VehicleDataRefreshRequest;
};
export type TriggerAddCapabilitiesEventApiResponse =
  /** status 200 OK */ GmResponseCommonEmpty;
export type TriggerAddCapabilitiesEventApiArg = {
  /** The organization ID. */
  organizationId?: any;
  /** List of asset ids to trigger add capability event */
  assetIds?: any;
  /** Batch size for processing the asset ids */
  batchSize?: number;
  'cs-organization': string;
  body: string[];
};
export type BatchOnboardVehiclesV2ApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type BatchOnboardVehiclesV2ApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  /** The provider of the asset remote commands. */
  remoteProvider?: string;
  /** The provider of the asset telemetry data. */
  telemetryProvider?: string;
  /** The type of upload: 'MANUAL' or 'FILE'. Defaults to 'MANUAL'. */
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  /** The connection policy for data services enrollment. Only 'LIMITED' and 'STANDARD' are allowed. Defaults to 'STANDARD'. */
  'X-Boarding-Connection-Policy'?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  body: {
    file: Blob;
  };
};
export type TriggerEventApiResponse =
  /** status 200 OK */ GmResponseCommonEmpty;
export type TriggerEventApiArg = {
  /** List of asset ids to trigger asset creation event */
  assetIds?: any;
  body: string[];
};
export type GetActiveFieldActionVehicleSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleFieldActionSummaryResponse20241204;
export type GetActiveFieldActionVehicleSummaryApiArg = {
  /** Expected organization id for vehicle field action. */
  organizationId?: any;
  /** Request containing fleet id. */
  vehicleFieldActionSummaryRequest?: any;
  'x-bd-organization': string;
  body: VehicleFieldActionSummaryRequest;
};
export type GetAssetReadinessV20241203ApiResponse =
  /** status 200 OK */ GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
export type GetAssetReadinessV20241203ApiArg = {
  'x-bd-organization'?: string;
  'x-bd-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type RejectVehicleProofOfOwnershipApiResponse =
  /** status 202 Accepted */ GmResponseCommonVehicleOwnershipOperationBatchResponse;
export type RejectVehicleProofOfOwnershipApiArg = {
  /** JSON payload containing a list of vehicle entries for which proof
    of ownership needs confirmation.
     */
  vehicleOwnershipOperationBatchRequest: VehicleOwnershipOperationBatchRequest;
};
export type ConfirmVehicleProofOfOwnershipApiResponse =
  /** status 202 Accepted */ GmResponseCommonVehicleOwnershipOperationBatchResponse;
export type ConfirmVehicleProofOfOwnershipApiArg = {
  /** JSON payload containing a list of vehicle entries for which proof
    of ownership needs confirmation.
     */
  vehicleOwnershipOperationBatchRequest: VehicleOwnershipOperationBatchRequest;
};
export type GetFieldActionSummaryReportApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleFieldActionReportItem;
export type GetFieldActionSummaryReportApiArg = {
  'x-bd-organization'?: string;
  'x-bd-fleet'?: string;
  vehicleFieldActionReportRequest: VehicleFieldActionReportRequest;
};
export type UpsertAssetApiResponse = /** status 200 OK */ GmResponseCommonEmpty;
export type UpsertAssetApiArg = {
  /** Boolean to indicate if the asset is being re-enrolled in telemetry services */
  isReEnrolling: boolean;
  body: UpdateVehicleJson | UpsertVehicleJson;
};
export type GetAssetsByPageApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponseViewPage;
export type GetAssetsByPageApiArg = {
  bdPageRequest: BdPageRequest;
};
export type DoSubscribeV2ApiResponse = /** status 201 Created */ Empty;
export type DoSubscribeV2ApiArg = {
  eventSubscriptionRequestV2: EventSubscriptionRequestV2;
};
export type GetAssetWithTireReadinessApiResponse =
  /** status 200 OK */ GmResponseCommonTireReadinessItemsResponsePage;
export type GetAssetWithTireReadinessApiArg = {
  bdPageRequest: BdPageRequest;
};
export type SearchAssetsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponsePage;
export type SearchAssetsApiArg = {
  bdPageRequest: BdPageRequest;
};
export type UpdateProtectedFieldsForAssetApiResponse =
  /** status 202 Success */ GmResponseCommonAsset;
export type UpdateProtectedFieldsForAssetApiArg = {
  /** Asset ID. */
  headerAssetId?: any;
  /** Request containing the protected fields to update. */
  request?: any;
  pathAssetId: string;
  protectedFieldsUpdateRequest: ProtectedFieldsUpdateRequest;
};
export type PatchVehicleProbeApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleProbe;
export type PatchVehicleProbeApiArg = {
  /** Vehicle VIN. */
  vin: string;
  vehicleProbe: VehicleProbe;
};
export type ResetOwnershipApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type ResetOwnershipApiArg = {
  /** Asset's identification. */
  id: string;
  updateVehicleJson: UpdateVehicleJson;
};
export type PatchVehicleInfoFieldsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type PatchVehicleInfoFieldsApiArg = {
  /** Asset's identification. */
  id: string;
  updateVehicleJson: UpdateVehicleJson;
};
export type UpdateConfigurationApiResponse =
  /** status 202 Accepted */ GmResponseCommonEmpty;
export type UpdateConfigurationApiArg = {
  /** query parameters to find assets to update */
  filters: {
    [key: string]: string;
  };
  updateConfigurationJson: UpdateConfigurationJson;
};
export type ListSummariesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingSummaryListResponse;
export type ListSummariesApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingSessionListResponse;
export type ListSessionsApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListResponse20260224;
export type ListVehiclesApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehicles1ApiResponse =
  /** status 200 OK */ GmResponseCommonConnectivityProviderVehicleListResponse;
export type ListVehicles1ApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehicles2ApiResponse =
  /** status 200 OK */ GmResponseCommonClaimedOnstarVehicleListResponse;
export type ListVehicles2ApiArg = {
  pageSize?: number;
};
export type ListVehicles3ApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListResponse;
export type ListVehicles3ApiArg = {
  pageSize?: number;
  onstarSupportStatus?: string;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type GetVehicleImageUrlApiResponse = unknown;
export type GetVehicleImageUrlApiArg = {
  /** Vehicle Identification Number */
  vin: string;
};
export type GetVehicleImageUrlWithParamsApiResponse = unknown;
export type GetVehicleImageUrlWithParamsApiArg = {
  /** Vehicle Identification Number aka Asset ID */
  vin: string;
  /** Size of the image, defaults to XSMALL. */
  size?:
    | 'XXSMALL'
    | 'XSMALL'
    | 'SMALL'
    | 'MEDIUM'
    | 'LARGE'
    | 'XLARGE'
    | 'XXLARGE';
  /** Angle of the vehicle in the photo, defaults to FRONT. */
  angle?: 'FRONT' | 'REAR' | 'DRIVER_SIDE' | 'PASSENGER_SIDE' | 'WHEEL' | 'TOP';
  /** Whether the image has a transparent background, defaults to true */
  isTransparentBackground?: boolean;
};
export type GetPropulsionSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonPropulsionTypeSummaryResponse;
export type GetPropulsionSummaryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
};
export type ListBatchSummariesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageBatchBoardingVehicleSummary;
export type ListBatchSummariesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Filter by user ID who created the batch. */
  createdBy?: string;
  /** Filter by batch progress status (IN_PROGRESS, COMPLETED, INCOMPLETE, FAILED). */
  status?:
    | 'INITIALIZING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'INCOMPLETE'
    | 'FAILED';
  /** Filter by batch boarding type (ONBOARDING, OFFBOARDING). */
  boardingType?: 'ONBOARDING' | 'OFFBOARDING';
  /** Number of items per page. */
  size?: number;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetBatchSummaryByIdApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingVehicleSummary;
export type GetBatchSummaryByIdApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch. */
  batchId: string;
};
export type GetBatchSessionsByIdApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageBatchSummaryVehicleBoardingSession;
export type GetBatchSessionsByIdApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch. */
  batchId: string;
  /** Optional VIN to search for specific vehicle sessions. */
  vin?: string;
  /** Optional list of statuses to filter sessions. Returns sessions matching any of the provided statuses exactly. Can be provided multiple times, e.g., ?status=PENDING&status=COMPLETED */
  status?: (
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER'
  )[];
  /** Number of items per page. */
  size?: number;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetAssets20250923BoardingBatchesByBatchIdExtendedApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingVehicleSummary;
export type GetAssets20250923BoardingBatchesByBatchIdExtendedApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the batch. */
  batchId: string;
};
export type ExportBatchVehiclesToCsvApiResponse = /** status 200 OK */ string;
export type ExportBatchVehiclesToCsvApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch to export. */
  batchId: string;
  /** Optional VIN to search for specific vehicle sessions. */
  vin?: string;
  /** Optional list of statuses to filter sessions. Returns sessions matching any of the provided statuses exactly. Can be provided multiple times, e.g., ?status=PENDING&status=COMPLETED */
  status?: (
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER'
  )[];
};
export type ListPendingConnectionVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPagePendingConnectionVehicleItemV20250826;
export type ListPendingConnectionVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar account owner email ID. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) FAN (Factory Assigned Number). */
  fan?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by pending connection statuses. */
  pendingConnectionStatuses?: (
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'CONNECTION_FAILURE'
    | 'NOT_DEFINED'
  )[];
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetOilLifeSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonOilLifeSummary;
export type GetOilLifeSummaryMetricsV20250826ApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetDiagnosticsSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonDiagnosticsSummary;
export type GetDiagnosticsSummaryMetricsV20250826ApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetConnectivityStatusDashboardSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonConnectivityStatusSummaryV20250826;
export type GetConnectivityStatusDashboardSummaryMetricsV20250826ApiArg = {
  /** A map containing optional filters for the data. */
  filters?: any;
  /** The ID of the organization for which the connectivity status summary metrics is to be fetched. */
  orgId?: any;
  'x-bd-organization': string;
};
export type GetChargeSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonChargeSummary;
export type GetChargeSummaryMetricsV20250826ApiArg = {
  /** The the organization ID. */
  organizationId?: any;
  /** The fleet ID. */
  fleetId?: any;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type GetSummaryOfBoardingSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionBatchSummary;
export type GetSummaryOfBoardingSessionsApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The boarding session's batch identification number. */
  batchId: string;
};
export type SearchAssetApiResponse =
  /** status 200 Successfully searched organizations. */ GmResponseCommonAzureAiSearchResponseAssetEntitlement;
export type SearchAssetApiArg = {
  /** Search text to search for assets. */
  searchText?: string;
  /** Number of items to return. */
  top?: number;
  /** Number of items to skip. */
  skip?: number;
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** List of filters to apply to the search.
    Each filter should be a valid OData filter expression.
    Document: https://learn.microsoft.com/en-us/azure/search/search-query-odata-filter
     */
  filters?: string[];
  /** List of fields to select in the search results.
    If not provided, all fields will be returned.
     */
  fieldsToSelect?: string[];
  /** Query type to use for the search.
    Possible values: 'FULL', 'SIMPLE', 'SEMANTIC'.
    Default is 'SIMPLE'.
     */
  queryType?: 'simple' | 'full' | 'semantic';
};
export type GetVehiclesWithDriversApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleWithDriverResponse;
export type GetVehiclesWithDriversApiArg = {
  /** Filter by organization ID. */
  'cs-organization': string;
  /** Filter by list of fleet ID. */
  'cs-fleet'?: string;
  /** Number of items per page for pagination (min: 1, max: 20, default: 5). */
  size?: number;
  /** Continuation token for pagination. */
  'header_cs-continuation-token'?: any;
  /** Vehicle keyword to search against the vehicle's name. */
  vehicleSearchKeyword?: string;
  page?: number;
  'query_cs-continuation-token'?: string;
};
export type ListVehicleBoardingSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageVehicleBoardingWorkflowSessionDetail;
export type ListVehicleBoardingSessionsApiArg = {
  /** The boarding session's batch identification number. */
  batchId?: string;
  /** The organization id associated with the session. */
  organizationId: string;
  /** The number of items to return for the request page. */
  size?: number;
  /** The vehicle boarding session type. */
  sessionType?: 'ONBOARDING' | 'OFFBOARDING';
  /** The vehicle's identification number. */
  vin?: string;
  /** The continuation token for the next set of sessions. */
  token?: any;
  /** The continuation token for the next set of sessions. */
  'cs-continuation-token'?: string;
};
export type GetOilLifeSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated diagnostics. */ GmResponseCommonOilLifeSummary;
export type GetOilLifeSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetDiagnosticsSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated diagnostics. */ GmResponseCommonDiagnosticsSummary;
export type GetDiagnosticsSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetConnectivityStatusSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated connectivity status data. */ GmResponseCommonConnectivityStatusDashboardSummaryItem;
export type GetConnectivityStatusSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetChargeLevelSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated charge level data. */ GmResponseCommonChargeLevelDashboardSummaryResponse;
export type GetChargeLevelSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetVehiclesBasicDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseBasicVehicleDetails;
export type GetVehiclesBasicDetailsApiArg = {
  /** The number of items to return. Default is 10. */
  size?: number;
  /** List of vehicle identification numbers. */
  vins?: string[];
  /** The vehicle name. */
  name?: string;
  /** The vehicle license plate. */
  licensePlate?: string;
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  /** The continuation token. */
  'cs-continuation-token'?: string;
  sortBy?: string;
  sortOrder?: string;
};
export type SearchAsset1ApiResponse =
  /** status 200 Successfully searched organizations. */ GmResponseCommonAzureAiSearchResponseAsset;
export type SearchAsset1ApiArg = {
  /** Search text to search for assets. */
  searchText?: string;
  /** Number of items to return. */
  top?: number;
  /** Number of items to skip. */
  skip?: number;
  /** Organization ID. */
  'cs-organization'?: string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** List of filters to apply to the search.
    Each filter should be a valid OData filter expression.
    Document: https://learn.microsoft.com/en-us/azure/search/search-query-odata-filter
     */
  filters?: string[];
  /** Query type to use for the search.
    Possible values: 'FULL', 'SIMPLE', 'SEMANTIC'.
    Default is 'SIMPLE'.
     */
  queryType?: 'simple' | 'full' | 'semantic';
};
export type ListIncompleteOnboardingVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonIncompleteOnboardingVehiclesResponse;
export type ListIncompleteOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by reason. */
  reason?:
    | 'UNEXPECTED_FAILURE'
    | 'VEHICLE_REJECTED_ACTIVELY_ONBOARDING'
    | 'VEHICLE_REJECTED_ACTIVELY_OFFBOARDING'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OTHER'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OWNER'
    | 'VEHICLE_REJECTED_DUPLICATE_VIN'
    | 'VEHICLE_REJECTED_NO_INFORMATION_FOUND'
    | 'VEHICLE_REJECTED_INSUFFICIENT_INFORMATION'
    | 'VEHICLE_REJECTED_INVALID_VIN'
    | 'VEHICLE_REJECTED_BATCH_VIN_LIMIT_EXCEEDED'
    | 'VEHICLE_MANUAL_PROOF_OF_OWNERSHIP_REJECTED'
    | 'VEHICLE_REJECTED_NOT_SUPPORTED';
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetAssetsListApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseAssetListItem;
export type GetAssetsListApiArg = {
  /** The number of items to return. Default is 10. */
  size?: number;
  /** The propulsion types filter. */
  propulsionTypes?: ('EV' | 'ICE' | 'HEV' | 'PHEV')[];
  /** The vehicle identification number. */
  vin?: string;
  /** The vehicle name. */
  name?: string;
  /** The vehicle license plate. */
  licensePlate?: string;
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id. */
  'cs-fleet': string;
  /** The continuation token. */
  'cs-continuation-token'?: string;
};
export type GetVehicleIgnitionStatusApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleIgnitionStatusView;
export type GetVehicleIgnitionStatusApiArg = {
  /** Vehicle Identification Number of the vehicle. */
  vin: string;
};
export type GetAssetStatusWithFilteringApiResponse =
  /** status 200 OK */ GmResponseCommonAssetStatusView;
export type GetAssetStatusWithFilteringApiArg = {
  /** Asset's identification. */
  id: string;
  /** An optional list of statuses to filter the results. */
  statuses?: string[];
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type ListPendingOnboardingVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonPendingOnboardingVehiclesResponse;
export type ListPendingOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by status. */
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by request review reasons. */
  reviewReasons?: (
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE'
  )[];
  /** Filter by (partial) FAN. */
  fan?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar email. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type ExecuteRemoteCommandsApiResponse =
  /** status 200 OK */ GmResponseCommonOptionalRemoteCommandResponse;
export type ExecuteRemoteCommandsApiArg = {
  /** The type of command to be executed. Permissible values are:
    engine, door, alert, ignition.
     */
  commandType: 'ENGINE' | 'DOOR' | 'ALERT' | 'IGNITION' | 'VEHICLE';
  /** The specific action to be performed. Permissible values are:
    engine - start, cancel;
    door - lock, unlock;
    alert - start, cancel;
    ignition - enable, disable.
     */
  command:
    | 'START'
    | 'CANCEL'
    | 'LOCK'
    | 'UNLOCK'
    | 'ENABLE'
    | 'DISABLE'
    | 'CONNECT';
  /** VIN of the vehicle on which the command is to be executed. */
  vin: string;
  /** The organization Id. */
  'cs-organization': string;
};
export type GetChargeLevelDashboardSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonChargeLevelDashboardSummaryResponse;
export type GetChargeLevelDashboardSummaryApiArg = {
  /** Optional fleetId. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetFieldActionsForVinApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleFieldActionDetailsResponse;
export type GetFieldActionsForVinApiArg = {
  vin: string;
};
export type GetAssets20240717ByAssetIdInternalApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type GetAssets20240717ByAssetIdInternalApiArg = {
  /** Asset's identification. This is typically the VIN for vehicles. */
  assetId: string;
  /** Session token used by internal service-to-service calls to read recently-updated records
    (ensures session/consistency for reads after writes).
     */
  'cs-session-token'?: string;
};
export type GetVehicleBoardingProfileApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingProfileDetail;
export type GetVehicleBoardingProfileApiArg = {
  /** The vehicle's identification number. */
  vin: string;
};
export type GetCurrentVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionDetail;
export type GetCurrentVehicleBoardingSessionApiArg = {
  /** The vehicle's identification number. */
  vin: string;
};
export type GetVehicleBoardingSessionBySessionIdApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionDetail;
export type GetVehicleBoardingSessionBySessionIdApiArg = {
  /** ID number for a boarding session */
  sessionId: string;
};
export type GetOrganizationIdByAssetIdApiResponse =
  /** status 200 OK */ GmResponseCommonString;
export type GetOrganizationIdByAssetIdApiArg = {
  /** The asset ID to fetch the corresponding organization ID */
  assetId: string;
};
export type GetOrganizationAssetCountSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationAssetCountSummaryItem;
export type GetOrganizationAssetCountSummaryApiArg = {
  organizationId: string;
};
export type GetAssetByIdWithFanApiResponse =
  /** status 200 OK */ GmResponseCommonAssetByIdDetailResponse;
export type GetAssetByIdWithFanApiArg = {
  /** Asset's identification. */
  id: string;
};
export type GetComplianceReportV2ApiResponse =
  /** status 200 OK */ GmResponseCommonComplianceReportPage;
export type GetComplianceReportV2ApiArg = {
  /** Org/Fleet ids */
  params?: any;
  /** Optional orgId filter. */
  organizationId?: any;
  'x-bd-organization'?: string;
};
export type GetDashboardMetricsApiResponse =
  /** status 200 OK */ GmResponseCommonDashboardSummaryWrapper;
export type GetDashboardMetricsApiArg = {
  /** Filters of orgId/fleetId. */
  filters?: any;
  /** Optional filter for orgId instead of in filters. */
  orgId?: any;
  'x-bd-organization': string;
};
export type GetMapListItemsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseViewMapListItem;
export type GetMapListItemsApiArg = {
  /** Filters of orgId/fleetId. */
  filters?: any;
  /** number of items to return */
  size?: number;
  /** continuation token for the next set of assets */
  continuationToken?: string;
};
export type GetAssetWithi8NDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponseView;
export type GetAssetWithi8NDetailsApiArg = {
  /** Asset's identification. */
  id: string;
};
export type PostAudit20250603ExportSyncApiResponse =
  /** status 200 No matching records; returns 200 with CSV header row only (X-Result-Count: 0) */
  | object
  | /** status 206 Partial content; export truncated at limit. All rows read are included (X-Result-Count = limit). */ object;
export type PostAudit20250603ExportSyncApiArg = {
  /** Organization ID */
  'cs-organization': string;
  /** Fleet ID (optional) */
  'cs-fleet'?: string;
  auditExportRequest: AuditExportRequest;
};
export type FetchOrganizationNameApiResponse =
  /** status 200 OK */ GmResponseCommonString;
export type FetchOrganizationNameApiArg = {
  organizationId: string;
};
export type FetchFleetApiResponse = /** status 200 OK */ GmResponseCommonString;
export type FetchFleetApiArg = {
  organizationId: string;
  fleetId: string;
};
export type DemoApiResponse = /** status 200 OK */ GmResponseCommonDemoResponse;
export type DemoApiArg = void;
export type CreateProductApiResponse =
  /** status 200 Success */ GmResponseCommonProductDto;
export type CreateProductApiArg = {
  createProductDto: CreateProductDto;
};
export type GetProductsApiResponse =
  /** status 200 Success */ GmResponseCommonProductsPageDto;
export type GetProductsApiArg = {
  productListDto: ProductListDto;
};
export type CreateFeatureApiResponse =
  /** status 200 Success */ GmResponseCommonFeatureDto;
export type CreateFeatureApiArg = {
  createFeatureDto: CreateFeatureDto;
};
export type SunsetProductApiResponse =
  /** status 200 Success */ GmResponseCommonListProductDto;
export type SunsetProductApiArg = {
  sunsetRequestDto: SunsetRequestDto;
};
export type GetProductByIdApiResponse =
  /** status 200 Success */ GmResponseCommonProductDto;
export type GetProductByIdApiArg = {
  productId: string;
};
export type UpdateHomeChargeReimbursementRecordUtilityRateApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonChargeHistoryChargeSessionDetailsDto;
export type UpdateHomeChargeReimbursementRecordUtilityRateApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** User preference for viewing distances. Options are KM or MILES. Defaults to KM. */
  distancePreference?: string;
  updateReimbursementUtilityRateRequestDto: UpdateReimbursementUtilityRateRequestDto;
};
export type UpdateDriverUtilityRateApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonDriverDetailsDto;
export type UpdateDriverUtilityRateApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  updateDriverUtilityPlanRequestDto: UpdateDriverUtilityPlanRequestDto;
};
export type CreateFormattedChargeReimbursementsForReportsApiResponse =
  /** status 200 Request was successful. */ string[];
export type CreateFormattedChargeReimbursementsForReportsApiArg = {
  /** Organization ID that the home charge reimbursement records belongs to. */
  'cs-organization': string;
  reportDataRequest: ReportDataRequest;
};
export type CreateStreamedReportRecordsForHomeChargeReimbursementApiResponse =
  /** status 200 Request was successful. */ string[];
export type CreateStreamedReportRecordsForHomeChargeReimbursementApiArg = {
  /** Organization ID that the home charge reimbursement records belongs to. */
  'cs-organization': string;
  reportDataRequest: ReportDataRequest;
};
export type CreateOrUpdateFleetUtilityRateSettingsApiResponse =
  /** status 200 Request was successful */ GmResponseCommonFindFleetUtilityRateSettingsDto;
export type CreateOrUpdateFleetUtilityRateSettingsApiArg = {
  /** Organization ID of the fleet utility rate settings for home charge reimbursement. */
  'cs-organization': string;
  /** Fleet ID of the fleet utility rate settings for home charge reimbursement. */
  'cs-fleet': string;
  createOrUpdateFleetUtilityRateSettingsDto: CreateOrUpdateFleetUtilityRateSettingsDto;
};
export type ExportSelectedOrAllHomeChargeReimbursementRecordsApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportSelectedOrAllHomeChargeReimbursementRecordsApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** Charge history records that have a plugin time after this start time. */
  pluginTimeAfterUtc?: string;
  /** Charge history records that have a plugin time before this end time */
  pluginTimeBeforeUtc?: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
  reimbursementExportRequestDto: ReimbursementExportRequestDto;
};
export type ExportSelectedHomeChargeReimbursementRecordsApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportSelectedHomeChargeReimbursementRecordsApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
  reimbursementExportRequestDto: ReimbursementExportRequestDto;
};
export type ExportSelectedHomeChargeReimbursementRecordsForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonExportReportByEmailResult;
export type ExportSelectedHomeChargeReimbursementRecordsForCurrentDriverApiArg =
  {
    /** Organization ID that the driver belongs to. */
    'cs-organization': string;
    /** User preference timezone Id */
    timeZoneId: string;
    /** User preference distance unit. If not provided defaults to MILES */
    distanceUnit?: string;
    /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
    temperatureUnit?: string;
    reimbursementExportRequestDto: ReimbursementExportRequestDto;
  };
export type SearchChargingStationsForDriverApiResponse =
  /** status 200 Success */ GmResponseCommonGmPageChargeStationDto;
export type SearchChargingStationsForDriverApiArg = {
  /** The focus point Latitude from which we measure distances to charge stations. */
  searchCenterLatitude: number;
  /** The focus point Longitude from which we measure distances to charge stations. */
  searchCenterLongitude: number;
  /** Search term (station name, address). */
  searchTerm?: string;
  /** The list of charge grades to filter the results (slow | fast). */
  chargingGrades?: ('FAST' | 'SLOW')[];
  /** The list of availabilities to filter the results (available | inactive | inuse | unknown). */
  availabilities?: ('AVAILABLE' | 'INACTIVE' | 'INUSE' | 'UNKNOWN')[];
  /** Vehicle plug types to filter by (any combination): NACS, J1772, CCS. Omit for no plug-type filtering. */
  plugTypes?: ('NACS' | 'J1772' | 'CCS')[];
  /** The list of charge providers to filter the results. */
  providerIds?: string[];
  /** The page size. */
  size?: number;
  /** Optional maximum search radius in kilometers from the focus location (e.g. 0.25 for 250 m). Only stations within this distance are returned. If omitted, no distance filter is applied. */
  searchRadiusInKilometers?: number;
  /**
                    Continuation token to be used to navigate to the next page
                    that comes from `result.continuation_token` response.
                 */
  continuationToken?: any;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /**
                Continuation token to be used to navigate to the next page
                that comes from `result.continuation_token` response.
             */
  'cs-continuation-token'?: string;
};
export type SearchApiResponse =
  /** status 200 Success */ GmResponseCommonGmPageChargeStationDto;
export type SearchApiArg = {
  /** The focus point Latitude from which we measure distances to charge stations. */
  searchCenterLatitude: number;
  /** The focus point Longitude from which we measure distances to charge stations. */
  searchCenterLongitude: number;
  /** Search term (station name, address). */
  searchTerm?: string;
  /** The list of charge grades to filter the results (slow | fast). */
  chargingGrades?: ('FAST' | 'SLOW')[];
  /** The list of availabilities to filter the results (available | inactive | inuse | unknown). */
  availabilities?: ('AVAILABLE' | 'INACTIVE' | 'INUSE' | 'UNKNOWN')[];
  /** Vehicle plug types to filter by (any combination): NACS, J1772, CCS. Omit for no plug-type filtering. */
  plugTypes?: ('NACS' | 'J1772' | 'CCS')[];
  /** The list of charge providers to filter the results. */
  providerIds?: string[];
  /** The page size. */
  size?: number;
  /** Optional maximum search radius in kilometers from the focus location (e.g. 0.25 for 250 m). Only stations within this distance are returned. If omitted, no distance filter is applied. */
  searchRadiusInKilometers?: number;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /**
                Continuation token to be used to navigate to the next page
                that comes from `result.continuation_token` response.
             */
  'cs-continuation-token'?: string;
};
export type GetFleetUtilityRateSettingsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonFindFleetUtilityRateSettingsDto;
export type GetFleetUtilityRateSettingsApiArg = {
  /** Organization ID of the fleet utility rate settings for home charge reimbursement. */
  'cs-organization': string;
  fleetId: string;
};
export type RemoveFleetUtilityRateSettingsApiResponse =
  /** status 200 Request was successful */ GmResponseCommon;
export type RemoveFleetUtilityRateSettingsApiArg = {
  /** Organization ID of the fleet utility rate settings for home charge reimbursement. */
  'cs-organization': string;
  fleetId: string;
};
export type ExportSingleHomeChargeReimbursementRecordApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportSingleHomeChargeReimbursementRecordApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** Charge session Id of the record we want to export. */
  chargeSessionId: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
};
export type ExportSingleHomeChargeReimbursementRecordForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonExportReportByEmailResult;
export type ExportSingleHomeChargeReimbursementRecordForCurrentDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Charge session Id of the record we want to export. */
  chargeSessionId: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
};
export type ExportHomeChargeReimbursementRecordsApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportHomeChargeReimbursementRecordsApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** Charge history records that have a plugin time after this start time. */
  pluginTimeAfterUtc?: string;
  /** Charge history records that have a plugin time before this end time */
  pluginTimeBeforeUtc?: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
};
export type ExportHomeChargeReimbursementRecordsForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonExportReportByEmailResult;
export type ExportHomeChargeReimbursementRecordsForCurrentDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Charge history records that have a plugin time after this start time. */
  pluginTimeAfterUtc: string;
  /** Charge history records that have a plugin time before this end time */
  pluginTimeBeforeUtc: string;
  /** User preference timezone Id */
  timeZoneId: string;
  /** User preference distance unit. If not provided defaults to MILES */
  distanceUnit?: string;
  /** User preference temperature unit. If not provided defaults to FAHRENHEIT */
  temperatureUnit?: string;
};
export type GetHomeChargingHistoryRecordsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonGmPageChargeHistoryTableLineDto;
export type GetHomeChargingHistoryRecordsApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Continuation token to retrieve the next page */
  'cs-continuation-token'?: string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** Charge history records that have a plugin time after this start time. */
  pluginTimeAfterUtc?: string;
  /** Charge history records that have a plugin time before this end time */
  pluginTimeBeforeUtc?: string;
  /** Size of the page to be returned. Defaults to 10. */
  pageSize?: number;
};
export type GetChargingHistorySummaryForDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonChargeHistoryChargeSessionDetailsDto;
export type GetChargingHistorySummaryForDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home where the charge history occurred. */
  driverId: string;
  /** Charge session Id of the history record. */
  chargeSessionId: string;
  /** User preference for viewing distances. Options are KM or MILES. Defaults to KM. */
  distancePreference?: string;
};
export type GetDriverUtilityPlanCardApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonCurrentDriverUtilityPlanCardDto;
export type GetDriverUtilityPlanCardApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Fleet ID that the driver belongs to. */
  'cs-fleet': string;
  /** Driver of the home charging configurations. */
  driverId: string;
};
export type GetHomeChargingHistoryRecordsForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonGmPageChargeHistoryTableLineDto;
export type GetHomeChargingHistoryRecordsForCurrentDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Continuation token to retrieve the next page */
  'cs-continuation-token'?: string;
  /** Charge history records that have a plugin time after this start time. */
  pluginTimeAfterUtc?: string;
  /** Charge history records that have a plugin time before this end time */
  pluginTimeBeforeUtc?: string;
  /** Size of the page to be returned. Defaults to 10. */
  pageSize?: number;
};
export type GetChargingHistorySummaryForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonChargeHistoryChargeSessionDetailsDto;
export type GetChargingHistorySummaryForCurrentDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
  /** Charge session Id of the history record. */
  chargeSessionId: string;
  /** User preference for viewing distances. Options are KM or MILES. Defaults to KM. */
  distancePreference?: string;
};
export type GetDriverUtilityPlanCardForCurrentDriverApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonCurrentDriverUtilityPlanCardDto;
export type GetDriverUtilityPlanCardForCurrentDriverApiArg = {
  /** Organization ID that the driver belongs to. */
  'cs-organization': string;
};
export type DownloadFeedbackImageApiResponse =
  /** status 200 Image body; Content-Type is jpeg, png, gif, or webp per stored blob. */ Blob;
export type DownloadFeedbackImageApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  blobName: string;
};
export type UploadFeedbackImageApiResponse =
  /** status 201 Created */ GmResponseCommonFeedbackImageAttachmentRef;
export type UploadFeedbackImageApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  body: {
    file: Blob;
  };
};
export type CreateFeedbackApiResponse =
  /** status 201 Created */ GmResponseCommonFeedbackCreateResponse;
export type CreateFeedbackApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  feedbackCreateRequest: FeedbackCreateRequest;
};
export type ListFeedbacksApiResponse =
  /** status 200 Success */
  | GmResponseCommonFeedbackListResponse
  | /** status 204 No results (empty list; response has no body per HTTP semantics) */ GmResponseCommonFeedbackListResponse;
export type ListFeedbacksApiArg = {
  'cs-organization'?: string;
  'cs-continuation-token'?: string;
  authorization?: string;
  pageSize?: number;
  feedbackListRequest: FeedbackListRequest;
};
export type CreateJiraTicketForFeedbackApiResponse =
  /** status 201 JIRA ticket created */ GmResponseCommonCreateJiraTicketResponse;
export type CreateJiraTicketForFeedbackApiArg = {
  'cs-organization': string;
  createJiraTicketRequest: CreateJiraTicketRequest;
};
export type UpdateFeedbackStatusApiResponse =
  /** status 200 Success */ GmResponseCommonFeedbackStatusUpdateResponse;
export type UpdateFeedbackStatusApiArg = {
  'cs-organization': string;
  feedbackStatusUpdateRequest: FeedbackStatusUpdateRequest;
};
export type EnrollOrUnenrollVehiclesApiResponse =
  /** status 202 Request was accepted for processing. */
  | GmResponseCommonEnrollVehiclesResponseDto
  | /** status 204 Unenroll is not handled yet. */ GmResponseCommonEnrollVehiclesResponseDto;
export type EnrollOrUnenrollVehiclesApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  enrollVehiclesRequestDto: EnrollVehiclesRequestDto;
};
export type GetEligibleVehiclesApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonEligibleVehiclesResponseDto;
export type GetEligibleVehiclesApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /**
                        Continuation token from a previous response (`result.continuation_token`)
                        to fetch the next page.
                     */
  'cs-continuation-token'?: string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  eligibleVehiclesRequestDto: EligibleVehiclesRequestDto;
};
export type FindVinsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonVehicleEnrollmentVinsResponse;
export type FindVinsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  vehicleEnrollmentVinsRequestDto: VehicleEnrollmentVinsRequestDto;
};
export type CreateOrgEnrollmentApiResponse =
  /** status 200 Request was successful. */
  | GmResponseCommonOrgEnrollmentResponseDto
  | /** status 202 Request was accepted for processing. */ GmResponseCommonOrgEnrollmentResponseDto;
export type CreateOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  createOrgEnrollmentRequestDto: CreateOrgEnrollmentRequestDto;
};
export type ValidateCredentialsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonValidateCredentialsResponseDto;
export type ValidateCredentialsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  validateCredentialsRequestDto: ValidateCredentialsRequestDto;
};
export type GetVehicleDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonGmfVehicleDetailsResponse;
export type GetVehicleDetailsApiArg = {
  'cs-organization': string;
  gmfVehicleDetailsRequest: GmfVehicleDetailsRequest;
};
export type LookupAuthorizedUserApiResponse =
  /** status 200 OK */ GmResponseCommonGmfAuthorizedUserEligibilityResponse;
export type LookupAuthorizedUserApiArg = {
  'cs-organization': string;
  gmfAuthorizedUserLookupRequest: GmfAuthorizedUserLookupRequest;
};
export type LookupServicesApiResponse =
  /** status 200 OK */ GmResponseCommonGmfServiceLookupResponse;
export type LookupServicesApiArg = {
  'cs-organization': string;
  gmfServiceLookupRequest: GmfServiceLookupRequest;
};
export type LookupOrganizationApiResponse =
  /** status 200 OK */ GmResponseCommonGmfOrganizationLookupResponse;
export type LookupOrganizationApiArg = {
  'cs-organization': string;
  gmfOrganizationLookupRequest: GmfOrganizationLookupRequest;
};
export type ValidateLineOfCreditApiResponse =
  /** status 200 OK */ GmResponseCommonGmfLineOfCreditResponse;
export type ValidateLineOfCreditApiArg = {
  'cs-organization': string;
  gmfLineOfCreditRequest: GmfLineOfCreditRequest;
};
export type VerifyEnrollmentApiResponse =
  /** status 200 OK */ FleetioVerifyEnrollmentResponse;
export type VerifyEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  fleetioVerifyEnrollmentRequest: FleetioVerifyEnrollmentRequest;
};
export type CreateBulkJobApiResponse =
  /** status 200 OK */ FleetioBulkJobResponse;
export type CreateBulkJobApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  fleetioBulkJobRequest: FleetioBulkJobRequest;
};
export type GetVehiclesEnrollmentViewApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonVehiclesEnrollmentViewResponseDto;
export type GetVehiclesEnrollmentViewApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Optional fleet scope for fleet manager view. */
  'cs-fleet'?: string;
  /**
                        Continuation token from a previous response (`result.continuation_token`)
                        to fetch the next page.
                     */
  'cs-continuation-token'?: string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  vehiclesEnrollmentViewRequestDto: VehiclesEnrollmentViewRequestDto;
};
export type GetVehicleEnrollmentBatchApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonVehicleEnrollmentBatchResponseDto;
export type GetVehicleEnrollmentBatchApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Batch identifier from the enroll or unenroll response. */
  batchId: string;
};
export type GetAllEligibleVinsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonAllEligibleVinsResponse;
export type GetAllEligibleVinsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type ListProvidersApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonProvidersResponseDto;
export type ListProvidersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type ProviderIntegrationsStatusApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonProviderIntegrationsStatusResponseDto;
export type ProviderIntegrationsStatusApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Optional provider code to filter integration status. */
  providerCode?: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type GetOrgEnrollmentApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonOrgEnrollmentResponseDto;
export type GetOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the enrollment. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type UnlinkOrgEnrollmentApiResponse =
  /** status 202 Request was accepted for processing. */ GmResponseCommon;
export type UnlinkOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code to unlink. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type GetCurrentUserApiResponse =
  /** status 200 OK */ FleetioUserResponse;
export type GetCurrentUserApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type GetBulkJobApiResponse = /** status 200 OK */ FleetioBulkJobResponse;
export type GetBulkJobApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  jobId: string;
};
export type GetAccountsApiResponse =
  /** status 200 OK */ FleetioAccountResponse[];
export type GetAccountsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type CountRemainingOfApiResponse =
  /** status 200 Remaining count returned */ GmResponseCommonOffboardRemainingResponse;
export type CountRemainingOfApiArg = {
  organizationId: string;
};
export type SoftDeleteNextPageOfApiResponse =
  /** status 200 Page processed */ GmResponseCommonOffboardPageResponse;
export type SoftDeleteNextPageOfApiArg = {
  organizationId: string;
};
export type ListOviBoundariesApiResponse =
  /** status 200 Migrated OVI boundaries returned */ GmResponseCommonGmPageMigratedBoundary;
export type ListOviBoundariesApiArg = {
  /** CSP organization ID filter */
  organizationId?: string;
  /** CSP fleet ID filter */
  fleetId?: string;
  /** OVI business account ID filter */
  oviAccountId?: string;
  /** OVI fleet account ID filter */
  oviFleetId?: string;
  /** OVI boundary ID filter */
  oviBoundaryId?: string;
  /** CSP geofence ID filter */
  id?: string;
  /** Max number of items per page for pagination */
  size?: number;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type SyncBoundariesApiResponse =
  /** status 200 Sync results returned */ GmResponseCommonSyncOviBoundariesResponse;
export type SyncBoundariesApiArg = {
  /** Forces changed writes even when the combined change sequence matches. */
  'FORCE-CHANGE'?: boolean;
  syncOviBoundariesRequest: SyncOviBoundariesRequest;
};
export type ValidateBoundariesApiResponse =
  /** status 200 Validation results returned */ GmResponseCommonValidateOviBoundariesResponse;
export type ValidateBoundariesApiArg = {
  validateOviBoundariesRequest: ValidateOviBoundariesRequest;
};
export type GetGeofenceCountByRuleIdsApiResponse =
  /** status 200 Successfully return geofence count based on rule id's provided */ GmResponseCommonMapStringInteger;
export type GetGeofenceCountByRuleIdsApiArg = {
  /** Organization ID to which the geofence belongs */
  'cs-organization': string;
  /** Fleet ID to which the geofence belongs. Optional. */
  'cs-fleet'?: string;
  ruleGeofenceCountRequest: RuleGeofenceCountRequest;
};
export type CreateGeofenceApiResponse =
  /** status 201 Geofence created successfully. */ GmResponseCommonGeofenceCreateResponse;
export type CreateGeofenceApiArg = {
  /** Organization Id */
  'cs-organization': string;
  /** Fleet Id */
  'cs-fleet'?: string;
  geofenceCreateRequest: GeofenceCreateRequest;
};
export type FetchGeofencesApiResponse =
  /** status 200 Success */
  | GmResponseCommonGmPageGeofenceItem
  | /** status 204 No Geofence Found */ GmResponseCommonGmPageGeofenceItem;
export type FetchGeofencesApiArg = {
  /** Number of items per page (1-100) */
  pageSize?: number;
  /** Whether to include rule information */
  includeRules?: boolean;
  /** Organization ID to which the geofences belong */
  'cs-organization': string;
  /** Fleet ID to which the geofences belong. Optional. */
  'cs-fleet'?: string;
  /** Continuation token for pagination from previous request */
  'cs-continuation-token'?: string;
  geofenceRequest: GeofenceRequest;
};
export type DeleteGeofenceApiResponse =
  /** status 200 Geofence successfully marked as deleted */ GmResponseCommonVoid;
export type DeleteGeofenceApiArg = {
  /** The ID of the geofence to delete */
  geofenceId: string;
  /** Organization ID to which the geofence belongs */
  'cs-organization': string;
  /** Fleet ID to which the geofence belongs. Optional. */
  'cs-fleet'?: string;
};
export type UpdateGeofenceApiResponse =
  /** status 200 Geofence updated successfully. */ GmResponseCommonGeofenceItem;
export type UpdateGeofenceApiArg = {
  /** Organization Id */
  'cs-organization': string;
  /** Fleet Id */
  'cs-fleet'?: string;
  /** Geofence Id */
  geofenceId: string;
  geofenceUpdateRequest: GeofenceUpdateRequest;
};
export type AssignRuleIdsToGeofenceApiResponse =
  /** status 200 Rule assignments successfully updated for geofence */
  | GmResponseCommonAssignRulesResponse
  | /** status 206 Rule assignments updated but some subscription creations failed (partial success) */ GmResponseCommonAssignRulesResponse;
export type AssignRuleIdsToGeofenceApiArg = {
  /** The ID of the geofence to update with rule IDs */
  geofenceId: string;
  /** Organization ID to which the geofence belongs */
  'cs-organization': string;
  /** Fleet ID to which the geofence belongs. */
  'cs-fleet'?: string;
  /** Optional timezone for subscription creation (e.g., 'America/New_York', 'America/Detroit'). Defaults to UTC if not provided. */
  timezone?: string;
  assignRulesRequest: AssignRulesRequest;
};
export type GetGeofencesIdAndNameByRuleIdApiResponse =
  /** status 200 Successfully return a list of geofences ids and names based on rule id provided */
  | GmResponseCommonListGeofenceByRuleIdResponse
  | /** status 204 No Geofences Found for the given rule id */ GmResponseCommonListGeofenceByRuleIdResponse;
export type GetGeofencesIdAndNameByRuleIdApiArg = {
  /** Organization ID to which the geofence belongs */
  'cs-organization': string;
  /** Fleet ID to which the geofence belongs. Optional. */
  'cs-fleet'?: string;
  /** Rule ID to fetch associated geofences */
  ruleId: string;
};
export type GetOrdersV20260505ApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersPageV20260505Dto;
export type GetOrdersV20260505ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Continuation token returned in the previous response's continuationToken field. Omit or leave blank for the first page. */
  'cs-continuation-token'?: string;
  /** If true, includes orders where ingestionType is AUTO_IMPORT in addition to MANUAL and
                        legacy orders; if false (default), only MANUAL or unset ingestionType are returned. */
  includeAutoImportedOrders?: boolean;
  ordersListV20260505Dto: OrdersListV20260505Dto;
};
export type ExportOrdersV20260505ApiResponse = /** status 200 OK */ CsvRowDto[];
export type ExportOrdersV20260505ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** If true, includes orders where ingestionType is AUTO_IMPORT in addition to MANUAL and
                        legacy orders; if false (default), only MANUAL or unset ingestionType are returned. */
  includeAutoImportedOrders?: boolean;
  ordersExportV20260505Dto: OrdersExportV20260505Dto;
};
export type AutoImportApiResponse =
  /** status 200 OK */ GmResponseCommonAutoImportResponseDto;
export type AutoImportApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  autoImportRequestDto: AutoImportRequestDto;
};
export type AddOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonAddOrdersDto;
export type AddOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  orderCodesDto: OrderCodesDto;
};
export type GetOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersPageDto;
export type GetOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  ordersListDto: OrdersListDto;
};
export type ExportOrdersApiResponse = /** status 200 OK */ CsvRowDto[];
export type ExportOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  ordersListDto: OrdersListDto;
};
export type DeleteOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonListString;
export type DeleteOrdersApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  removeCodesDto: RemoveCodesDto;
};
export type GetOrderFiltersApiResponse =
  /** status 200 OK */ GmResponseCommonOrderFiltersDto;
export type GetOrderFiltersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /**
                        If true, includes all orders (manual, auto-imported, and legacy);
                        if false (default), only MANUAL or unset ingestionType.
                     */
  includeAutoImportedOrders?: boolean;
};
export type GetOrderCountApiResponse =
  /** status 200 OK */ GmResponseCommonOrdersCountDto;
export type GetOrderCountApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet Account Number. */
  fan?: string;
  /** ISO 8601 instant (e.g. 2026-10-07T01:01:00Z). When provided, only orders whose updatedAt is on or after this timestamp are included. When absent, all orders are returned. */
  afterTimestamp?: string;
  /** Number of minutes (0–1440 or 24 hours) to subtract from afterTimestamp to widen the query window. Only applies when afterTimestamp is provided. Defaults to 0. */
  afterTimeInterval?: number;
};
export type GetOrderApiResponse =
  /** status 200 OK */ GmResponseCommonSingleOrderDto;
export type GetOrderApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  orderCode: string;
};
export type GetOrderSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonMapStatusInteger;
export type GetOrderSummaryApiArg = {
  /** Organization ID. */
  'x-bd-organization': string;
  /**
                        If true, includes AUTO_IMPORT orders in the per-status counts;
                        if false (default), only MANUAL or unset ingestionType orders are counted.
                     */
  includeAutoImportedOrders?: boolean;
};
export type SoftDeleteOrdersApiResponse =
  /** status 200 OK */ GmResponseCommonDeletedOrdersDto;
export type SoftDeleteOrdersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  softDeleteRequestDto: SoftDeleteRequestDto;
};
export type UpdateVerificationStatusApiResponse =
  /** status 200 Successfully updated verification status. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateVerificationStatusApiArg = {
  /** ID of the organization to update */
  orgId: string;
  verificationStatusUpdateRequest: VerificationStatusUpdateRequest;
};
export type GetAutoOnboardingSettingsApiResponse =
  /** status 200 Successfully retrieved auto-onboarding settings. */ GmResponseCommonAutoOnboardingSettingsResponse;
export type GetAutoOnboardingSettingsApiArg = {
  orgId: string;
};
export type UpdateAutoOnboardingSettingsApiResponse =
  /** status 200 Successfully updated auto-onboarding settings. */ GmResponseCommonAutoOnboardingSettingsResponse;
export type UpdateAutoOnboardingSettingsApiArg = {
  orgId: string;
  autoOnboardingSettingsUpdateRequest: AutoOnboardingSettingsUpdateRequest;
};
export type UpdateFleetV20250114ApiResponse =
  /** status 200 Successfully updated fleet. */ GmResponseCommonFleetResponse;
export type UpdateFleetV20250114ApiArg = {
  organizationId: string;
  fleetId: string;
  fleetUpdateRequestV20250115: FleetUpdateRequestV20250115;
};
export type UpdateOrganizationV20241204ApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateOrganizationV20241204ApiArg = {
  /** ID of the organization to update */
  orgId: string;
  organizationUpdateRequestV20241204: OrganizationUpdateRequestV20241204;
};
export type UpdateOrganizationV20230717ApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20230717;
export type UpdateOrganizationV20230717ApiArg = {
  /** ID of the organization to update */
  orgId: string;
  organizationUpdateRequest: OrganizationUpdateRequest;
};
export type UpdateFleetsByOrganizationIdAndFleetIdApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponse;
export type UpdateFleetsByOrganizationIdAndFleetIdApiArg = {
  /** organization id for fleet's parent */
  orgId: string;
  /** fleet id */
  fleetId: string;
  fleetUpdateRequest: FleetUpdateRequest;
};
export type LookupEnrollmentApiResponse =
  /** status 200 Lookup successful — returns candidate list. */ GmResponseCommonEnrollmentLookupResponse;
export type LookupEnrollmentApiArg = {
  enrollmentUnifiedLookupRequest: EnrollmentUnifiedLookupRequest;
};
export type SyncOviBusinessAccountApiResponse =
  /** status 200 Successfully synced OVI account. */ GmResponseCommonSyncOviBusinessAccountResponse;
export type SyncOviBusinessAccountApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  accountId: string;
  syncOviBusinessAccountRequest: SyncOviBusinessAccountRequest;
};
export type GetOrganizationsInfoV20260120ApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationViewResponseV20260113;
export type GetOrganizationsInfoV20260120ApiArg = {
  organizationViewRequest: OrganizationViewRequest;
};
export type LookupOrganizationByInfoApiResponse =
  /** status 200 Lookup performed successfully. */ GmResponseCommonCspCandidate;
export type LookupOrganizationByInfoApiArg = {
  organizationLookupRequest: OrganizationLookupRequest;
};
export type LookupOrganizationByRawAddressInfoApiResponse =
  /** status 200 ODI returned a successful raw-address lookup payload. */ GmResponseCommonOrganizationLookupRawAddressResponse;
export type LookupOrganizationByRawAddressInfoApiArg = {
  organizationLookupRequestRawAddress: OrganizationLookupRequestRawAddress;
};
export type EnrollAutomaticApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAutomaticApiArg = {
  odiMatchConfirmation: OdiMatchConfirmation;
};
export type EnrollForReviewApiResponse =
  /** status 201 Enrollment application submitted to advisor. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollForReviewApiArg = {
  enrollNoMatchRequest: EnrollNoMatchRequest;
};
export type AcceptTermsApiResponse =
  /** status 200 OK */ GmResponseCommonTermsResponseV20250211;
export type AcceptTermsApiArg = {
  /** The id of the organization to accept terms for. */
  orgId: string;
  termsRequestV20250211: TermsRequestV20250211;
};
export type EnrollAsCustomerApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAsCustomerApiArg = {
  enrollmentRequest: EnrollmentRequest;
};
export type DeclineEnrollmentApiResponse =
  /** status 200 Successfully declined enrollment. */ GmResponseCommonVoid;
export type DeclineEnrollmentApiArg = {
  id: string;
  enrollmentDeclineRequest: EnrollmentDeclineRequest;
};
export type ApproveEnrollmentApiResponse =
  /** status 200 Successfully approved enrollment. */ GmResponseCommonVoid;
export type ApproveEnrollmentApiArg = {
  /** If true, skips the creation of the admin user for the organization. */
  skipAdminCreation?: boolean;
  id: string;
};
export type EnrollAsAdminApiResponse =
  /** status 201 Successfully submitted enrollment. */ GmResponseCommonEnrollmentSubmissionResponse;
export type EnrollAsAdminApiArg = {
  adminEnrollmentRequest: AdminEnrollmentRequest;
};
export type UpdateOrgDefaultFleetApiResponse =
  /** status 200 Successfully updated organization. */ GmResponseCommonOrganizationResponseV20241120;
export type UpdateOrgDefaultFleetApiArg = {
  id: string;
  updateDefaultFleetRequest: UpdateDefaultFleetRequest;
};
export type CreateFleetApiResponse =
  /** status 201 Successfully created fleet. */ GmResponseCommonFleetCreateResponse;
export type CreateFleetApiArg = {
  organizationId: string;
  fleetCreateRequestV20240926: FleetCreateRequestV20240926;
};
export type CheckIfFleetConfigHasChangedApiResponse =
  /** status 200 Successful Operation */ boolean;
export type CheckIfFleetConfigHasChangedApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
  action: string;
  configChangeCheckRequest: ConfigChangeCheckRequest;
};
export type GetOrganizationsInfoApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationsViewResponse;
export type GetOrganizationsInfoApiArg = {
  organizationViewRequest: OrganizationViewRequest;
};
export type GetOrganizationFanDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationFanResponse;
export type GetOrganizationFanDetailsApiArg = void;
export type CheckEnrollmentInviteApiResponse =
  /** status 200 Successfully checked enrollment eligibility. */ GmResponseCommonEnrollmentInviteResponse;
export type CheckEnrollmentInviteApiArg = void;
export type GetOrganizationByOrgIdApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationDto;
export type GetOrganizationByOrgIdApiArg = {
  /** Organization's identification. */
  orgId: string;
};
export type GetAllFleetsApiResponse =
  /** status 200 Successfully retrieved fleets. */ GmResponseCommonGmPageFleetResponse;
export type GetAllFleetsApiArg = {
  /** Organization ID. */
  organizationId: string;
  /** Number of fleets to return. */
  size?: number;
  /** Token to continue fetching fleets. */
  continuationToken?: string;
  /** Filter fleets by name. */
  fleetName?: string;
};
export type GetFleetByIdApiResponse =
  /** status 200 OK */ GmResponseCommonFleetResponse;
export type GetFleetByIdApiArg = {
  organizationId: string;
  fleetId: string;
};
export type GetAllOrganizationsApiResponse =
  /** status 200 Successfully retrieved organizations. */ GmResponseCommonPaginatedDataResponseOrganizationResponseV20241120;
export type GetAllOrganizationsApiArg = {
  /** The name of the organization to search for. */
  name?: string;
  /** The fan of the organization to search for. */
  fan?: string;
  /** The primary email address of the organization to search for. */
  email?: string;
  /** Filter by list of organizations status. */
  statuses?: (
    | 'DRAFT'
    | 'PENDING'
    | 'ENROLLING'
    | 'ACTIVE'
    | 'DISABLED'
    | 'DELETED'
    | 'ABORTED'
    | 'RETIRED'
  )[];
  /** Number of organizations to return. */
  size?: number;
  /** Token to continue fetching organizations. */
  continuationToken?: string;
};
export type GetOrgByIdApiResponse =
  /** status 200 Successfully retrieved organization. */ GmResponseCommonOrganizationResponseV20241120;
export type GetOrgByIdApiArg = {
  id: string;
};
export type GetCapDetailsApiResponse =
  /** status 200 Successful Communication with GFSS  */ GmResponseCommonCapsResponse;
export type GetCapDetailsApiArg = {
  'x-bd-organization': string;
};
export type GetDocumentApiResponse =
  /** status 200 Successfully retrieved CAP Agreement PDF for document id */ string;
export type GetDocumentApiArg = {
  'x-bd-organization': string;
  documentId: string;
};
export type GetAllOrganizationsWithTypeApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationResponseV20230717;
export type GetAllOrganizationsWithTypeApiArg = void;
export type GetOrganizationByIdWithTypeApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationResponseV20230717;
export type GetOrganizationByIdWithTypeApiArg = {
  /** The id of the organization to retrieve. */
  id: string;
};
export type GetFleetByIdV2ApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponseV2;
export type GetFleetByIdV2ApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
};
export type GetAllOrganizations1ApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationResponseV20211115;
export type GetAllOrganizations1ApiArg = void;
export type GetAllHubsApiResponse =
  /** status 200 Successfully retrieved hubs. */ GmResponseCommonListOrganizationEntityResponse;
export type GetAllHubsApiArg = {
  /** organization id for parent */
  organizationId: string;
};
export type GetHubByIdApiResponse =
  /** status 200 Successfully retrieved hub. */ GmResponseCommonOrganizationEntityResponse;
export type GetHubByIdApiArg = {
  /** organization id of hub's parent */
  organizationId: string;
  /** Hub Id */
  hubId: string;
};
export type GetAllFleets1ApiResponse =
  /** status 200 OK */ GmResponseCommonListFleetResponseDeprecated;
export type GetAllFleets1ApiArg = {
  organizationId: string;
  hubId: string;
};
export type GetFleetById1ApiResponse =
  /** status 200 OK */ GmResponseCommonFleetConfigurationResponse;
export type GetFleetById1ApiArg = {
  organizationId: string;
  hubId: string;
  fleetId: string;
};
export type GetFleetChildrenApiResponse =
  /** status 200 Successfully retrieved fleets under the hub. */ GmResponseCommonOrganizationViewJson;
export type GetFleetChildrenApiArg = {
  /** Organization ID. */
  organizationId: string;
  /** Hub ID. */
  hubId: string;
  /** Fleet ID. */
  fleetId: string;
};
export type GetHubChildrenApiResponse =
  /** status 200 Successfully retrieved hub children. */ GmResponseCommonOrganizationViewJson;
export type GetHubChildrenApiArg = {
  /** org Id for org entity */
  organizationId: string;
  /** Hub Id */
  hubId: string;
};
export type GetOrganizationChildrenApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationViewJson;
export type GetOrganizationChildrenApiArg = {
  /** The id of the organization to retrieve children for. */
  orgId: string;
};
export type GetOrganizationByIdApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationResponseV20211115;
export type GetOrganizationByIdApiArg = {
  id: string;
};
export type GetOrganizationStatsByIdApiResponse =
  /** status 200 OK */ GmResponseCommonStatsV1;
export type GetOrganizationStatsByIdApiArg = {
  id: string;
};
export type GetAllFleetsByOrganizationIdApiResponse =
  /** status 200 OK */ GmResponseCommonListFleetResponseDeprecated;
export type GetAllFleetsByOrganizationIdApiArg = {
  /** The id of the organization to retrieve fleets for. */
  id: string;
};
export type GetTopLevelOrganizationsApiResponse =
  /** status 200 OK */ GmResponseCommonListOrganizationMinViewDto;
export type GetTopLevelOrganizationsApiArg = void;
export type ProcessSurfsightOrderUpdateWebhookApiResponse = unknown;
export type ProcessSurfsightOrderUpdateWebhookApiArg = {
  body: string;
};
export type ProcessSurfsightWebhookPayloadApiResponse =
  /** status 200 Received. Check `success` for whether the payload was processed. */ GmResponseCommon;
export type ProcessSurfsightWebhookPayloadApiArg = {
  'X-Surfsight-Signature'?: string;
  body: string;
};
export type FetchRecordingAvailabilityApiResponse =
  /** status 204 Refresh request accepted; no response body */ string;
export type FetchRecordingAvailabilityApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The peripheral ID to refresh recording availability for. */
  peripheralId: string;
};
export type RetryClipApiResponse = /** status 200 Success */ GmResponseCommon;
export type RetryClipApiArg = {
  /**
                        Unique identifier of the clip to retry. The clip must be in a state that allows
                        retry (for example, not READY or PENDING).
                     */
  clipId: string;
  /** Organization ID of the user. */
  'cs-organization': string;
  /**
                        Fleet ID to scope the retry. When omitted, the retry is evaluated with organization-wide
                        access for the caller.
                     */
  'cs-fleet'?: string;
};
export type GetClipsApiResponse =
  /** status 200 Success */ GmResponseCommonRetrieveClipsResponseDto;
export type GetClipsApiArg = {
  /** Organization ID of the user. */
  'cs-organization': string;
  /** Fleet ID to filter clips by. If not provided, clips across all fleets are returned. */
  'cs-fleet'?: string;
  /** Sets items count in a page. Minimum 1, maximum 200. Defaults to 10. */
  size?: number;
  /**
                        Continuation token to be used to navigate to the next page
                        that comes from `result.continuation_token` response.
                        When value becomes null, it indicates that the list has reached its last page.
                     */
  'cs-continuation-token'?: string;
  /** Search keyword to filter clips by name, driver, or vehicle. */
  searchKeyword?: string;
  /** Start timestamp range filter for the selected timeWindowField. If this is provided, endDateTime and timeWindowField must be specified. */
  startDateTime?: string;
  /** End timestamp range filter for the selected timeWindowField. If this is provided, startDateTime and timeWindowField must be specified. */
  endDateTime?: string;
  /** The field to search the date range against the provided startDateTime and endDateTime. Required when startDateTime or endDateTime is provided. */
  timeWindowField?: 'createdTimestampInUTC' | 'startTimestampInUTC';
  /** Sort clips by the specified field. */
  sortBy?: 'createdTimestampInUTC' | 'startTimestampInUTC';
  /** Sort direction for the results. */
  sortDirection?: 'ASC' | 'DESC';
};
export type CreateClipApiResponse =
  /** status 201 Created */ GmResponseCommonClipDetailsDto;
export type CreateClipApiArg = {
  /** Organization ID of the user. */
  'cs-organization': string;
  /** Fleet ID to scope the clip creation. Optional. */
  'cs-fleet'?: string;
  createClipRequestDto: CreateClipRequestDto;
};
export type RetryActivatePeripheralsApiResponse =
  /** status 200 Success - Returns batch ID for tracking */ GmResponseCommonActivatePeripheralsResponseDto;
export type RetryActivatePeripheralsApiArg = {
  /** Organization ID of the peripherals. User must have operation access to this organization. */
  'x-bd-organization': string;
  /** Fleet ID of the peripherals. User must have operation access to this fleet. */
  'x-bd-fleet'?: string;
  activatePeripheralsRequestDto: ActivatePeripheralsRequestDto;
};
export type ExportPeripheralsApiResponse = /** status 200 Success */ Blob;
export type ExportPeripheralsApiArg = {
  exportPeripheralsRequestDto: ExportPeripheralsRequestDto;
};
export type ProcessOrderUpdateApiResponse =
  /** status 200 Update processed */ GmResponseCommonOrderUpdateAdminResponse;
export type ProcessOrderUpdateApiArg = {
  /** Vendor make (`GEOTAB` or `LYTX`). */
  vendor: string;
  jsonNode: JsonNode;
};
export type CleanPeripheralApiResponse =
  /** status 200 Peripheral cleaned */ GmResponseCommonCleanPeripheralAdminResponse;
export type CleanPeripheralApiArg = {
  cleanPeripheralAdminRequest: CleanPeripheralAdminRequest;
};
export type ProcessPlugEventApiResponse =
  /** status 200 Plug event processed */ GmResponseCommonAdapterPlugEventAdminResponse;
export type ProcessPlugEventApiArg = {
  adapterPlugEventAdminRequest: AdapterPlugEventAdminRequest;
};
export type ActivatePeripheralsApiResponse =
  /** status 200 Success - Returns batch ID for tracking */ GmResponseCommonActivatePeripheralsResponseDto;
export type ActivatePeripheralsApiArg = {
  /** Organization ID of the peripherals. User must have operation access to this organization. */
  'x-bd-organization': string;
  /** Fleet ID of the peripherals. User must have operation access to this fleet. */
  'x-bd-fleet'?: string;
  activatePeripheralsRequestDto: ActivatePeripheralsRequestDto;
};
export type GetPeripheralsByVinsApiResponse =
  /** status 200 Success */ GmResponseCommonListPeripheralSummaryDto;
export type GetPeripheralsByVinsApiArg = {
  /** Organization ID of the peripherals. User must have operation access to this organization. */
  'cs-organization': string;
  /** Fleet ID to filter peripherals by. If provided, only peripherals in this fleet will be returned. */
  'cs-fleet'?: string;
  /** Filter peripherals by peripheral type. If not provided, all types are returned. */
  type?: string;
  getPeripheralsByVinsRequestDto: GetPeripheralsByVinsRequestDto;
};
export type TransferPeripheralsApiResponse =
  /** status 200 Transfer completed */ GmResponseCommonTransferResultDto;
export type TransferPeripheralsApiArg = {
  organizationTransferRequest: OrganizationTransferRequest;
};
export type UnlinkVehicleApiResponse =
  /** status 200 Success */ GmResponseCommon;
export type UnlinkVehicleApiArg = {
  /** Peripheral ID */
  id: string;
  /** Organization ID of the peripheral and user must have operation access to this organization. */
  'x-bd-organization': string;
  'x-bd-fleet'?: string;
};
export type MoveFleetApiResponse =
  /** status 200 If ALL IDs were processed successfully. */ GmResponseCommonMoveFleetResponseDto;
export type MoveFleetApiArg = {
  /** Organization ID of the provided peripheral IDs. */
  'x-bd-organization': string;
  moveFleetRequestDto: MoveFleetRequestDto;
};
export type LinkToVehicleApiResponse =
  /** status 200 Success */ GmResponseCommon;
export type LinkToVehicleApiArg = {
  /** Peripheral ID */
  id: string;
  /** Organization ID of the peripheral and user must have operation access to this organization. */
  'x-bd-organization': string;
  /** Fleet ID assigned to the peripheral. */
  'x-bd-fleet': string;
  linkToVehicleRequestDto: LinkToVehicleRequestDto;
};
export type BatchOnboardPeripheralsApiResponse =
  /** status 202 Accepted */ GmResponseCommonOnboardResponseDto;
export type BatchOnboardPeripheralsApiArg = {
  /** Organization ID */
  organizationId: string;
  /** Peripheral type */
  type: string;
  body: {
    file: Blob;
  };
};
export type UpdateSettingsApiResponse = /** status 200 OK */ GmResponseCommon;
export type UpdateSettingsApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  body: {
    [key: string]: SettingDetailsDto;
  };
};
export type GetAccessTokenApiResponse =
  /** status 200 Success */ GmResponseCommonString;
export type GetAccessTokenApiArg = void;
export type GetRecordingsByMonthApiResponse =
  /** status 200 Successfully retrieved recording dates */ GmResponseCommonListLocalDate;
export type GetRecordingsByMonthApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The peripheral ID to retrieve recordings for. */
  peripheralId: string;
  /** The year-month to filter recordings by (e.g. 2026-03). */
  yearMonth: string;
  /**
                        Optional offset from UTC in whole hours, used to decide which calendar day each
                        recorded instant falls on (e.g. -5 for US Eastern). Allowed range is -12 through
                        14. If not provided, UTC (0) is used.
                     */
  timezoneOffset?: number;
};
export type GetRecordingsByDateApiResponse =
  /** status 200 Successfully retrieved recording windows */ GmResponseCommonListCameraTripDto;
export type GetRecordingsByDateApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The peripheral ID to retrieve recordings for. */
  peripheralId: string;
  /** The date to retrieve recordings for (e.g. 2026-03-10). */
  localDate: string;
  /**
                        Optional offset from UTC in whole hours, used to decide which calendar day each
                        trip instant falls on (e.g. -5 for US Eastern). Allowed range is -12 through 14.
                        If not provided, UTC (0) is used.
                     */
  timezoneOffset?: number;
};
export type GetMediaInternalApiResponse =
  /** status 200 Success */ GmResponseCommonString;
export type GetMediaInternalApiArg = {
  /** The event ID for the media. */
  eventId: string;
  /** The organization ID where the event belongs to. */
  'cs-organization': string;
  /** The fleet ID where the event belongs to. */
  'cs-fleet'?: string;
  /** The type of media to retrieve. Defaults to SNAPSHOT */
  mediaType?: 'SNAPSHOT' | 'VIDEO';
  /** The camera position to retrieve. Defaults to INWARD */
  cameraPosition?: 'INWARD' | 'OUTWARD';
};
export type GetMediaApiResponse =
  /** status 200 Success */ GmResponseCommonString;
export type GetMediaApiArg = {
  /** The event ID for the media. */
  eventId: string;
  /** The organization ID where the event belongs to. */
  'cs-organization': string;
  /** The fleet ID where the event belongs to. */
  'cs-fleet'?: string;
  /** The type of media to retrieve. Defaults to SNAPSHOT */
  mediaType?: 'SNAPSHOT' | 'VIDEO';
  /** The camera position to retrieve. Defaults to INWARD */
  cameraPosition?: 'INWARD' | 'OUTWARD';
};
export type GetClipDetailsApiResponse =
  /** status 200 Success */ GmResponseCommonClipDetailsDto;
export type GetClipDetailsApiArg = {
  /** Unique identifier of the clip. */
  id: string;
  /** Organization ID of the user. */
  'cs-organization': string;
  /** Fleet ID to scope the clip lookup. If not provided, the clip is looked up across all fleets. */
  'cs-fleet'?: string;
};
export type GetCameraAssignmentsApiResponse =
  /** status 200 OK */ GmResponseCommonListCameraAssignmentDto;
export type GetCameraAssignmentsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Search for making partial matches to VINs and vehicle names. */
  searchKeyword?: string;
};
export type GetSettingsApiResponse =
  /** status 200 Successfully retrieved settings */ GmResponseCommonListCameraSettingDto;
export type GetSettingsApiArg = {
  /** The organization ID to which the settings belong. */
  'cs-organization': string;
  /** The fleet ID for which the settings belong. */
  'cs-fleet'?: string;
};
export type GetPeripheralStatusCountsApiResponse =
  /** status 200 Success */ GmResponseCommonPeripheralStatusCountsResponseDto;
export type GetPeripheralStatusCountsApiArg = {
  /** Organization ID. User must have read access to this organization. */
  'x-bd-organization': string;
  /** Peripheral type to count (adapter, fleet-camera, fleet-key-module). */
  type: string;
  /**
                        Optional fleet ID(s) to filter by. Supports comma-separated values (e.g., fleet1,fleet2).
                        When omitted, counts include all devices in the organization.
                     */
  fleetIds?: string;
};
export type GetOrderByIdApiResponse =
  /** status 200 Success */ GmResponseCommonPeripheralOrder;
export type GetOrderByIdApiArg = {
  /** Order ID */
  orderId: string;
  /** Organization ID of the peripheral order. User must have operation access to this organization. */
  'cs-organization': string;
};
export type GetAdapterSupportedFeaturesApiResponse =
  /** status 200 Success */ GmResponseCommonAdapterSupportedFeaturesResponseDto;
export type GetAdapterSupportedFeaturesApiArg = {
  /** Vehicle Identification Number (VIN). */
  vin: string;
};
export type GetPeripheralByIdApiResponse =
  /** status 200 Success */ GmResponseCommonPeripheralSummaryDto;
export type GetPeripheralByIdApiArg = {
  /** Peripheral ID */
  id: string;
  /** Organization ID of the peripheral. User must have operation access to this organization. */
  'cs-organization': string;
};
export type GetPeripheralsApiResponse =
  /** status 200 Success */ GmResponseCommonRetrievePeripheralsResponseDto;
export type GetPeripheralsApiArg = {
  /** Filter peripheral by organization ID. Defaults to the user's assigned organization ID. */
  organizationId?: any;
  /**
                            Filter peripheral by fleet ID(s). Supports multiple comma-separated values (e.g., fleet1,fleet2).
                            Defaults to the user's assigned fleet ID. If no fleet ID is present, it will return all peripherals for the organization.
                         */
  fleetId?: any;
  /** Filter peripheral by the device's serial number. */
  serialNumber?: any;
  /** Filter peripheral by imei. */
  imei?: any;
  /** Filter peripheral by peripheral type. */
  type?: any;
  /** Filter peripheral by manufacturer. */
  make?: any;
  /** Filter peripheral by model name. */
  model?: any;
  /** Filter peripheral by VIN where it is attached to. */
  vin?: any;
  /** Filter peripheral whether it is attached to VIN or not. */
  hasAttachedVin?: any;
  /** Filter peripheral by pre-paid status. */
  isPrePaid?: any;
  /** Filter peripheral by status(es). Supports multiple comma-separated values (e.g., assigned,unassigned). */
  status?: any;
  /** Filter peripheral by linked vehicle's license plate. */
  licensePlate?: any;
  /** Filter peripheral by linked vehicle's name. */
  attachedVehicleName?: any;
  /**
                           Filter peripheral by last communicated date in UTC in ISO 8601 Format
                           where value will be INCLUSIVE when filtered.
                           
                           Only works if 'lastCommunicatedDateEnd' is also provided.
                         */
  lastCommunicatedDateStart?: any;
  /**
                           Filter peripheral by last communicated date in UTC in ISO 8601 Format
                           where value will be EXCLUSIVE when filtered.
                           
                           Only works if 'lastCommunicatedDateStart' is also provided.
                         */
  lastCommunicatedDateEnd?: any;
  /** Filter peripheral by firmware version (case-insensitive partial match). */
  firmware?: any;
  /**
                        Sort peripherals by one or more fields (comma-separated).
                        Valid values: 'serialNumber', 'imei' (e.g. serialNumber,imei).
                        If not provided or invalid value provided,
                        defaults to 'creationDateTime' DESC (original behavior).
                     */
  sortBy?: string;
  /**
                        Sort direction for the results when sortBy is specified.
                        Allowed values: 'asc' (ascending), 'desc' (descending).
                        Defaults to 'desc' if not provided or invalid.
                     */
  sortDirection?: string;
  /** Sets items count in a page. */
  size?: number;
  /**
                Continuation token to be used to navigate to the next page
                that comes from `result.continuation_token` response.
             */
  continuationToken?: string;
};
export type GetBatchEntityApiResponse =
  /** status 200 OK */ GmResponseCommonBatchEntityResponseDto;
export type GetBatchEntityApiArg = {
  /** Peripheral batch ID */
  id: string;
  'x-bd-organization': string;
};
export type DeleteClipApiResponse = /** status 200 Success */ GmResponseCommon;
export type DeleteClipApiArg = {
  /** Unique identifier of the clip to delete. */
  clipId: string;
  /** Organization ID of the user. */
  'cs-organization': string;
  /**
                        Fleet ID to scope the delete. When omitted, the delete is evaluated with organization-wide
                        access for the caller.
                     */
  'cs-fleet'?: string;
};
export type UpdateReportMetadataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type UpdateReportMetadataApiArg = {
  /** The report Id for the report to update. */
  reportId: string;
  reportMetadataRequestBodyDto: ReportMetadataRequestBodyDto;
};
export type CreateOrUpdateUserReportFiltersApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type CreateOrUpdateUserReportFiltersApiArg = {
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  userDefinedFilterDto: UserDefinedFilterDto;
};
export type ExportReportApiResponse =
  /** status 200 Request was successful. */ object;
export type ExportReportApiArg = {
  /** The report type to export for the given report type. */
  reportType: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type ExportReportCsvApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportReportCsvApiArg = {
  /** The report type to export for the given report type. */
  reportType: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type CreateReportMetadataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type CreateReportMetadataApiArg = {
  reportMetadataRequestBodyDto: ReportMetadataRequestBodyDto;
};
export type GetFilterDataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonListUserDefinedFilterDto;
export type GetFilterDataApiArg = {
  /** user id */
  userId: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
};
export type GetReportsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonListReportDescriptionDto;
export type GetReportsApiArg = {
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
};
export type AdminExportReportCsvApiResponse =
  /** status 200 Request was successful. */ Blob;
export type AdminExportReportCsvApiArg = {
  /** The report type to export. Must be SAFETY_EVENTS or TRIP_HISTORY. */
  reportType: string;
  /** Organization ID to scope the report data. */
  'cs-organization': string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type UpdateRuleApiResponse = unknown;
export type UpdateRuleApiArg = {
  /** Organization ID to which the rule belongs */
  'cs-organization': string;
  /** Fleet ID to which the rule belongs. */
  'cs-fleet'?: string;
  updateRuleRequest: UpdateRuleRequest;
};
export type CreateRuleApiResponse =
  /** status 201 Rule successfully created */ GmResponseCommonCreateRuleResponse;
export type CreateRuleApiArg = {
  /** Organization ID to which the rule belongs */
  'cs-organization': string;
  /** Fleet ID to which the rule belongs. */
  'cs-fleet'?: string;
  createRuleRequest: CreateRuleRequest;
};
export type ListOviAlertRulesApiResponse =
  /** status 200 Migrated OVI alert rules returned */ GmResponseCommonGmPageMigratedAlertRule;
export type ListOviAlertRulesApiArg = {
  /** CSP organization ID filter */
  organizationId?: string;
  /** CSP fleet ID filter */
  fleetId?: string;
  /** OVI business account ID filter */
  oviAccountId?: string;
  /** OVI fleet account ID filter */
  oviFleetId?: string;
  /** OVI alert rule ID filter */
  oviAlertRuleId?: string;
  /** CSP rule ID filter */
  ruleId?: string;
  /** Max number of items per page for pagination */
  size?: number;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type SyncAlertRulesApiResponse =
  /** status 200 Sync results returned */ GmResponseCommonSyncOviAlertRulesResponse;
export type SyncAlertRulesApiArg = {
  /**
                        When true, bypasses the change-sequence guard and forces a
                        CHANGED write even when the sequence matches.
                     */
  'FORCE-CHANGE'?: boolean;
  syncOviAlertRulesRequest: SyncOviAlertRulesRequest;
};
export type ValidateAlertRulesApiResponse =
  /** status 200 Validation results returned */ GmResponseCommonValidateOviAlertRulesResponse;
export type ValidateAlertRulesApiArg = {
  validateOviAlertRulesRequest: ValidateOviAlertRulesRequest;
};
export type GetRuleListByCategoryAndEventApiResponse =
  /** status 200 Success */
  | GmResponseCommonListRuleItemResponse
  | /** status 204 No content */ GmResponseCommonListRuleItemResponse;
export type GetRuleListByCategoryAndEventApiArg = {
  /** Organization ID to which the rule belongs */
  'cs-organization': string;
  /** Fleet ID to which the rule belongs. */
  'cs-fleet'?: string;
  ruleFilterRequest: RuleFilterRequest;
};
export type GetRulesByIdsApiResponse =
  /** status 200 Rules successfully retrieved */
  | GmResponseCommonRulesResponse
  | /** status 204 No rules found */ GmResponseCommonRulesResponse
  | /** status 206 Partial content */ GmResponseCommonRulesResponse;
export type GetRulesByIdsApiArg = {
  /** Organization ID to which the rules belong */
  'cs-organization': string;
  /** Fleet ID to which the rules belong. */
  'cs-fleet'?: string;
  getRulesRequest: GetRulesRequest;
};
export type GetUnassignedRulesApiResponse =
  /** status 200 Rules retrieved successfully */
  | GmResponseCommonListWithGeofenceCountResponse
  | /** status 204 No unassigned rules found */ GmResponseCommonListWithGeofenceCountResponse;
export type GetUnassignedRulesApiArg = {
  /** Organization ID to which the rules belong */
  'cs-organization': string;
  /** Fleet ID to which the rules belong. */
  'cs-fleet'?: string;
  /**
                        Fleet assigned to the geofence for filtering rules.
                        Can be empty, 'ALL', or any string representing a fleet ID.
                        - When null, empty, or 'ALL': returns rules with 'ALL' in assignedFleetIds or assignedFleetIds.
                        - When a specific fleet ID: returns rules with that fleet ID OR 'ALL' OR assignedFleetIds.
                     */
  assignedFleetId?: string;
  /** When true, excludes org-wide rules (assignedFleetIds contains 'ALL'). Default false. */
  excludeOrgWideRules?: boolean;
  getListWithGeofenceCountRequest: GetListWithGeofenceCountRequest;
};
export type GetRulesWithSubscriptionsApiResponse =
  /** status 200 Rules retrieved successfully */
  | GmResponseCommonRuleListWithSubscriptionsResponse
  | /** status 204 No rules found */ GmResponseCommonRuleListWithSubscriptionsResponse;
export type GetRulesWithSubscriptionsApiArg = {
  /** Organization ID to which the rules belong */
  'cs-organization': string;
  /** Fleet ID to which the rules belong. */
  'cs-fleet'?: string;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
  /** Number of items per page (1-10) */
  pageSize?: number;
  /** Rule category to filter by. Defaults to geofence. */
  category?: string;
};
export type DeleteRuleApiResponse =
  /** status 204 Rule successfully deleted */ string;
export type DeleteRuleApiArg = {
  /** Organization ID to which the rule belongs */
  'cs-organization': string;
  /** Fleet ID to which the rule belongs. */
  'cs-fleet'?: string;
  ruleId: string;
};
export type RetrieveSafetyEventsByTripIdsApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyTripEventsResponseDto
  | /** status 204 No Content */ GmResponseCommonSafetyTripEventsResponseDto
  | /** status 206 Partial Content */ GmResponseCommonSafetyTripEventsResponseDto;
export type RetrieveSafetyEventsByTripIdsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  safetyTripEventsRequestDto: SafetyTripEventsRequestDto;
};
export type GetVehicleSettingsApiResponse =
  /** status 200 Success */ GmResponseCommonEventSettingsDto;
export type GetVehicleSettingsApiArg = {
  /** Organization ID */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
};
export type UpdateVehicleSettingsApiResponse =
  /** status 200 Success */ GmResponseCommon;
export type UpdateVehicleSettingsApiArg = {
  /** Organization ID */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  eventSettingsRequest: EventSettingsRequest;
};
export type RetrieveEmergencyEventSummaryApiResponse =
  /** status 200 Success */ GmResponseCommonListSafetyApiEventTypeCountDto;
export type RetrieveEmergencyEventSummaryApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. Counts cover all fleets in the organization when omitted. */
  'cs-fleet'?: string;
};
export type RetrieveSafetyEventsV2ApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto
  | /** status 204 No safety events found */ GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto;
export type RetrieveSafetyEventsV2ApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty */
  eventTypes?: string[];
  /** Filter events by a specific driver ID. Defaults to all drivers if empty. */
  driverId?: string;
  /** Search for making partial matches to VINs. */
  searchKeyword?: string;
  /** Filters events to only include those with media. */
  hasMedia?: boolean;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type RetrieveSafetyEventDetailsByIdApiResponse =
  /** status 200 Success */ GmResponseCommonSafetyApiEventDetailsV2Dto;
export type RetrieveSafetyEventDetailsByIdApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The ID of the safety event */
  id: string;
};
export type RetrieveSafetyEventsForSelfV2ApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto
  | /** status 204 No safety events found */ GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto;
export type RetrieveSafetyEventsForSelfV2ApiArg = {
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty */
  eventTypes?: string[];
  /** Search for making partial matches to VINs. */
  searchKeyword?: string;
  /** Filters events to only include those with media. */
  hasMedia?: boolean;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type GetDriverScoreDetailsForSelfApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoreDetailsDto;
export type GetDriverScoreDetailsForSelfApiArg = void;
export type GetVehicleScoresApiResponse =
  /** status 200 Success */ GmResponseCommonVehicleScoresResponse;
export type GetVehicleScoresApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Pagination continuation token. */
  'cs-continuation-token'?: string;
  /** Search substring for vehicle VIN. */
  vinSearch?: string;
  /** Minimum score of the vehicle scores. */
  minScore?: number;
  /** Maximum score of the vehicle scores. */
  maxScore?: number;
  /** Exclude vehicles without score (no trips recently). */
  excludeNoScore?: boolean;
  /** ASC or DESC. */
  sortOrder?: 'ASC' | 'DESC';
  /** Page size. */
  size?: number;
};
export type GetDriverScoresSummaryApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoresSummaryDto;
export type GetDriverScoresSummaryApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
};
export type GetScoreApiResponse =
  /** status 200 Success */ GmResponseCommonFleetScoreDto;
export type GetScoreApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet': string;
};
export type GetDriverScoresApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoresResponse;
export type GetDriverScoresApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Pagination continuation token. */
  'cs-continuation-token'?: string;
  /** Search substring for driver name. */
  driverNameSearch?: string;
  /** Minimum score filter (0–100). */
  minScore?: number;
  /** Maximum score filter (0–100). */
  maxScore?: number;
  /** Minimum rank filter. */
  minRank?: number;
  /** Maximum rank filter. */
  maxRank?: number;
  /** Exclude drivers without score (no trips recently). */
  excludeNoScore?: boolean;
  /** ASC or DESC. */
  sortOrder?: 'ASC' | 'DESC';
  /** rank | score | criticalEvents | warningEvents. */
  sortBy?: 'RANK' | 'SCORE' | 'CRITICAL_EVENTS' | 'WARNING_EVENTS';
  /** Page size (min1, max 100, default 20). */
  size?: number;
};
export type GetDriverScoreDetailsApiResponse =
  /** status 200 Success */ GmResponseCommonDriverScoreDetailsDto;
export type GetDriverScoreDetailsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** ID of the driver score record. */
  driverScoreId: string;
};
export type ProcessTripsApiResponse =
  /** status 200 Success */
  | GmResponseCommonTripRoutesResponseDto
  | /** status 204 No Trips Found */ GmResponseCommonTripRoutesResponseDto
  | /** status 206 Subset of the trips found from the requested trips */ GmResponseCommonTripRoutesResponseDto;
export type ProcessTripsApiArg = {
  /** Organization ID to which the vehicle belongs. */
  'cs-organization': string;
  /** Fleet ID to which the vehicle belongs. Defaults to null. */
  'cs-fleet'?: string;
  tripRoutesRequestDto: TripRoutesRequestDto;
};
export type GetTripEventsApiResponse =
  /** status 200 Success */
  | GmResponseCommonTripEventsResponseDto
  | /** status 204 No Content */ GmResponseCommonTripEventsResponseDto
  | /** status 206 Partial Content */ GmResponseCommonTripEventsResponseDto;
export type GetTripEventsApiArg = {
  /** Organization ID to which the vehicle belongs. */
  'cs-organization': string;
  /** Fleet ID to which the vehicle belongs. Defaults to null. */
  'cs-fleet'?: string;
  tripEventsRequestDto: TripEventsRequestDto;
};
export type GetRawSafetyEventDetailsApiResponse =
  /** status 200 Success */ GmResponseCommonRawSafetyEventDetailsDto;
export type GetRawSafetyEventDetailsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The ID of the trip */
  tripId: string;
  /** The ID of the safety event */
  id: string;
};
export type GetRawSafetyEventsApiResponse =
  /** status 200 Success */
  | GmResponseCommonRawSafetyEventsResponse
  | /** status 204 No safety events found */ GmResponseCommonRawSafetyEventsResponse;
export type GetRawSafetyEventsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty. Allowed values are:<p>
   * accidentDetected<br/>
   * cellPhoneUsage<br/>
   * driverDistracted<br/>
   * eatingAndDrinking<br/>
   * excessiveSpeeding<br/>
   * followDistance<br/>
   * hardAcceleration<br/>
   * hardBrake<br/>
   * hardCornering<br/>
   * laneWeaving<br/>
   * possibleFatigue<br/>
   * seatbeltUnbuckled<br/>
   * smoking<br/>
   * speedOverPostedLimit<br/>
   * unbuckledSeatBelt<br/>
   */
  eventTypes?: string[];
  /** Filter events by a specific driver ID. Defaults to all drivers if empty. */
  driverId?: string;
  /**
                    Keyword to search events to the listed properties below. Case-insensitive partial match.
                      1. assetId (VIN)
                     */
  searchKeyword?: string;
  /** Filter events based on whether they have associated media. */
  hasMedia?: boolean;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type GetSafetyEventDetailsApiResponse =
  /** status 200 Success */ GmResponseCommonSafetyEventDetailsDto;
export type GetSafetyEventDetailsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** The ID of the trip */
  tripId: string;
  /** The ID of the safety event */
  id: string;
};
export type GetSafetyEventsApiResponse =
  /** status 200 Success */
  | GmResponseCommonSafetyEventsResponse
  | /** status 204 No safety events found */ GmResponseCommonSafetyEventsResponse;
export type GetSafetyEventsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** Start date-time for filtering events. Format: ISO 8601. */
  startEventDateTime?: string;
  /** End date-time for filtering events. Format: ISO 8601. */
  endEventDateTime?: string;
  /** Comma-separated list of event types to filter by. Defaults to all event types if empty. Allowed values are:<p>
   * seatbeltUnbuckled<br/>
   * hardAcceleration<br/>
   * hardBrake<br/>
   * excessiveSpeeding<br/>
   * driverDistracted<br/>
   * cellPhoneUsage<br/>
   * accidentDetected<br/>
   * eatingAndDrinking<br/>
   */
  eventTypes?: string[];
  /** Filter events by a specific driver ID. Defaults to all drivers if empty. */
  driverId?: string;
  /**
                    Keyword to search events to the listed properties below. Case-insensitive partial match.
                      1. assetId (VIN)
                     */
  searchKeyword?: string;
  /** Number of items to return. Defaults to 20, minimum 1, maximum 50. */
  size?: number;
  /** Sort order for the results. "ASC" and "DESC" allowed. Defaults to DESC. */
  sortOrder?: 'ASC' | 'DESC';
};
export type GetTripSummariesApiResponse =
  /** status 200 Success */
  | GmResponseCommonTripSummariesResponseDto
  | /** status 204 No trips matching the filter */ GmResponseCommonTripSummariesResponseDto;
export type GetTripSummariesApiArg = {
  /** Organization ID to which the vehicle belongs. */
  'cs-organization': string;
  /** fleet ID to which the vehicle belongs. Defaults to null. */
  'cs-fleet'?: string;
  /** continuation token for pagination. Defaults to null. */
  'cs-continuation-token'?: string;
  /** The VIN of the vehicle */
  vin: string;
  /** Trips that started after this time (TRIP_STARTED_AFTER), in ISO 8601 format */
  tripsStartedAfter: string;
  /** Trips that started before this time (TRIP_STARTED_BEFORE), in ISO 8601 format.
                        Null values are considered valid and will default to TRIP_STARTED_AFTER + 24hours */
  tripsStartedBefore?: string;
  /** Size of the page to be returned. Defaults to 10. */
  pageSize?: number;
};
export type RevokeTrustedDeviceApiResponse =
  /** status 200 OK */ GmResponseCommonTrustedDeviceResponse;
export type RevokeTrustedDeviceApiArg = {
  id: string;
};
export type UpdateOrgLevelAppIdentityApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type UpdateOrgLevelAppIdentityApiArg = {
  /** The ID of the app profile to update. */
  profileId: string;
  /** The ID of the organization the profile belongs to. */
  organizationId: string;
  orgAppUpdateRequest: OrgAppUpdateRequest;
};
export type UpdateAppIdentityApiResponse =
  /** status 200 Successfully updated system-level app identity profile. */ GmResponseCommonVoid;
export type UpdateAppIdentityApiArg = {
  /** App identity profile ID to update */
  id: string;
  appUpdateRequest: AppUpdateRequest;
};
export type DeleteAppIdentityApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DeleteAppIdentityApiArg = {
  /** Profile ID of the app identity to delete. */
  id: string;
};
export type UpdateProfileCustomPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateProfileCustomPermissionsApiArg = {
  /** Profile id to update. */
  id: string;
  profileUpdateRequestV20231010: ProfileUpdateRequestV20231010;
};
export type ResetAppSecretApiResponse =
  /** status 200 Successfully reset app secret. */ GmResponseCommonSecret;
export type ResetAppSecretApiArg = {
  /** Profile ID for app identity account */
  id: string;
  /** Secret to reset - primary or secondary */
  secretType: 'PRIMARY' | 'SECONDARY';
};
export type GetProfileByIdApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type GetProfileByIdApiArg = {
  /** Profile id to get. */
  id: string;
};
export type UpdateUserProfileV1ApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateUserProfileV1ApiArg = {
  id: string;
  profileUpdateJson: ProfileUpdateJson;
};
export type UpdateMyLegalDocsApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateMyLegalDocsApiArg = {
  legalRequestJson: LegalRequestJson;
};
export type UpdateIdentityIdByUserCodeApiResponse =
  /** status 200 OK */ GmResponseCommonCodesResponse;
export type UpdateIdentityIdByUserCodeApiArg = {
  userCode: string;
};
export type CheckTenantAssociationApiResponse = unknown;
export type CheckTenantAssociationApiArg = {
  tenantUserCheck: TenantUserCheck;
};
export type VerifyOtpApiResponse = /** status 200 OK */ GmResponseCommonBoolean;
export type VerifyOtpApiArg = {
  otpVerifyRequest: OtpVerifyRequest;
};
export type SendOtpApiResponse = unknown;
export type SendOtpApiArg = void;
export type VerifyMfaApiResponse =
  /** status 200 OK */ GmResponseCommonMfaResponse;
export type VerifyMfaApiArg = {
  mfaRequest: MfaRequest;
};
export type OffboardOrganizationUsersApiResponse =
  /** status 200 OK */ GmResponseCommonOffboardKickoffResponse;
export type OffboardOrganizationUsersApiArg = {
  /** The organization to off-board. */
  organizationId: string;
  /** Identifies the close run asking, as close:{organizationId}:{runEpoch}:users. */
  'cs-idempotency-key'?: string;
};
export type ShowGettingStartedApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type ShowGettingStartedApiArg = {
  /** Profile id to show the getting started experience for. */
  profileId: string;
};
export type DismissGettingStartedApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type DismissGettingStartedApiArg = {
  /** Profile id to dismiss the getting started experience for. */
  profileId: string;
};
export type MarkAppSpaceViewedApiResponse =
  /** status 200 The space was recorded as viewed (or was already viewed). */ GmResponseCommonProfileResponse;
export type MarkAppSpaceViewedApiArg = {
  /** Profile id to update. */
  profileId: string;
  /** Application space code that was viewed, e.g. "vehicles" or "business-profile". Matching is case-insensitive. */
  space: 'BUSINESS_PROFILE' | 'VEHICLES' | 'DRIVERS' | 'USERS' | 'GEOFENCES';
};
export type ValidateOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonValidateMigratedOviVehicleSchedulesResponse;
export type ValidateOviVehicleSchedulesApiArg = {
  validateMigratedOviVehicleSchedulesRequest: ValidateMigratedOviVehicleSchedulesRequest;
};
export type ValidateOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonValidateMigratedOviPersonsResponse;
export type ValidateOviPersonsApiArg = {
  validateMigratedOviPersonsRequest: ValidateMigratedOviPersonsRequest;
};
export type ActivateOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonActivateUsersResponse;
export type ActivateOviPersonsApiArg = {
  activateUsersRequest: ActivateUsersRequest;
};
export type ListOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageMigratedVehicleSchedule;
export type ListOviVehicleSchedulesApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviVehicleId?: string;
  oviPersonId?: string;
  organizationId?: string;
  fleetId?: string;
  assetId?: string;
  driverId?: string;
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
};
export type SyncOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonSyncOviVehicleSchedulesResponse;
export type SyncOviVehicleSchedulesApiArg = {
  'FORCE-CHANGE'?: boolean;
  syncOviVehicleSchedulesRequest: SyncOviVehicleSchedulesRequest;
};
export type ListOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageProfile;
export type ListOviPersonsApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviPersonId?: string;
  organizationId?: string;
  fleetId?: string;
  userId?: string;
  size?: number;
  'cs-continuation-token'?: string;
};
export type SyncOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonSyncOviPersonsResponse;
export type SyncOviPersonsApiArg = {
  'FORCE-CHANGE'?: boolean;
  syncOviPersonsRequest: SyncOviPersonsRequest;
};
export type BulkGetDriversApiResponse =
  /** status 200 OK */ GmResponseCommonBulkGetDriversResponse;
export type BulkGetDriversApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  bulkGetDriversRequest: BulkGetDriversRequest;
};
export type CreateProfileCustomPermissionsApiResponse =
  /** status 201 Created */ GmResponseCommonOrgAppCreateResponse;
export type CreateProfileCustomPermissionsApiArg = {
  orgAppCreateRequest: OrgAppCreateRequest;
};
export type AssignVehicleApiResponse = unknown;
export type AssignVehicleApiArg = {
  /** Driver profile id to assign vehicle to. */
  driverId: string;
  'cs-organization': string;
  'cs-fleet'?: string;
  driverVehicleAssignmentRequest: DriverVehicleAssignmentRequest;
};
export type UnassignVehiclesApiResponse = unknown;
export type UnassignVehiclesApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  driverVehicleBulkUnassignRequest: DriverVehicleBulkUnassignRequest;
};
export type CreateAppApiResponse =
  /** status 201 Successfully created app account. */ GmResponseCommonAppCreateResponse;
export type CreateAppApiArg = {
  appCreateRequest: AppCreateRequest;
};
export type GetDriverProfilesApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseDriverProfileResponse;
export type GetDriverProfilesApiArg = {
  /** Filter by organization ID. */
  organizationId?: any;
  /** Filter by list of fleet IDs. */
  fleetIds?: any;
  /** Search by driver name. */
  name?: string;
  /** Sort driver profiles by field. */
  sortBy?: 'EMAIL' | 'NAME' | 'PHONE_NUMBER';
  /** Sort order for driver profiles. */
  sortOrder?: 'ASC' | 'DESC';
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  'cs-organization': string;
  'cs-fleet'?: string[];
};
export type CreateDriverProfileApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileCreateResponse;
export type CreateDriverProfileApiArg = {
  'cs-organization': string;
  'cs-fleet': string;
  driverProfileCreateRequest: DriverProfileCreateRequest;
};
export type RecordLastSignedInApiResponse = unknown;
export type RecordLastSignedInApiArg = {
  recordLastSignedInRequest: RecordLastSignedInRequest;
};
export type CreateAdministrativeUserApiResponse =
  /** status 201 Created */ GmResponseCommonProfileResponse;
export type CreateAdministrativeUserApiArg = {
  createAdminUserProfileRequest: CreateAdminUserProfileRequest;
};
export type CancelInvitesApiResponse =
  /** status 200 OK */ GmResponseCommonCancelInvitesResponseDto;
export type CancelInvitesApiArg = {
  /** The organization ID to identify organization for invitation's. */
  'x-bd-organization': string;
  cancelInvitesRequestDto: CancelInvitesRequestDto;
};
export type ResendInvitesApiResponse =
  /** status 200 OK */ GmResponseCommonResendInvitesResponseDto;
export type ResendInvitesApiArg = {
  /** Suppresses email notifications if set to true. */
  'x-suppress-notification'?: boolean;
  resendInvitesRequestDto: ResendInvitesRequestDto;
};
export type AcceptInviteApiResponse =
  /** status 200 OK */ GmResponseCommonProfile;
export type AcceptInviteApiArg = {
  legalRequest: LegalRequest;
};
export type InviteUsersApiResponse =
  /** status 200 OK */ GmResponseCommonInviteUsersResponse;
export type InviteUsersApiArg = {
  /** The organization ID to identify the invitee user's organization. */
  'x-bd-organization': string;
  /** Suppresses email notifications if set to true. */
  'x-suppress-notification'?: boolean;
  inviteUsersRequest: InviteUsersRequest;
};
export type EnrichTokenApiResponse =
  /** status 200 CS profile was found. */ TokenEnrichResponse;
export type EnrichTokenApiArg = {
  tokenEnrichForSsoRequest: TokenEnrichForSsoRequest;
};
export type EnrichToken1ApiResponse =
  /** status 200 CS profile was found. */ TokenEnrichResponse;
export type EnrichToken1ApiArg = {
  tokenEnrichForCdiRequest: TokenEnrichForCdiRequest;
};
export type ResetAllAppSecretsApiResponse =
  /** status 200 Successfully reset one or both app secret types. */ GmResponseCommonMapStringSecret;
export type ResetAllAppSecretsApiArg = {
  /** Id for app identity account (profile id) */
  id: string;
};
export type GenerateDeviceCodeApiResponse =
  /** status 200 OK */ GmResponseCommonCodesResponse;
export type GenerateDeviceCodeApiArg = void;
export type GetIdentityIdByDeviceCodeApiResponse =
  /** status 200 Successfully retrieved identityId. */ GmResponseCommonIdentityIdResponse;
export type GetIdentityIdByDeviceCodeApiArg = {
  retrieveIdentityIdRequest: RetrieveIdentityIdRequest;
};
export type GetDriverProfileByIdApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileResponse;
export type GetDriverProfileByIdApiArg = {
  /** Driver profile id to get. */
  id: string;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type UpdateDriverProfileApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileResponse;
export type UpdateDriverProfileApiArg = {
  /** Driver profile id to update. */
  id: string;
  'cs-organization': string;
  'cs-fleet'?: string;
  driverProfileUpdateRequest: DriverProfileUpdateRequest;
};
export type ListTrustedDevicesApiResponse =
  /** status 200 OK */ GmResponseCommonListTrustedDeviceResponse;
export type ListTrustedDevicesApiArg = void;
export type GetOffboardStatusApiResponse =
  /** status 200 OK */ GmResponseCommonOffboardStatusResponse;
export type GetOffboardStatusApiArg = {
  /** The organization being off-boarded. */
  organizationId: string;
  /** The run to report on. */
  jobId: string;
};
export type RetrieveResourceCountsApiResponse =
  /** status 200 Available resource counts were retrieved. */ GmResponseCommonRetrieveResourceCountsResponse;
export type RetrieveResourceCountsApiArg = {
  /** Profile whose accessible resources are counted. */
  profileId: string;
  /** Optional fleet used to restrict resource counts. */
  fleetId?: string;
};
export type GetCustomPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonSetString;
export type GetCustomPermissionsApiArg = void;
export type GetAppIdentitiesApiResponse =
  /** status 200 Successfully retrieved app identities. */ GmResponseCommonGmPageAppIdentity;
export type GetAppIdentitiesApiArg = {
  /** Max number of items per page for pagination */
  size?: number;
  /** The email of the app identity to search for. */
  email?: string;
  /** The clientId of the app identity to search for. */
  clientId?: string;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type FindDriversByVinsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseDriverWithAssignedVehicles;
export type FindDriversByVinsApiArg = {
  /** List of Vehicle Identification Numbers to search for */
  vins: string[];
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type SearchUserProfilesApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseProfile;
export type SearchUserProfilesApiArg = {
  /** Filter by organization ID. */
  organizationId?: string;
  /** Filter by list of fleet IDs. */
  fleetIds?: string[];
  /** Filter by list of profile statuses. */
  statuses?: (
    | 'CONTACT'
    | 'ACTIVE'
    | 'DISABLED'
    | 'PENDING'
    | 'RETIRED'
    | 'DELETED'
  )[];
  /** Filter by list of profile roles. */
  roles?: (
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'CUSTOM_ACCESS_ORG_LEVEL'
    | 'CUSTOM_ACCESS_SYS_LEVEL'
  )[];
  /** Filter by list of profile invite statuses. */
  inviteStatuses?: ('PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED')[];
  /** Search by profile name */
  name?: string;
  /** Search by profile email */
  email?: string;
  /** Sort profiles by field */
  sortBy?:
    | 'EMAIL'
    | 'NAME'
    | 'ROLE'
    | 'INVITE_STATUS'
    | 'LAST_SIGNED_IN'
    | 'CREATION_DATE';
  /** Sort order profiles */
  sortOrder?: 'ASC' | 'DESC';
  /** Max number of items per page for pagination */
  size?: number;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type FindProfilesByOrgIdAndEmailApiResponse =
  /** status 200 OK */ GmResponseCommonListProfileResponse;
export type FindProfilesByOrgIdAndEmailApiArg = {
  /** Asset's identification. */
  organizationId: string;
  /** State to transition. */
  email: string;
};
export type GetCdiUserProfileApiResponse =
  /** status 200 CDI user details alongside matching CSP profile information if available. */ GmResponseCommonCdiUserProfile;
export type GetCdiUserProfileApiArg = {
  cdiProfileId: string;
};
export type FindAllProfilesBetaApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseProfile;
export type FindAllProfilesBetaApiArg = {
  /** Filters to apply to the query. */
  filters?: any;
  size?: number;
  continuationToken?: string;
};
export type FindAllProfilesByApiResponse =
  /** status 200 OK */ GmResponseCommonListProfileResponse;
export type FindAllProfilesByApiArg = void;
export type GetContactInfoApiResponse =
  /** status 200 OK */ GmResponseCommonContactInfo;
export type GetContactInfoApiArg = {
  /** User id to get corresponding contact from. */
  id: string;
};
export type GetUsers20211115MeApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type GetUsers20211115MeApiArg = void;
export type DeleteAdministrativeUserApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DeleteAdministrativeUserApiArg = {
  /** Profile ID of the administrative user to delete. */
  id: string;
};
export type DeleteUserProfileApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type DeleteUserProfileApiArg = {
  /** ID of the user to delete. */
  id: string;
};
export type RegistrationItemDto = {
  /** Represents the group of the events */
  category: string;
  /** Event name where the user is subscribed to. */
  event: string;
  /**
                Collection of sub-types where user is subscribed to. This cannot be empty if the registration have sub-types.
             */
  subTypes?: string[];
};
export type SubscriptionDto = {
  /** Unique identifying subscription ID. */
  id?: string;
  /** Unique identifier of a custom pool of subscriptions. */
  subscriptionPoolId?: string;
  organizationId: string;
  /** List of registrations for this subscription */
  registrations: RegistrationItemDto[];
  /** Whether subscription is active. */
  active: boolean;
  /** Whether subscription parent toggle is active. */
  toggleActive: boolean;
  /** Threshold For Noisy Messages In Minutes */
  noiseThresholdInMinutes?: number;
  profileId?: string;
  /** The notification receipt preferences */
  receiptPreferences?: ('EMAIL' | 'FEED')[];
  /** The notification preferred name */
  preferredName?: string;
  /** List of assetIds for this subscription */
  assets?: string[];
  /** true if alerts in this subscription should be grouped together. false otherwise. */
  grouped?: boolean;
  /** The time zone a user is in. This is used to determine when to create a new group. */
  timeZone?: string;
  /** The email frequency for this subscription */
  emailFrequency?: 'IMMEDIATE' | 'DAILY' | 'WEEKLY' | 'BI_WEEKLY';
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonSubscriptionDto = {
  result?: SubscriptionDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SubscriptionUpdateDto = {
  /** Whether subscription is active. */
  active: boolean;
  /** Threshold For Noisy Messages In Minutes */
  noiseThresholdInMinutes?: number;
  /** The notification receipt preferences */
  receiptPreferences?: ('EMAIL' | 'FEED')[];
  /** The notification preferred name */
  preferredName?: string;
  /** List of registrations for this subscription */
  registrations?: RegistrationItemDto[];
  /** List of assetIds for this subscription */
  assets?: string[];
  /** true if alerts in this subscription should be grouped together. false otherwise. */
  grouped?: boolean;
  /** The email frequency for this subscription */
  emailFrequency?: 'IMMEDIATE' | 'DAILY' | 'WEEKLY' | 'BI_WEEKLY';
  subscriptionPoolId?: string;
};
export type EventSubTypeDto = {
  /** The subType name. */
  name: string;
  /** Whether the user is subscribed to this subType. */
  active: boolean;
};
export type EventSubscriptionDto = {
  /** Unique identifying subscription ID. Null when the user has no subscription for the event. */
  id?: string;
  /** The registration category. */
  category: string;
  /** The registered event name. */
  eventName: string;
  /** Whether the subscription is active. */
  active: boolean;
  /** The subTypes of the event, null when the event has none. */
  subTypes?: EventSubTypeDto[];
  /** true if alerts for this event should be grouped together. false otherwise. */
  grouped?: boolean;
  /** The email frequency for this event. */
  emailFrequency?: 'IMMEDIATE' | 'DAILY' | 'WEEKLY' | 'BI_WEEKLY';
  /** Threshold for noisy messages in minutes. */
  noiseThresholdInMinutes?: number;
  /** The notification receipt preferences. */
  receiptPreferences?: ('EMAIL' | 'FEED')[];
  /** List of assetIds for this event. */
  assets?: string[];
};
export type CategorySubscriptionsResponse = {
  /** Whether at least one matched subscription in the response has its group toggle active. */
  toggleActive: boolean;
  /** Subscription state for each requested category and event pair, in request order. */
  eventSubscriptions: EventSubscriptionDto[];
};
export type GmResponseCommonListCategorySubscriptionsResponse = {
  result?: CategorySubscriptionsResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CategoryEventRequestDto = {
  /** The registration category. */
  category: string;
  /** The registered event name. */
  eventName: string;
};
export type ValidationError = {
  code?:
    | 'NOT_FOUND'
    | 'NO_ASSIGNMENT_FOUND'
    | 'INVALID_STATE'
    | 'INVALID_FIELD';
  field?: string;
  message?: string;
};
export type ValidateOviPersonChannelsResponseEntry = {
  valid: boolean;
  error?: ValidationError;
  vin: string;
  personChannelId: string;
};
export type ValidateOviPersonChannelsResponse = {
  allOviPersonChannelsMatched: boolean;
  allCspAlertSubscriptionsMatched: boolean;
  vehicles: ValidateOviPersonChannelsResponseEntry[];
};
export type GmResponseCommonValidateOviPersonChannelsResponse = {
  result?: ValidateOviPersonChannelsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleEntry = {
  vehicleId: string;
  vin: string;
};
export type Vehicles = {
  all: boolean;
  entries: VehicleEntry[];
};
export type ValidateOviPersonChannelsRequestEntry = {
  personChannelId: string;
  personId: string;
  ruleId: string;
  ruleName: string;
  alertType: string;
  secondaryId?: string;
  email: boolean;
  alert: boolean;
  vehicles: Vehicles;
  vehicleAccountId?: string;
};
export type ValidateOviPersonChannelsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  channels: ValidateOviPersonChannelsRequestEntry[];
};
export type MigratedPersonChannel = {
  organizationId?: string;
  profileId?: string;
  oviAccountId?: string;
  oviPersonId?: string;
  oviPersonChannelId?: string;
  oviChangeSequence?: string;
};
export type GmPageMigratedPersonChannel = {
  items: MigratedPersonChannel[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedPersonChannel = {
  result?: GmPageMigratedPersonChannel;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EntryError = {
  errorCode?: string;
  errorMessage?: string;
};
export type SyncOviPersonChannelsResponseEntry = {
  success: boolean;
  error?: EntryError;
  personChannelId: string;
  changeOp?: 'CREATED' | 'UPDATED' | 'DELETED' | 'NO_CHANGE';
};
export type SyncOviPersonChannelsResponse = {
  channels: SyncOviPersonChannelsResponseEntry[];
};
export type GmResponseCommonSyncOviPersonChannelsResponse = {
  result?: SyncOviPersonChannelsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DataChangeTracking = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
};
export type SyncOviPersonChannelsRequestEntry = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  personChannelId: string;
  personId: string;
  ruleId: string;
  ruleName?: string;
  alertType?: string;
  secondaryId?: string;
  email: boolean;
  alert: boolean;
  statusCode: 'active' | 'retired';
  vehicles: Vehicles;
  vehicleAccountId?: string;
  alertRuleDataChangeTracking?: DataChangeTracking;
};
export type SyncOviPersonChannelsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  channels: SyncOviPersonChannelsRequestEntry[];
};
export type SupportTicketResponse = {
  message: string;
  submittedAt: string;
};
export type GmResponseCommonSupportTicketResponse = {
  result?: SupportTicketResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BrowserInfo = {
  userAgent: string;
  browserName?: string;
  browserVersion?: string;
  osName?: string;
  osVersion?: string;
  deviceType?: string;
  browserResolution?: string;
  browserZoom?: string;
};
export type SupportTicketRequest = {
  subject:
    | 'VEHICLE_CONNECTIVITY'
    | 'ONSTAR_PLANS'
    | 'ACCOUNT_USERS_BILLING'
    | 'ADAPTERS_CAMERAS'
    | 'FEEDBACK'
    | 'ORDER_SHIPPING_DELIVERY'
    | 'ORDER_STATUS'
    | 'COMPETITIVE_ASSISTANCE_PROGRAM'
    | 'ACCESSORIES'
    | 'FLEET_TOOL_ACCESS_ID'
    | 'ORDER_INVOICE_BILLING'
    | 'MANUFACTURERS_CERTIFICATE'
    | 'FLEET_PROGRAMS_INCENTIVES'
    | 'FLEET_ACCOUNT_NUMBER';
  name: string;
  phoneNumber?: string;
  email: string;
  organizationName: string;
  fan?: string;
  role:
    | 'ADVISOR'
    | 'SYSTEM_MANAGER'
    | 'SERVICE_MANAGER'
    | 'SYSTEM_READER'
    | 'ORG_MANAGER'
    | 'SERVICE_TECHNICIAN'
    | 'HUB_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'VIEWER'
    | 'TECHNICAL_MANAGER';
  vins?: string[];
  description: string;
  browserInfo?: BrowserInfo;
  locale?: string;
};
export type NoiseThresholdResponse = {
  /** Organization ID */
  organizationId: string;
  /** Number of subscriptions updated */
  updatedCount: number;
  /** New noise threshold value in minutes */
  noiseThresholdInMinutes: number;
};
export type GmResponseCommonNoiseThresholdResponse = {
  result?: NoiseThresholdResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type NoiseThresholdUpdate = {
  /** Organization ID */
  organizationId: string;
  /** Threshold For Noisy Messages In Minutes */
  noiseThresholdInMinutes: number;
};
export type Subscription = {
  state?: 'ACTIVE' | 'INACTIVE';
  organizationId?: string;
  planCode?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  serviceCodes?: (
    | 'DTC_NOTIFICATION'
    | 'EV_PHEV_DATA'
    | 'HARD_ACCELERATION'
    | 'HARD_BRAKE'
    | 'INCAB_ALERTS'
    | 'PREDELIVERY'
    | 'TELEMETRY'
  )[];
};
export type SortObject = {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
};
export type PageableObject = {
  offset?: number;
  sort?: SortObject;
  pageSize?: number;
  pageNumber?: number;
  paged?: boolean;
  unpaged?: boolean;
};
export type PageSubscription = {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Subscription[];
  number?: number;
  sort?: SortObject;
  last?: boolean;
  first?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
};
export type BdSubscriptionPage = {
  page?: PageSubscription;
  items: SubscriptionDto[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonBdSubscriptionPage = {
  result?: BdSubscriptionPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BdQuery = {
  qualifier:
    | 'ALL'
    | 'IS_EQUAL'
    | 'OR'
    | 'AND'
    | 'NOT'
    | 'BEFORE'
    | 'AFTER'
    | 'IN'
    | 'NOT_IN'
    | 'IS_NULL'
    | 'IS_NOT_NULL'
    | 'LESS_THAN'
    | 'LESS_THAN_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_EQUAL'
    | 'CONTAINING'
    | 'ENDS_WITH'
    | 'STARTS_WITH'
    | 'TRUE'
    | 'FALSE'
    | 'BETWEEN'
    | 'ARRAY_CONTAINS'
    | 'STRING_EQUALS'
    | 'NOT_CONTAINING';
  field?: string;
  values?: any[];
  leftQuery?: BdQuery;
  rightQuery?: BdQuery;
};
export type BdPageRequest = {
  page: number;
  size: number;
  /** Direct has been deprecated in favor of query. */
  direct?: boolean;
  sort: SortObject[];
  token?: string;
  query?: BdQuery;
};
export type EmailSettings = {
  templates?: {
    [key: string]: string;
  };
};
export type ContentSettings = {
  email?: EmailSettings;
};
export type Registration = {
  id?: string;
  applicationId?: string;
  sourceType: string;
  category: string;
  event: string;
  subTypes?: string[];
  createDateTime?: string;
  timestamp?: string;
  contentSettings?: ContentSettings;
  uniqueKeys?: (
    | 'PROFILE_ID'
    | 'ORGANIZATION_ID'
    | 'REGISTRATIONS'
    | 'SUBSCRIPTION_POOL_ID'
  )[];
};
export type PageRegistration = {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: Registration[];
  number?: number;
  sort?: SortObject;
  last?: boolean;
  first?: boolean;
  numberOfElements?: number;
  pageable?: PageableObject;
  empty?: boolean;
};
export type RegistrationDto = {
  id?: string;
  applicationId?: string;
  /** Source type for the registration. */
  sourceType: string;
  /** Category type for the registration. */
  category: string;
  /** Event type for the registration. */
  event: string;
  /** Sub-event types of an event. */
  subTypes?: string[];
  contentSettings?: ContentSettings;
  uniqueKeys?: (
    | 'PROFILE_ID'
    | 'ORGANIZATION_ID'
    | 'REGISTRATIONS'
    | 'SUBSCRIPTION_POOL_ID'
  )[];
};
export type BdRegistrationPage = {
  page?: PageRegistration;
  items: RegistrationDto[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonBdRegistrationPage = {
  result?: BdRegistrationPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonString = {
  result?: string;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EventDto = {
  /** The category of the event. */
  category: string;
  /** The type of event that triggered the alert. */
  event: string;
  /** The source type of the event. */
  sourceType: string;
  /** The sub-type of the event, if applicable. */
  subType?: string;
  /** The ID of the source that generated the event. */
  sourceId: string;
  eventTimestamp: string;
  /** A map of content variables associated with the event. */
  contentVariableMap?: {
    [key: string]: any;
  };
};
export type AlertResponse = {
  /** Unique generated identifying ID. */
  id?: string;
  /** ID of base subscription for alert. */
  subscriptionId: string;
  /** Unique identifier of a custom pool of subscriptions. */
  subscriptionPoolId?: string;
  /** The event details that triggered this alert. */
  event: EventDto;
  /** The type of the alert, which can be SINGLE or GROUP. */
  type: 'SINGLE' | 'GROUP';
  /** If the alert is read. */
  read: boolean;
  /** If the alert is pinned. */
  pinned: boolean;
  /** The ID of the group this alert belongs to, if any. */
  groupId?: string;
  lastEventDateTime: string;
};
export type GmPageAlertResponse = {
  items: AlertResponse[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageAlertResponse = {
  result?: GmPageAlertResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmPageSubscriptionDto = {
  items: SubscriptionDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageSubscriptionDto = {
  result?: GmPageSubscriptionDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SingleAlertRecord = AlertRecord & {
  /** The event that triggered the alert. */
  event: EventDto;
  /** true if the alert is pinned, false otherwise. */
  pinned: boolean;
};
export type GroupEventDto = {
  /** ID of the group's last single alert */
  id: string;
  /** The event that triggered the alert. */
  event: EventDto;
  /** true if the alert is pinned, false otherwise. */
  pinned: boolean;
};
export type GroupAlertRecord = AlertRecord & {
  /** The last event added the group alert. */
  lastGroupEvent: GroupEventDto;
  /** The name of the group, if applicable. */
  groupName?: string;
  /** The number of alerts in the group. */
  alertCount: number;
  /** The number of non-dismissed alerts in the group. */
  feedActiveCount: number;
};
export type AlertRecord =
  | ({
      type: 'SINGLE';
    } & SingleAlertRecord)
  | ({
      type: 'GROUP';
    } & GroupAlertRecord);
export type GmPageAlertRecord = {
  items: AlertRecord[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageAlertRecord = {
  result?: GmPageAlertRecord;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Event = {
  sourceId: string;
  sourceType: string;
  applicationId: string;
  category: string;
  event: string;
  subType?: string;
  eventTimestamp: string;
  contentVariableMap?: {
    [key: string]: any;
  };
  returnUrl?: string;
};
export type AlertDto = {
  /** Unique generated identifying ID. */
  id?: string;
  profileId: string;
  /** ID of base subscription for alert. */
  subscriptionId: string;
  /**
                Primary identifier to denote the action that raised the alert.
                See https://dev.azure.com/BrightDrop/BrightDrop/_wiki/wikis/BrightDrop.wiki/1260/0012a-Alerts
                for information about well know events.
                 */
  event: Event;
  organizationId: string;
  createDateTime: string;
  /** If the alert is read. */
  read: boolean;
  /** The notification receipt preferences */
  receiptPreferences?: ('EMAIL' | 'FEED')[];
  /** If the alert is pinned. */
  pinned: boolean;
  /** The ID of the group this alert belongs to, if any. */
  groupId?: string;
};
export type AlertsPaginatedResponse = {
  /** The list of alerts in the current page */
  items: AlertDto[];
  /** The total number of alerts for the current user, not just the current page */
  total_items?: number;
  /** The continuation token to be used to navigate to the next page */
  continuation_token?: string;
};
export type GmResponseCommonAlertsPaginatedResponse = {
  result?: AlertsPaginatedResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StatusValueResponse = {
  value?: any;
  deviceTimestamp?: string;
};
export type DiagnosticSubsystem = {
  type?:
    | 'airbag_deployment'
    | 'antilock_brake'
    | 'auxiliary_transmission_pump'
    | 'battery_conditioning'
    | 'charging_cable'
    | 'electric_all_wheel_drive'
    | 'engine_cooling'
    | 'engine_electrical'
    | 'evaporative_emissions'
    | 'exhaust_emissions'
    | 'hybrid_battery'
    | 'hybrid_powertrain'
    | 'lighting'
    | 'motor_control'
    | 'onboard_charging'
    | 'peripheral'
    | 'safety_belt_pretensioner'
    | 'stabilitrak'
    | 'traction_control'
    | 'wireless_communications';
};
export type DiagnosticSystem = {
  type?:
    | 'airbag'
    | 'antilock_braking'
    | 'electric_drive'
    | 'electric_lamps'
    | 'emissions'
    | 'engine_and_transmission'
    | 'high_voltage_battery'
    | 'onstar'
    | 'stability_control';
  subsystems?: DiagnosticSubsystem[];
};
export type DiagnosticsValueResponse = {
  value?: boolean;
  severity?: string;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
};
export type StateResponseJson = {
  connectivity?: string;
  diagnostic?: string;
  availability?: string;
  safetyCompliant?: boolean;
  mil?: string;
  provisioning?: string;
  homeLocationCompliant?: boolean;
  chargingScheduleCompliant?: boolean;
  chargeState?: string;
  vehicleIdling?: boolean;
};
export type AssetResponseBase = {
  type: string;
  /** Asset id */
  id?: string;
  fleetId?: string;
  organizationId?: string;
  name?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  status?: {
    [key: string]: StatusValueResponse;
  };
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
  state?: StateResponseJson;
  availabilityState?: string;
  fan?: string;
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  lastModifiedEpoch?: number;
  lastOnboardedDate?: string;
  creationDateTime?: string;
};
export type PropulsionModelBase = {
  vehiclePropulsion: string;
};
export type HvBattery = {
  batteryCapacityKwh?: number;
};
export type Ev = {
  vehiclePropulsion: 'Ev';
} & PropulsionModelBase & {
    hvBattery?: HvBattery;
  };
export type FuelTank = {
  fuelTankCapacityL?: number;
  fuelType?: 'GASOLINE' | 'DIESEL';
};
export type Hev = {
  vehiclePropulsion: 'Hev';
} & PropulsionModelBase & {
    fuelTank?: FuelTank;
  };
export type Ice = {
  vehiclePropulsion: 'Ice';
} & PropulsionModelBase & {
    fuelTank?: FuelTank;
  };
export type Phev = {
  vehiclePropulsion: 'Phev';
} & PropulsionModelBase & {
    hvBattery?: HvBattery;
    fuelTank?: FuelTank;
  };
export type OnStar = {
  supportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  subscriberAccountNumber?: string;
  unitGenerationId?: string;
  unitState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  stationId?: string;
  tcpsAccepted?: boolean;
  vduState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  accountOwnerProfileId?: string;
  accountOwnerEmailId?: string;
  accountStatus?: string;
  accountCreationDate?: string;
};
export type ConnectivityConsentSession = {
  attemptCount?: number;
  createdAt?: string;
  id?: string;
  lastAttempt?: string;
  status?: 'COMPLETED' | 'PENDING' | 'REJECTED' | 'FAILED';
  statusReason?:
    | 'CONSENT_GRANTED_SUCCESSFULLY'
    | 'CONSENT_REVOKED_SUCCESSFULLY'
    | 'PENDING_REQUEST_PROCESSING'
    | 'PENDING_ONSTAR_UNIT_CONNECTED'
    | 'PENDING_TCPS_ACCEPTANCE'
    | 'CONNECTIVITY_PROVIDER_NOT_ELIGIBLE'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_SIM_NOT_SUPPORTED'
    | 'VEHICLE_PROPULSION_MODEL_NOT_SUPPORTED'
    | 'TIMEOUT_WAITING_FOR_ONSTAR_UNIT_TO_BE_CONNECTED'
    | 'TIMEOUT_WAITING_FOR_TCPS_ACCEPTANCE'
    | 'UNRECOVERABLE_ERROR';
  type?: 'GRANT' | 'REVOKE';
  retailVehicle?: boolean;
  accountNumber?: string;
};
export type ConnectivityConsent = {
  status?: 'ACTIVE' | 'GRANTING' | 'INACTIVE' | 'REVOKING' | 'UNKNOWN';
  session?: ConnectivityConsentSession;
};
export type ConnectivitySessionTask = {
  lastUpdatedDate?: string;
  name?: string;
  sessionId?: string;
  status?: 'CANCELED' | 'FAILED' | 'PENDING' | 'SUCCESS';
  type?: 'ENROLL' | 'UNENROLL';
};
export type ConnectivitySession = {
  attemptCount?: number;
  createdAt?: string;
  id?: string;
  lastAttempt?: string;
  status?: 'CANCELED' | 'COMPLETED' | 'FAILED' | 'PENDING';
  type?: 'ENROLL' | 'UNENROLL';
  connectionPolicy?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  tasks?: ConnectivitySessionTask[];
};
export type ConnectivityEnrolledTask = {
  enrolledDate?: string;
  name?: string;
};
export type ConnectivityProvider = {
  consent?: ConnectivityConsent;
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  session?: ConnectivitySession;
  enrolledTasks?: ConnectivityEnrolledTask[];
  consentRevoked?: boolean;
};
export type AdapterConnectivity = {
  id?: string;
  serialNumber?: string;
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  connectedDate?: string;
};
export type TelematicsConnectivity = {
  provider?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  simulate?: boolean;
  onStar?: ConnectivityProvider;
  adapter?: AdapterConnectivity;
};
export type VehicleResponse = {
  type: 'VehicleResponse';
} & AssetResponseBase & {
    /** Vehicle identification number. */
    vin?: string;
    /** License plate of the vehicle. */
    licensePlate?: string;
    /** Manufacturer of the Vehicle. */
    vehicleMake?: string;
    /** Model name of the Vehicle. */
    vehicleModel?: string;
    /** Model year of the Vehicle. */
    vehicleYear?: string;
    /** Platform, Engine, and Gearbox code. */
    peg?: string;
    /** Engine type of the vehicle. */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** Onstar related data such as account number for the vehicle. */
    onStar?: OnStar;
    /** Telematics connectivity: provider + connectivity details. */
    connectivity?: TelematicsConnectivity;
    /** List of option codes. */
    rpoCodes?: string[];
    /** Trim level, package, and option code. */
    merchandisingModel?: string;
    /** Time value of when the vehicle was delivered. */
    deliveryDate?: string;
    /** Onstar connection status */
    onStarConnectionStatus?:
      | 'CONNECTED'
      | 'CONNECTING'
      | 'DISCONNECTED'
      | 'DISCONNECTING'
      | 'UNKNOWN';
    /** Source of the vehicle image. Will fall back to generated image if it is not set in cosmos */
    vehicleImageSource?: string;
    /** Vehicle capabilities represented as key-value pairs. */
    capabilities?: {
      [key: string]: string;
    };
  };
export type GmResponseCommonAssetResponse = {
  result?: VehicleResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Empty = any;
export type GmResponseCommonEmpty = {
  result?: Empty;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChangeStateRequestJson = {
  /** Current state of the asset */
  current: string;
  /** Desired state of the asset */
  desired: string;
};
export type UpdateAssetJsonBase = {
  type: string;
  id?: string;
  /** Fleet ID for fleet the asset belongs to */
  fleetId?: string;
  /** Organization ID for organization the asset belongs to */
  organizationId?: string;
  /** Asset name */
  name?: string;
  /** Hardware ID of the asset */
  hardwareId?: string;
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Vehicle account type */
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  /** Boarding session ID */
  boardingSessionId?: string;
  /** Asset capabilities represented as key-value pairs.
    
    Update semantics:
    - null: no change
    - empty map {}: reset (clear all capabilities)
    - non-empty map: merge with existing capabilities
      (incoming keys overwrite existing keys; unspecified keys are preserved)
    
    Full replacement requires a reset ({}) followed by a subsequent update
    with the desired values.
     */
  capabilities?: {
    [key: string]: string;
  };
  changeAvailabilityStateRequest?: ChangeStateRequestJson;
};
export type UpdateVehicleJson = {
  type: 'UpdateVehicleJson';
} & UpdateAssetJsonBase & {
    /** Asset capabilities as a name-value pair */
    capabilities?: {
      [key: string]: string;
    };
    /** Vehicle Identification Number */
    vin?: string;
    /** Vehicle license plate number */
    licensePlate?: string;
    /** Vehicle license plate expiration date */
    licensePlateExpirationDate?: string;
    /** Vehicle manufacturer */
    vehicleMake?: string;
    /** Vehicle model name */
    vehicleModel?: string;
    /** Vehicle model year */
    vehicleYear?: string;
    /** Vehicle image source */
    vehicleImageSource?: string;
    /** Vehicle propulsion system type */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** OnStar service configuration */
    onStar?: OnStar;
  };
export type VehicleIdleState = {
  isIdle?: boolean;
  timestamp?: string;
};
export type EngineRunTimeState = {
  lifetimeTotalSec?: number;
  lifetimeOffsetSec?: number;
  lastRawEngineRunTimeSec?: number;
  lastResetAt?: string;
  timestamp?: string;
};
export type State = {
  connectivity?: 'online' | 'offline';
  diagnostics?: 'clear' | 'impaired' | 'critical';
  diagnosticsCritical?: boolean;
  diagnosticsImpaired?: boolean;
  availability?: 'in_service' | 'out_of_service';
  safetyCompliant?: boolean;
  provisioning?: 'in_progress' | 'failed' | 'completed';
  mil?: '30_clear' | '10_critical' | '20_impaired';
  homeLocationCompliant?: boolean;
  chargingScheduleCompliant?: boolean;
  chargeState?:
    | 'unplugged'
    | 'plugged'
    | 'charging'
    | 'completed'
    | 'aborted'
    | 'idle';
  vehicleIdleState?: VehicleIdleState;
  engineRunTimeState?: EngineRunTimeState;
  fieldSourceTransactionId?: {
    [key: string]: string;
  };
};
export type StatusItemValueObject = {
  name?: string;
  value?: any;
  deviceTimestamp?: string;
  receivedDateTime?: string;
  sourceTransactionId?: string;
};
export type DiagnosticsItemValue = {
  name?: string;
  value?: boolean;
  severity?: string;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
  sourceTransactionId?: string;
};
export type UpsertVehicleJson = {
  type: 'UpsertVehicleJson';
} & UpdateAssetJsonBase & {
    /** Asset capabilities as a name-value pair */
    capabilities?: {
      [key: string]: string;
    };
    /** Vehicle Identification Number */
    vin?: string;
    /** Vehicle license plate number */
    licensePlate?: string;
    /** Vehicle license plate expiration date */
    licensePlateExpirationDate?: string;
    /** Vehicle manufacturer */
    vehicleMake?: string;
    /** Vehicle model name */
    vehicleModel?: string;
    /** Vehicle model year */
    vehicleYear?: string;
    /** Vehicle image source */
    vehicleImageSource?: string;
    /** Vehicle propulsion system type */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** OnStar service configuration */
    onStar?: OnStar;
    /** Fleet Account Number */
    fan?: string;
    /** Provider for telemetry services */
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    /** Provider for remote services */
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    /** Type of vehicle account */
    accountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    /** Platform, Engine, and Gearbox code */
    peg?: string;
    /** List of RPO codes */
    rpoCodes?: string[];
    /** Vehicle merchandising model code */
    merchandisingModelCode?: string;
    /** Whether the vehicle is a GM vehicle */
    gmVehicle?: boolean;
    /** Vehicle delivery date */
    deliveryDate?: string;
    /** Connectivity state of the vehicle */
    state?: State;
    /** Any status items on the vehicle */
    statuses?: {
      [key: string]: StatusItemValueObject;
    };
    /** DTCs on the vehicle */
    diagnostics?: {
      [key: string]: DiagnosticsItemValue;
    };
  };
export type UpdateBatchBoardingSummaryResponse = {
  summaryId?: string;
  updated?: boolean;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
};
export type GmResponseCommonUpdateBatchBoardingSummaryResponse = {
  result?: UpdateBatchBoardingSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateBoardingSessionResponse = {
  sessionId?: string;
  updated?: boolean;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
};
export type GmResponseCommonUpdateBoardingSessionResponse = {
  result?: UpdateBoardingSessionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateVehicleGmVehicleResponse20260224 = {
  vin?: string;
  updated?: boolean;
  valueAfter?: boolean;
  reason?: string;
};
export type GmResponseCommonUpdateVehicleGmVehicleResponse20260224 = {
  result?: UpdateVehicleGmVehicleResponse20260224;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateConnectivityProviderResponse = {
  vin?: string;
  updated?: boolean;
  providerBefore?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  providerAfter?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  simulate?: boolean;
};
export type GmResponseCommonUpdateConnectivityProviderResponse = {
  result?: UpdateConnectivityProviderResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateClaimedOnstarResponse = {
  vin?: string;
  updated?: boolean;
  providerBefore?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  providerAfter?: 'NONE' | 'ONSTAR' | 'ADAPTER';
};
export type GmResponseCommonUpdateClaimedOnstarResponse = {
  result?: UpdateClaimedOnstarResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListUpdateClaimedOnstarResponse = {
  result?: UpdateClaimedOnstarResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateVehicleOnStarSupportStatusResponse = {
  vin?: string;
  updated?: boolean;
  valueBefore?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  valueAfter?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
};
export type GmResponseCommonUpdateVehicleOnStarSupportStatusResponse = {
  result?: UpdateVehicleOnStarSupportStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RemoteCommandError = {
  code?: string;
  description?: string;
};
export type RemoteCommandResponse = {
  requestTime?: string;
  completionTime?: string;
  url?: string;
  status?: string;
  type?: string;
  requestId?: string;
  error?: RemoteCommandError;
  body?: any;
  payload?: any;
  errorDescription?: string;
};
export type GmResponseCommonOptionalRemoteCommandResponse = {
  result?: RemoteCommandResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OtpPayload = {
  otp?: string;
  rememberDevice?: boolean;
};
export type VerifiedVehicleListItem = {
  /** 17-character Vehicle Identification Number. */
  vin?: string;
  /** Model year. Null when metadata is unavailable. */
  year?: number;
  /** Vehicle make. Null when metadata is unavailable. */
  make?: string;
  /** Vehicle model. Null when metadata is unavailable. */
  model?: string;
  /** Vehicle image URL. Default stock url when metadata is unavailable */
  imageUrl?: string;
  /** Data source that identified this vehicle as verified. */
  source?: 'CARPARC' | 'ORDERTRACKING';
};
export type VerifiedVehiclesListResponse = {
  /** Total number of verified vehicles eligible for onboarding or offboarding for this organization. Stable within a sync window unless vehicles are offboarded mid-session. */
  totalCount?: number;
  /** Zero-based offset used to produce this page. */
  offset?: number;
  /** Page size used to produce this page. */
  limit?: number;
  /** Verified vehicle items for the requested page. */
  items?: VerifiedVehicleListItem[];
};
export type GmResponseCommonVerifiedVehiclesListResponse = {
  result?: VerifiedVehiclesListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerifiedVehiclesListRequest = {
  /** Zero-based page offset. */
  offset?: number;
  /** Maximum number of items to return (0–1000). Use 0 to fetch only totalCount. */
  limit?: number;
  /** Optional partial, case-insensitive search term applied across year, make, model, and VIN. */
  search?: string;
};
export type MigratedVehicleDto = {
  id?: string;
  assetId?: string;
  organizationId?: string;
  fleetId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  oviVehicleId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
  connectivity?: TelematicsConnectivity;
  state?: State;
  onStar?: OnStar;
  licensePlate?: string;
  name?: string;
  createDateTime?: string;
  updateDate?: string;
};
export type GmPageMigratedVehicleDto = {
  items: MigratedVehicleDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedVehicleDto = {
  result?: GmPageMigratedVehicleDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehiclesResponseError = {
  errorCode?: string;
  errorMessage?: string;
};
export type SyncOviVehiclesResponseEntry = {
  success?: boolean;
  error?: SyncOviVehiclesResponseError;
  assetId?: string;
  vehicleId?: string;
  fleetId?: string;
  changeOp?: 'onboarded' | 'offboarded' | 'changed' | 'no-change';
};
export type SyncOviVehiclesResponse = {
  vehicles?: SyncOviVehiclesResponseEntry[];
};
export type GmResponseCommonSyncOviVehiclesResponse = {
  result?: SyncOviVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehicleRequestEntry = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  vehicleId: string;
  accountId: string;
  statusCode: 'active' | 'retired';
  vin: string;
  licensePlate?: string;
  nickname?: string;
  accountVehicleDataChangeTracking: DataChangeTracking;
};
export type SyncOviVehiclesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  vehicles: SyncOviVehicleRequestEntry[];
};
export type BatchBoardingResponse = {
  batchId?: string;
};
export type GmResponseCommonBatchBoardingResponse = {
  result?: BatchBoardingResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LastIgnitionFilter = {
  /** Start timestamp for last ignition filter (from) */
  from?: string;
  /** End timestamp for last ignition filter (to) */
  to?: string;
};
export type VehicleListFilter = {
  /** List of boarding statuses to filter by */
  status?: (
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected'
  )[];
  /** List of VINs to export. When provided, only these vehicles are included. */
  includedVins?: string[];
  /** List of VINs to exclude from export. Used when all are selected and specific rows are deselected. */
  excludedVins?: string[];
  /** Last ignition timestamp range filter with from and to timestamps. */
  lastIgnition?: LastIgnitionFilter;
  /** List of fleet IDs to filter by. When provided, only vehicles in these fleets are returned. */
  fleetIds?: string[];
  /** Location masking filter */
  locationMasking?: ('enabled' | 'disabled')[];
};
export type VehicleOverviewSearchRequest = {
  /** Search term to filter vehicles */
  search?: string;
  /** Type of search query */
  queryType?: 'simple' | 'full' | 'semantic';
  /** Sort order for results */
  sort?: string;
  /** Number of items to skip (for pagination) */
  offset?: number;
  /** Number of items to return per page */
  size?: number;
  /** Filter criteria for vehicle list */
  filter?: VehicleListFilter;
};
export type VehicleBasicInfoResponse = {
  /** Vehicle Identification Number (VIN). */
  vin?: string;
  /** Vehicle name. */
  name?: string;
  /** Vehicle make. */
  make?: string;
  /** Vehicle model. */
  model?: string;
  /** Vehicle year. */
  year?: string;
  /** Vehicle propulsion type (e.g. EV, ICE, PHEV). */
  propulsion?: string;
  /** Vehicle image url. */
  imageSource?: string;
};
export type GmResponseCommonMapStringVehicleBasicInfoResponse = {
  result?: {
    [key: string]: VehicleBasicInfoResponse;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BulkGetVehicleBasicInfoRequest = {
  /** List of Vehicle Identification Numbers (VINs) to get basic info for. */
  vins: string[];
};
export type VehicleOverviewSearchResult = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet Name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Manufacturer of the Vehicle */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Engine type of the vehicle */
  propulsion?: string;
  /** Model year of the Vehicle */
  year?: string;
  /** Connectivity status */
  connectivity?: string;
  /** Unified connection status across OnStar and fleet-adapter providers */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** OnStar support status */
  onStarSupportStatus?: string;
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?: string;
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** The current state of the OnStar unit */
  onStarUnitState?: string;
  /** Location masking status */
  locationMaskingStatus?: string;
  /** Last ignition time of the vehicle */
  lastIgnition?: string;
};
export type AzureAiSearchResponseVehicleOverviewSearchResult = {
  /** List of items returns from search */
  items?: VehicleOverviewSearchResult[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseVehicleOverviewSearchResult = {
  result?: AzureAiSearchResponseVehicleOverviewSearchResult;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationResponse = {
  /** Organization id */
  id?: string;
  /** Organization name */
  name?: string;
};
export type AddressResponse = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type FleetResponse = {
  id?: string;
  name?: string;
  description?: string;
  phoneNumber?: string;
  emailAddress?: string;
  address?: AddressResponse;
  organizationId?: string;
  hubId?: string;
  creationDate?: string;
  timeZone?: string;
  isDefault?: boolean;
};
export type LastCommunicated = {
  deviceTimestamp?: string;
  status?: 'online' | 'offline';
};
export type BatteryInfo = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  soc?: number;
  targetSoc?: number;
  chargeState?: string;
  estimatedRangedInKM?: number;
  estimatedRangeAtTargetSocInKM?: number;
  estimatedTimeRemainingToTargetSOC?: number;
  chargingPowerInput?: number;
  chargingPowerType?: 'level_1' | 'level_2' | 'dc';
  chargeCompletionTime?: string;
  lifetimeEfficiencyInMpKWH?: number;
  chargePowerType?: 'AC' | 'DC' | 'unknown';
  chargingEstimatedCompletionDateTime?: string;
};
export type VehicleType = {
  /** Manufacturer of the Vehicle. */
  make?: string;
  /** Trim level, package, and option code. */
  merchandisingModel?: string;
  /** Model name of the Vehicle. */
  model?: string;
  /** Platform, Engine, and Gearbox code. */
  peg?: string;
  /** Engine type of the vehicle. */
  propulsion?: 'EV' | 'ICE' | 'HEV' | 'PHEV';
  /** List of option codes. */
  rpoCodes?: string[];
  /** Model year of the Vehicle. */
  year?: string;
};
export type BatteryReadinessItem = {
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  lastCommunicated?: LastCommunicated;
  battery?: BatteryInfo;
  vehicleType?: VehicleType;
  provisioning?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  tcpsAccepted?: boolean;
  connectivity?: TelematicsConnectivity;
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  licensePlate?: string;
};
export type BatteryReadinessItemsResponsePageV20250211 = {
  items?: BatteryReadinessItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonBatteryReadinessItemsResponsePageV20250211 = {
  result?: BatteryReadinessItemsResponsePageV20250211;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PeripheralCountByTypeDto = {
  /** Peripheral type */
  type?: string;
  /** Count of peripherals of this type */
  count?: number;
};
export type AssignedDriver = {
  /** Unique identifier for the driver */
  id?: string;
  /** Driver's full name */
  name?: string;
};
export type VehicleWithDriverAndPeripheralsResponse = {
  /** Vehicle Identification Number (VIN) */
  vin?: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  imageSourceUrl?: string;
  /** Fleet ID of the vehicle */
  fleetId?: string;
  /** Count of assigned devices grouped by peripheral type */
  assignedDevices?: PeripheralCountByTypeDto[];
  /** Driver assigned to this vehicle */
  assignedDriver?: AssignedDriver;
};
export type RetrieveVehiclesWithDriversAndPeripheralsResponse = {
  items: VehicleWithDriverAndPeripheralsResponse[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse =
  {
    result?: RetrieveVehiclesWithDriversAndPeripheralsResponse;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type GmResponseCommonBoolean = {
  result?: boolean;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehiclesWithDriversAndPeripheralsRequest = {
  /** List of Vehicle Identification Numbers (VINs) to include. Cannot be used together with excludedVins. */
  includedVins?: string[];
  /** List of Vehicle Identification Numbers (VINs) to exclude. Cannot be used together with includedVins. */
  excludedVins?: string[];
};
export type ChangeFleetResponse = {
  failedVins?: string[];
};
export type GmResponseCommonChangeFleetResponse = {
  result?: ChangeFleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChangeFleetRequest = {
  /** List of Vehicle Identification Numbers (VINs) to change fleet. */
  vins?: string[];
  /** The ID of the new fleet to assign the assets to. */
  newFleetId: string;
};
export type BatchBoardingSummaryVehicleEntry = {
  vin?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
};
export type BatchBoardingVehicleSummary = {
  id?: string;
  organizationId?: string;
  fleetId?: string;
  createdBy?: string;
  createdByName?: string;
  createdByEmail?: string;
  createdDate?: string;
  updatedDate?: string;
  startedDate?: string;
  completedDate?: string;
  status?:
    | 'INITIALIZING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'INCOMPLETE'
    | 'FAILED';
  batchBoardingType?: 'ONBOARDING' | 'OFFBOARDING';
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  totalVehicleCount?: number;
  pendingCount?: number;
  reviewCount?: number;
  completedCount?: number;
  failedCount?: number;
  rejectedCount?: number;
  canceledCount?: number;
  otherCount?: number;
  vehicleBoardingEntries?: BatchBoardingSummaryVehicleEntry[];
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
  sourceLabel?: string;
  messageReplyTo?: string;
  messageReplyToSessionId?: string;
  messageCorrelationId?: string;
};
export type CancelBatchResponse = {
  /** Indicates whether the cancel operation was performed */
  canceled?: boolean;
  /** Message describing the result of the operation */
  message?: string;
  /** The batch summary containing the current state */
  batchSummary?: BatchBoardingVehicleSummary;
};
export type GmResponseCommonCancelBatchResponse = {
  result?: CancelBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListOverview = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet Name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle type */
  vehicleType?: VehicleType;
  /** Connectivity status */
  connectivity?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  /** Unified connection status across OnStar and fleet-adapter providers */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** Last communicated date */
  lastCommunicated?: string;
  /** Indicates if TCPS is accepted */
  tcpsAccepted?: boolean;
  /** The current state of the OnStar unit */
  onStarUnitState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  /** Last onboarded date based on profile time zone */
  lastOnboardedDateWithProfileTimeZone?: string;
  /** Last communicated date based on profile time zone */
  lastCommunicatedWithProfileTimeZone?: string;
  /** Boarding status of the vehicle */
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  /** Location masking state on the vehicle */
  locationMasking?: string;
};
export type PaginatedDataResponseVehicleListOverview = {
  items?: VehicleListOverview[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleListOverview = {
  result?: PaginatedDataResponseVehicleListOverview;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StateDiagnostic = {
  state?: string;
  type?: string;
  deviceTimestamp?: string;
};
export type BatteryInfoJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  soc?: number;
  chargeState?: string;
  estimatedRangedInKM?: number;
};
export type FuelLevelJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  fuelLevel?: number;
};
export type OilLifeJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  oilLife?: number;
};
export type BrakePadJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  brakePadLife?: number;
};
export type VehicleDiagnosticsList = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle type */
  vehicleType?: VehicleType;
  /** Availability state */
  availabilityState?: 'in_service' | 'out_of_service';
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** Last communicated date */
  lastCommunicated?: string;
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Indicates if there are critical diagnostics */
  diagnosticsCritical?: boolean;
  /** Indicates if there are impaired diagnostics */
  diagnosticsImpaired?: boolean;
  /** List of diagnostics */
  diagnostics?: StateDiagnostic[];
  /** Battery information */
  battery?: BatteryInfoJson;
  /** Fuel level information */
  fuelLevel?: FuelLevelJson;
  /** Oil life information */
  oilLife?: OilLifeJson;
  /** Front brake pad information */
  brakePadFront?: BrakePadJson;
  /** Rear brake pad information */
  brakePadRear?: BrakePadJson;
  /** Engine air filter life */
  engineAirFilterLife?: number;
  /** Engine run time hour */
  engineHour?: number;
  /** Odometer reading */
  odometer?: number;
  /** Last onboarded date based on profile time zone */
  lastOnboardedDateWithProfileTimeZone?: string;
  /** Last communicated date based on profile time zone */
  lastCommunicatedWithProfileTimeZone?: string;
};
export type PaginatedDataResponseVehicleDiagnosticsList = {
  items?: VehicleDiagnosticsList[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleDiagnosticsList = {
  result?: PaginatedDataResponseVehicleDiagnosticsList;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PendingVehicleExportRequest = {
  vins?: string[];
};
export type EngineAirFilterJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  engineAirFilter?: number;
  engineAirFilterStatus?:
    | 'replace_now'
    | 'inactive'
    | 'indeterminate'
    | 'missing'
    | 'blocked'
    | 'replace_next_time'
    | 'no_fault'
    | 'unknown';
};
export type AssetReadinessItemEnhancedDiagnostics = {
  /** Asset id */
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  licensePlate?: string;
  lastCommunicated?: LastCommunicated;
  vehicleType?: VehicleType;
  provisioning?: string;
  tcpsAccepted?: boolean;
  connectivity?: TelematicsConnectivity;
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  diagnosticState?: 'clear' | 'impaired' | 'critical';
  diagnosticsCritical?: boolean;
  diagnosticsImpaired?: boolean;
  availabilityState?: 'in_service' | 'out_of_service';
  diagnostics?: StateDiagnostic[];
  battery?: BatteryInfoJson;
  fuelLevel?: FuelLevelJson;
  oilLife?: OilLifeJson;
  brakePadFront?: BrakePadJson;
  brakePadRear?: BrakePadJson;
  engineAirFilter?: EngineAirFilterJson;
  tires?: 'good' | 'impaired' | 'critical' | 'no_data';
  brakeFluid?: 'good' | 'critical' | 'no_data';
  washerFluid?: 'good' | 'impaired' | 'no_data';
  milState?: string;
};
export type AssetReadinessEnhancedDiagnosticsItemResponsePageV20241203 = {
  items?: AssetReadinessItemEnhancedDiagnostics[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203 =
  {
    result?: AssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type RestartConnectivityError = {
  code?: string;
  message?: string;
};
export type RestartConnectivityResponseEntry = {
  /** Vehicle Identification Number from the request entry */
  vin?: string;
  /** Type of connectivity operation requested */
  type?: 'ENROLL' | 'UNENROLL';
  /** Indicates if the connectivity restart operation was successfully sent for processing */
  success?: boolean;
  unitGenId?: string;
  /** Details of any error that occurred during the connectivity restart processing for this VIN */
  error?: RestartConnectivityError;
  ev?: boolean;
};
export type RestartConnectivityResponse = {
  entries?: RestartConnectivityResponseEntry[];
};
export type GmResponseCommonRestartConnectivityResponse = {
  result?: RestartConnectivityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatus = {
  vin?: string;
  status?: 'ENABLED' | 'DISABLED' | 'UNKNOWN';
};
export type VehicleListIgnitionStatusResponse = {
  ignitionStatuses?: VehicleIgnitionStatus[];
};
export type GmResponseCommonVehicleListIgnitionStatusResponse = {
  result?: VehicleListIgnitionStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatusBatchRequest = {
  vins: string[];
};
export type RestartConnectivityRequestEntry = {
  vin: string;
  type: 'ENROLL' | 'UNENROLL';
};
export type RestartConnectivityRequest = {
  entries?: RestartConnectivityRequestEntry[];
};
export type RetryOnboardingVehicleResponse = {
  vin?: string;
  success?: boolean;
  error?: EntryError;
};
export type RetryOnboardingVehicleBatchResponse = {
  entries?: RetryOnboardingVehicleResponse[];
};
export type GmResponseCommonRetryOnboardingVehicleBatchResponse = {
  result?: RetryOnboardingVehicleBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetryOnboardingVehicleBatchRequest = {
  vins: string[];
};
export type GmResponseCommonVoid = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelConnectivitySessionResponse = {
  successfulVins?: string[];
  failedVins?: string[];
};
export type GmResponseCommonCancelConnectivitySessionResponse = {
  result?: CancelConnectivitySessionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelConnectivitySessionRequest = {
  vins: string[];
};
export type FuelOrCharge = {
  /** Asset's battery level. */
  batteryInfo?: BatteryInfoJson;
  /** Asset's fuel level. */
  fuelLevel?: FuelLevelJson;
};
export type VehicleListMapsResponse = {
  /** Asset id. */
  id?: string;
  /** Asset's name. */
  name?: string;
  /** Asset's license plate */
  licensePlate?: string;
  /** Asset's vehicle type. */
  vehicleType?: VehicleType;
  /** If asset's diagnostics are critical. */
  diagnosticsCritical?: boolean;
  /** If asset's diagnostics are impaired. */
  diagnosticsImpaired?: boolean;
  /** Asset's fuel or charge level. */
  fuelOrCharge?: FuelOrCharge;
  /** Status of the vehicle based on the gear state. */
  vehicleStatus?: string;
  /** encoded RPO codes. */
  encodedRpoCodes?: string;
  /** Location coordinates of the vehicle. */
  location?: number[];
};
export type PaginatedDataResponseVehicleListMapsResponse = {
  items?: VehicleListMapsResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleListMapsResponse = {
  result?: PaginatedDataResponseVehicleListMapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SearchCriteria = {
  /** Asset name */
  name?: string;
};
export type FilterCriteria = {
  assetIds?: string[];
  fuelChargePctLevels?: ('LOW' | 'LOW_TO_MID' | 'MID_TO_HIGH' | 'HIGH')[];
  vehicleStatuses?: (
    | 'PARK'
    | 'OFFLINE'
    | 'MOVING'
    | 'IDLING'
    | 'LOCATION_MASKED'
  )[];
  diagnosticsStates?: ('OK' | 'WARNING' | 'CRITICAL')[];
};
export type VehicleListMapsRequest = {
  /** Page size for the maps request. */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
};
export type VehicleLocationMapsResponse = {
  /** List of cluster counts. */
  clusters?: number[];
  /** H3 resolution value (0 to 16). */
  h3resolution?: number;
  /** Polyline-encoded string for cluster locations. */
  polylineEncodedClusterLocations?: string;
  /** Polyline-encoded string for vehicle locations. */
  polylineEncodedVehicleLocations?: string;
  /** Map of vehicle VINs and their meta data. Example: gear states, direction, etc. */
  vehicleMetaData?: {
    [key: string]: any[];
  };
};
export type GmResponseCommonVehicleLocationMapsResponse = {
  result?: VehicleLocationMapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ViewPort = {
  /** Width of the viewport in pixels. */
  width?: number;
  /** Height of the viewport in pixels. */
  height?: number;
};
export type LocationCriteria = {
  /** Viewport dimensions. */
  viewPort?: ViewPort;
  /** Zoom level of the map. */
  zoomLevel?: number;
  /** Bounding box coordinates as a 2D array: [[lat1, lon1], [lat2, lon2]]. */
  boundingBoxCoordinates?: number[][];
  /** Whether to include left navigation panel. */
  includeLeftNavigation?: boolean;
  /** H3 resolution for geospatial indexing. */
  h3Resolution?: number;
};
export type VehicleLocationMapsRequest = {
  /** Page size for the maps request. */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
  /** Criteria for vehicle location on map view. */
  locationCriteria?: LocationCriteria;
};
export type VehicleDataRefreshResponse = {
  acceptedEntries?: string[];
  rejectedEntries?: string[];
};
export type GmResponseCommonVehicleDataRefreshResponse = {
  result?: VehicleDataRefreshResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleDataRefreshRequest = {
  vins?: string[];
};
export type VehicleFieldActionSummaryResponse20241204 = {
  /** Organization ID */
  organizationId?: string;
  /** Total number of vehicles with active field actions. */
  activeFieldActionVehicleCount?: number;
};
export type GmResponseCommonVehicleFieldActionSummaryResponse20241204 = {
  result?: VehicleFieldActionSummaryResponse20241204;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleFieldActionSummaryRequest = {
  fleetId?: string;
};
export type CompletedOperationEntry = {
  vin?: string;
};
export type OperationError = {
  errorCode?: string;
  message?: string;
};
export type FailedOperationEntry = {
  vin?: string;
  error?: OperationError;
};
export type VehicleOwnershipOperationBatchResponse = {
  completedEntries?: CompletedOperationEntry[];
  failedEntries?: FailedOperationEntry[];
};
export type GmResponseCommonVehicleOwnershipOperationBatchResponse = {
  result?: VehicleOwnershipOperationBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleOwnershipOperation = {
  vin: string;
  note?: string;
};
export type VehicleOwnershipOperationBatchRequest = {
  entries: VehicleOwnershipOperation[];
};
export type VehicleFieldActionReportItem = {
  id?: string;
  name?: string;
  licensePlate?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  availabilityState?: 'in_service' | 'out_of_service';
  vehicleType?: VehicleType;
  fieldActionSummary?: {
    [key: string]: string[];
  };
};
export type PaginatedDataResponseVehicleFieldActionReportItem = {
  items?: VehicleFieldActionReportItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleFieldActionReportItem =
  {
    result?: PaginatedDataResponseVehicleFieldActionReportItem;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type VehicleFieldActionReportRequest = {
  /** Page size */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
  /** Continuation token */
  token?: string;
};
export type DiagnosticsValueResponseView = {
  value?: boolean;
  severity?: string;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
  name?: string;
  text?: string;
  recommendation?: string[];
};
export type AssetDetailResponseView = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  /** Asset diagnostics */
  diagnostics?: {
    [key: string]: DiagnosticsValueResponseView;
  };
  /** Unified vehicle connection status derived from OnStar and fleet-adapter providers. */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
};
export type AssetDetailResponseViewPage = {
  items: AssetDetailResponseView[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonAssetDetailResponseViewPage = {
  result?: AssetDetailResponseViewPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EventSubscriptionRequestV2 = {
  type: 'ORG' | 'ASSET_ID';
  id: string;
  organizationId: string;
  cleanFromOthers?: boolean;
};
export type TireStatus = {
  pressureInPSI?: number;
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  deviceTimestamp?: string;
};
export type TireInfoJson = {
  leftFront?: TireStatus;
  rightFront?: TireStatus;
  leftRear?: TireStatus;
  rightRear?: TireStatus;
  overallStatus?: 'good' | 'impaired' | 'critical' | 'no_data';
};
export type TireReadinessItem = {
  id?: string;
  name?: string;
  licensePlate?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  ready?: 'ready' | 'not_ready' | 'unknown';
  lastCommunicated?: LastCommunicated;
  tires?: TireInfoJson;
  vehicleType?: VehicleType;
  availabilityState?: 'in_service' | 'out_of_service';
};
export type TireReadinessItemsResponsePage = {
  items: TireReadinessItem[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonTireReadinessItemsResponsePage = {
  result?: TireReadinessItemsResponsePage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetDetailResponse = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
};
export type AssetDetailResponsePage = {
  items: AssetDetailResponse[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonAssetDetailResponsePage = {
  result?: AssetDetailResponsePage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Value = {
  autolockEnabled?: boolean;
  autolockTimeout?: number;
  proximityUnlockEnabled?: boolean;
  timeZone?: string;
  audioVolumeLimit?: number;
  audioVolumeLimitEnabled?: boolean;
  speedWarningThreshold?: number;
  speedWarningEnabled?: boolean;
  buckleToDriveEnabled?: boolean;
  supervisedDriveModeEnabled?: boolean;
  chargingScheduleEnabled?: boolean;
  chargingScheduleTargetChargeLevel?: number;
  chargingScheduleDepartureTime?: string;
  homeLocationLatitude?: number;
  homeLocationLongitude?: number;
};
export type ConfigurationValue = {
  lastUpdated?: string;
  value?: Value;
};
export type Configuration = {
  desiredConfigurationValue?: ConfigurationValue;
  currentConfigurationValue?: ConfigurationValue;
};
export type Properties = {
  encodedPolyline?: string;
};
export type AssetBase = {
  type?: string;
  assetClass: string;
  id?: string;
  assetId?: string;
  fleetId?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  name?: string;
  offlineAccessToken?: string;
  fan?: string;
  hardwareId?: string;
  dataCommunicationActivityStatus?:
    | 'NOT_PERMITTED'
    | 'PENDING'
    | 'PREPARING'
    | 'ACTIVATING'
    | 'ACTIVATED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  statuses?: {
    [key: string]: StatusItemValueObject;
  };
  diagnostics?: {
    [key: string]: DiagnosticsItemValue;
  };
  capabilities?: {
    [key: string]: string;
  };
  configuration?: Configuration;
  properties?: Properties;
  state?: State;
  connectivity?: TelematicsConnectivity;
  createDateTime?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  ready?: 'ready' | 'not_ready' | 'unknown';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  faultCount?: number;
  lastCommunicated?: string;
  boardingSessionId?: string;
  lastOnboardedDate?: string;
  get_etag?: string;
};
export type AssetBaseWrite = {
  type?: string;
  assetClass: string;
  id?: string;
  assetId?: string;
  fleetId?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  name?: string;
  offlineAccessToken?: string;
  fan?: string;
  hardwareId?: string;
  dataCommunicationActivityStatus?:
    | 'NOT_PERMITTED'
    | 'PENDING'
    | 'PREPARING'
    | 'ACTIVATING'
    | 'ACTIVATED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  statuses?: {
    [key: string]: StatusItemValueObject;
  };
  diagnostics?: {
    [key: string]: DiagnosticsItemValue;
  };
  capabilities?: {
    [key: string]: string;
  };
  configuration?: Configuration;
  properties?: Properties;
  state?: State;
  connectivity?: TelematicsConnectivity;
  createDateTime?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  ready?: 'ready' | 'not_ready' | 'unknown';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  faultCount?: number;
  lastCommunicated?: string;
  boardingSessionId?: string;
  lastOnboardedDate?: string;
  get_etag?: string;
  _ts?: number;
};
export type Error = {
  errorCode?: string;
  message?: string;
};
export type VehicleProbe = {
  sessionId?: string;
  status?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  attempts?: number;
  lastAttemptedDate?: string;
  startedDate?: string;
  completedDate?: string;
  errors?: Error[];
};
export type SelfServeApiPlatformLicense = {
  subscriptionPlan?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  status?: 'PENDING' | 'CREATED' | 'FAILED';
  licenseId?: string;
  licenseStatus?: string;
  requestId?: string;
  statusUrl?: string;
  boardingExternalSessionId?: string;
  attemptCount?: number;
  createdAt?: string;
  updatedAt?: string;
};
export type Vehicle = {
  assetClass: 'Vehicle';
} & AssetBase & {
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    connectivity?: TelematicsConnectivity;
    boardingStatus?:
      | 'pending_verification'
      | 'not_equipped'
      | 'pending_connection'
      | 'connected';
    vin?: string;
    licensePlate?: string;
    licensePlateExpirationDate?: string;
    vehicleMake?: string;
    vehicleModel?: string;
    vehicleYear?: string;
    vehicleImageSource?: string;
    onStar?: OnStar;
    oviVehicleId?: string;
    oviAccountId?: string;
    oviFleetId?: string;
    oviChangeSequence?: string;
    peg?: string;
    vehiclePropulsionModel?: Ev | Hev | Ice | Phev;
    vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    vehicleRpoCodes?: string[];
    vehicleMerchandisingModel?: string;
    vehicleProbe?: VehicleProbe;
    selfServeApiPlatformLicense?: SelfServeApiPlatformLicense;
    gmVehicle?: boolean;
    vehicleDeliveryDate?: string;
    availableCommands?: (
      | 'ALERT'
      | 'CANCEL_ALERT'
      | 'START'
      | 'CANCEL_START'
      | 'ENABLE_IGNITION'
      | 'DISABLE_IGNITION'
      | 'LOCK_DOOR'
      | 'UNLOCK_DOOR'
    )[];
  };
export type VehicleWrite = {
  assetClass: 'Vehicle';
} & AssetBaseWrite & {
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    connectivity?: TelematicsConnectivity;
    boardingStatus?:
      | 'pending_verification'
      | 'not_equipped'
      | 'pending_connection'
      | 'connected';
    vin?: string;
    licensePlate?: string;
    licensePlateExpirationDate?: string;
    vehicleMake?: string;
    vehicleModel?: string;
    vehicleYear?: string;
    vehicleImageSource?: string;
    onStar?: OnStar;
    oviVehicleId?: string;
    oviAccountId?: string;
    oviFleetId?: string;
    oviChangeSequence?: string;
    peg?: string;
    vehiclePropulsionModel?: Ev | Hev | Ice | Phev;
    vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    vehicleRpoCodes?: string[];
    vehicleMerchandisingModel?: string;
    vehicleProbe?: VehicleProbe;
    selfServeApiPlatformLicense?: SelfServeApiPlatformLicense;
    gmVehicle?: boolean;
    vehicleDeliveryDate?: string;
    availableCommands?: (
      | 'ALERT'
      | 'CANCEL_ALERT'
      | 'START'
      | 'CANCEL_START'
      | 'ENABLE_IGNITION'
      | 'DISABLE_IGNITION'
      | 'LOCK_DOOR'
      | 'UNLOCK_DOOR'
    )[];
  };
export type Asset = Vehicle;
export type AssetWrite = VehicleWrite;
export type GmResponseCommonAsset = {
  result?: Asset | Vehicle;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAssetWrite = {
  result?: AssetWrite | VehicleWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProtectedFieldsUpdateRequest = {
  /** Six digit FAN of the asset */
  fan?: string;
};
export type GmResponseCommonVehicleProbe = {
  result?: VehicleProbe;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConfigurationValueJson = {
  properties?: {
    [key: string]: any;
  };
};
export type UpdateConfigurationJson = {
  configuration?: ConfigurationValueJson;
  lastUpdated?: string;
};
export type SummaryListEntry = {
  summaryId?: string;
  organizationId?: string;
  createdBy?: string;
  createdDate?: string;
};
export type BatchBoardingSummaryListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: SummaryListEntry[];
};
export type GmResponseCommonBatchBoardingSummaryListResponse = {
  result?: BatchBoardingSummaryListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SessionListEntry = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  createdBy?: string;
  createdOn?: string;
};
export type VehicleBoardingSessionListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: SessionListEntry[];
};
export type GmResponseCommonVehicleBoardingSessionListResponse = {
  result?: VehicleBoardingSessionListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListEntry = {
  vin?: string;
  organizationId?: string;
  model?: string;
  make?: string;
  year?: string;
  gmVehicle?: boolean;
  ownershipStatus?: 'AVAILABLE' | 'CLAIMING' | 'CLAIMED' | 'RELEASING';
  accountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  createdDate?: string;
};
export type VehicleListResponse20260224 = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonVehicleListResponse20260224 = {
  result?: VehicleListResponse20260224;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityProviderVehicleListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonConnectivityProviderVehicleListResponse = {
  result?: ConnectivityProviderVehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ClaimedOnstarVehicleListResponse = {
  totalItems?: number;
  count?: number;
  items?: VehicleListEntry[];
};
export type GmResponseCommonClaimedOnstarVehicleListResponse = {
  result?: ClaimedOnstarVehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonVehicleListResponse = {
  result?: VehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PropulsionTypeSummaryResponse = {
  /** Count of ICE vehicles */
  ice?: number;
  /** Count of EV vehicles */
  ev?: number;
  /** Count of HEV vehicles */
  hev?: number;
  /** Count of PHEV vehicles */
  phev?: number;
  /** Count of vehicles with unknown propulsion type */
  unknown?: number;
  /** Total number of vehicles */
  total?: number;
};
export type GmResponseCommonPropulsionTypeSummaryResponse = {
  result?: PropulsionTypeSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmPageBatchBoardingVehicleSummary = {
  items: BatchBoardingVehicleSummary[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageBatchBoardingVehicleSummary = {
  result?: GmPageBatchBoardingVehicleSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonBatchBoardingVehicleSummary = {
  result?: BatchBoardingVehicleSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BatchSummaryVehicleBoardingSession = {
  id?: string;
  batchId?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
  reasonCode?: string;
  createdBy?: string;
  createdDate?: string;
  vehicleName?: string;
  vin?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  licensePlate?: string;
  licensePlateExpiration?: string;
  fleetId?: string;
  organizationId?: string;
};
export type GmPageBatchSummaryVehicleBoardingSession = {
  items: BatchSummaryVehicleBoardingSession[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageBatchSummaryVehicleBoardingSession = {
  result?: GmPageBatchSummaryVehicleBoardingSession;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PendingConnectionVehicleItemV20250826 = {
  vin?: string;
  name?: string;
  licensePlate?: string;
  fleetId?: string;
  organizationId?: string;
  vehicleMake?: 'GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET';
  vehicleModel?: string;
  vehicleYear?: string;
  vehicleImageSrc?: string;
  createdDate?: string;
  lastOnboardedDate?: string;
  merchandisingModel?: string;
  stationId?: string;
  peg?: string;
  fan?: string;
  subscriberAccountNumber?: string;
  accountOwnerEmailId?: string;
  pendingConnectionStatus?:
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'CONNECTION_FAILURE'
    | 'NOT_DEFINED';
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  rpoCodes?: string[];
  connectivity?: TelematicsConnectivity;
};
export type GmPagePendingConnectionVehicleItemV20250826 = {
  items: PendingConnectionVehicleItemV20250826[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPagePendingConnectionVehicleItemV20250826 = {
  result?: GmPagePendingConnectionVehicleItemV20250826;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OilLifeStatusSummary = {
  criticalCount?: number;
  lowCount?: number;
  goodCount?: number;
};
export type OilLifeSummary = {
  organizationId?: string;
  fleetId?: string;
  totalIceCount?: number;
  oilLifeStatusSummary?: OilLifeStatusSummary;
};
export type GmResponseCommonOilLifeSummary = {
  result?: OilLifeSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DiagnosticsSummaryItem = {
  criticalCount?: number;
  warningCount?: number;
  okCount?: number;
  totalCount?: number;
};
export type DiagnosticsSummary = {
  organizationId?: string;
  fleetId?: string;
  totalVehicleCount?: number;
  diagnostics?: DiagnosticsSummaryItem;
};
export type GmResponseCommonDiagnosticsSummary = {
  result?: DiagnosticsSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityStatusItem = {
  /** The primary ownership status of the organization. */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** The OnStar support status. */
  onStarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** The connection status from connectivity.onStar. */
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
};
export type ConnectivityStatusSummaryV20250826 = {
  /** The ID of the organization. */
  organizationId?: string;
  /** The total count of vehicles. */
  totalVehicleCount?: number;
  /** A list of connectivity status items. */
  items?: ConnectivityStatusItem[];
};
export type GmResponseCommonConnectivityStatusSummaryV20250826 = {
  result?: ConnectivityStatusSummaryV20250826;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChargeLevelSummary = {
  charging?: number;
  criticalCount?: number;
  lowCount?: number;
  goodCount?: number;
  highCount?: number;
};
export type ChargeStatusSummary = {
  unpluggedCount?: number;
  pluggedCount?: number;
  waitingCount?: number;
  chargingCount?: number;
  completedCount?: number;
  unableCount?: number;
};
export type ChargeSummary = {
  organizationId?: string;
  fleetId?: string;
  totalEVCount?: number;
  chargeLevelSummary?: ChargeLevelSummary;
  chargeStatusSummary?: ChargeStatusSummary;
};
export type GmResponseCommonChargeSummary = {
  result?: ChargeSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleBoardingWorkflowSessionBatchEntry = {
  vin?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
};
export type VehicleBoardingWorkflowSessionBatchSummary = {
  id?: string;
  createdBy?: string;
  createdOn?: string;
  organizationId?: string;
  fleetIds?: string[];
  type?: 'ONBOARDING' | 'OFFBOARDING';
  status?: 'PENDING' | 'COMPLETED';
  startedDate?: string;
  completedDate?: string;
  entriesTotalCount?: number;
  entriesPendingCount?: number;
  entriesReviewCount?: number;
  entriesCompletedCount?: number;
  entriesFailedCount?: number;
  entriesRejectedCount?: number;
  entriesCanceledCount?: number;
  entriesOtherCount?: number;
  entries?: VehicleBoardingWorkflowSessionBatchEntry[];
};
export type GmResponseCommonVehicleBoardingWorkflowSessionBatchSummary = {
  result?: VehicleBoardingWorkflowSessionBatchSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type License = {
  level?: string;
  productCode?: string;
};
export type Entitlement = {
  licenses?: License[];
  capabilities?: string[];
  enablements?: string[];
};
export type AssetEntitlement = {
  id?: string;
  name?: string;
  licensePlate?: string;
  vin?: string;
  peg?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  vehicleMerchandisingModel?: string;
  availability?: string;
  provisioning?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?: string;
  fleetId?: string;
  fleetName?: string;
  onStarTcpsAccepted?: boolean;
  entitlement?: Entitlement;
  vehiclePropulsion?: string;
};
export type AzureAiSearchResponseAssetEntitlement = {
  /** List of items returns from search */
  items?: AssetEntitlement[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseAssetEntitlement = {
  result?: AzureAiSearchResponseAssetEntitlement;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Driver = {
  /** Unique identifier for the driver profile */
  driverProfileId?: string;
  /** Full name of the driver */
  name?: string;
  /** Email address of the driver */
  email?: string;
};
export type FleetDto = {
  /** Fleet ID */
  id: string;
  /** Fleet name */
  name: string;
};
export type VehicleWithDriverResponse = {
  /** Vehicle VIN */
  vin?: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  vehicleImageSource?: string;
  /** Driver profile information */
  driver?: Driver;
  /** Fleet details of vehicle */
  fleet?: FleetDto;
};
export type PaginatedDataResponseVehicleWithDriverResponse = {
  items?: VehicleWithDriverResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleWithDriverResponse = {
  result?: PaginatedDataResponseVehicleWithDriverResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type WorkflowEventData = {
  result?: string;
  context?: string;
};
export type WorkflowEvent = {
  createdOn?: string;
  data?: WorkflowEventData;
  eventType?:
    | 'SESSION_STARTED'
    | 'SESSION_COMPLETED'
    | 'SESSION_FAILED'
    | 'SESSION_TERMINATED'
    | 'SESSION_ARCHIVED'
    | 'ACTIVITY_SCHEDULED'
    | 'ACTIVITY_COMPLETED'
    | 'ACTIVITY_FAILED'
    | 'WAIT_SCHEDULED'
    | 'WAIT_COMPLETED'
    | 'WAIT_FAILED';
  name?: string;
};
export type VehicleProofOfOwnership = {
  status?: 'PENDING' | 'REVIEW' | 'CONFIRMED' | 'REJECTED' | 'CANCELED';
  requestReviewDate?: string;
  requestReviewReason?:
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE';
  confirmedDate?: string;
  confirmedBy?: string;
  confirmedNote?: string;
  confirmedApproach?: 'AUTO' | 'MANUAL';
  rejectedDate?: string;
  rejectedBy?: string;
  rejectedNote?: string;
  rejectedApproach?: 'AUTO' | 'MANUAL';
  rejectedReason?:
    | 'VEHICLE_REJECTED_ADAPTER_ONSTAR_CONFLICT'
    | 'VEHICLE_REJECTED_INVALID_FLEET_ADAPTER';
};
export type VehicleBoardingParameters = {
  fleetAccountNumber?: string;
  onstarAccountNumber?: string;
  onstarTcpsAccepted?: boolean;
  fleetId?: string;
  vehicleName?: string;
  vehicleLicensePlate?: string;
  vehicleLicensePlateExpirationDate?: string;
  connectionPolicy?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  subscription?: Subscription;
};
export type VehicleBoardingWorkflowSessionDetail = {
  id?: string;
  vin?: string;
  docType?: string;
  batchId?: string;
  createdBy?: string;
  createdOn?: string;
  events?: WorkflowEvent[];
  organizationId?: string;
  ownership?: VehicleProofOfOwnership;
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  sessionType?: 'ONBOARDING' | 'OFFBOARDING';
  status?: 'ACTIVE' | 'COMPLETED' | 'FAILED' | 'TERMINATED' | 'ARCHIVED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  vehicleBoardingParameters?: VehicleBoardingParameters;
  vehicleImageSrc?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
  sourceLabel?: string;
};
export type GmPageVehicleBoardingWorkflowSessionDetail = {
  items: VehicleBoardingWorkflowSessionDetail[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageVehicleBoardingWorkflowSessionDetail = {
  result?: GmPageVehicleBoardingWorkflowSessionDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityStatusDashboardSummaryItem = {
  /** The ID of the organization. */
  organizationId?: string;
  /** The total count of vehicles. */
  totalVehicleCount?: number;
  /** A list of connectivity status items. */
  items?: ConnectivityStatusItem[];
};
export type GmResponseCommonConnectivityStatusDashboardSummaryItem = {
  result?: ConnectivityStatusDashboardSummaryItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChargeLevelDashboardSummaryResponse = {
  organizationId?: string;
  fleetId?: string;
  totalEVCount?: number;
  chargeLevelSummary?: ChargeLevelSummary;
};
export type GmResponseCommonChargeLevelDashboardSummaryResponse = {
  result?: ChargeLevelDashboardSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BasicVehicleDetails = {
  /** id also known as vin. */
  id?: string;
  /** the vehicle name. */
  name?: string;
  /** license plate associated with vehicle. */
  licensePlate?: string;
  /** the id of the organization this vehicle is associated with. */
  organizationId?: string;
  /** the id of the fleet this vehicle is associated with. */
  fleetId?: string;
  /** vehicle type. */
  vehicleType?: VehicleType;
};
export type PaginatedDataResponseBasicVehicleDetails = {
  items?: BasicVehicleDetails[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseBasicVehicleDetails = {
  result?: PaginatedDataResponseBasicVehicleDetails;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AzureAiSearchResponseAsset = {
  /** List of items returns from search */
  items?: (Asset | Vehicle)[];
  /** Total number of items found */
  totalItems?: number;
};
export type AzureAiSearchResponseAssetWrite = {
  /** List of items returns from search */
  items?: (AssetWrite | VehicleWrite)[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseAsset = {
  result?: AzureAiSearchResponseAsset;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAzureAiSearchResponseAssetWrite = {
  result?: AzureAiSearchResponseAssetWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type IncompleteOnboardingVehicleListItem = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  fleetId?: string;
  reason?:
    | 'UNEXPECTED_FAILURE'
    | 'VEHICLE_REJECTED_ACTIVELY_ONBOARDING'
    | 'VEHICLE_REJECTED_ACTIVELY_OFFBOARDING'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OTHER'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OWNER'
    | 'VEHICLE_REJECTED_DUPLICATE_VIN'
    | 'VEHICLE_REJECTED_NO_INFORMATION_FOUND'
    | 'VEHICLE_REJECTED_INSUFFICIENT_INFORMATION'
    | 'VEHICLE_REJECTED_INVALID_VIN'
    | 'VEHICLE_REJECTED_BATCH_VIN_LIMIT_EXCEEDED'
    | 'VEHICLE_MANUAL_PROOF_OF_OWNERSHIP_REJECTED'
    | 'VEHICLE_REJECTED_NOT_SUPPORTED';
  createdOn?: string;
  createdBy?: string;
  vehicleImageSrc?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleYear?: string;
};
export type IncompleteOnboardingVehiclesResponse = {
  items?: IncompleteOnboardingVehicleListItem[];
  totalItems?: number;
  token?: string;
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonIncompleteOnboardingVehiclesResponse = {
  result?: IncompleteOnboardingVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetListItem = {
  /** Asset id. */
  id?: string;
  /** Asset name. */
  name?: string;
  /** Asset license plate. */
  licensePlate?: string;
  /** Asset propulsion type. */
  vehicleType?: VehicleType;
  /** Vehicle OnStar tcpsAccepted */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Fan number. */
  fan?: string;
  /** Organization primary ownership status. */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Organization representation for organization id and name. */
  organization?: OrganizationResponse;
  /** Fleet representation for fleet id and name. */
  fleet?: FleetResponse;
  /** Provisioning state. */
  provisioning?: string;
  /** Telematics connectivity details. */
  connectivity?: TelematicsConnectivity;
  /** Unified vehicle connection status across OnStar and fleet-adapter providers. */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** Vehicle image source URL. */
  vehicleImageSource?: string;
};
export type PaginatedDataResponseAssetListItem = {
  items?: AssetListItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseAssetListItem = {
  result?: PaginatedDataResponseAssetListItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatusView = {
  ignitionStatus?: 'ENABLED' | 'DISABLED' | 'UNKNOWN';
};
export type GmResponseCommonVehicleIgnitionStatusView = {
  result?: VehicleIgnitionStatusView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetMinimalStatusObject = {
  value?: any;
  deviceTimestamp?: string;
};
export type AssetStatusView = {
  statuses?: {
    [key: string]: AssetMinimalStatusObject;
  };
};
export type GmResponseCommonAssetStatusView = {
  result?: AssetStatusView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PendingOnboardingVehicleListItem = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  fleetId?: string;
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  reviewReason?:
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE';
  createdOn?: string;
  vehicleImageSrc?: string;
  vehicleMake?: 'GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET';
  vehicleModel?: string;
  vehicleYear?: string;
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  merchandisingModel?: string;
  peg?: string;
  rpoCodes?: string[];
  fan?: string;
  onStar?: OnStar;
};
export type PendingOnboardingVehiclesResponse = {
  items?: PendingOnboardingVehicleListItem[];
  totalItems?: number;
  token?: string;
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonPendingOnboardingVehiclesResponse = {
  result?: PendingOnboardingVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleFieldActionDetails = {
  title?: string;
  releaseDate?: string;
  type?: 'ZPSR' | 'ZPER' | 'ZNCR' | 'ZCSP';
};
export type VehicleFieldActionDetailsResponse = {
  id?: string;
  fieldActions?: VehicleFieldActionDetails[];
};
export type GmResponseCommonVehicleFieldActionDetailsResponse = {
  result?: VehicleFieldActionDetailsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleBoardingProfileDetail = {
  id?: string;
  vin?: string;
  docType?: string;
  status?: 'INACTIVE' | 'OFFBOARDING' | 'ONBOARDING';
  organizationId?: string;
  createdOn?: string;
  updatedOn?: string;
  lastCompletedBoardingSessionId?: string;
  lastAbortedBoardingSessionId?: string;
  currentBoardingSessionId?: string;
};
export type GmResponseCommonVehicleBoardingProfileDetail = {
  result?: VehicleBoardingProfileDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonVehicleBoardingWorkflowSessionDetail = {
  result?: VehicleBoardingWorkflowSessionDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetAssetCountSummaryItem = {
  fleetId?: string;
  numberOfAssets?: number;
};
export type OrganizationAssetCountSummaryItem = {
  organizationId?: string;
  numberOfAssets?: number;
  fleets?: {
    [key: string]: FleetAssetCountSummaryItem;
  };
};
export type GmResponseCommonOrganizationAssetCountSummaryItem = {
  result?: OrganizationAssetCountSummaryItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetByIdDetailResponse = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
  offlineAccessToken?: string;
  fan?: string;
  /** OnStar subscription and vehicle architecture data */
  onStar?: OnStar;
};
export type GmResponseCommonAssetByIdDetailResponse = {
  result?: AssetByIdDetailResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyComplianceInfo = {
  value?: boolean;
  lastUpdated?: string;
  complianceStatus?: {
    [key: string]: boolean;
  };
};
export type ChargingComplianceStatus = {
  chargingScheduleCompliant?: boolean;
  homeLocationCompliant?: boolean;
};
export type ChargingComplianceInfo = {
  value?: boolean;
  complianceStatus?: ChargingComplianceStatus;
};
export type ComplianceItem = {
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  safetyCompliance?: SafetyComplianceInfo;
  chargingCompliance?: ChargingComplianceInfo;
};
export type ComplianceReportPage = {
  items: ComplianceItem[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonComplianceReportPage = {
  result?: ComplianceReportPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BatterySummaryItem = {
  critical?: number;
  impaired?: number;
  info0?: number;
  info1?: number;
  no_data?: number;
};
export type ChargeSummaryItem = {
  charging?: number;
  no_data?: number;
};
export type DiagnosticSummaryItem = {
  tire_low?: number;
  tire_flat?: number;
  fluid_low_brake?: number;
  fluid_low_washer?: number;
  mil_critical?: number;
  mil_impaired?: number;
};
export type ConnectivitySummaryItem = {
  online?: number;
  offline?: number;
  no_data?: number;
};
export type AvailabilitySummaryItem = {
  in_service?: number;
  out_of_service?: number;
};
export type DashboardSummaryItem = {
  type?: string;
  total?: number;
  ready?: number;
  battery?: BatterySummaryItem;
  charge?: ChargeSummaryItem;
  diagnostics?: DiagnosticSummaryItem;
  connectivity?: ConnectivitySummaryItem;
  availability?: AvailabilitySummaryItem;
  not_ready?: number;
};
export type BatterySettings = {
  thresholds?: {
    [key: string]: number;
  };
};
export type DashboardSettings = {
  battery?: BatterySettings;
};
export type DashboardSummaryWrapper = {
  summaries?: DashboardSummaryItem[];
  settings?: DashboardSettings;
};
export type GmResponseCommonDashboardSummaryWrapper = {
  result?: DashboardSummaryWrapper;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AddressJson = {
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Address city */
  city?: string;
  /** Address state or province */
  state?: string;
  /** Address postal code */
  postalCode?: string;
  /** Address country */
  country?: string;
};
export type LocationResponseJson = {
  lon?: number;
  lat?: number;
  address?: AddressJson;
};
export type OperationalStatus = {
  primary?: 'OFFLINE' | 'STOPPED' | 'MOVING' | 'UNKNOWN';
  speed?: number;
  direction?: number;
  lastUpdated?: string;
};
export type ViewMapListItem = {
  id?: string;
  name?: string;
  battery?: BatteryInfo;
  location?: LocationResponseJson;
  operational?: OperationalStatus;
  connectivity?: 'online' | 'offline';
  brakeFluid?: 'good' | 'critical' | 'no_data';
  washerFluidState?: 'good' | 'impaired' | 'no_data';
  tires?: 'good' | 'impaired' | 'critical' | 'no_data';
  ready?: boolean;
  faultCount?: number;
  milState?: string;
  availability?: 'in_service' | 'out_of_service';
  cubbyTempState?: 'good' | 'impaired' | 'critical';
  lastCommunicated?: string;
};
export type PaginatedDataResponseViewMapListItem = {
  items?: ViewMapListItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseViewMapListItem = {
  result?: PaginatedDataResponseViewMapListItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAssetDetailResponseView = {
  result?: AssetDetailResponseView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AuditExportRequest = {
  /** Start of the export time range (inclusive), in UTC (ISO-8601). */
  fromTimestampInUtc: string;
  /** End of the export time range (inclusive), in UTC (ISO-8601). */
  toTimestampInUtc: string;
  /** Optional list of audit categories to include (e.g. REMOTE_COMMANDS, BOARDING). Omit or empty to include all. */
  category?: string[];
  /** Optional list of event types to include. Omit or empty to include all. */
  eventType?: string[];
  /** Optional action filter (e.g. REQUESTED, COMPLETED). Omit to include all actions. */
  action?: string;
  /** Optional list of VINs (asset IDs) to filter by. Omit or empty to include all assets. */
  vins?: string[];
  /** Optional IANA time zone for formatting timestamps in the export (e.g. America/Detroit). Defaults to UTC if omitted. */
  timeZone?: string;
  /** Optional BCP 47 locale for CSV headers and timestamps (for example en-US, fr-CA, es-MX). Defaults to en-US. */
  locale?: string;
};
export type DemoResponse = {
  response: string;
};
export type GmResponseCommonDemoResponse = {
  result?: DemoResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConditionDtoBase = {
  /** Type of the condition. For the accepted values condition this defines an asset property which
                |value (or values) are evaluated against the accepted values. */
  type: 'RPO' | 'MODEL_YEAR' | 'MAKE' | 'MODEL';
  /** Boolean indicator to indicate if the condition is the inverse.
            True represent negation. If omitted, default value of false is applied. */
  negated: boolean;
};
export type AcceptedValuesConditionDto = {
  type: 'AcceptedValuesConditionDTO';
} & ConditionDtoBase & {
    /** The set of accepted values for the condition. */
    acceptedValues: string[];
  };
export type ModelYearConditionDto = {
  type: 'ModelYearConditionDTO';
} & ConditionDtoBase & {
    /** The beginning year for the condition. */
    start: number;
    /** The ending year for the condition. */
    end?: number;
    type: 'RPO' | 'MODEL_YEAR' | 'MAKE' | 'MODEL';
  };
export type LicensingModelDto = {
  /** Type of this licensing model. */
  type: 'SUBSCRIPTION' | 'RPO' | 'MODEL_YEAR' | 'MODEL' | 'MAKE';
  /** The duration of validity of the license created using this licensing model. */
  duration: string;
  /** Type of the Dates model (that defines how the start date of the license created using this licensing
                model is calculated. */
  dates: 'DELIVERY' | 'NONE';
  /** List of different roles this licensing model is visible to. */
  visibleTo: ('ADVISOR' | 'CUSTOMER')[];
  /** Required license condition (that carry some expression and logic to determine if the condition is satisfied). */
  licensingCondition: AcceptedValuesConditionDto | ModelYearConditionDto;
  /** Represent real time condition checks to be copied to the license to confirm that the license can be currently
                "used. */
  usageRestrictions?: (AcceptedValuesConditionDto | ModelYearConditionDto)[];
  /** Optional list of additional conditions to be satisfied for the licensing model to
            generate a License during licenses generation process. */
  additionalConditions?: (AcceptedValuesConditionDto | ModelYearConditionDto)[];
};
export type ConditionDto = AcceptedValuesConditionDto | ModelYearConditionDto;
export type FeatureDto = {
  /** Unique identifier of the feature. */
  id: string;
  /** Globally unique feature shortcode. */
  code: string;
  /** Name label for this feature. */
  name: string;
  /** Description for this feature. */
  description?: string;
  /** Optional list of the Conditions to be evaluated to determine capabilities of the assets,
            to see if they’re capable of supporting the feature. */
  capabilityChecks?: ConditionDto[];
  /** Date and time this feature is created. */
  createdDateTime: string;
  /** ID of the actor who create the feature. */
  createdBy: string;
  /** Date and time this feature is last updated. */
  updatedDateTime: string;
  /** ID of the actor who last update the feature. */
  updatedBy: string;
};
export type ProductDto = {
  /** Unique identifier of the Product. */
  id: string;
  /** The associated Zuora product ID for this product. */
  zuoraProductId?: string;
  /** Product short code for internal use. */
  code: string;
  /** Name label for this product. */
  name: string;
  /** Textual description of this product */
  description?: string;
  /** The date the product shall become active. */
  effectiveDate: string;
  /** Date this product shall be sunset (no longer allow new license to be created for it) */
  sunsetDate?: string;
  /** ID of the actor who last update the sunset date of this product */
  sunsetBy?: string;
  /** An optional list of products required for this product. */
  requiredProductIds?: string[];
  /** List of models that indicates owning a license to this product. */
  licensingModels: LicensingModelDto[];
  /** The list of countries this product is available in. */
  countries: string[];
  /** The list of features this product has. */
  features?: FeatureDto[];
  /** List of constraint conditions for this product. */
  constraintConditions?: ConditionDto[];
  /** Date and time this product is created. */
  createdDateTime: string;
  /** ID of the actor who create the product. */
  createdBy: string;
  /** Date and time this product is last updated. */
  updatedDateTime: string;
  /** ID of the actor who last update the product. */
  updatedBy: string;
};
export type GmResponseCommonProductDto = {
  result?: ProductDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateProductDto = {
  /** The associated Zuora product ID for this product. */
  zuoraProductId?: string;
  /** Product short code for internal use. */
  code: string;
  /** Name label for this product. */
  name: string;
  /** Textual description of this product */
  description?: string;
  /** The date the product shall become active. */
  effectiveDate: string;
  /** Date this product shall be sunset (no longer allow new license to be created for it) */
  sunsetDate?: string;
  /** ID of the actor who last update the sunset date of this product */
  sunsetBy?: string;
  /** An optional list of products required for this product. */
  requiredProductIds?: string[];
  /** List of models that indicates owning a license to this product. */
  licensingModels: LicensingModelDto[];
  /** The list of countries this product is available in. */
  countries: string[];
  /** The list of features this product has. */
  features: string[];
  /** List of constraint conditions for this product. */
  constraintConditions?: (AcceptedValuesConditionDto | ModelYearConditionDto)[];
};
export type ProductsPageDto = {
  items: ProductDto[];
  totalItems?: number;
  previousToken?: string;
  token?: string;
  nextToken?: string;
  firstpageItemIndex: number;
};
export type GmResponseCommonProductsPageDto = {
  result?: ProductsPageDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FilterBy = any;
export type ListFilter = FilterBy & {
  oneOfValues: string[];
};
export type Range = {
  min: string;
  max: string;
};
export type RangeFilter = FilterBy & {
  range: Range;
};
export type ProductListDto = {
  sort?: {
    [key: string]: 'ASC' | 'DESC';
  };
  filter?: {
    [key: string]: ListFilter | RangeFilter;
  };
  token?: string;
  itemsPerResponse: number;
};
export type GmResponseCommonFeatureDto = {
  result?: FeatureDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateFeatureDto = {
  /** Globally unique feature shortcode. */
  code: string;
  /** Name label for this feature. */
  name: string;
  /** Description for this feature. */
  description?: string;
  /** Optional list of the Conditions to be evaluated to determine capabilities of the assets,
            to see if they’re capable of supporting the feature. */
  capabilityChecks?: (AcceptedValuesConditionDto | ModelYearConditionDto)[];
};
export type GmResponseCommonListProductDto = {
  result?: ProductDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SunsetRequestDto = {
  /** ID of the product to sunset. */
  productIdToSunset: string;
  /** Optional, ID of the product to make active. */
  productIdToActivate?: string;
};
export type DriverCardDto = {
  /** Identification of the driver. */
  driverId: string;
  /** Name of the driver. */
  driverName: string;
};
export type VehicleDto = {
  /** The VIN of the vehicle charged. */
  vin: string;
  /** The name of the vehicle charged.. */
  vehicleName?: string;
  /** The make of the vehicle charged.. */
  make?: string;
  /** The model of the vehicle charged.. */
  model?: string;
  /** The year of the vehicle charged.. */
  year?: number;
};
export type ChargeRangeAddedDto = {
  /** The range that was added as the result of the charge session. */
  rangeAdded: number;
  /** The unit of measurement for the range added. */
  units: 'KM' | 'MILES';
};
export type ChargeDurationDto = {
  /** The number of hours of the charge session. */
  hours: number;
  /** The number of minutes of the charge session. */
  minutes: number;
};
export type ChargeSummaryCardDto = {
  /** Charge level start in percentage. Might not be provided by data team. */
  chargeLevelStartPercentage?: number;
  /** Charge level at the end of the charging, in percentage. Might not be provided by data team. */
  chargeLevelEndPercentage?: number;
  /** Energy added in this charge session in kWh. */
  energyAddedInKwh: number;
  /** Drive range added in this charge session. Might not be provided by data team. */
  rangeAdded?: ChargeRangeAddedDto;
  /** Plugin time as UTC ISO 8601 of the charge session. */
  chargeSessionStartTime: string;
  /** The charge duration of the charge session. Might not be provided by data team. */
  chargeSessionDuration?: ChargeDurationDto;
  /** The charger type used to charge the car. Might not be provided by data team. */
  chargerType?: 'LEVEL_1' | 'LEVEL_2' | 'FAST';
  /** The location type of the charge session. */
  chargeLocation: 'HOME' | 'DEPOT' | 'PUBLIC' | 'OTHER';
};
export type UtilityAndCostCardDto = {
  /** Currency Code as a string of the utility rate. */
  currency: string;
  /** Utility Rate Source Type. */
  utilityRateSourceType:
    | 'FLEET_RATE'
    | 'DRIVER_RATE'
    | 'REGIONAL_RATE'
    | 'NATIONAL_RATE'
    | 'EMPTY'
    | 'INVALID';
  /** The utility rate cost per kWh. */
  rate: number;
  /** The estimated cost using the utility rate and the energy added for the charge session. */
  cost: number;
  /** The utility rate provider name. Optional, might not exist. */
  providerName?: string;
};
export type ChargeHistoryChargeSessionDetailsDto = {
  /** The driver information of the vehicle charged in a charge session. */
  driver: DriverCardDto;
  /** The vehicle information of the vehicle charged in a charge session. */
  vehicle: VehicleDto;
  /** Summary of the charge session information. */
  summary: ChargeSummaryCardDto;
  /** Utility information and estimated cost for the charge session. */
  utilityAndCostCard: UtilityAndCostCardDto;
};
export type GmResponseCommonChargeHistoryChargeSessionDetailsDto = {
  result?: ChargeHistoryChargeSessionDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateReimbursementUtilityRateRequestDto = {
  /** Charge session id of the reimbursement record to update. */
  chargeSessionId: string;
  /**
                    The new utility rate for the home charge reimbursement and driver utility rate.
                    Must be greater than 0.
                 */
  newUtilityRate: number;
  /** The currency code of the new utility rate. */
  rateCurrencyCode: string;
  /** Optional utility provider code. */
  utilityProviderCode?: string;
  /** Optional utility provider name. */
  utilityProviderName?: string;
};
export type DriverDetailsDto = {
  /** Identification of the driver. */
  driverId: string;
  /** Name of the driver. */
  driverName: string;
  /** Single line of display address. */
  driverDisplayAddress: string;
  /** Currency Code as a string of the utility rate. */
  currency: string;
  /** Utility Rate Source Type. */
  utilityRateSourceType:
    | 'FLEET_RATE'
    | 'DRIVER_RATE'
    | 'REGIONAL_RATE'
    | 'NATIONAL_RATE'
    | 'EMPTY'
    | 'INVALID';
  /** The utility rate cost per kWh. */
  rate: number;
  /** Optional utility provider code. */
  utilityProviderCode?: string;
  /** Optional utility provider name. */
  utilityProviderName?: string;
};
export type GmResponseCommonDriverDetailsDto = {
  result?: DriverDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateDriverUtilityPlanRequestDto = {
  /**
                    The new utility rate. Must be greater than 0.
                 */
  newUtilityRate: number;
  /** The currency code of the new utility rate. */
  rateCurrencyCode: string;
  /** Optional utility provider code. */
  utilityProviderCode?: string;
  /** Optional utility provider name. */
  utilityProviderName?: string;
};
export type ReportColumnFilterDtoBase = {
  type: string;
  columnName: string;
};
export type DateRangeFilterDto = {
  type: 'DateRangeFilterDto';
} & ReportColumnFilterDtoBase & {
    startDateUtc: string;
    endDateUtc: string;
  };
export type SimpleStringColumnFilterDto = {
  type: 'SimpleStringColumnFilterDto';
} & ReportColumnFilterDtoBase & {
    values: string[];
  };
export type ReportDataFilters = {
  dateRangeFilter: DateRangeFilterDto;
  orgId: string;
  columnFilters: (DateRangeFilterDto | SimpleStringColumnFilterDto)[];
};
export type ReportDataRequest = {
  /** Filtering options used to query and narrow down the report data. */
  filters: ReportDataFilters;
  locale: string;
  timeZone?: string;
  unitSystem?: string;
};
export type FindFleetUtilityRateSettingsDto = {
  /** Identification of the fleet. */
  fleetId: string;
  /** Identification of the organization. */
  orgId: string;
  /**
                    Identification of the organization. Indicates if the driver
                    is allowed to override the fleet utility rate setting.
                 */
  allowDriverOverride: boolean;
  /** The 3 letter ISO code for the fleet utility rate currency. */
  currency: string;
  /** The fleet utility rate cost per kilowatt. This field can be null. */
  costPerKilowatt?: number;
  /**
                    Defines the type of the fleet selected utility plan.
                    In the case where the fleet manager decides not to define a rate, the type is EMPTY.
                    In the case where the fleet manager decides to define some other type of rate, the rate will be
                    returned, currently FLEET_RATE is the other supported type.
                 */
  utilityPlanType: string;
  /** False if the utility rate was never configured for this fleet. */
  neverDefined: boolean;
};
export type GmResponseCommonFindFleetUtilityRateSettingsDto = {
  result?: FindFleetUtilityRateSettingsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateOrUpdateFleetUtilityRateSettingsDto = {
  /** Identification of the fleet. */
  fleetId: string;
  /** Identification of the organization. */
  orgId: string;
  /** Indicates if the driver is allowed to override the fleet utility rate setting. */
  allowDriverOverride: boolean;
  /** The 3 letter ISO code for the fleet utility rate currency. */
  currency: string;
  /**
                    The fleet utility rate cost per kilowatt. This field is not required. In the case where the rate
                    is null an EmptyUtilityPlan with UtilityRateSourceType.EMPTY will be created.
                 */
  costPerKilowatt?: number;
};
export type ReimbursementExportRequestDto = {
  /** Set of records to be selected for the selected reimbursement. */
  selectedRecordIds: string[];
};
export type ExportReportByEmailResult = {
  /** Indication if the attempt to send the report by email was successful. */
  success: boolean;
  /** Email that the report was sent to. */
  sentToEmail: string;
  /** Name that appears in the email template. */
  name: string;
};
export type GmResponseCommonExportReportByEmailResult = {
  result?: ExportReportByEmailResult;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AddressDto = {
  /** House number of the address. */
  houseNumber?: string;
  /** Street name of the address. */
  street?: string;
  /** City of the address. */
  city?: string;
  /** State code of the address. */
  stateCode?: string;
  /** ZIP code of the address. */
  zipCode?: string;
  /** Country code of the address (ISO 3166-1 alpha-2). */
  countryCode?: string;
};
export type WeeklyPeriodDto = {
  /** Days of the week for this period (e.g., 1-4,7 for Monday-Thursday and Sunday). */
  days?: string;
  /** Start hour of the period (0-23). */
  from?: number;
  /** End hour of the period (0-23). */
  to?: number;
};
export type PriceComponentDto = {
  /** Type of the price component. */
  type:
    | 'ENERGY'
    | 'FLAT'
    | 'PARKING_TIME'
    | 'TIME'
    | 'CONGESTION_TIME'
    | 'SESSION_TIME'
    | 'MAX'
    | 'MIN';
  /** Price value for this component. */
  price: number;
};
export type TariffElementDto = {
  /** List of price components that define the pricing for this tariff element. */
  priceComponents?: PriceComponentDto[];
};
export type TariffDto = {
  /** Currency code for the tariff (ISO 4217). */
  currency: string;
  /** List of tariff elements that define the pricing structure. */
  elements?: TariffElementDto[];
};
export type ConnectorDto = {
  /** Type of the connector. */
  connectorType?:
    | 'IEC_62196_T1'
    | 'IEC_62196_T1_COMBO'
    | 'SAE_J3400'
    | 'TESLA_S'
    | 'DOMESTIC_B';
  /** Charging grade of the connector (FAST | SLOW). */
  chargingGrade?: 'FAST' | 'SLOW';
  /** Label or name of the connector. */
  label?: string;
  /** Maximum power output of the connector in kilowatts. */
  maxPowerInKiloWatt?: number;
  /** Current availability status of the connector. */
  availability?: 'AVAILABLE' | 'INACTIVE' | 'INUSE' | 'UNKNOWN';
  /** Tariff information for this connector. */
  tariff?: TariffDto;
};
export type ChargeSpotDto = {
  /** Charging grade of the spot (FAST | SLOW). */
  chargingGrade?: 'FAST' | 'SLOW';
  /** Current availability status of the charge spot. */
  availability?: 'AVAILABLE' | 'INACTIVE' | 'INUSE' | 'UNKNOWN';
  /** List of connectors available at this charge spot. */
  connectors?: ConnectorDto[];
};
export type ChargeStationDto = {
  /** Unique identifier of the charge station. */
  id: string;
  /** Name of the charge station. */
  name?: string;
  /** Description of the charge station. */
  description?: string;
  /** Number of ratings for this charge station. */
  ratingCount?: number;
  /** Average rating score for this charge station (0.0 to 5.0). */
  ratingScore?: number;
  /** Geographic location of the charge station as [latitude, longitude]. */
  location: number[];
  /** Distance from the search center point in kilometers. */
  distanceInKilometers?: number;
  /** Address information of the charge station. */
  address?: AddressDto;
  /** Contact phone number for the charge station. */
  contactPhone?: string;
  /** Indicates if the charge station is open 24 hours a day, 7 days a week. */
  open24x7?: boolean;
  /** List of weekly opening hours periods. */
  openingHours?: WeeklyPeriodDto[];
  /** List of image URLs for the charge station. */
  imageUrls?: string[];
  /** Charging grade of the station (FAST | SLOW). */
  chargingGrade?: 'FAST' | 'SLOW';
  /** Current availability status of the charge station. */
  availability?: 'AVAILABLE' | 'INACTIVE' | 'INUSE' | 'UNKNOWN';
  /** Identifier of the charge provider. */
  chargeProviderId?: string;
  /** List of charge spots available at this station. */
  chargeSpots?: ChargeSpotDto[];
};
export type GmPageChargeStationDto = {
  items: ChargeStationDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageChargeStationDto = {
  result?: GmPageChargeStationDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChargeHistoryTableLineDto = {
  /** Identifier of the charge session id for this charge history line. */
  chargeSessionId: string;
  /** Plugin time of the charge session as a UTC ISO 8601. */
  chargeSessionDateTime: string;
  /** Currency Code as a string of the utility rate. */
  currency: string;
  /** Estimation of the charge session cost. */
  cost: number;
  /** Energy added in this charge session in kWh. */
  energyAddedInKwh: number;
  /** The utility rate cost per Kwh used to calculate the cost. */
  utilityRatePerKwh: number;
  /** Utility Rate Source Type. */
  utilityRateSourceType:
    | 'FLEET_RATE'
    | 'DRIVER_RATE'
    | 'REGIONAL_RATE'
    | 'NATIONAL_RATE'
    | 'EMPTY'
    | 'INVALID';
  /** The location type of the charge session. */
  chargeLocation: 'HOME' | 'DEPOT' | 'PUBLIC' | 'OTHER' | 'UNKNOWN';
  /** The vehicle information of the vehicle charged in a charge session. */
  vehicle: VehicleDto;
};
export type GmPageChargeHistoryTableLineDto = {
  items: ChargeHistoryTableLineDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageChargeHistoryTableLineDto = {
  result?: GmPageChargeHistoryTableLineDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CurrentDriverUtilityPlanCardDto = {
  /** Identification of the driver. */
  driverId: string;
  /** Utility Rate Source Type. */
  utilityRateSourceType:
    | 'FLEET_RATE'
    | 'DRIVER_RATE'
    | 'REGIONAL_RATE'
    | 'NATIONAL_RATE'
    | 'EMPTY'
    | 'INVALID';
  /** Currency Code as a string of the utility rate. Can be empty if there is no configured rate. */
  currencyType?: string;
  /** The utility rate cost per Kwh. Can be empty if there is no configured rate. */
  rate?: number;
};
export type GmResponseCommonCurrentDriverUtilityPlanCardDto = {
  result?: CurrentDriverUtilityPlanCardDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FeedbackImageAttachmentRef = {
  blobName: string;
  contentType?: string;
  sizeBytes?: number;
};
export type GmResponseCommonFeedbackImageAttachmentRef = {
  result?: FeedbackImageAttachmentRef;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FeedbackCreateResponse = {
  id: string;
  status: string;
  feedback: string;
  orgId: string;
  url?: string;
  fleetId?: string;
  userId?: string;
  userAgent?: string;
  viewportWidth?: number;
  viewportHeight?: number;
  platform?: string;
  osVersion?: string;
  hardwareModel?: string;
  starRating?: number;
  tags?: string[];
  imageAttachments?: string[];
  createdAt: string;
};
export type GmResponseCommonFeedbackCreateResponse = {
  result?: FeedbackCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ViewportDto = {
  width: number;
  height: number;
};
export type FeedbackCreateRequest = {
  feedback: string;
  url?: string;
  userId?: string;
  heapSessionId?: string;
  userAgent?: string;
  viewport?: ViewportDto;
  platform?: 'IOS' | 'ANDROID' | 'WEB';
  osVersion?: string;
  hardwareModel?: string;
  starRating?: number;
  imageAttachments?: FeedbackImageAttachmentRef[];
};
export type FeedbackListItem = {
  id: string;
  orgId: string;
  feedback: string;
  url?: string;
  fleetId?: string;
  userId?: string;
  userAgent?: string;
  viewportWidth?: number;
  viewportHeight?: number;
  platform?: string;
  osVersion?: string;
  hardwareModel?: string;
  starRating?: number;
  tags?: string[];
  imageAttachments?: string[];
  jiraIssueKey?: string;
  status: 'RECEIVED' | 'IN_REVIEW' | 'DONE';
  createdAt: string;
  organizationName?: string;
  fleetName?: string;
  userFirstName?: string;
  userLastName?: string;
  heapSessionId?: string;
};
export type FeedbackListResponse = {
  items: FeedbackListItem[];
  totalItems: number;
  continuationToken?: string;
};
export type GmResponseCommonFeedbackListResponse = {
  result?: FeedbackListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FeedbackListRequest = {
  fleetId?: string;
  userId?: string;
  status?: 'RECEIVED' | 'IN_REVIEW' | 'DONE';
};
export type CreateJiraTicketResponse = {
  issueKey: string;
  issueUrl: string;
};
export type GmResponseCommonCreateJiraTicketResponse = {
  result?: CreateJiraTicketResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateJiraTicketRequest = {
  feedbackId: string;
};
export type FeedbackStatusUpdateResponse = {
  feedbackId: string;
  status: string;
};
export type GmResponseCommonFeedbackStatusUpdateResponse = {
  result?: FeedbackStatusUpdateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FeedbackStatusUpdateRequest = {
  feedbackId: string;
  status: 'RECEIVED' | 'IN_REVIEW' | 'DONE';
};
export type EnrollVehiclesResponseDto = {
  /** Organization that owns the batch */
  organizationId: string;
  /** Batch identifier for polling enrollment progress */
  batchId: string;
  /** Provider for the batch */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Enroll or unenroll command accepted for this batch */
  action: 'ENROLL' | 'UNENROLL';
  /** Batch processing status */
  status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  /** When the batch was created */
  createdAt: string;
  /** Number of vehicles requested in this batch */
  requestedCount: number;
};
export type GmResponseCommonEnrollVehiclesResponseDto = {
  result?: EnrollVehiclesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollVehiclesRequestDto = {
  /** Whether to enroll or unenroll the selected vehicles */
  action: 'ENROLL' | 'UNENROLL';
  /** System that initiated the command. OFI when the field is omitted. */
  source: 'OVI' | 'GMF' | 'OFI';
  /**
                VINs to enroll or unenroll.
                Values are trimmed; blank entries are ignored.
                A VIN that appears more than once is kept once.
                At least one VIN must remain after normalization.
             */
  vins: string[];
  /** Who requested the batch. Omitted when the caller does not supply it. */
  requestedBy?: string;
};
export type EligibleVehicleLicenseDto = {
  /** Product code */
  productCode?: string;
  /** License level */
  level?: string;
  /** License type */
  type?: string;
  /** License start date */
  startDate?: string;
  /** License end date */
  endDate?: string;
};
export type EligibleVehicleResponseDto = {
  /** Asset identifier */
  id: string;
  /** Vehicle identification number */
  vin?: string;
  /** Vehicle name */
  name?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle make */
  vehicleMake?: string;
  /** Vehicle model */
  vehicleModel?: string;
  /** Vehicle year */
  vehicleYear?: string;
  /** Merchandising model */
  vehicleMerchandisingModel?: string;
  /** Propulsion */
  vehiclePropulsion?: string;
  /** Fleet identifier */
  fleetId?: string;
  /** Fleet name */
  fleetName?: string;
  /** Licenses on the vehicle */
  licenses: EligibleVehicleLicenseDto[];
};
export type EligibleVehiclesResponseDto = {
  /** Vehicles on this page */
  items: EligibleVehicleResponseDto[];
  /** Total vehicles matching the filter */
  total_items?: number;
  /**
                Continuation token for the next page via the `cs-continuation-token` request header.
                Null when there is no next page.
             */
  continuation_token?: string;
};
export type GmResponseCommonEligibleVehiclesResponseDto = {
  result?: EligibleVehiclesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EligibleVehiclesSearchDto = {
  /** Search text. Blank means no text filter. At most 50 characters. */
  term?: string;
};
export type EligibleVehiclesRequestDto = {
  /** When set, only vehicles in this fleet are returned. */
  fleetId?: string;
  /** Optional text search. Omitted means no text filter. */
  search?: EligibleVehiclesSearchDto;
  /** Vehicles per page. Defaults to 10. Maximum is 99. */
  itemsPerResponse?: number;
};
export type VehicleEnrollmentVinsResponse = {
  vins: string[];
};
export type GmResponseCommonVehicleEnrollmentVinsResponse = {
  result?: VehicleEnrollmentVinsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleEnrollmentVinsRequestDto = {
  /** Enrollment source. A VIN matches only this source. */
  source: 'OVI' | 'GMF' | 'OFI';
  /** Source asset statuses. A VIN matches when its status is any of these. */
  sourceAssetStatus: (
    | 'INGESTED'
    | 'ONBOARDED'
    | 'ERROR'
    | 'OFFBOARD_REQUESTED'
    | 'OFFBOARD_REJECTED'
    | 'OFFBOARDED'
    | 'OFFBOARD_ACCEPTED'
    | 'OFFBOARD_EXPIRED'
    | 'OFFBOARD_FAILED'
    | 'OFI_LINKED'
    | 'EXCLUDED'
  )[];
  /** When set, a VIN matches when its provider is any of these. Omitted means every provider. */
  providerCode?: ('COAST' | 'FLEET_IO' | 'GMF')[];
  /** When set, only rows updated at or after this time are included */
  since?: string;
};
export type ProviderAuthDto = {
  /** Enrollment provider code */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Authentication type for the provider. Defaults to NO_AUTH when omitted from a request. */
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type OrgEnrollmentResponseDto = {
  /** Org enrollment to third party provider identifier */
  id: string;
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** External provider account identifier when known */
  providerAccountId?: string;
  /** Current org enrollment lifecycle status */
  status:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** When the organization enrollment was linked (UTC, ISO-8601). Null until the link is complete. */
  linkedDate?: string;
  /** If enrollment is asynchronous, the integration can be created successfully while vehicle enrollment is tracked by operationId and per-vehicle status */
  operationId?: string;
  /** Batch identifier for polling vehicle enrollment progress when [vins] were supplied on create. Poll via `/vehicle-enrollments/{providerCode}/batches/{batchId}`. Null when no batch was started. */
  batchId?: string;
  /** Provider-specific JSON object stored with the enrollment. */
  customData?: {
    [key: string]: any;
  };
};
export type GmResponseCommonOrgEnrollmentResponseDto = {
  result?: OrgEnrollmentResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProviderCredentialsDto = {
  /** API key for API_KEY auth providers */
  apiKey?: string;
  /** Username for USERNAME_PASSWORD auth providers */
  username?: string;
  /** Password for USERNAME_PASSWORD auth providers */
  password?: string;
};
export type ConsentRequestDto = {
  /** Terms name accepted by the user */
  termsName: string;
  /** Terms version accepted by the user */
  termsVersion: string;
  /** When the terms were accepted (ISO-8601) */
  acceptedAt: string;
  /** User who accepted the terms */
  acceptedBy?: string;
};
export type CreateOrgEnrollmentRequestDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Provider credentials (write-only; never returned). Optional and ignored when authType is NO_AUTH; required fields depend on authType otherwise. */
  credentials?: ProviderCredentialsDto;
  /** External provider account identifier. Required for GMF and set to the GMF Tax ID. */
  providerAccountId?: string;
  /** Org enrollment lifecycle status. */
  status?:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** Accepted terms and consent metadata. Optional; when an item is provided, termsName, termsVersion, and acceptedAt are required. Service will enforce termsRequired later. */
  consents: ConsentRequestDto[];
  /** Provider-specific JSON object stored with the enrollment. */
  customData?: {
    [key: string]: any;
  };
  /**
                Optional VINs to enroll after a fuel-card organization link succeeds. When omitted or null,
                only the org link is created and no vehicle enrollment batch is started. A supplied list must
                contain at least one non-blank VIN after trimming; blank entries are ignored.
             */
  vins?: string[];
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type ValidateCredentialsResponseDto = {
  /** Whether the credentials are valid */
  valid: boolean;
  /** Provider identity and auth method that were validated */
  provider: ProviderAuthDto;
};
export type GmResponseCommonValidateCredentialsResponseDto = {
  result?: ValidateCredentialsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateCredentialsRequestDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Provider credentials (write-only; never returned). Optional and ignored when authType is NO_AUTH; required fields depend on authType otherwise. */
  credentials?: ProviderCredentialsDto;
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type GmfVehicleMetadata = {
  year?: number;
  make?: string;
  model?: string;
  licensePlate?: string;
};
export type GmfVehiclePlan = {
  serviceProvider?: string;
  productDescription?: string;
  serviceEnrollmentDate?: string;
  serviceArchiveDate?: string;
};
export type GmfVehicle = {
  vin?: string;
  vehicleId?: string;
  vinSource?: string;
  productType?: string;
  status?: string;
  updatedDate?: string;
  terminationDate?: string;
  metadata?: GmfVehicleMetadata;
  plans?: GmfVehiclePlan[];
};
export type GmfVehicleDetailsResponse = {
  vehicles?: GmfVehicle[];
};
export type GmResponseCommonGmfVehicleDetailsResponse = {
  result?: GmfVehicleDetailsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfVehicleDetailsRequest = {
  taxId: string;
  organizationId: string;
};
export type GmfAuthorizedUserEligibilityResponse = {
  customerName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  authorizedFlag: boolean;
};
export type GmResponseCommonGmfAuthorizedUserEligibilityResponse = {
  result?: GmfAuthorizedUserEligibilityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfAuthorizedUserLookupRequest = {
  email: string;
  taxId: string;
  organizationId: string;
};
export type GmfServicePlan = {
  fleetId?: string;
  partner?: string;
  activationDate?: string;
  terminationDate?: string;
};
export type GmfServicePlanWrite = {
  fleetId?: string;
  partner?: string;
  activationDate?: string;
  terminationDate?: string;
  accountToken?: string;
};
export type GmfServiceLookupResponse = {
  taxId?: string;
  plans?: GmfServicePlan[];
};
export type GmfServiceLookupResponseWrite = {
  taxId?: string;
  plans?: GmfServicePlanWrite[];
};
export type GmResponseCommonGmfServiceLookupResponse = {
  result?: GmfServiceLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonGmfServiceLookupResponseWrite = {
  result?: GmfServiceLookupResponseWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfServiceLookupRequest = {
  taxId: string;
  organizationId: string;
};
export type GmfOrganizationAddress = {
  addressType?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
};
export type GmfOrganizationLookupResponse = {
  taxId?: string;
  businessName?: string;
  address?: GmfOrganizationAddress[];
  dunsId?: string;
  fan?: string;
  website?: string;
  preferredName?: string;
  accountStatus?: string;
};
export type GmResponseCommonGmfOrganizationLookupResponse = {
  result?: GmfOrganizationLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfOrganizationLookupRequest = {
  taxId?: string;
  dunsId?: string;
  organizationId: string;
};
export type GmfLineOfCreditResponse = {
  taxId: string;
  organizationId: string;
  remainingLoc: number;
};
export type GmResponseCommonGmfLineOfCreditResponse = {
  result?: GmfLineOfCreditResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfLineOfCreditRequest = {
  taxId: string;
  organizationId: string;
};
export type FleetioVerifyEnrollmentResponse = {
  /** Whether Fleetio accepted the API key for the enrollment's Fleetio account. */
  verified: boolean;
  /** Why verification failed. Absent when verified is true. */
  description?: string;
};
export type FleetioVerifyEnrollmentRequest = {
  /** Fleetio API key (write-only; never saved or returned). */
  apiKey: string;
};
export type FleetioFailedRecord = {
  /** Position of the record in the request, starting at 0. */
  index: number;
  /** Error messages by field. */
  error_messages?: {
    [key: string]: string[];
  };
};
export type FleetioSuccessfulRecord = {
  /** Position of the record in the request, starting at 0. */
  index: number;
  /** ID of the created resource. */
  id?: number;
};
export type FleetioBulkJobResponse = {
  /** Bulk job ID. */
  id: string;
  /** Job state (e.g. pending, complete). */
  state?: string;
  /** Resource type. */
  resource?: string;
  /** Operation type. */
  operation?: string;
  /** Total records submitted. */
  total_count?: number;
  /** Records created so far. */
  completed_count?: number;
  /** Records that failed processing. */
  failed_count?: number;
  /** Records Fleetio rejected, by position in the request. */
  failed_records?: FleetioFailedRecord[];
  /** Records Fleetio created, by position in the request. */
  successful_records?: FleetioSuccessfulRecord[];
};
export type MeterEntryRecord = {
  /** Fleetio vehicle ID. */
  vehicle_id: number;
  /** Date and time of the reading (ISO 8601). */
  date: string;
  /** Meter reading value. */
  value: number;
  /** Set to secondary for a secondary meter reading. Leave empty for the primary meter. */
  meter_type?: 'secondary';
};
export type FleetioBulkJobRequest = {
  /** Meter entry records to upload. */
  records: MeterEntryRecord[];
};
export type VehiclesEnrollmentViewVehicleDto = {
  /** Vehicle identification number */
  vin: string;
  /** Vehicle display name when known */
  name?: string;
  /** License plate when known */
  licensePlate?: string;
  /** Vehicle make when known */
  make?: string;
  /** Vehicle model when known */
  model?: string;
  /** Model year when known */
  year?: string;
  /** Merchandising model when known */
  merchandisingModel?: string;
  /** Propulsion type when known */
  propulsion?: string;
  /** Vehicle image source URI when known */
  vehicleImageSource?: string;
};
export type VehiclesEnrollmentViewItemDto = {
  /** Vehicle */
  vehicle: VehiclesEnrollmentViewVehicleDto;
  /** Current enrollment status */
  enrollmentStatus:
    | 'PENDING_READINESS'
    | 'PENDING_ENROLL'
    | 'ENROLLED'
    | 'PENDING_UNENROLL'
    | 'UNENROLLED'
    | 'ERROR_ENROLLMENT'
    | 'ERROR_UNENROLLMENT';
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Fleet identifier when applicable */
  fleetId?: string;
  /** Fleet display name when applicable */
  fleetName?: string;
  /** Provider-side vehicle identifier when assigned */
  providerVehicleId?: string;
  /** When the vehicle was enrolled */
  enrolledAt?: string;
  /** When the enrollment row was last updated */
  lastUpdatedAt?: string;
  /** Normalized enrollment error when applicable */
  errorType?:
    | 'ORG_ENROLLMENT_INVALID'
    | 'NO_LICENSE_PLATE'
    | 'DUPLICATE_LICENSE_PLATE'
    | 'PROVIDER_UNAVAILABLE'
    | 'PROVIDER_REQUEST_TIMEOUT'
    | 'NOT_ELIGIBLE'
    | 'UNKNOWN';
};
export type VehiclesEnrollmentViewResponseDto = {
  /** Table rows for the current page */
  items: VehiclesEnrollmentViewItemDto[];
  /** Total rows matching the filter across all pages */
  total_items?: number;
  /**
                Continuation token for the next page via the `cs-continuation-token` request header.
                Null when there is no next page.
             */
  continuation_token?: string;
};
export type GmResponseCommonVehiclesEnrollmentViewResponseDto = {
  result?: VehiclesEnrollmentViewResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehiclesEnrollmentViewSearchDto = {
  /**
                Free-text table search on vehicle name, VIN, license plate, make, model, year,
                and merchandising model. Blank means no text filter.
             */
  term?: string;
  /** Reserved for future sort support; ignored by the API. */
  sort?: string;
};
export type VehiclesEnrollmentViewRequestDto = {
  /** Fleet scope filter when not using cs-fleet header */
  fleetIds: string[];
  /**
                Filter by enrollment status. A vehicle matches when its status is any of these values.
                An empty list means no status filter (all statuses in scope).
             */
  enrollmentStatuses: (
    | 'PENDING_READINESS'
    | 'PENDING_ENROLL'
    | 'ENROLLED'
    | 'PENDING_UNENROLL'
    | 'UNENROLLED'
    | 'ERROR_ENROLLMENT'
    | 'ERROR_UNENROLLMENT'
  )[];
  /**
                VIN list filter. Entries are trimmed; blank or whitespace-only entries are ignored.
                An empty list after normalization means no VIN filter (all vehicles in scope).
             */
  vins: string[];
  /** Table search (separate from fleetIds/vins filters); sort is not applied yet */
  search: VehiclesEnrollmentViewSearchDto;
  /** Page size */
  size: number;
};
export type VehicleEnrollmentBatchFailedItemDto = {
  /** Vehicle identification number */
  vin: string;
  /** Normalized enrollment error when this VIN failed */
  errorType?:
    | 'ORG_ENROLLMENT_INVALID'
    | 'NO_LICENSE_PLATE'
    | 'DUPLICATE_LICENSE_PLATE'
    | 'PROVIDER_UNAVAILABLE'
    | 'PROVIDER_REQUEST_TIMEOUT'
    | 'NOT_ELIGIBLE'
    | 'UNKNOWN';
  /** Explanation of the failure when the error type does not already name it */
  errorMessage?: string;
};
export type VehicleEnrollmentBatchResponseDto = {
  /** Organization that owns the batch */
  organizationId: string;
  /** Batch identifier from the enroll or unenroll command */
  batchId: string;
  /** Provider for the batch */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Enroll or unenroll command for this batch */
  action: 'ENROLL' | 'UNENROLL';
  /** Overall batch processing status */
  status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  /** Total vehicles in the batch */
  totalCount: number;
  /** Vehicles that succeeded in the batch */
  completedCount: number;
  /** Vehicles that failed in the batch */
  failedCount: number;
  /** VINs in this batch whose outcome is FAILED */
  failedItems: VehicleEnrollmentBatchFailedItemDto[];
};
export type GmResponseCommonVehicleEnrollmentBatchResponseDto = {
  result?: VehicleEnrollmentBatchResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AllEligibleVinsResponse = {
  /** Eligible VINs. Empty when none match. */
  vins: string[];
  /** Number of eligible VINs */
  total_items: number;
};
export type GmResponseCommonAllEligibleVinsResponse = {
  result?: AllEligibleVinsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProviderDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Whether terms and conditions must be accepted to enroll with this provider */
  termsRequired: boolean;
  /** Number of vehicles eligible for enrollment with this fuel-card provider for the organization. Omitted for non-fuel-card providers (for example GMF and Fleetio). */
  eligibleVehicleCount?: number;
  /** Whether the UI may offer manual vehicle selection when enrolling with this fuel-card provider. False when the organization has an ACTIVE GMF enrollment. Omitted for non-fuel-card providers. */
  manualVehicleSelectionAllowed?: boolean;
};
export type ProvidersResponseDto = {
  /** Providers available to the organization */
  providers: ProviderDto[];
};
export type GmResponseCommonProvidersResponseDto = {
  result?: ProvidersResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleEnrollmentSummaryDto = {
  /** Vehicles currently enrolled */
  enrolled: number;
  /** Vehicles pending enrollment */
  pendingEnrollment: number;
  /** Vehicles pending unenrollment */
  pendingUnEnrollment: number;
  /** Vehicles with enrollment errors */
  errorEnrollment: number;
  /** Vehicles with unenrollment errors */
  errorUnEnrollment: number;
};
export type IntegrationStatusDto = {
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Org enrollment identifier */
  integrationId: string;
  /** Provider-side account identifier associated with the organization enrollment. */
  providerAccountId?: string;
  /** Current org enrollment lifecycle status */
  status:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** Aggregated vehicle enrollment counts for this integration */
  vehicleEnrollmentStatus: VehicleEnrollmentSummaryDto;
};
export type ProviderWithStatusDto = {
  /** Provider available for organization enrollment */
  provider: ProviderDto;
  /** Organization enrollment status for this provider */
  integrationStatus?: IntegrationStatusDto;
};
export type ProviderIntegrationsStatusResponseDto = {
  /** Providers with their integration status */
  integrations: ProviderWithStatusDto[];
};
export type GmResponseCommonProviderIntegrationsStatusResponseDto = {
  result?: ProviderIntegrationsStatusResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetioUserResponse = {
  /** Fleetio user ID. */
  id: number;
  /** User email address. */
  email?: string;
  /** User first name. */
  first_name?: string;
  /** User last name. */
  last_name?: string;
};
export type FleetioAccountResponse = {
  /** Fleetio account ID. */
  id: number;
  /** Account name. */
  name?: string;
};
export type OffboardRemainingResponse = {
  undeletedGeofenceCount: number;
};
export type GmResponseCommonOffboardRemainingResponse = {
  result?: OffboardRemainingResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OffboardPageResponse = {
  softDeletedGeofenceCount: number;
  failedGeofenceCount: number;
  undeletedGeofenceCount: number;
};
export type GmResponseCommonOffboardPageResponse = {
  result?: OffboardPageResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type MigratedBoundary = {
  organizationId: string;
  fleetId?: string;
  id: string;
  oviBoundaryId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
};
export type GmPageMigratedBoundary = {
  items: MigratedBoundary[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedBoundary = {
  result?: GmPageMigratedBoundary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type MigrationSyncError = {
  errorCode: string;
  errorMessage: string;
};
export type SyncOviBoundariesResponseEntry = {
  success: boolean;
  geofenceId?: string;
  boundaryId: string;
  fleetId?: string;
  oviFleetId?: string;
  changeOp?: 'created' | 'changed' | 'no-change' | 'deleted';
  error?: MigrationSyncError;
};
export type SyncOviBoundariesResponse = {
  organizationId: string;
  boundaries: SyncOviBoundariesResponseEntry[];
};
export type GmResponseCommonSyncOviBoundariesResponse = {
  result?: SyncOviBoundariesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BoundaryDataRaw = {
  type:
    | 'radius'
    | 'polygon'
    | 'city'
    | 'state'
    | 'zipCode'
    | 'county'
    | 'country';
  value?: string;
  center?: number[];
  radius?: number;
};
export type AlertRule = {
  alertRuleId: string;
  hvrChangeSequence: string;
};
export type SyncOviBoundariesRequestEntry = {
  oviFleetId?: string;
  boundaryId: string;
  boundaryName: string;
  boundaryDataRaw: BoundaryDataRaw;
  boundaryData: string;
  oviAssignedAlertRuleIds: AlertRule[];
  oviCreatedOn: string;
  oviUpdatedOn?: string;
  hvrChangeSequence: string;
};
export type SyncOviBoundariesRequest = {
  cspOrganizationId: string;
  oviAccountId: string;
  boundaries: SyncOviBoundariesRequestEntry[];
};
export type ValidateOviBoundariesResponseEntry = {
  valid: boolean;
  oviBoundaryId: string;
  geofenceId?: string;
  error?: ValidationError;
};
export type ValidateOviBoundariesResponse = {
  allOviBoundariesMatched: boolean;
  allCspBoundariesMatched: boolean;
  boundaries: ValidateOviBoundariesResponseEntry[];
};
export type GmResponseCommonValidateOviBoundariesResponse = {
  result?: ValidateOviBoundariesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateOviBoundariesRequestEntry = {
  oviFleetId?: string;
  boundaryId: string;
  boundaryName: string;
  boundaryDataRaw: BoundaryDataRaw;
  boundaryData: string;
  oviAssignedAlertRuleIds: string[];
  oviCreatedOn: string;
  oviUpdatedOn?: string;
};
export type ValidateOviBoundariesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  boundaries: ValidateOviBoundariesRequestEntry[];
};
export type GmResponseCommonMapStringInteger = {
  result?: {
    [key: string]: number;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RuleGeofenceCountRequest = {
  /** List of rule IDs to get geofence counts for */
  ruleIds?: string[];
};
export type GeofenceCreateResponse = {
  /** Geofence ID */
  id: string;
};
export type GmResponseCommonGeofenceCreateResponse = {
  result?: GeofenceCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GeofenceAreaRequest = {
  /** Polygon coordinates as nested arrays [[[longitude, latitude], ...]] */
  coordinates?: number[][][];
  /** Center coordinate for circular geofence [longitude, latitude] */
  centerCoordinate?: number[];
  /** Radius of circular geofence in kilometers */
  radiusInKm?: number;
  /** Google-encoded polyline string, decoded into coordinates when supplied. If both coordinates and polyEncodedCoordinates are provided, coordinates take precedence. */
  polyEncodedCoordinates?: string;
};
export type GeofenceCreateRequest = {
  /** Name of geofence */
  name: string;
  /** Geofence status */
  status: 'ACTIVE' | 'INACTIVE' | 'DELETED';
  /** Geofence type */
  geofenceType: 'POLYGON' | 'CIRCLE';
  /** Geofence area */
  area: GeofenceAreaRequest;
  /** Notification enabled */
  notificationEnabled?: boolean;
};
export type GeofenceArea = {
  /** Center coordinate [lng, lat] for the geofence. Empty list for polygon geofences. */
  centerCoordinate: number[];
  /** Radius in kilometers for circular geofences. Null for polygon geofences. */
  radiusInKm?: number;
  /** Google-encoded polyline string for efficient coordinate transmission. */
  encodedPolyline?: string;
};
export type AssignedRule = {
  ruleId: string;
  assignedAt: string;
};
export type GeofenceItem = {
  /** Unique identifier of the geofence. */
  id: string;
  /** OrgId associated with the geofence. */
  orgId: string;
  /** FleetId associated with the geofence. */
  fleetId?: string;
  /** Human-readable name of the geofence. */
  name: string;
  /** Type of geofence geometry (Polygon, Circle). */
  type: 'POLYGON' | 'CIRCLE';
  /** Current status of the geofence (ACTIVE, INACTIVE). */
  status: 'ACTIVE' | 'INACTIVE' | 'DELETED';
  /** Number of rules assigned to this geofence. */
  ruleCount: number;
  /** Geographical area definition of the geofence including encoded polyline. */
  area: GeofenceArea;
  /** List of rules assigned to this geofence. */
  ruleIds: AssignedRule[];
  /** Whether notifications are enabled. */
  notificationsEnabled: boolean;
  /** Last updated timestamp. Will be the createdAt time if geofence was never updated. */
  lastUpdated?: string;
};
export type GmPageGeofenceItem = {
  items: GeofenceItem[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageGeofenceItem = {
  result?: GmPageGeofenceItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GeofenceRequest = {
  /**
                List of geofence IDs to fetch.
                    If empty, fetches all geofences for the organization/fleet.
             */
  geofenceIds: string[];
  /** Search for geofence by name */
  geofenceName?: string;
};
export type GmResponseCommonGeofenceItem = {
  result?: GeofenceItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GeofenceUpdateRequest = {
  /** Name of geofence */
  name?: string;
  /** Geofence type */
  geofenceType?: 'POLYGON' | 'CIRCLE';
  /** Geofence area */
  area?: GeofenceAreaRequest;
  /** Notification enabled */
  notificationEnabled?: boolean;
};
export type AssignRulesResponse = {
  /**
                List of successfully created subscription details for each rule.
                Each item contains the full subscription information including subscription ID,
                subscriptionPoolId(rule ID), organization ID, registrations, and preferences.
             */
  items: SubscriptionDto[];
  /**
                List of subscription pool IDs (rule IDs) for which subscription creation failed.
                Empty list indicates all subscriptions were created successfully.
             */
  ruleIdsFailedSubscriptionCreation: string[];
};
export type GmResponseCommonAssignRulesResponse = {
  result?: AssignRulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RuleAssignmentItem = {
  /** Rule ID to be assigned to the geofence */
  ruleId: string;
  /** Category for the subscription registration. */
  category?: string;
  /** Event type for the subscription registration. */
  event?: string;
};
export type AssignRulesRequest = {
  /**
                List of rules to be newly assigned to the geofence with their subscription configuration.
                Each rule includes ruleId (required), category (optional) and event (optional).
                Maximum 10 rules can be assigned at once.
             */
  newlyAssignedRules: RuleAssignmentItem[];
  /**
                List of rule IDs to be removed from the geofence.
                These rules will be unassigned from the geofence if currently assigned.
             */
  removeExistingRules: string[];
};
export type GeofenceByRuleIdResponse = {
  /** ID of the geofence */
  id: string;
  /** Name of the geofence */
  name: string;
};
export type GmResponseCommonListGeofenceByRuleIdResponse = {
  result?: GeofenceByRuleIdResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrderTrackingFleetDto = {
  id: string;
  name: string;
};
export type ImageUrlsDto = {
  thumb: string;
  full: string;
  large: string;
  views: string[];
};
export type VehicleDetailsDto = {
  vehicleName?: string;
  imageUrls: ImageUrlsDto;
  make: string;
  model: string;
  year: number;
  vin?: string;
  trim?: string;
  color?: string;
  interiorColor?: string;
};
export type DealerAddressDto = {
  street: string;
  city: string;
  province: string;
  country: string;
  postalCode: string;
  latitude: string;
  longitude: string;
};
export type DealerDto = {
  code: string;
  name: string;
  phone: string;
  address: DealerAddressDto;
};
export type StatusHistoryDto = {
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
};
export type SingleOrderDto = {
  code: string;
  orderedAt?: string;
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
  statusDetails?: string;
  parentCode?: string;
  fleet?: OrderTrackingFleetDto;
  targetProductionDate?: string;
  estimatedDeliveryDate?: string;
  vehicleDetails: VehicleDetailsDto;
  dealer?: DealerDto;
  statusHistory?: StatusHistoryDto[];
  updatedAt?: string;
  updatedBy?: string;
  fan?: string;
};
export type OrdersPageV20260505Dto = {
  items: SingleOrderDto[];
  totalItems?: number;
  continuationToken?: string;
};
export type GmResponseCommonOrdersPageV20260505Dto = {
  result?: OrdersPageV20260505Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrdersListV20260505FilterDto = {
  make?: string[];
  year?: number[];
  status?: (
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED'
  )[];
  lastLoginDate?: string;
  orderCode?: string[];
};
export type OrdersListV20260505Dto = {
  filter?: OrdersListV20260505FilterDto;
  itemsPerResponse: number;
};
export type CsvRowDto = {
  code: string;
  orderedAt?: string;
  status:
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED';
  statusAt?: string;
  statusDetails?: string;
  parentCode?: string;
  fleetId?: string;
  fleetName?: string;
  targetProductionDate?: string;
  estimatedDeliveryDate?: string;
  vehicleName?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleYear?: number;
  vehicleVin?: string;
  vehicleTrim?: string;
  vehicleColor?: string;
  vehicleInteriorColor?: string;
  updatedAt?: string;
  updatedBy?: string;
};
export type OrdersExportV20260505Dto = {
  filter?: OrdersListV20260505FilterDto;
};
export type AutoImportResponseDto = {
  /** Current status of the auto-import operation */
  status: 'COMPLETED' | 'IN_PROGRESS' | 'FAILED';
  /** Total order count found in UIV for the lookup criteria */
  totalFromUIV: number;
  /** Number of orders that already existed in the system */
  existingCount: number;
  /** Number of new orders being imported */
  newOrdersCount: number;
};
export type GmResponseCommonAutoImportResponseDto = {
  result?: AutoImportResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoImportRequestDto = {
  /** Fleet Assigned Number to import orders for */
  fan: string;
};
export type AddOrdersDto = {
  created: string[];
  existed: string[];
  missing: string[];
};
export type GmResponseCommonAddOrdersDto = {
  result?: AddOrdersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrderCodesDto = {
  /** List of codes to be processed */
  codes: string[];
  /** Fleet info */
  fleet?: FleetDto;
};
export type OrdersPageDto = {
  items: SingleOrderDto[];
  totalItems?: number;
  previousToken?: string;
  token?: string;
  nextToken?: string;
  firstPageItemIndex: number;
};
export type GmResponseCommonOrdersPageDto = {
  result?: OrdersPageDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrdersListDto = {
  sort?: {
    [key: string]: 'ASC' | 'DESC';
  };
  filter?: {
    [key: string]: ListFilter | RangeFilter;
  };
  token?: string;
  itemsPerResponse: number;
};
export type GmResponseCommonListString = {
  result?: string[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RemoveCodesDto = {
  codes: string[];
};
export type OrderFiltersDto = {
  makes: string[];
  modelYears: number[];
  statuses: (
    | 'ORDERED'
    | 'ACCEPTED'
    | 'PRODUCED'
    | 'SHIPPED'
    | 'AT_DEALERSHIP'
    | 'DELIVERED'
    | 'CANCELED'
  )[];
};
export type GmResponseCommonOrderFiltersDto = {
  result?: OrderFiltersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoImportRedisStatus = {
  status: 'COMPLETED' | 'IN_PROGRESS' | 'FAILED';
  total: number;
  processed: number;
  fan: string;
};
export type OrdersCountDto = {
  manuallyAddedCount: number;
  autoImportedCount: number;
  totalCount: number;
  autoImportRedisStatus?: AutoImportRedisStatus;
};
export type GmResponseCommonOrdersCountDto = {
  result?: OrdersCountDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonSingleOrderDto = {
  result?: SingleOrderDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonMapStatusInteger = {
  result?: {
    [key: string]: number;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DeletedOrdersDto = {
  deleted: string[];
  failed: string[];
};
export type GmResponseCommonDeletedOrdersDto = {
  result?: DeletedOrdersDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SoftDeleteRequestDto = {
  orders: string[];
  deletionInitiatorRole:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'HUB_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'VIEWER';
};
export type Address = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type TermsUrlsV20250211 = {
  termsAndConditions: string;
};
export type Terms = {
  /** Indicates if the terms are accepted */
  accepted?: boolean;
  /** URL of the terms document */
  url?: TermsUrlsV20250211;
  /** The date and time when the terms were accepted */
  acceptedDate?: string;
};
export type PrimaryContact = {
  id?: string;
  name?: string;
};
export type AutoOnboardingConfiguration = {
  /** Whether automatic order import is enabled for this organization */
  autoImportOrdersEnabled: boolean;
  /** Whether automatic vehicle onboarding is enabled for this organization */
  autoOnboardVehiclesEnabled: boolean;
};
export type AutoOnboardingEffectiveSettings = {
  /** Whether auto order import can run; computed, always true or false when this object is present */
  canAutoImportOrders: boolean;
  /** Whether auto vehicle onboarding can run; computed, always true or false when this object is present */
  canAutoOnboardVehicles: boolean;
};
export type AutoOnboardingSettings = {
  /** Persisted toggles */
  configuration?: AutoOnboardingConfiguration;
  /** Effective capability flags derived from org status, verification, and configuration */
  effectiveSettings?: AutoOnboardingEffectiveSettings;
};
export type OrganizationSettings = {
  /** Auto-onboarding configuration and effective flags */
  autoOnboarding?: AutoOnboardingSettings;
};
export type OrganizationResponseV20241120 = {
  /** Unique identifier of the organization */
  id?: string;
  /** Unique identifier of the organization */
  organizationId?: string;
  /** Name of the organization */
  name?: string;
  /** Email address of the organization */
  emailAddress?: string;
  /** Address of the organization */
  address?: Address;
  /** Creation date of the organization */
  creationDate?: string;
  /** Activation date of the organization */
  activationDate?: string;
  /** Status of the organization */
  status?: string;
  /** Terms of the organization */
  terms?: Terms;
  /** Industry of the organization */
  industry?: string;
  /** Preferred name of the organization */
  preferredName?: string;
  /** Website of the organization */
  website?: string;
  /** Fleet Account Number (FAN) of the organization */
  fan?: string;
  /** Default fleet of the organization */
  defaultFleet?: string;
  /** Primary contact of the organization */
  primaryContact?: PrimaryContact;
  /** Verification status of the organization */
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  /** Organization settings; computed effective flags are not persisted */
  settings?: OrganizationSettings;
};
export type GmResponseCommonOrganizationResponseV20241120 = {
  result?: OrganizationResponseV20241120;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerificationStatusUpdateRequest = {
  /** Verification status to set on the organization */
  verificationStatus: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
};
export type AutoOnboardingSettingsResponse = {
  /** Organization settings including auto-onboarding configuration and calculated effective flags */
  settings?: OrganizationSettings;
};
export type GmResponseCommonAutoOnboardingSettingsResponse = {
  result?: AutoOnboardingSettingsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AutoOnboardingSettingsUpdateRequest = {
  /** Persisted configuration of auto-onboarding toggles */
  configuration: AutoOnboardingConfiguration;
};
export type GmResponseCommonFleetResponse = {
  result?: FleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetUpdateRequestV20250115 = {
  /** Name of the fleet */
  name: string;
  /** Notes of the fleet */
  description?: string;
  /** Contact email address of the fleet */
  emailAddress?: string;
  /** Address of the fleet */
  address?: Address;
  /** Contact phone number of the fleet */
  phoneNumber?: string;
  /** Timezone of the fleet */
  timeZone?: string;
};
export type OrganizationUpdateRequestV20241204 = {
  /** Name of the organization. */
  name: string;
  /** Address of the organization. */
  address: Address;
  /** Industry category of the organization. */
  industry?:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Primary Contact for the organization. */
  primaryContact?: PrimaryContact;
  /** Fan of organization */
  fan?: string;
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
};
export type OrganizationResponseV20230717 = {
  id?: string;
  name: string;
  emailAddress: string;
  address: Address;
  creationDate?: string;
  activationDate?: string;
  status?: string;
  phoneNumber: string;
  primaryContact?: PrimaryContact;
  type?: string;
  orgMasterNumber?: string;
};
export type GmResponseCommonOrganizationResponseV20230717 = {
  result?: OrganizationResponseV20230717;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UserPreferences = {
  locale?: string;
  timeZone?: string;
  doNotShowLegalNotice?: boolean;
  showGettingStarted?: boolean;
};
export type LevelDto = {
  name?: string;
};
export type OrganizationUpdateRequest = {
  /** Organization name */
  name: string;
  /** Email address */
  emailAddress: string;
  /** User preferences */
  userPreferences?: UserPreferences;
  /** Address */
  address: Address;
  /** Phone number */
  phoneNumber: string;
  /** Primary contact for the organization */
  primaryContact?: PrimaryContact;
  /** Hierarchy levels for organization */
  levels?: {
    [key: string]: LevelDto;
  };
  level?: number;
  /** Organization master number. Should be a 10-digit number that does not start with zero */
  orgMasterNumber?: string;
};
export type HierarchyObjectView = {
  id?: string;
  name?: string;
};
export type ConfigurationValueDto = {
  lastUpdated?: string;
  value?: Value;
};
export type FleetConfigurationResponse = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
};
export type GmResponseCommonFleetConfigurationResponse = {
  result?: FleetConfigurationResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConfigurationRequest = {
  /** Flag to set if asset automatically locks itself. */
  autolockEnabled: boolean;
  /** Threshold time before this asset locks when autolock is enabled. */
  autolockTimeout?: number;
  /** Lock/unlock's asset if within an area near to it. */
  proximityUnlockEnabled: boolean;
  /** Enables to set maximum audio limit. */
  audioVolumeLimitEnabled?: boolean;
  /** Sets maximum audio limit of audio limit is enabled. Minimum is 0. */
  audioVolumeLimit?: number;
  /** Enables asset's safety setting feature. */
  supervisedDriveModeEnabled?: boolean;
  /** Sets the maximum speed of an asset when enabled. */
  speedWarningEnabled?: boolean;
  /**   Maximum speed an asset can go if speedWarningEnabled is true.
      Should be between 0 and 161.
     */
  speedWarningThreshold?: number;
  /**   Notifies automatically the driver to buckle-on before driving
      but is dependent to supervisedDriveModeEnabled to be enabled.
     */
  buckleToDriveEnabled?: boolean;
  /** Whether charging schedule is enabled for this fleet. */
  chargingScheduleEnabled?: boolean;
  /** The target soc level for it to be considered charged. */
  chargingScheduleTargetChargeLevel?: number;
  /**   The time the assets in this fleet should be ready by this time of the day.
      Time should be in 24-hour format with 15-minute increments and seconds are in 0 value
     */
  chargingScheduleDepartureTime?: string;
  /** Latitude of this fleet's home location. */
  homeLocationLatitude?: number;
  /** Longitude of this fleet's home location. */
  homeLocationLongitude?: number;
  /** Timezone this fleet is in. */
  timeZone?: string;
};
export type OrganizationEntityConfigurationDto = {
  safeRefrigeratedGroceryThreshold?: number;
  safeFrozenGroceryThreshold?: number;
  chargingScheduleHomeLocationDisplayAddress?: string;
};
export type FleetUpdateRequest = {
  name?: string;
  hubId: string;
  description?: string;
  configuration?: ConfigurationRequest;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type EnrollmentCandidate = {
  /** Opaque reference for submit (e.g. sf:123456). */
  candidateRef?: string;
  /** Business name from Salesforce. */
  name?: string;
  /** Business address from Salesforce. */
  address?: Address;
  /** Fleet Account Number. */
  fan?: string;
  /** Business phone number. */
  phoneNumber?: string;
  /** Business website. */
  website?: string;
  /** Industry classification. */
  industry?: string;
};
export type EnrollmentLookupResponse = {
  enrollmentCandidates?: EnrollmentCandidate[];
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH';
};
export type GmResponseCommonEnrollmentLookupResponse = {
  result?: EnrollmentLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollmentUnifiedLookupRequest = {
  /** Fleet Account Number (6 alphanumeric characters). */
  fan?: string;
  /** Organization name for name+address lookup. */
  name?: string;
  /** Structured address for name+address lookup. */
  address?: Address;
  /** Raw address fallback for name+address lookup. */
  rawAddress?: string;
};
export type SyncOviBusinessAccountResponse = {
  /** CSP organization ID. */
  organizationId?: string;
  /** OVI business account ID. */
  accountId?: string;
  /** Change operation performed. */
  changeOp?: 'created' | 'updated' | 'retired' | 'no-change';
};
export type GmResponseCommonSyncOviBusinessAccountResponse = {
  result?: SyncOviBusinessAccountResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviAddress = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  addressType?: 'billing' | 'home' | 'work';
  countryCode?: string;
  stateCode?: string;
  city?: string;
  street?: string;
  house?: string;
  zipCode?: string;
  postBox?: string;
  district?: string;
};
export type OviContact = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  contactType?: 'email' | 'phone';
  contactLabel?: string;
  contactDescription?: string;
};
export type SyncOviBusinessAccountRequest = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  /** OVI account ID. */
  accountId: string;
  /** OVI account name. */
  accountName: string;
  /** OVI account status code. */
  statusCode: 'active' | 'inactive' | 'retired';
  /** List of FAN identifiers. */
  fans?: string[];
  /** List of OVI addresses. */
  addresses: OviAddress[];
  /** List of OVI contacts. */
  contacts: OviContact[];
};
export type FleetView = {
  id?: string;
  name?: string;
};
export type OrganizationView = {
  id?: string;
  name?: string;
  defaultFleetId?: string;
  fleets?: {
    [key: string]: FleetView;
  };
};
export type OrganizationViewResponseV20260113 = {
  organizations?: {
    [key: string]: OrganizationView;
  };
};
export type GmResponseCommonOrganizationViewResponseV20260113 = {
  result?: OrganizationViewResponseV20260113;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationViewRequest = {
  /** Organization Ids to view data for */
  organizationIds?: string[];
};
export type CspCandidate = {
  name: string;
  address: Address;
  odiRef: string;
  phoneNumber?: string;
  website?: string;
  industry?: string;
};
export type GmResponseCommonCspCandidate = {
  result?: CspCandidate;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationLookupRequest = {
  /** Name of the organization. */
  name: string;
  /** Structured postal address of the organization. */
  address: Address;
};
export type OrganizationLookupRawAddressResponse = {
  /** Structured postal address returned by ODI after parsing and resolving the raw search string; present whenever ODI supplied resolved coordinates or normalized address components. */
  resolvedAddress?: Address;
  /** CSP match candidate when ODI produced a definitive CSP organization match; null when no such match exists. */
  candidate?: CspCandidate;
};
export type GmResponseCommonOrganizationLookupRawAddressResponse = {
  result?: OrganizationLookupRawAddressResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationLookupRequestRawAddress = {
  /** Name of the organization. */
  name: string;
  /** Free-form address text passed to ODI for parsing, geocoding, and CSP matching (e.g. street, city, region, postal code). */
  rawAddressSearchString: string;
};
export type EnrollmentSubmissionResponse = {
  organizationId?: string;
  status?: 'REVIEW' | 'APPROVED' | 'DECLINED';
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH';
};
export type GmResponseCommonEnrollmentSubmissionResponse = {
  result?: EnrollmentSubmissionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OdiMatchConfirmation = {
  /** Structured name and address from the customer's enrollment input.
    After '/lookup-raw-address', rebuild this object using the resolved structured address from that response together with the confirmed organization name. */
  originalRequest: OrganizationLookupRequest;
  /** The `odiRef` from the CSP candidate (HTTP 200 responses from '/lookup' or '/lookup-raw-address'). */
  odiRef: string;
};
export type EnrollNoMatchRequest = {
  /** Data from the original user input (structured address fields).
    If enrollment began with '/lookup-raw-address', compose this object using the resolved address from that step. */
  originalRequest: OrganizationLookupRequest;
  /** The `odiRef` value from a successful '/lookup' response or from `candidate.odiRef` after '/lookup-raw-address'. */
  odiRef?: string;
};
export type TermsResponseV20250211 = {
  organizationId?: string;
  terms?: Terms;
};
export type GmResponseCommonTermsResponseV20250211 = {
  result?: TermsResponseV20250211;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TermsRequestV20250211 = {
  /** URL of the terms document */
  urls: TermsUrlsV20250211;
  /** If the terms are accepted */
  accepted?: boolean;
};
export type EnrollmentRequest = {
  /** Name of the organization. */
  name: string;
  /** Industry category of the organization. */
  industry:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Address of the organization. */
  address: Address;
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
};
export type EnrollmentDeclineRequest = {
  /** Reason for decline the enrollment. */
  reasonNote: string;
  /** Reason code for decline the enrollment */
  reasonCode: 'NOT_QUALIFIED' | 'OTHER';
};
export type AdminEnrollmentRequest = {
  /** Name of the organization. */
  name: string;
  /** On behalf of email address, represents primary email of the org. */
  onBehalfOfEmail: string;
  /** Address of the organization. */
  address: Address;
  /** Fan of organization */
  fan?: string;
  /** Industry category of the organization. */
  industry:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  /** Preferred Name of the organization. */
  preferredName?: string;
  /** Website of the organization. */
  website?: string;
};
export type UpdateDefaultFleetRequest = {
  /** The ID of the fleet to set as the default fleet. */
  defaultFleetId: string;
};
export type FleetCreateResponse = {
  id?: string;
  name?: string;
  description?: string;
  phoneNumber?: string;
  emailAddress?: string;
  address?: AddressResponse;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  timeZone?: string;
};
export type GmResponseCommonFleetCreateResponse = {
  result?: FleetCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetCreateRequestV20240926 = {
  /** Name of the fleet */
  name: string;
  /** Notes of the fleet */
  description?: string;
  /** Contact email address of the fleet */
  emailAddress?: string;
  /** Address of the fleet */
  address?: Address;
  /** Contact phone number of the fleet */
  phoneNumber?: string;
  /** Timezone of the fleet */
  timeZone?: string;
};
export type ConfigChangeCheckRequest = {
  lastUpdated?: string;
};
export type EntityViewJson = {
  id?: string;
  name?: string;
};
export type HubViewJson = {
  id?: string;
  name?: string;
  fleets?: {
    [key: string]: EntityViewJson;
  };
};
export type OrganizationViewJson = {
  id?: string;
  name?: string;
  defaultFleetId?: string;
  hubs?: {
    [key: string]: HubViewJson;
  };
};
export type OrganizationsViewResponse = {
  organizations?: {
    [key: string]: OrganizationViewJson;
  };
};
export type GmResponseCommonOrganizationsViewResponse = {
  result?: OrganizationsViewResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationFanResponse = {
  /** Unique identifier of the organization */
  organizationId?: string;
  /** Fleet Account Number (FAN) of the organization */
  fan?: string;
  /** Organization settings */
  settings?: OrganizationSettings;
};
export type GmResponseCommonListOrganizationFanResponse = {
  result?: OrganizationFanResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollmentInviteResponse = {
  /** Whether the user has access to business enrollment */
  invited?: boolean;
};
export type GmResponseCommonEnrollmentInviteResponse = {
  result?: EnrollmentInviteResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type HierarchyObjectViewDto = {
  id?: string;
  name?: string;
};
export type LegalDocumentDto = {
  url?: string;
  accepted?: boolean;
  acceptedDate?: string;
};
export type LegalDto = {
  termsAndConditions?: LegalDocumentDto;
  privacyPolicy?: LegalDocumentDto;
};
export type EnrollmentDto = {
  status?: 'REVIEW' | 'APPROVED' | 'DECLINED';
  submittedDate?: string;
  submittedAccountType?: 'CUSTOMER' | 'ADVISOR' | 'NONE';
  submittedOnBehalfOfEmail?: string;
  approvedDate?: string;
  approvedApproach?: 'AUTO' | 'MANUAL';
  approvedBy?: string;
  declinedDate?: string;
  declinedBy?: string;
  declinedNote?: string;
  declineReasonCode?: 'NOT_QUALIFIED' | 'OTHER';
  reviewReason?:
    | 'DOMAIN_MISMATCH'
    | 'FAN_DUPLICATE'
    | 'FAN_NOT_ELIGIBLE'
    | 'CUSTOMER_DECLINED'
    | 'NO_MATCH';
};
export type AutoOnboardingConfigurationDto = {
  autoImportOrdersEnabled?: boolean;
  autoOnboardVehiclesEnabled?: boolean;
};
export type AutoOnboardingDto = {
  configuration?: AutoOnboardingConfigurationDto;
};
export type OrganizationSettingsDto = {
  autoOnboarding?: AutoOnboardingDto;
};
export type OrganizationDto = {
  id?: string;
  organizationId?: string;
  odiId?: string;
  name?: string;
  primaryEmailAddress?: string;
  address?: Address;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  activationDate?: string;
  activatedBy?: string;
  status?:
    | 'DRAFT'
    | 'PENDING'
    | 'ENROLLING'
    | 'ACTIVE'
    | 'DISABLED'
    | 'DELETED'
    | 'ABORTED'
    | 'RETIRED';
  phoneNumber?: string;
  primaryContact?: HierarchyObjectViewDto;
  legal?: LegalDto;
  levels?: {
    [key: string]: LevelDto;
  };
  childStats?: {
    [key: string]: number;
  };
  level?: number;
  type?: 'ASSET' | 'SERVICE' | 'GMF';
  orgMasterNumber?: string;
  enrollment?: EnrollmentDto;
  preferredName?: string;
  industry?:
    | 'AGRICULTURE'
    | 'MINING'
    | 'UTILITIES'
    | 'CONSTRUCTION'
    | 'MANUFACTURING'
    | 'WHOLESALE'
    | 'RETAIL'
    | 'TRANSPORTATION'
    | 'INFORMATION'
    | 'FINANCE'
    | 'REAL_ESTATE'
    | 'PROFESSIONAL'
    | 'MANAGEMENT'
    | 'ADMINISTRATIVE'
    | 'EDUCATIONAL'
    | 'HEALTH'
    | 'ARTS'
    | 'FOOD'
    | 'OTHER'
    | 'PUBLIC';
  website?: string;
  fan?: string;
  defaultFleet?: string;
  verificationStatus?: 'VERIFIED' | 'PARTIALLY_VERIFIED' | 'UNVERIFIED';
  settings?: OrganizationSettingsDto;
  draftReasonCode?: 'MIGRATION';
  draftReasonMessage?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
};
export type GmResponseCommonOrganizationDto = {
  result?: OrganizationDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmPageFleetResponse = {
  items: FleetResponse[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageFleetResponse = {
  result?: GmPageFleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PaginatedDataResponseOrganizationResponseV20241120 = {
  items?: OrganizationResponseV20241120[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseOrganizationResponseV20241120 =
  {
    result?: PaginatedDataResponseOrganizationResponseV20241120;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type OpportunitiesResponse = {
  modelYear?: string;
  signedAgreementDate?: string;
  signedAgreementId?: string;
};
export type CapsResponse = {
  opportunities?: OpportunitiesResponse[];
  isFanNumberValid?: boolean;
  fanNumber?: string;
  accountOwnerFullName?: string;
  accountOwnerEmailAddress?: string;
  accountOwnerPhoneNumber?: string;
  accountPrimaryContactName?: string;
  accountPrimaryContactEmail?: string;
  accountPrimaryContactNumber?: string;
  gfssResponseStatus?: number;
  gfssErrorMessage?: string;
};
export type GmResponseCommonCapsResponse = {
  result?: CapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListOrganizationResponseV20230717 = {
  result?: OrganizationResponseV20230717[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetConfigurationResponseV2 = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonFleetConfigurationResponseV2 = {
  result?: FleetConfigurationResponseV2;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationResponseV20211115 = {
  id?: string;
  name: string;
  emailAddress: string;
  address: Address;
  creationDate?: string;
  activationDate?: string;
  status?: string;
  phoneNumber: string;
  primaryContact?: PrimaryContact;
};
export type GmResponseCommonListOrganizationResponseV20211115 = {
  result?: OrganizationResponseV20211115[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationEntityResponse = {
  id?: string;
  organization?: HierarchyObjectView;
  name?: string;
  description?: string;
  address?: Address;
  creationDate?: string;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonListOrganizationEntityResponse = {
  result?: OrganizationEntityResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationEntityResponse = {
  result?: OrganizationEntityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetResponseDeprecated = {
  id?: string;
  name?: string;
  description?: string;
  organization?: HierarchyObjectView;
  hub?: HierarchyObjectView;
  creationDate?: string;
  configuration?: ConfigurationValueDto;
  organizationEntityConfiguration?: OrganizationEntityConfigurationDto;
};
export type GmResponseCommonListFleetResponseDeprecated = {
  result?: FleetResponseDeprecated[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationViewJson = {
  result?: OrganizationViewJson;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonOrganizationResponseV20211115 = {
  result?: OrganizationResponseV20211115;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StatsV1 = {
  hubCount?: number;
  fleetCount?: number;
};
export type GmResponseCommonStatsV1 = {
  result?: StatsV1;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationMinViewDto = {
  id?: string;
  name?: string;
};
export type GmResponseCommonListOrganizationMinViewDto = {
  result?: OrganizationMinViewDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ClipProfileDto = {
  /** Profile ID */
  id: string;
  /** Profile's full name */
  name?: string;
  /** Profile's email address */
  email?: string;
};
export type ClipVehicleDto = {
  /** Vehicle Identification Number */
  vin: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle manufacturer */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle model year */
  year?: string;
  /** URL of the vehicle image */
  imageSource?: string;
};
export type ClipListItemDto = {
  /** Unique identifier of the clip */
  id: string;
  /** Display name of the clip */
  name: string;
  /** Clip start timestamp in UTC (ISO 8601) */
  startTimestampInUTC: string;
  /** Processing status of the clip */
  status: 'PENDING' | 'PROCESSING' | 'FAILED' | 'READY' | 'EXPIRED';
  /** Error code describing why the clip failed, if applicable */
  errorCode?:
    | 'INVALID_STARTTIME'
    | 'DEVICE_OFFLINE'
    | 'UNSUPPORTED_FIRMWARE'
    | 'TIMED_OUT'
    | 'INTERNAL_ERROR'
    | 'NO_CAMERA_ASSOCIATED';
  /** Driver associated with the clip */
  driver?: ClipProfileDto;
  /** Vehicle associated with the clip */
  vehicle: ClipVehicleDto;
  /** Clip creation timestamp in UTC (ISO 8601) */
  createdTimestampInUTC: string;
};
export type RetrieveClipsResponseDto = {
  /** Clips list in the current page. */
  items: ClipListItemDto[];
  /** Total number of items based on the given filter and is not the total in the page. */
  total_items?: number;
  /**
           Continuation token to be provided through `continuationToken` request header when navigating to the next page.
           When value becomes null, it indicates that the list has reached its last page.
         */
  continuation_token?: string;
};
export type GmResponseCommonRetrieveClipsResponseDto = {
  result?: RetrieveClipsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ClipCoordinatesDto = {
  /** Latitude of the location */
  latitude: number;
  /** Longitude of the location */
  longitude: number;
};
export type ClipLocationPointDto = {
  /** GPS coordinates of the location point */
  coordinates: ClipCoordinatesDto;
  /** Address of the location point */
  address?: string;
  /** Timestamp in UTC (ISO 8601) when the vehicle was at this location */
  timestampInUTC: string;
};
export type ClipLocationDto = {
  /** The start point of the clip location */
  start?: ClipLocationPointDto;
  /** The end point of the clip location */
  end?: ClipLocationPointDto;
};
export type ClipDetailsDto = {
  /** Unique identifier of the clip */
  id: string;
  /** Display name of the clip */
  name: string;
  /** The vehicle where the clip was recorded */
  vehicle: ClipVehicleDto;
  /** Driver at the time of the clip */
  driver?: ClipProfileDto;
  /** Fleet or org manager who created the clip. Null for automatically created clips. */
  requestorProfile?: ClipProfileDto;
  /** Duration in seconds of the clip */
  requestedDurationSeconds: number;
  /** Location contains the start/end time and location for the clip */
  location?: ClipLocationDto;
  /** Camera positions included in the clip */
  requestedCameraPositions?: ('INWARD' | 'OUTWARD')[];
  /** The id of the video clip itself, pass to get media endpoint to retrieve video and thumbnails */
  cameraEventId?: string;
  /** The status of the requested clip processing */
  status: 'PENDING' | 'PROCESSING' | 'FAILED' | 'READY' | 'EXPIRED';
  /** The timestamp in UTC (ISO 8601) when the clip was created */
  createdTimestampInUTC: string;
  /** Error code if the clip processing failed */
  errorCode?:
    | 'INVALID_STARTTIME'
    | 'DEVICE_OFFLINE'
    | 'UNSUPPORTED_FIRMWARE'
    | 'TIMED_OUT'
    | 'INTERNAL_ERROR'
    | 'NO_CAMERA_ASSOCIATED';
};
export type GmResponseCommonClipDetailsDto = {
  result?: ClipDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateClipRequestDto = {
  /** Unique identifier of the camera peripheral */
  peripheralId: string;
  /** Display name of the clip */
  name: string;
  /** Start timestamp of the clip in UTC (ISO 8601) */
  startTimestampInUTC: string;
  /** Requested duration of the clip in seconds */
  requestedDurationSeconds: number;
  /** Camera positions to include in the clip. Defaults to INWARD and OUTWARD if not provided. */
  requestedCameraPositions?: ('INWARD' | 'OUTWARD')[];
  /** Location of the clip with start and end points */
  location?: ClipLocationDto;
};
export type ActivatePeripheralsResponseDto = {
  /** Unique batch ID for tracking the activation status */
  batchId: string;
  /** Organization ID */
  organizationId: string;
};
export type GmResponseCommonActivatePeripheralsResponseDto = {
  result?: ActivatePeripheralsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ActivatePeripheralsRequestDto = {
  /** Set of unique peripheral IDs to activate. Duplicates will be automatically removed. */
  peripheralIds: string[];
  /** Peripheral type to activate (adapter or fleet-camera). All peripheral IDs in the request must be of this type. */
  peripheralType: string;
};
export type ExportPeripheralsRequestDto = {
  /** Filter criteria using the same filter names and values supported by the peripherals list API. The type filter is required and must specify exactly one exportable peripheral type: fleet-camera or adapter. */
  filters: {
    [key: string]: string;
  };
  /** Field used to sort the exported peripherals. Uses the same supported sort fields as the peripherals list API. */
  sortBy?: string;
  /** Sort direction for the exported peripherals. Uses the same values and default behavior as the peripherals list API. */
  sortDirection?: 'ASC' | 'DESC';
  /** Optional set of peripheral IDs selected in the frontend. When provided, only these peripherals are exported. When empty, all peripherals matching filters and sort are exported. Advisors and system managers may export selected IDs across organizations without an organizationId filter. Organization-scoped users are scoped to their organization from auth. */
  selectedIds: string[];
  /** Locale identifier used to localize CSV headers and formatted values, for example en-US or fr-FR. Defaults to en-US when not provided. */
  locale?: string;
  /** IANA time zone identifier used when formatting date and time values in the export, for example America/New_York. Defaults to UTC when not provided or invalid. */
  timeZone?: string;
  /** Unit system preference used for formatting exported values that support unit conversion. Defaults to IMPERIAL when not provided. */
  unitSystem?: 'METRIC' | 'IMPERIAL';
};
export type OrderUpdateAdminResponse = {
  outcome: string;
  reason?: string;
  orderId?: string;
};
export type GmResponseCommonOrderUpdateAdminResponse = {
  result?: OrderUpdateAdminResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type JsonNode = any;
export type CleanPeripheralAdminResponse = {
  outcome: string;
  reason?: string;
  peripheralId?: string;
  organizationId?: string;
};
export type GmResponseCommonCleanPeripheralAdminResponse = {
  result?: CleanPeripheralAdminResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CleanPeripheralAdminRequest = {
  peripheralId: string;
};
export type AdapterPlugEventAdminResponse = {
  outcome: string;
  reason?: string;
};
export type GmResponseCommonAdapterPlugEventAdminResponse = {
  result?: AdapterPlugEventAdminResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AdapterPlugEventAdminRequest = {
  serialNumber: string;
  vin: string;
  action: 'PLUG' | 'UNPLUG';
  eventTimestamp?: string;
};
export type PeripheralSummaryDto = {
  /** Unique Identifier of the peripheral. */
  id: string;
  /** Assigned serial number or ESN. */
  serialNumber: string;
  /** Assigned IMEI of the peripheral. */
  imei?: string;
  /** Manufacturer name or code of the peripheral. */
  make: string;
  /** Model name of the peripheral. */
  model: string;
  /** Hardware type of the peripheral. */
  peripheralType: 'fleet-camera' | 'fleet-key-module' | 'adapter' | 'harness';
  /** VIN where this peripheral is attached to. */
  vin: string;
};
export type GmResponseCommonListPeripheralSummaryDto = {
  result?: PeripheralSummaryDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GetPeripheralsByVinsRequestDto = {
  /** List of VINs to filter peripherals by. */
  vins: string[];
};
export type TransferErrorDto = {
  /** Error code indicating the type of failure */
  code:
    | 'INTERNAL_ERROR_UNABLE_TO_COMMUNICATE_TO_DATABASE'
    | 'PERIPHERAL_ID_INVALID'
    | 'INTERNAL_ERROR_UNABLE_TO_COMMUNICATE_TO_CLOUD_PROVIDER';
  /** Human-readable error message */
  message: string;
};
export type TransferFailureDto = {
  /** Peripheral ID that failed to transfer */
  id: string;
  /** Error details for the failed transfer */
  error: TransferErrorDto;
};
export type TransferResultDto = {
  /** List of successfully transferred peripheral IDs */
  successList: string[];
  /** List of failed transfer attempts with error details */
  failedList: TransferFailureDto[];
};
export type GmResponseCommonTransferResultDto = {
  result?: TransferResultDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrganizationTransferRequest = {
  /** Destination organization ID to transfer peripherals to */
  destinationOrganizationId: string;
  /** Set of peripheral IDs to transfer */
  peripheralIds: string[];
};
export type ErrorResponseDto = {
  /** Error code which caused this item to fail. */
  id: 'NOT_FOUND' | 'PERIPHERAL_LINKED_TO_VIN' | 'INTERNAL_ERROR';
  /** Detailed error message. */
  message: string;
};
export type FailedItemDetailDto = {
  /** ID of the failed peripheral item. */
  id: string;
  /** Error details on why the item failed. */
  error: ErrorResponseDto;
};
export type MoveFleetResponseDto = {
  /** List of Peripheral ID that were successfully moved. */
  successList: string[];
  /** List of Peripheral ID that were failed to be moved. */
  failedList: FailedItemDetailDto[];
};
export type GmResponseCommonMoveFleetResponseDto = {
  result?: MoveFleetResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DestinationOrganization = {
  /** Fleet ID */
  fleetId: string;
};
export type MoveFleetRequestDto = {
  /** Destination organization */
  destination: DestinationOrganization;
  /** Peripheral IDs */
  peripheralIds: string[];
};
export type LinkToVehicleRequestDto = {
  /**
            VIN where the given peripheral will be attached to.
            This VIN must be in the same organization and fleet of the peripheral.
             */
  vin: string;
};
export type OnboardResponseDto = {
  batchId: string;
  organizationId: string;
};
export type GmResponseCommonOnboardResponseDto = {
  result?: OnboardResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SettingDetailsDto = {
  /** The value of the setting */
  value?: string;
  /** Indicates if the setting is enabled */
  enabled?: boolean;
  /** The minimum speed threshold in MPH */
  minSpeedThresholdInMPH?: number;
};
export type GmResponseCommonListLocalDate = {
  result?: string[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TripPointDto = {
  /** Address of the location */
  address?: string;
  /** Latitude of the location */
  latitude: number;
  /** Longitude of the location */
  longitude: number;
};
export type CameraTripDto = {
  /** Start time of the trip in UTC (ISO 8601) */
  startTimestampInUTC: string;
  /** End time of the trip in UTC (ISO 8601) */
  endTimestampInUTC: string;
  /** Encoded polyline representing the trip route */
  polyline?: string;
  /** Timestamps of recorded data points within the trip */
  timestamps: string[];
  /** Start location of the trip */
  start?: TripPointDto;
  /** End location of the trip */
  end?: TripPointDto;
  /** Name of the driver associated with the trip's vehicle */
  driverName?: string;
};
export type GmResponseCommonListCameraTripDto = {
  result?: CameraTripDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CameraAssignmentDtoBase = {
  /** ID of the camera peripheral */
  id: string;
  /** Type of the camera assignment, either VEHICLE or DRIVER */
  type: 'VEHICLE' | 'DRIVER';
};
export type VehicleCameraAssignmentDto = {
  type: 'VehicleCameraAssignmentDTO';
} & CameraAssignmentDtoBase & {
    /** VIN of the assigned vehicle */
    vin: string;
    /** Name of the vehicle */
    name?: string;
    /** Make of the assigned vehicle */
    make?: string;
    /** Model of the assigned vehicle */
    model?: string;
    /** Year of the assigned vehicle */
    year?: string;
    /** Image persisted from peripheral DB, may be null */
    imageSource?: string;
  };
export type GmResponseCommonListCameraAssignmentDto = {
  result?: VehicleCameraAssignmentDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CameraSettingDto = {
  /** The name of the camera setting */
  name:
    | 'pin'
    | 'inCabAlerts'
    | 'inCabAlertInattentive'
    | 'inCabAlertSeatbeltUnbuckled'
    | 'inCabAlertPhoneUse'
    | 'inCabAlertLensObstructed'
    | 'inCabAlertSmoking'
    | 'inCabAlertEatingOrDrinking'
    | 'eventPossibleFatigue'
    | 'eventPossibleAccident'
    | 'eventCameraKeyPress';
  /** Details of the camera setting */
  details: SettingDetailsDto;
};
export type GmResponseCommonListCameraSettingDto = {
  result?: CameraSettingDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StatusCountDto = {
  /** Business status bucket name. */
  status: string;
  /** Number of devices in this status bucket. */
  count: number;
};
export type PeripheralStatusCountsResponseDto = {
  /** Peripheral type the counts apply to. */
  peripheralType: string;
  /** Device counts per business status bucket. */
  counts: StatusCountDto[];
  /** Total number of devices across all status buckets. */
  total: number;
};
export type GmResponseCommonPeripheralStatusCountsResponseDto = {
  result?: PeripheralStatusCountsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ShippingInfo = {
  /** Recipient first name. */
  firstName: string;
  /** Recipient last name. */
  lastName: string;
  /** Company name, if shipping to a business address. */
  companyName?: string;
  /** Recipient email address. */
  email: string;
  /** Contact phone number. */
  phoneNumber: string;
  /** Primary street address line. */
  line1: string;
  /** Secondary street address line (suite, unit, etc.). */
  line2?: string;
  /** City name. */
  city: string;
  /** State or province code. */
  state: string;
  /** Postal or ZIP code. */
  postalCode: string;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode: string;
};
export type OrderItem = {
  /** SKU code of the product. */
  skuCode: string;
  /** Hardware type of the product. */
  type: 'fleet-camera' | 'fleet-key-module' | 'adapter' | 'harness';
  /** Quantity ordered for this SKU and type. */
  quantity: number;
};
export type ProductItem = {
  /** SKU code of the product. */
  skuCode: string;
  /** Hardware type of the product. */
  type: 'fleet-camera' | 'fleet-key-module' | 'adapter' | 'harness';
  /** Serial number of the product. */
  serialNumber?: string;
  /** IMEI of the product. */
  imei?: string;
};
export type TrackingDetail = {
  /** Carrier handling the shipment. */
  carrierName: string;
  /** Carrier tracking number for the shipment. */
  trackingNumber: string;
  /** URL to track the shipment with the carrier. */
  trackingUrl: string;
};
export type PeripheralOrder = {
  /** Unique identifier of the order. */
  id: string;
  /** CS Organization ID that owns this order. */
  organizationId: string;
  /** Vendor-assigned identifier for this order. */
  vendorOrderId: string;
  /** Whether the order was paid in advance before fulfillment. */
  isPrePaidOrder: boolean;
  /** Vendor (manufacturer or integration partner) for the order. */
  vendor: 'LYTX' | 'VAST' | 'GEOTAB';
  /** ISO 3166-1 alpha-2 country code for the order market. */
  countryCode: string;
  /** Timestamp when the order was placed (UTC, ISO-8601). */
  orderedAt?: string;
  /** Shipping address for the order. */
  shippingAddress: ShippingInfo;
  /** Current status of the order. */
  status:
    | 'new'
    | 'ordered'
    | 'partially_shipped'
    | 'shipped'
    | 'delivered'
    | 'failed';
  /** Line items requested on the order (SKU, type, quantity). */
  orderItems: OrderItem[];
  /** Sum of ordered quantities across all line items. */
  totalOrderedQuantity: number;
  /** Individual shipped units with serial numbers when known. */
  shippedProducts?: ProductItem[];
  /** Total count of units shipped. */
  totalShippedQuantity: number;
  /** Shipping mode or carrier service used. */
  shippingMode?: string;
  /** Date the order was shipped. */
  shippingDate?: string;
  /** Carrier tracking details for the shipment(s), one entry per tracking number. */
  trackingDetails: TrackingDetail[];
  /** Estimated delivery date. */
  estimatedDeliveryDate?: string;
};
export type GmResponseCommonPeripheralOrder = {
  result?: PeripheralOrder;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AdapterSupportedFeaturesResponseDto = {
  /** Tire pressure monitoring supported when all codes 79, 80, 81, and 82 are supported. */
  tirePressure: boolean;
  /** Oil life (code 77). */
  oilLife: boolean;
  /** Fuel economy supported when codes 2187 and 5 are both supported. */
  fuelEconomy: boolean;
  /** Fuel capacity (code 71). */
  fuelCapacity: boolean;
  /** EV charging state (code 3289). */
  evChargingState: boolean;
  /** EV plug voltage (code 3290). */
  evPlugVoltage: boolean;
  /** Odometer (code 5). */
  odometer: boolean;
  /** Engine hours (code 9). */
  engineHours: boolean;
  /** Accelerometer (code 2517). */
  accelerometer: boolean;
  /** Gear (code 8). */
  gear: boolean;
  /** State of charge (code 2118). */
  soc: boolean;
  /** Range supported when fuel capacity and fuel economy are both supported. */
  range: boolean;
};
export type GmResponseCommonAdapterSupportedFeaturesResponseDto = {
  result?: AdapterSupportedFeaturesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonPeripheralSummaryDto = {
  result?: PeripheralSummaryDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PeripheralStatus = {
  value:
    | 'assigned'
    | 'unassigned'
    | 'activation_required'
    | 'activation_retry'
    | 'expires_soon'
    | 'expired';
  lastUpdateDateTime: string;
};
export type VehicleTypeDto = {
  make?: string;
  year?: string;
  model?: string;
  propulsion?: string;
};
export type VinInfoDto = {
  /** VIN aka asset.id of the vehicle */
  vin: string;
  /** The name assigned to the vehicle */
  name?: string;
  /** The license plate of the vehicle */
  licensePlate?: string;
  /** The type of vehicle */
  vehicleType?: VehicleTypeDto;
  /** The image of the vehicle provided by asset service */
  vehicleImageSource?: string;
  /** Whether the vehicle is a GM vehicle */
  gmVehicle?: boolean;
};
export type PeripheralResponseDto = {
  /** Unique Identifier of the peripheral. */
  id: string;
  /** Assigned serial number or ESN. */
  serialNumber?: string;
  /** Assigned IMEI of the peripheral. */
  imei?: string;
  /** Main peripheral status */
  status?: PeripheralStatus;
  /** CS Organization ID who owns the peripheral. */
  organizationId: string;
  /** CS Fleet ID who owns the peripheral within the organization. */
  fleetId?: string;
  /** Hardware type. */
  type: 'fleet-camera' | 'fleet-key-module' | 'adapter' | 'harness';
  /** Assigned name of the peripheral. */
  name?: string;
  /** Manufacturer name or code of the peripheral. */
  make: 'LYTX' | 'VAST' | 'GEOTAB';
  /** Model name of the peripheral. */
  model: string;
  /** VIN where this peripheral is known to be attached to. */
  attachedToVin?: VinInfoDto;
  /** Date and time when this peripheral is associated to the organization. */
  creationDateTime: string;
  isPrePaid: boolean;
};
export type HealthStatus = {
  value: 'healthy' | 'unhealthy' | 'unknown';
  lastUpdateDateTime: string;
};
export type AdapterPeripheralResponseDto = PeripheralResponseDto & {
  /** Unique identifier of the adapter peripheral. */
  id: string;
  /** Assigned serial number or ESN of the adapter. */
  serialNumber?: string;
  /** Assigned IMEI of the adapter peripheral. */
  imei?: string;
  /** Current operational status of the adapter. */
  status?: PeripheralStatus;
  /** CS Organization ID that owns this adapter peripheral. */
  organizationId: string;
  /** CS Fleet ID who owns the adapter peripheral within the organization. */
  fleetId?: string;
  /** Type of peripheral hardware. */
  type: 'fleet-camera' | 'adapter';
  /** User-assigned name for the adapter. */
  name?: string;
  /** Manufacturer name or code of the adapter. */
  make: 'LYTX' | 'GEOTAB';
  /** Model name of the adapter. */
  model: string;
  /** Vehicle information if the adapter is attached to a vehicle. */
  attachedToVin?: VinInfoDto;
  /** Date and time when this adapter was registered to the organization. */
  creationDateTime: string;
  /** Indicates whether the peripheral was created from a pre-paid order. */
  isPrePaid: boolean;
  /** Latest date and time when the adapter communicated with the platform. */
  lastCommunicatedDateTime?: string;
  /** Current health status of the adapter device. */
  health?: HealthStatus;
  /** Software and firmware version installed on the adapter device. */
  firmware?: string;
  /** Date and time when the adapter was activated. */
  activationDateTime?: string;
  /** User ID of the user who activated the adapter. */
  activatedByUserId?: string;
  /** Date and time when the user cancelled the subscription. */
  cancellationDateTime?: string;
  /** User ID of the user who cancelled the subscription. */
  cancelledByUserId?: string;
  /** Date and time when the subscription expired (on BCD). */
  expirationDateTime?: string;
  /** Correlation ID for matching asset API onboarding request/response. */
  correlationId?: string;
  /** Date and time of the last plug-in event received from DataCore. */
  lastPlugInDateTime?: string;
};
export type FleetCameraPeripheralResponseDto = PeripheralResponseDto & {
  /** Unique identifier of the fleet camera peripheral. */
  id: string;
  /** Assigned serial number or ESN of the camera. */
  serialNumber?: string;
  /** Assigned IMEI of the fleet camera peripheral. */
  imei?: string;
  /** Current operational status of the camera. */
  status?: PeripheralStatus;
  /** CS Organization ID that owns this fleet camera peripheral. */
  organizationId: string;
  /** CS Fleet ID who owns the camera peripheral within the organization. */
  fleetId?: string;
  /** Type of peripheral hardware. */
  type: 'fleet-camera' | 'adapter';
  /** User-assigned name for the camera. */
  name?: string;
  /** Manufacturer name or code of the camera. */
  make: 'LYTX' | 'GEOTAB';
  /** Model name of the camera. */
  model: string;
  /** Vehicle information if the camera is attached to a vehicle. */
  attachedToVin?: VinInfoDto;
  /** Date and time when this camera was registered to the organization. */
  creationDateTime: string;
  /** Indicates whether the peripheral was created from a pre-paid order. */
  isPrePaid: boolean;
  /** Latest date and time when the camera communicated with the platform. */
  lastCommunicatedDateTime?: string;
  /** Current health status of the camera device. */
  health?: HealthStatus;
  /** Software and firmware version installed on the camera device. */
  firmware?: string;
  /** Date and time when the subscription expired (on BCD). */
  expirationDateTime?: string;
};
export type RetrievePeripheralsResponseDto = {
  /** Peripherals list in the current page. */
  items: (AdapterPeripheralResponseDto | FleetCameraPeripheralResponseDto)[];
  /** Total number of items based on the given filter and is not the total in the page. */
  total_items?: number;
  /**
           Continuation token to be provided through `continuationToken` request header when navigating to the next page.
           Ensure that the backslash before the double quotes are filtered-out before using.
           When value becomes null, it indicates that the list has reached its last page.
         */
  continuation_token?: string;
};
export type GmResponseCommonRetrievePeripheralsResponseDto = {
  result?: RetrievePeripheralsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BatchParameters = {
  peripheralType?: 'fleet-camera' | 'fleet-key-module' | 'adapter' | 'harness';
  fileName?: string;
};
export type BatchItemError = {
  deviceId?: string;
  errorId:
    | 'MISSING_DEVICE_ID'
    | 'PERIPHERAL_ALREADY_CLAIMED'
    | 'FAILURE_TO_CREATE_CAMERA'
    | 'DUPLICATE_PERIPHERAL'
    | 'UNABLE_TO_REGISTER_DEVICE_TO_CLOUD_PROVIDER'
    | 'MISSING_MAKE'
    | 'MISSING_MODEL'
    | 'INVALID_MAKE_FOR_MODEL'
    | 'INVALID_TYPE_FOR_MODEL'
    | 'INTERNAL_ERROR'
    | 'SERIAL_AND_IMEI_NOT_ASSOCIATED'
    | 'MULTIPLE_PERIPHERALS_FOUND'
    | 'MISSING_SERIAL_NUMBER'
    | 'MISSING_IMEI'
    | 'INTERNAL_ERROR_UNABLE_TO_COMMUNICATE_TO_DATABASE'
    | 'MISSING_REQUIRED_PARAMETER_BY_PROVIDER'
    | 'FAILURE_TO_CREATE_ADAPTER'
    | 'PERIPHERAL_NOT_FOUND'
    | 'PERIPHERAL_ALREADY_ACTIVATED'
    | 'UNSUPPORTED_PERIPHERAL_MAKE'
    | 'ACCESS_DENIED'
    | 'CLOUD_PROVIDER_ERROR'
    | 'ACTIVATION_NOT_SUPPORTED'
    | 'INVALID_PERIPHERAL_STATUS';
  errorMessage: string;
};
export type BatchDetails = {
  totalItems: number;
  successCount: number;
  failureCount: number;
  errors: BatchItemError[];
};
export type BatchEntityResponseDto = {
  id: string;
  status: 'pending' | 'in-progress' | 'completed' | 'failed';
  error?:
    | 'ONE_OR_MORE_ITEM_FAILED_ONBOARDING'
    | 'FILE_IS_EMPTY'
    | 'INVALID_CSV_COLUMN_COUNT'
    | 'INVALID_CSV_STRUCTURE'
    | 'INTERNAL_ERROR_UNABLE_TO_FULLY_PROCESS_BATCH'
    | 'INTERNAL_ERROR_UNABLE_TO_COMMUNICATE_TO_CLOUD_PROVIDER';
  action: 'onboard' | 'activate';
  organizationId: string;
  parameters: BatchParameters;
  details: BatchDetails;
  createDateTime: string;
  updatedDateTime: string;
};
export type GmResponseCommonBatchEntityResponseDto = {
  result?: BatchEntityResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FetchingMetadataDto = {
  /** Type of report (e.g., TRIP_HISTORY, SAFETY_EVENTS) */
  type?: string;
  /** API version used for fetching the report data */
  apiVersion?: string;
};
export type ReportMetadataRequestBodyDto = {
  /** Unique identifier for the report. Required for updates, optional for creates */
  reportId?: string;
  /** Metadata about how the report data is fetched */
  fetchingMetadata?: FetchingMetadataDto;
  /** Display name of the report */
  name?: string;
  /** Detailed description of the report */
  description?: string;
  /** Set of supported filter types for this report */
  supportedFilterTypes?: string[];
};
export type DateRangeDto = {
  /** Date range type. Use CUSTOM for explicit dates, or predefined options. */
  lastDays:
    | 'LAST_7_DAYS'
    | 'LAST_30_DAYS'
    | 'LAST_3_MONTHS'
    | 'LAST_6_MONTHS'
    | 'LAST_12_MONTHS'
    | 'YEAR_TO_DATE'
    | 'CUSTOM';
  /** Start date for custom range (required if lastDays is CUSTOM) */
  fromDate?: string;
  /** End date for custom range (required if lastDays is CUSTOM) */
  toDate?: string;
};
export type FiltersDto = {
  /** Organization ID to filter the report data */
  orgId: string;
  /** Set of fleet IDs to include in the report */
  fleetIds?: string[];
  /** Set of selected driver IDs */
  driversSelection?: string[];
  /** Set of vehicle IDs to include in the report */
  vehiclesSelection?: string[];
  /** Date range for the report. Defaults to LAST_7_DAYS if not provided. */
  dateRangeFilter: DateRangeDto;
};
export type UserDefinedFilterDto = {
  /** User ID to filter the filter data */
  userId: string;
  /** Filters applied when generating the report */
  filters: FiltersDto;
};
export type ReportFiltersDto = {
  /** Organization ID to filter the report data. If provided, must match the cs-organization header value; the header value is always used for the query. */
  orgId?: string;
  /** List of fleet IDs to filter the report data */
  fleetIds?: string[];
  /** List of driver IDs to filter the report data */
  driverIds?: string[];
  /** List of vehicle IDs to filter the report data */
  vehicleIds?: string[];
  /** Start date for the report data range in ISO 8601 UTC format. If not provided, defaults to 30 days ago. */
  fromDate?: string;
  /** End date for the report data range in ISO 8601 UTC format. If not provided, defaults to current date/time. */
  toDate?: string;
  /** User time zone in ISO 8601 format */
  userTimeZone?: string;
};
export type UserPreferencesDto = {
  /** Locale identifier for formatting (e.g., en-US, fr-FR) */
  locale: string;
  /** User time zone identifier (e.g., 'America/Los_Angeles') */
  timeZone?: string;
  /** Deprecated. Ignored. Prefer distanceUnit, temperatureUnit, fuelConsumptionUnit, and energyConsumptionUnit. Omitted units are resolved from locale via csp-commonlib. */
  unitSystem?: 'METRIC' | 'IMPERIAL' | 'US_CUSTOMARY';
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: string;
  /** Optional temperature unit (e.g. CELSIUS, FAHRENHEIT). Defaults from locale. Used by Home Charge. */
  temperatureUnit?: string;
  /** Optional fuel-consumption unit (e.g. KILOMETER_PER_LITER, MILE_PER_GALLON_US). Defaults from locale. */
  fuelConsumptionUnit?: string;
  /** Optional energy-consumption unit (e.g. WATT_HOUR_PER_KILOMETER, WATT_HOUR_PER_MILE). Defaults from locale. */
  energyConsumptionUnit?: string;
};
export type ReportExportRequestBodyDto = {
  /** Filters to apply when exporting the report */
  filters: ReportFiltersDto;
  /** User preferences for locale and unit system */
  userPreferences?: UserPreferencesDto;
};
export type GmResponseCommonListUserDefinedFilterDto = {
  result?: UserDefinedFilterDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ReportDescriptionDto = {
  /** The type of report (e.g., TRIP_HISTORY, SAFETY_EVENTS, HOME_CHARGING, UTILIZATION) */
  reportType?: string;
  /** Display name of the report */
  name?: string;
  /** Detailed description of what the report contains */
  description?: string;
};
export type GmResponseCommonListReportDescriptionDto = {
  result?: ReportDescriptionDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateRuleRequest = {
  /** Unique identifier of the rule to update. */
  ruleId: string;
  /** Human-readable name of the rule. */
  name: string;
  /** Category of the rule. */
  category: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Event type. */
  event:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
  /** Detailed rule configuration as a JSON object.
                - GEOFENCE (entry-exit): {"entry": true, "exit": true}
                - ASSET + vehicle-inactive(vehicle-low-utilization): {">": {"field": "days", "value": 10}} (days 1-999)
                - SAFETY_AND_SECURITY + idling: {">": {"field": "minutes", "value": 60}} (minutes 1-999)
                - SAFETY_AND_SECURITY + off-hours-driving: {"not": {"and": [{"in": {"field": "day_of_week",
                  "values": ["MON","TUE","WED","THU","FRI"]}}, {">=": {"field": "start_time", "value": "08:00"}},
                  {"<=": {"field": "end_time", "value": "17:00"}}]}} or {"outside_working_hours": {"days": ["MON"],
                  "start_time": "08:00", "end_time": "17:00"}} */
  rule?: {
    [key: string]: any;
  };
  /** List of fleet IDs assigned to this rule. */
  assignedFleetIds?: string[];
  /** List of VINs this rule applies to. */
  vins?: string[];
};
export type CreateRuleResponse = {
  /** Unique identifier of the created rule. */
  ruleId: string;
};
export type GmResponseCommonCreateRuleResponse = {
  result?: CreateRuleResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CreateRuleRequest = {
  /** Human-readable name of the rule. */
  name: string;
  /** Category of the rule. */
  category: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Event type. */
  event:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
  /** Detailed rule configuration as a JSON object.
                - GEOFENCE (entry-exit): {"entry": true, "exit": true}
                - ASSET + vehicle-inactive(vehicle-low-utilization): {">": {"field": "days", "value": 10}} (days 1-999)
                - SAFETY_AND_SECURITY + idling: {">": {"field": "minutes", "value": 60}} (minutes 1-999)
                - SAFETY_AND_SECURITY + off-hours-driving: {"not": {"and": [{"in": {"field": "day_of_week",
                  "values": ["MON","TUE","WED","THU","FRI"]}}, {">=": {"field": "start_time", "value": "08:00"}},
                  {"<=": {"field": "end_time", "value": "17:00"}}]}} or {"outside_working_hours": {"days": ["MON"],
                  "start_time": "08:00", "end_time": "17:00"}}
                - Defaults (org-wide, fleet manager): idling 10 min, vehicle-inactive 10 days,
                  off-hours weekdays 08:00-17:00 */
  rule?: {
    [key: string]: any;
  };
  /** List of fleet IDs assigned to this rule. */
  assignedFleetIds?: string[];
  /** List of VINs this rule applies to. */
  vins?: string[];
};
export type MigratedAlertRule = {
  organizationId?: string;
  fleetId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviAlertRuleId?: string;
  ruleId?: string;
  oviChangeSequence?: string;
};
export type GmPageMigratedAlertRule = {
  items: MigratedAlertRule[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedAlertRule = {
  result?: GmPageMigratedAlertRule;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviSyncError = {
  code: string;
  message: string;
};
export type OviAlertRuleSyncResult = {
  oviAlertRuleId: string;
  cspRuleId?: string;
  assignedFleetIds?: string[];
  changeOp: 'created' | 'reused_existing' | 'changed' | 'no_change' | 'deleted';
  success: boolean;
  error?: OviSyncError;
};
export type SyncOviAlertRulesResponse = {
  organizationId: string;
  alertRules: OviAlertRuleSyncResult[];
};
export type GmResponseCommonSyncOviAlertRulesResponse = {
  result?: SyncOviAlertRulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviAlertRuleSyncItem = {
  oviAlertRuleId: string;
  hvrChangeSequence: string;
  oviFleetId?: string;
  isOnEnter: boolean;
  isOnExit: boolean;
  statusCode: 'active' | 'retired';
};
export type SyncOviAlertRulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  alertRules: OviAlertRuleSyncItem[];
};
export type OviAlertRuleValidationResult = {
  valid: boolean;
  error?: ValidationError;
  oviAlertRuleId: string;
  cspRuleId?: string;
};
export type ValidateOviAlertRulesResponse = {
  allOviAlertRulesMatched: boolean;
  allCspRulesMatched: boolean;
  alertRules: OviAlertRuleValidationResult[];
};
export type GmResponseCommonValidateOviAlertRulesResponse = {
  result?: ValidateOviAlertRulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviAlertRuleValidateItem = {
  oviAlertRuleId: string;
  oviFleetId?: string;
  isOnEnter: boolean;
  isOnExit: boolean;
};
export type ValidateOviAlertRulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  alertRules: OviAlertRuleValidateItem[];
};
export type RuleItemResponse = {
  /** Unique identifier of the rule */
  id: string;
  /** Status of the rule */
  status: 'ACTIVE' | 'DELETED';
  /** Organization ID of the rule */
  orgId: string;
  /** List of fleet IDs assigned to the rule */
  assignedFleetIds: string[];
  /** List of VINs assigned to the rule */
  vins?: string[];
  /** Name of the rule */
  name: string;
  /** State type of the rule */
  stateType: 'STATEFUL' | 'STATELESS';
  /** Process of the rule */
  process?: string;
  /** Data source of the rule */
  dataSource: 'ASSET';
  /** Category of the rule */
  category: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Event of the rule */
  event:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
  /** Rule of the rule */
  rule?: {
    [key: string]: any;
  };
  /** Created at of the rule */
  createdAt: string;
  /** Updated at of the rule */
  updatedAt?: string;
};
export type GmResponseCommonListRuleItemResponse = {
  result?: RuleItemResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CategoryEvent = {
  /** Category type of the rule. Valid values:
                - 'drive-block'
                - 'asset'
                - 'geofence' */
  category: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Event type of the rule. Valid values depend on the category:
                    - For 'drive-block': vehicle-ready-to-block
                    - For 'asset': location-masked-unmasked
                    - For 'geofence': entry-exit */
  event:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
};
export type RuleFilterRequest = {
  /** List of events and categories for which to fetch rules.
                    Each item should specify both a category and an event.
                    If null or empty, returns all active rules. */
  filters?: CategoryEvent[];
};
export type RegistrationData = {
  /** Event category */
  category: string;
  /** Event type */
  event: string;
};
export type SubscriptionData = {
  /** Unique identifier of the subscription */
  id: string;
  /** Subscription pool identifier */
  subscriptionPoolId?: string;
  /** Organization ID */
  organizationId: string;
  /** List of event registrations */
  registrations?: RegistrationData[];
  /** Whether the subscription is active */
  active: boolean;
  /** Indicator for Group level subscription activeness */
  toggleActive: boolean;
  /** Noise threshold in minutes */
  noiseThresholdInMinutes: number;
  /** Receipt preferences (e.g., FEED, EMAIL) */
  receiptPreferences?: string[];
  /** Associated assets */
  assets?: string[];
  /** Whether events are grouped */
  grouped: boolean;
  /** Email frequency setting */
  emailFrequency?: string;
};
export type RuleItem = {
  /** Unique identifier of the rule. */
  id: string;
  /** Category of the rule derived from business logic. */
  type: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Organization ID associated with the rule. */
  orgId: string;
  /** List of fleet IDs assigned to this rule. */
  assignedFleetIds: string[];
  /** Human-readable name of the rule. */
  name: string;
  /** Event type. */
  event?:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
  /** Detailed rule configuration as a JSON object. Example: {"rules": {"entry": true, "exit": true}} */
  rule?: {
    [key: string]: any;
  };
  /** Time at which the rule was created. */
  createdAt: string;
  /** Time at which the rule was last updated. */
  updatedAt?: string;
  /** Subscription data for this rule. */
  subscription?: SubscriptionData;
};
export type RulesResponse = {
  /** List of rule items. */
  items: RuleItem[];
  /** Total count of rules returned. */
  total: number;
  /** List of rule IDs that were not found in the database. */
  missedRuleIds?: string[];
};
export type GmResponseCommonRulesResponse = {
  result?: RulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GetRulesRequest = {
  ruleIds: string[];
};
export type RuleItemWithGeofenceCount = {
  /** Unique identifier of the rule. */
  id: string;
  /** Human-readable name of the rule. */
  name: string;
  /** List of fleet IDs assigned to this rule. */
  assignedFleetIds?: string[];
  /** Count of geofences associated with this rule. Omitted if geofence API is unavailable. */
  geofenceCount?: number;
  /** Category type of the rule. Valid values: asset, geofence, drive-block. */
  category: 'asset' | 'geofence' | 'drive-block' | 'safety-and-security';
  /** Event type of the rule. Valid values:
                vehicle-ready-to-block, location-masked-unmasked, entry-exit. */
  event:
    | 'vehicle-ready-to-block'
    | 'location-masked-unmasked'
    | 'entry-exit'
    | 'idling'
    | 'vehicle-low-utilization'
    | 'off-hours-driving';
};
export type ListWithGeofenceCountResponse = {
  /** List of rules with geofence count */
  items: RuleItemWithGeofenceCount[];
};
export type GmResponseCommonListWithGeofenceCountResponse = {
  result?: ListWithGeofenceCountResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GetListWithGeofenceCountRequest = {
  /**
                List of rule IDs to exclude from the response.
                These rules will be omitted from the response, allowing only unassigned rules to be fetched.
             */
  excludedRuleIds?: string[];
};
export type RuleItemWithSubscription = {
  /** Unique identifier of the rule */
  ruleId: string;
  /** Human-readable name of the rule */
  name: string;
  /** List of fleet IDs assigned to this rule */
  assignedFleetIds?: string[];
  /** Category of the rule */
  category: string;
  /** Event type */
  event: string;
  /** Subscription information from Alerts API */
  subscription?: SubscriptionData;
  /** Count of geofences associated with this rule */
  geofenceCount?: number;
};
export type RuleListWithSubscriptionsResponse = {
  /** List of rules with subscription and geofence data */
  items: RuleItemWithSubscription[];
  /** Continuation token for fetching next page */
  token?: string;
};
export type GmResponseCommonRuleListWithSubscriptionsResponse = {
  result?: RuleListWithSubscriptionsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Details = {
  /** Location coordinates of the event as [longitude, latitude]. */
  location?: number[];
  /** Gear state of the vehicle during the event. */
  gear?: string;
  /** Odometer reading in kilometers at the time of the event. */
  odometerInKm?: number;
  /** Fuel level as a percentage during the event. */
  fuelLevelInPercent?: number;
  /** Battery charge level as a percentage during the event. */
  chargeInPercent?: number;
  /** State of charge of the battery during the event. */
  stateOfCharge?: number;
  /** Speed of the vehicle in kilometers per hour during the event. */
  speedInKmh?: number;
  /** Duration of prolonged idling in seconds during the event. */
  prolongedIdlingDurationInS?: number;
  /** Following distance in meters during the event. */
  followDistanceInMeters?: number;
  /** Address of the event location. */
  address?: string;
};
export type Events = {
  /** Unique identifier of the event. */
  eventId: string;
  /** Unique identifier of the asset. */
  assetId?: string;
  /** Source of the event. */
  eventSource: string;
  /** Type of the event. */
  eventType: string;
  /** Formatted timestamp of the event in ISO 8601 format. */
  eventTs: string;
  /** Details of the event. */
  details: Details;
};
export type SafetyTripEventResponseItemDto = {
  /** Unique Identifier of the trip. */
  tripId: string;
  /** List of events for the trip. */
  events: Events[];
  /** Total number of events based on the given filter. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type SafetyTripEventsResponseDto = {
  /** List of trip event response items. */
  items: SafetyTripEventResponseItemDto[];
  /** List of trip IDs that have no safety events. */
  tripsWithoutSafetyEvents: string[];
  /** List of trip IDs that failed fetch from database due to request timeout or any other error. */
  unprocessedTripsIds: string[];
};
export type GmResponseCommonSafetyTripEventsResponseDto = {
  result?: SafetyTripEventsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyTripEventsReference = {
  /** Unique identifier for the trip. */
  tripId: string;
  /** Continuation token from the previous response, if applicable. */
  token?: string;
};
export type SafetyTripEventsRequestDto = {
  /** Maximum number of events to be fetched per trip. Defaults to 100. */
  size: number;
  /** If true, the response includes all available details; otherwise it includes location and speedInKmh only. */
  includeAllDetails: boolean;
  /** List of event sources to retrieve, e.g., VEHICLE, CAMERA. */
  safetyEventSource: string[];
  /** List of trips with their IDs and continuation tokens. */
  trips: SafetyTripEventsReference[];
};
export type EventSettingDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
};
export type EventSettingWithSpeedDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Minimum speed threshold in MPH to trigger the event. */
  minSpeedThresholdInMPH: number;
};
export type EventSettingWithSensitivityDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Sensitivity threshold to trigger the event. */
  sensitivityThreshold: 'LOW' | 'MEDIUM' | 'HIGH';
};
export type EventSettingWithDurationDto = {
  /** Indicates if the event type is enabled. */
  enabled: boolean;
  /** Idling duration in seconds before the event is triggered. */
  durationInSeconds: number;
};
export type EventSettingsDto = {
  /** Main toggle for all vehicle safety events. */
  vehicleAlerts: EventSettingDto;
  /** Excessive Speeding event settings. */
  excessiveSpeeding: EventSettingWithSpeedDto;
  /** Harsh Braking event settings. */
  harshBraking: EventSettingWithSensitivityDto;
  /** Harsh Acceleration event settings. */
  harshAcceleration: EventSettingWithSensitivityDto;
  /** Harsh Cornering event settings. */
  harshCornering: EventSettingWithSensitivityDto;
  /** Idling event settings. */
  idling: EventSettingWithDurationDto;
};
export type GmResponseCommonEventSettingsDto = {
  result?: EventSettingsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EventSettingsRequest = {
  /** Main toggle for all vehicle safety events. */
  vehicleAlerts?: EventSettingDto;
  /** Excessive Speeding event settings. */
  excessiveSpeeding?: EventSettingWithSpeedDto;
  /** Harsh Braking event settings. */
  harshBraking?: EventSettingWithSensitivityDto;
  /** Harsh Acceleration event settings. */
  harshAcceleration?: EventSettingWithSensitivityDto;
  /** Harsh Cornering event settings. */
  harshCornering?: EventSettingWithSensitivityDto;
  /** Idling event settings. */
  idling?: EventSettingWithDurationDto;
};
export type SafetyApiEventTypeCountDto = {
  /** The safety event type. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Count of events of this type within the window. Zero when none occurred. */
  count: number;
};
export type GmResponseCommonListSafetyApiEventTypeCountDto = {
  result?: SafetyApiEventTypeCountDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyApiEventFleetDto = {
  /** Fleet ID. */
  id?: string;
  /** Fleet name. */
  name?: string;
};
export type SafetyApiDriverDto = {
  /** Identifier of the driver associated with the event. */
  id?: string;
  /** Display name of the driver associated with the event. */
  name?: string;
  /** Email of the driver associated with the event. */
  email?: string;
};
export type SafetyApiEventVehicleDto = {
  /** Vehicle Identification Number */
  vin: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  imageSource?: string;
};
export type SafetyApiEventV2Dto = {
  /** Id of the snapshot safety event. Shared id with peripheral-api if it's a camera event */
  id: string;
  /** Unique Identifier of the trip. */
  tripId?: string;
  /** Fleet that the vehicle belongs to. */
  fleet?: SafetyApiEventFleetDto;
  /** Organization that the vehicle belongs to. */
  orgId: string;
  /** Type of the safety event. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Timestamp of the event. */
  eventDateTime: string;
  /** Driver information enriched from profile-api. */
  driver?: SafetyApiDriverDto;
  /** Vehicle details enriched from asset-service. */
  vehicle: SafetyApiEventVehicleDto;
  /** If media is associated with the event. */
  hasMedia: boolean;
};
export type SafetyApiEventListResponseSafetyApiEventV2Dto = {
  /** Safety Events list. */
  items: SafetyApiEventV2Dto[];
  /** Total number of safety events in result set. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type GmResponseCommonSafetyApiEventListResponseSafetyApiEventV2Dto = {
  result?: SafetyApiEventListResponseSafetyApiEventV2Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyApiEventDetailsV2Dto = {
  /** Id of the safety event */
  id: string;
  /** Id of the trip that the safety event belongs to. It may be null if the trip has not ended yet */
  tripId?: string;
  /** Type of the safety event */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Timestamp of the event */
  eventDateTime: string;
  /** Address information for the event location */
  address?: Address;
  /** Vehicle information */
  vehicle?: SafetyApiEventVehicleDto;
  /** Driver information */
  driver?: SafetyApiDriverDto;
  /** Speed in kilometers per hour at the time of the event */
  speedInKmh?: number;
  /** Duration of an idling event in seconds, null if not an idling event */
  durationInSeconds?: number;
  /**
                Indicates if the event has associated media, hasMedia is considered true if cameraEventStatus is READY,
                PROCESSING, or PENDING
                 */
  hasMedia: boolean;
  /**
                External reference to the Peripheral DB cameraEvents container primary id, this is the id used to call
                getMedia API
                 */
  cameraEventId?: string;
  /** Status of the camera event, hasMedia is considered true if cameraEventStatus is READY,
                PROCESSING, or PENDING
                 */
  cameraEventStatus?: 'PENDING' | 'PROCESSING' | 'FAILED' | 'READY' | 'EXPIRED';
  /** Error code of the camera event */
  cameraEventErrorCode?:
    | 'INVALID_STARTTIME'
    | 'DEVICE_OFFLINE'
    | 'UNSUPPORTED_FIRMWARE'
    | 'TIMED_OUT'
    | 'INTERNAL_ERROR'
    | 'NO_CAMERA_ASSOCIATED';
  /**
                The event's stored detail properties that safety-api does not model, passed through exactly as
                stored, so the set of keys varies by event source. Properties with a field of their own on this
                response are not repeated here, and media is never included: use cameraEventId and hasMedia.
                 */
  details: {
    [key: string]: any;
  };
};
export type GmResponseCommonSafetyApiEventDetailsV2Dto = {
  result?: SafetyApiEventDetailsV2Dto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ScoreDataPoint = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Driver score for that date. */
  value: number;
};
export type ScoreDto = {
  /** Current score. */
  value: number;
  /** Delta vs previous score. */
  delta: number;
  /** Chronological score trend. */
  trend: ScoreDataPoint[];
};
export type RankDataPoint = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Rank for that date. */
  value: number;
};
export type RankDto = {
  /** Current rank. */
  value: number;
  /** Total drivers considered for rank. */
  totalDrivers: number;
  /** Delta vs previous rank. */
  delta: number;
  /** Chronological rank trend. */
  trend: RankDataPoint[];
};
export type NormalizedValueDto = {
  /**
                    Normalized value representing events per 1000 miles for count type,
                    or percentage value for percentage type.
                 */
  value?: number;
  /** Normalized type whether it is "count" or "percentage" */
  type?: string;
};
export type ContributingEventDto = {
  /** Event type identifier. */
  type: string;
  /** Count of events of this type. */
  eventCount: number;
  /** Severity classification (CRITICAL/WARNING). */
  severity: string;
  /** Normalized value for this event type. */
  normalized: NormalizedValueDto;
  /** Impact classification (HIGH/LOW). */
  impact: string;
  /** Points delta contribution (positive or negative). */
  pointsDelta: number;
};
export type SeverityPerDayDto = {
  /** Date string (YYYY-MM-DD). */
  date: string;
  /** Critical event count that day. */
  criticalEventCount: number;
  /** Warning event count that day. */
  warningEventCount: number;
};
export type DriverScoreDetailsDto = {
  /** Unique identifier of the driver score record. */
  id: string;
  /** Unique identifier of the driver. */
  driverId?: string;
  /** Driver name. */
  name?: string;
  /** Driver email. */
  email?: string;
  /** Distance driven in miles. */
  distanceInMiles: number;
  /** Score data (current, delta, trend). */
  score?: ScoreDto;
  /** Rank data (current, total drivers, delta, trend). */
  rank?: RankDto;
  /** Total number of critical events. */
  criticalEventCount: number;
  /** Total number of warning events. */
  warningEventCount: number;
  /** List of contributing events sorted by eventCount. */
  contributingEvents: ContributingEventDto[];
  /** Daily severity counts sorted chronologically. */
  severityPerDay: SeverityPerDayDto[];
  /** Value is true when the driver did not drive in the scoring period. */
  isExpired: boolean;
  /** Last update timestamp ISO 8601. */
  updatedAt: string;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type GmResponseCommonDriverScoreDetailsDto = {
  result?: DriverScoreDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleScoreDto = {
  /** Unique identifier of the driver score. */
  id: string;
  /** Unique identifier of the asset, also known as VIN. */
  assetId?: string;
  /** Display name of the vehicle. */
  vehicleName?: string;
  /** Vehicle make, e.g., Chevrolet. */
  vehicleMake?: string;
  /** Vehicle model, e.g. Silverado. */
  vehicleModel?: string;
  /** Vehicle year, e.g., 2020. */
  vehicleYear?: string;
  /** URL of the vehicle image; null if not available. */
  vehicleImageUrl?: string;
  /** Safety score value between 0 and 100. Null if vehicle has no score. */
  score?: number;
  /** Number of critical events in scoring window. */
  criticalEventsCount: number;
  /** Number of warning events in scoring window. */
  warningEventsCount: number;
  /** Value is true when the vehicle has no trips in the scoring period. */
  isExpired: boolean;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type VehicleScoresResponse = {
  /** Vehicle score items list. */
  items: VehicleScoreDto[];
  /** Vehicle score overall total count. */
  total_items?: number;
  /** Continuation token for pagination; null if last page. */
  continuation_token?: string;
};
export type GmResponseCommonVehicleScoresResponse = {
  result?: VehicleScoresResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverScoresSummaryDto = {
  /**
                Average safety score across all drivers in the fleet, weighted by distance driven. Excludes expired driver
                scores. Returns zero if no valid driver scores.
             */
  averageScore: number;
  /** Total count of drivers with scores, excludes expired scores. */
  driverScoresCount: number;
  /** Total count of drivers within org/fleet. */
  totalDriversCount: number;
  /** Total count of vehicles w/o assigned driver that have scores, excludes expired scores. */
  vehicleScoresCount: number;
};
export type GmResponseCommonDriverScoresSummaryDto = {
  result?: DriverScoresSummaryDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TrendItem = {
  /** Date. */
  date?: string;
  /** Value. */
  value?: number;
};
export type ScoreWithTrend = {
  /** Current score value. */
  value?: number;
  /** Delta change from previous period. */
  delta?: number;
  /** Historical trend data. */
  trend?: TrendItem[];
};
export type RankWithTrend = {
  /** Current rank value. */
  value?: number;
  /** Total number of fleets. */
  totalFleets?: number;
  /** Delta change from previous period. */
  delta?: number;
  /** Historical trend data. */
  trend?: TrendItem[];
};
export type EventDetailDto = {
  /** Event type. */
  type?:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt'
    | 'cameraKeyPress'
    | 'idling'
    | 'accident'
    | 'lowImpactCollision'
    | 'thermal'
    | 'theft';
  /** Event severity. */
  severity?: 'critical' | 'warning';
};
export type PerformerDto = {
  /** Driver name. */
  name?: string;
  /** Driver score. */
  score?: number;
  /** Driver rank. */
  rank?: number;
  /** Score change/delta. */
  scoreDelta?: number;
  /** Recent event details. Optional field. */
  recentEventTypes?: EventDetailDto[];
};
export type DriverDto = {
  /** Identifier of the driver associated with the event. */
  id?: string;
  /** Display name of the driver associated with the event. */
  name?: string;
  /** Email of the driver associated with the event. */
  email?: string;
};
export type VehicleDto2 = {
  /** Vehicle Identification Number */
  vin: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  imageSource?: string;
};
export type SafetyEventDto = {
  /** Id of the snapshot safety event. Shared id with peripheral-api if it's a camera event */
  id: string;
  /** Unique Identifier of the trip. */
  tripId: string;
  /** Fleet that the vehicle belongs to. */
  fleetId?: string;
  /** Organization that the vehicle belongs to. */
  orgId: string;
  /** Type of the safety event. */
  eventType: string;
  /** Timestamp of the event. */
  eventDateTime: string;
  /** Driver information enriched from profile-api. */
  driver?: DriverDto;
  /** Vehicle details enriched from asset-service. */
  vehicle?: VehicleDto2;
  /** If media is associated with the event. */
  hasMedia: boolean;
};
export type CountWithDelta = {
  /** Current count value. */
  value?: number;
  /** Change from previous period. */
  delta?: number;
};
export type FleetScoreDto = {
  /** Organization ID. */
  orgId: string;
  /** Fleet ID. */
  fleetId?: string;
  /** Average driver scores with value, delta, and trend. */
  averageDriverScores?: ScoreWithTrend;
  /** Fleet rankings with value, total fleets, delta, and trend. */
  fleetRankings?: RankWithTrend;
  /** List of bottom performing drivers. */
  bottomPerformers?: PerformerDto[];
  /** List of top performing drivers. */
  topPerformers?: PerformerDto[];
  /** Event values by event type. */
  events?: SafetyEventDto[];
  /** Severity counts per day. */
  severityPerDay?: SeverityPerDayDto[];
  /** Critical event count with delta. */
  criticalEventCount?: CountWithDelta;
  /** Last updated timestamp. */
  updatedAt: string;
};
export type GmResponseCommonFleetScoreDto = {
  result?: FleetScoreDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverScoreDto = {
  /** Unique identifier of the driver score. */
  id: string;
  /** Unique identifier of the driver. */
  driverId?: string;
  /** Leaderboard rank of the driver. Null if driver has no score (e.g., no trips in last 7 days). */
  rank?: number;
  /** Safety score value between 0 and 100. Null if driver has no score. */
  score?: number;
  /** Delta (positive or negative) of score compared to previous calculation window. Null if no trend data available. */
  scoreDelta?: number;
  /** Driver display name. */
  name?: string;
  /** Driver email address. */
  email?: string;
  /** Number of critical events in scoring window. */
  criticalEventsCount: number;
  /** Number of warning events in scoring window. */
  warningEventsCount: number;
  /** Value is true when the driver did not drive in the scoring period. */
  isExpired: boolean;
  /** Fleet information. */
  fleet?: SafetyApiEventFleetDto;
};
export type DriverScoresResponse = {
  /** Driver score items list. */
  items: DriverScoreDto[];
  /** Driver score overall total count. */
  total_items?: number;
  /** Continuation token for pagination; null if last page. */
  continuation_token?: string;
  /** Latest update timestamp ISO 8601. */
  latestUpdateTimestamp?: string;
};
export type GmResponseCommonDriverScoresResponse = {
  result?: DriverScoresResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Geometry = {
  type: string;
};
export type Feature = {
  type: string;
  geometry: Geometry;
  properties: Properties;
};
export type TripRouteGeoJson = {
  type: string;
  features: Feature[];
};
export type TripRouteDto = {
  /** Unique Identifier of the trip. */
  tripId: string;
  /** Trip Start time in ISO 8601 format. */
  eventTs: string;
  /** Details of the trip route. */
  tripRoute?: TripRouteGeoJson;
};
export type TripRoutesResponseDto = {
  /** List of trip routes corresponding to the provided trip IDs. */
  items: TripRouteDto[];
  /** IDs of the trips not found in the database. */
  tripsWithoutRoute: string[];
  /** IDs that were not processed. */
  unprocessedTripIds: string[];
};
export type GmResponseCommonTripRoutesResponseDto = {
  result?: TripRoutesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TripRoutesRequestDto = {
  tripIds: string[];
};
export type TripEventResponseItemDto = {
  /** Unique Identifier of the trip. */
  tripId: string;
  /** List of events for the trip. */
  events: Events[];
  /** Total number of events based on the given filter. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type TripEventsResponseDto = {
  /** List of trip event response items. */
  items: TripEventResponseItemDto[];
  /** List of trip IDs that are missing safety event details. */
  tripsWithoutSafetyEvents: string[];
  /** List of trip IDs that failed fetch from database due to request timeout or any other error. */
  unprocessedTripsIds: string[];
};
export type GmResponseCommonTripEventsResponseDto = {
  result?: TripEventsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TripReference = {
  /** Unique identifier for the trip. */
  tripId: string;
  /** Continuation token from the previous response, if applicable. */
  token?: string;
};
export type TripEventsRequestDto = {
  /** Maximum number of events to be fetched for the given tripIds.
            | Default is 100. */
  size: number;
  /** If the includeAllDetails is true, the response will include all the details.
            | Else it will include location and speedInKmh by default. */
  includeAllDetails: boolean;
  /** List of event types to retrieve, e.g., VEHICLE, CAMERA. */
  safetyEventSource: string[];
  /** List of trips with their IDs and continuation tokens. */
  trips: TripReference[];
  isTripCountValid: boolean;
};
export type RawSafetyEventDetailsDto = {
  /** Id of the safety event */
  id: string;
  /** Unique Identifier of the trip. */
  tripId: string;
  /** Fleet that the vehicle belongs to. */
  fleetId?: string;
  /** Organization that the vehicle belongs to. */
  orgId: string;
  /** Type of the safety event. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt';
  /** Timestamp of the event. */
  eventDateTime: string;
  /** Identifier of the driver associated with the event. */
  driverId?: string;
  /** Vehicle Identification Number (VIN). */
  vin: string;
  /** Location coordinates of the event as [longitude, latitude]. */
  location?: number[];
  /** If media is associated with the event. */
  hasMedia: boolean;
  /** Speed in kilometers per hour at the time of the event. */
  speedInKmh?: number;
};
export type GmResponseCommonRawSafetyEventDetailsDto = {
  result?: RawSafetyEventDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RawSafetyEventDto = {
  /** Id of the snapshot safety event. Shared id with peripheral-api if it's a camera event */
  id: string;
  /** Unique Identifier of the trip. */
  tripId: string;
  /** Fleet that the vehicle belongs to. */
  fleetId?: string;
  /** Organization that the vehicle belongs to. */
  orgId: string;
  /** Type of the safety event. */
  eventType:
    | 'accidentDetected'
    | 'cellPhoneUsage'
    | 'driverDistracted'
    | 'eatingAndDrinking'
    | 'excessiveSpeeding'
    | 'followDistance'
    | 'hardAcceleration'
    | 'hardBrake'
    | 'hardCornering'
    | 'laneWeaving'
    | 'possibleFatigue'
    | 'seatbeltUnbuckled'
    | 'smoking'
    | 'speedOverPostedLimit'
    | 'unbuckledSeatBelt';
  /** Timestamp of the event. */
  eventDateTime: string;
  /** Identifier of the driver associated with the event. */
  driverId?: string;
  /** Vehicle Identification Number (VIN). */
  vin: string;
  /** If media is associated with the event. */
  hasMedia: boolean;
};
export type RawSafetyEventsResponse = {
  /** Raw Safety Events list. */
  items: RawSafetyEventDto[];
  /** Total number of safety events in result set. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type GmResponseCommonRawSafetyEventsResponse = {
  result?: RawSafetyEventsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyEventDetailsDto = {
  /** Id of the safety event */
  id: string;
  /** Type of the safety event */
  eventType: string;
  /** Timestamp of the event */
  eventDateTime: string;
  /** Address information for the event location */
  address?: Address;
  /** Vehicle information */
  vehicle?: VehicleDto2;
  /** Driver information */
  driver?: DriverDto;
  /** Speed in kilometers per hour at the time of the event */
  speedInKmh?: number;
  /** Indicates if the event has associated media */
  hasMedia: boolean;
};
export type GmResponseCommonSafetyEventDetailsDto = {
  result?: SafetyEventDetailsDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyEventsResponse = {
  /** Safety Events list. */
  items: SafetyEventDto[];
  /** Total number of safety events in result set. */
  total_items?: number;
  /**
               Continuation token to be provided through request to provide the next set of events.
               When value becomes null, it indicates that the list has reached its last page.
             */
  continuation_token?: string;
};
export type GmResponseCommonSafetyEventsResponse = {
  result?: SafetyEventsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleEventsCount = {
  hardBrake?: number;
  hardAcceleration?: number;
  accidentDetected?: number;
  unbuckledSeatBelt?: number;
};
export type CameraEventsCount = {
  driverDistracted?: number;
  cellPhoneUsage?: number;
  possibleFatigue?: number;
  seatbeltUnbuckled?: number;
  smoking?: number;
  eatingAndDrinking?: number;
  excessiveSpeeding?: number;
  speedOverPostedLimit?: number;
  hardCornering?: number;
  followDistance?: number;
  forwardCollisionWarning?: number;
  laneWeaving?: number;
  runningAStopSign?: number;
  runningRedLight?: number;
  unintendedLaneDepartureSwerving?: number;
  aggressiveBehaviors?: number;
  prolongedIdling?: number;
  potentialAccidentDetection?: number;
};
export type Summary = {
  vehicle?: VehicleEventsCount;
  camera?: CameraEventsCount;
};
export type TripSummariesResponseItemDto = {
  /** Unique Identifier of the trip. */
  tripId: string;
  /** Unique Identifier of the vehicle. */
  vin?: string;
  /** UUID of the driver, if a driver was assigned to the vehicle during the trip. */
  driverId?: string;
  /** Name of the driver, provided by Profile service */
  driverName?: string;
  /** Trip score ranging from 0 to 100. */
  tripScore?: number;
  /** Total number of safety events during the trip. */
  totalSafetyEventsCount?: number;
  /** Total number of vehicle camera events during the trip. */
  totalVehicleCameraEventsCount?: number;
  /** Trip start time in ISO 8601 format. */
  tripStartTimeUtc: string;
  /** Trip end time in ISO 8601 format. */
  tripEndTimeUtc: string;
  /** Total distance of the trip in kilometers.
                Can be null when the total distance is not available. */
  totalDistanceInKm?: number;
  /** Duration of the trip in seconds. */
  tripDurationInSeconds: number;
  /** Idle duration of the trip in seconds. */
  idleDurationInSeconds?: number;
  /** Drive idle duration of the trip in seconds. */
  driveIdleDurationInSeconds?: number;
  /** Park idle duration of the trip in seconds. */
  parkIdleDurationInSeconds?: number;
  /** Start location coordinates. */
  startLocation?: number[];
  /** Start address of the trip. */
  startAddress?: string;
  /** End location coordinates. */
  endLocation?: number[];
  /** End address of the trip. */
  endAddress?: string;
  /** Summary of the trip. */
  summary?: Summary;
  /** Fuel economy in Km/l. */
  fuelEconomyInKmPerL?: number;
  /** Energy economy in Kwh/Km. */
  energyEconomyInKwhPerKm?: number;
  /** Indicates whether the trip location was masked. */
  isLocationMasked?: boolean;
};
export type TripSummariesResponseDto = {
  /** Trips Summaries list in the current page. */
  items: TripSummariesResponseItemDto[];
  /** Total number of trips based on the given filter and is not the total in the page. */
  total_items: number;
  /**
           Continuation token to be provided through `continuationToken` request header when navigating to the next page.
           Ensure that the backslash before the double quotes are filtered-out before using.
           When value becomes null, it indicates that the list has reached its last page.
         */
  continuation_token?: string;
};
export type GmResponseCommonTripSummariesResponseDto = {
  result?: TripSummariesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TrustedDeviceResponse = {
  id?: string;
  createdAt?: string;
  lastAuthAt?: string;
  expiresAt?: string;
  revoked?: boolean;
  deviceInfo?: string;
};
export type GmResponseCommonTrustedDeviceResponse = {
  result?: TrustedDeviceResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrgAppUpdateRequest = {
  /** Status of the app identity. */
  status: 'ACTIVE' | 'DISABLED';
  /** Custom permissions for the app identity. Can be empty. */
  permissions: string[];
  /** Email address for the app identity used as a contact email. */
  contactEmail: string;
  /** Description for the app identity. */
  description: string;
};
export type AppUpdateRequest = {
  /** Status of the app identity. */
  status: 'ACTIVE' | 'DISABLED';
  /** Custom permissions for the app identity. Can be empty. */
  permissions: string[];
  /** Email address for the app identity used as a contact email. */
  contactEmail: string;
  /** Description for the app identity. */
  description: string;
};
export type AddressDto2 = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type EligibleAssetTypeDto = {
  provider: string;
};
export type InviteDto = {
  status?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
  activationState?:
    | 'MIGRATION_IN_PROGRESS'
    | 'AWAITING_ACCOUNT_ADMIN'
    | 'READY_TO_ACCEPT_TERMS';
  acceptedDate?: string;
  plannedExpiredDate?: string;
  lastExpiredDate?: string;
  lastInvitedBy?: string;
  lastInvitedDate?: string;
  lastResentBy?: string;
  lastResentDate?: string;
  lastCanceledBy?: string;
  lastCanceledDate?: string;
};
export type UserPreferencesDto2 = {
  locale: string;
  timeZone?: string;
  doNotShowLegalNotice?: boolean;
  showGettingStarted?: boolean;
};
export type MeasurementDto = {
  typeKey?: string;
  unitCode?: string;
};
export type Measurements = {
  unitSystem?: string;
  distance?: MeasurementDto;
  speed?: MeasurementDto;
  capacity?: MeasurementDto;
  fuelConsumption?: MeasurementDto;
  electricConsumption?: MeasurementDto;
  energy?: MeasurementDto;
  pressure?: MeasurementDto;
  temperature?: MeasurementDto;
  emission?: MeasurementDto;
};
export type FormatStyleDto = {
  typeKey?: string;
  styleCode?: string;
  pattern?: string;
};
export type AddressFormatDto = {
  styleCode?: string;
  line1Pattern?: string;
  line2Pattern?: string;
  cityLinePattern?: string;
  oneLinePattern?: string;
};
export type FirstDayOfWeekDto = {
  firstDayOfWeekCode?: string;
};
export type FormatStyles = {
  date?: FormatStyleDto;
  time?: FormatStyleDto;
  dateTime?: FormatStyleDto;
  currency?: FormatStyleDto;
  phone?: FormatStyleDto;
  number?: FormatStyleDto;
  address?: AddressFormatDto;
  firstDayOfWeek?: FirstDayOfWeekDto;
};
export type EffectiveUserPreferencesDto = {
  measurements?: Measurements;
  formats?: FormatStyles;
  locale?: string;
  timeZone?: string;
  unitSystem?: string;
  units?: {
    [key: string]: string;
  };
  fractionDigits?: {
    [key: string]: number;
  };
  dateStyle?: string;
  clockConvention?: string;
  firstDayOfWeek?: string;
  currencyCode?: string;
};
export type Secret = {
  startDateTime?: string;
  endDateTime?: string;
  secretText?: string;
  hint?: string;
};
export type AppSettingsDto = {
  clientId?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
  email?: string;
  description?: string;
};
export type ProfileResponse = {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  address?: AddressDto2;
  status?: string;
  role?: string;
  organization?: HierarchyObjectView;
  fleet?: HierarchyObjectView;
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  invite?: InviteDto;
  lastSignedInDate?: string;
  userPreferences?: UserPreferencesDto2;
  effectiveUserPreferences?: EffectiveUserPreferencesDto;
  type?: string;
  appSettings?: AppSettingsDto;
  cdiProfileId?: string;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  migrated?: boolean;
  viewedAppSpaceCodes?: (
    | 'BUSINESS_PROFILE'
    | 'VEHICLES'
    | 'DRIVERS'
    | 'USERS'
    | 'GEOFENCES'
  )[];
};
export type GmResponseCommonProfileResponse = {
  result?: ProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProfileUpdateRequestV20231010 = {
  /** Role of the user. */
  role: string;
  /** Status of the user. */
  status?: string;
  /** Fleet ID */
  fleetId?: string;
  /** List of eligible asset types for the user. */
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  /** User preferences */
  userPreferences?: UserPreferencesDto2;
};
export type GmResponseCommonSecret = {
  result?: Secret;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProfileUpdateJson = {
  role: string;
  status: string;
  fleetId?: string;
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  userPreferences?: UserPreferencesDto2;
};
export type UrlsJson = {
  termsAndConditions: string;
  privacyPolicy: string;
};
export type LegalRequestJson = {
  /** URLs for legal requests. */
  urls: UrlsJson;
  /** Accepted status for legal requests. */
  accepted: boolean;
};
export type CodesResponse = {
  userCode?: string;
  deviceCode?: string;
  expiresIn?: number;
};
export type GmResponseCommonCodesResponse = {
  result?: CodesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TenantUserCheck = {
  email: string;
};
export type OtpVerifyRequest = {
  otp: string;
};
export type MfaToken = {
  tokenId?: string;
  token?: string;
  expiration?: number;
};
export type MfaResponse = {
  authSuccess?: boolean;
  message?: string;
  token?: MfaToken;
};
export type GmResponseCommonMfaResponse = {
  result?: MfaResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type MfaRequest = {
  tokens?: {
    [key: string]: string;
  };
  deviceFingerprint?: string;
  userAgent?: string;
  otp?: string;
  rememberDevice?: boolean;
};
export type OffboardKickoffResponse = {
  jobId?: string;
};
export type GmResponseCommonOffboardKickoffResponse = {
  result?: OffboardKickoffResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviVehicleSchedulesResponseEntry = {
  valid?: boolean;
  error?: ValidationError;
  vin?: string;
  scheduleId?: string;
};
export type ValidateMigratedOviVehicleSchedulesResponse = {
  allOviVehicleSchedulesMatched?: boolean;
  allCspDriverAssignmentsMatched?: boolean;
  vehicles?: ValidateMigratedOviVehicleSchedulesResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviVehicleSchedulesResponse = {
  result?: ValidateMigratedOviVehicleSchedulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviVehicleSchedulesRequestEntry = {
  scheduleId: string;
  vehicleId: string;
  vin: string;
  personId: string;
  startTime: string;
  endTime: string;
};
export type ValidateMigratedOviVehicleSchedulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  schedules: ValidateMigratedOviVehicleSchedulesRequestEntry[];
};
export type ValidateMigratedOviPersonsResponseEntry = {
  valid?: boolean;
  error?: ValidationError;
  oviPersonId?: string;
  cspProfileId?: string;
};
export type ValidateMigratedOviPersonsResponse = {
  allOviPersonIdsMatched?: boolean;
  allCspProfileIdsMatched?: boolean;
  persons?: ValidateMigratedOviPersonsResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviPersonsResponse = {
  result?: ValidateMigratedOviPersonsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviPersonsRequestEntry = {
  personId: string;
  fleetId?: string;
  roleCode: 'manager' | 'driver';
  statusCode:
    | 'active'
    | 'inactive'
    | 'invited'
    | 'pending'
    | 'retired'
    | 'verified';
  firstName?: string;
  lastName?: string;
  userLanguage?: string;
  timezone?: string;
  addresses?: OviAddress[];
  contacts?: OviContact[];
};
export type ValidateMigratedOviPersonsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  persons: ValidateMigratedOviPersonsRequestEntry[];
};
export type ActivateUsersResponseEntry = {
  /** CSP profile ID. */
  cspProfileId?: string;
  /** OVI person ID. */
  oviPersonId?: string;
  /** True when the user is active after this request; false when activation failed. */
  activated?: boolean;
};
export type ActivateUsersResponse = {
  /** Activation result for each migrated profile processed by this request. */
  users?: ActivateUsersResponseEntry[];
};
export type GmResponseCommonActivateUsersResponse = {
  result?: ActivateUsersResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ActivateUsersRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** CSP organization ID. */
  cspOrganizationId: string;
};
export type DriverAssignedVehicle = {
  /** Vehicle Identification Number (VIN) */
  vin: string;
  /** Name for the vehicle */
  vehicleName: string;
  /** Vehicle manufacturer */
  make: string;
  /** Vehicle model */
  model: string;
  /** Vehicle manufacturing year */
  year?: number;
  /** URL for an image of the vehicle */
  vehicleImageSource?: string;
  /** Date when the vehicle was updated */
  updatedDateTime?: string;
  /** Date when the vehicle assignment was created */
  createdDateTime?: string;
};
export type MigratedDriverProfile = {
  oviVehicleIds?: string[];
  assignedVehicles?: DriverAssignedVehicle[];
};
export type MigratedVehicleSchedule = {
  userId?: string;
  organizationId?: string;
  fleetId?: string;
  driverProfile?: MigratedDriverProfile;
};
export type GmPageMigratedVehicleSchedule = {
  items: MigratedVehicleSchedule[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedVehicleSchedule = {
  result?: GmPageMigratedVehicleSchedule;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehicleSchedulesResponseEntry = {
  success?: boolean;
  error?: EntryError;
  scheduleId?: string;
  assetId?: string;
  userId?: string;
  changeOp?: 'ASSIGNED' | 'UNASSIGNED' | 'NO_CHANGE';
};
export type SyncOviVehicleSchedulesResponse = {
  schedules?: SyncOviVehicleSchedulesResponseEntry[];
};
export type GmResponseCommonSyncOviVehicleSchedulesResponse = {
  result?: SyncOviVehicleSchedulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehicleSchedulesRequestEntry = {
  scheduleId: string;
  vehicleId: string;
  vin: string;
  personId: string;
  startTime: string;
  endTime: string;
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
};
export type SyncOviVehicleSchedulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  schedules: SyncOviVehicleSchedulesRequestEntry[];
};
export type LegalDocument = {
  accepted?: boolean;
  acceptedOn?: string;
  source?: string;
};
export type Legal = {
  termsAndConditions?: LegalDocument;
  privacyPolicy?: LegalDocument;
};
export type EligibleAssetType = {
  provider?: string;
};
export type Invite = {
  status?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
  activationState?:
    | 'MIGRATION_IN_PROGRESS'
    | 'AWAITING_ACCOUNT_ADMIN'
    | 'READY_TO_ACCEPT_TERMS';
  acceptedDate?: string;
  plannedExpiredDate?: string;
  lastExpiredDate?: string;
  lastInvitedBy?: string;
  lastInvitedDate?: string;
  lastResentBy?: string;
  lastResentDate?: string;
  lastCanceledBy?: string;
  lastCanceledDate?: string;
};
export type AppSettings = {
  objectId?: string;
  clientId?: string;
  email?: string;
  description?: string;
  displayName?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
};
export type DriverProfile = {
  /** Driver's license number for identification and verification purposes */
  licenseNumber?: string;
  /** Two-letter state or province code where the driver's license was issued */
  licenseState?: string;
  /** Unique employee identifier within the organization */
  employeeId?: string;
  /** Date when the driver started employment */
  employeeStartDate?: string;
  /** Additional notes or comments about the driver */
  notes?: string;
  /** List of vehicles assigned to this driver */
  assignedVehicles?: DriverAssignedVehicle[];
  /** OVI vehicle IDs associated with this driver's vehicle schedule assignments */
  oviVehicleIds?: string[];
  /** The hvr change sequence of OVI vehicle_schedules, used for OVI migration */
  oviChangeSequence?: string;
  /** Latitude coordinate of the driver's address location */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location */
  longitudeOfDriverAddress?: number;
};
export type Profile = {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  email?: string;
  description?: string;
  phoneNumber?: string;
  address?: Address;
  status?:
    | 'CONTACT'
    | 'ACTIVE'
    | 'DISABLED'
    | 'PENDING'
    | 'RETIRED'
    | 'DELETED';
  role?:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'GMF_ADVISOR'
    | 'CUSTOM_ACCESS_ORG_LEVEL'
    | 'CUSTOM_ACCESS_SYS_LEVEL';
  organization?: HierarchyObjectView;
  fleet?: HierarchyObjectView;
  identityId?: string;
  cdiProfileId?: string;
  legal?: Legal;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  identityDataUpdateDate?: string;
  lastSignedInDate?: string;
  onBoardingState?: string;
  eligibleAssetTypes?: EligibleAssetType[];
  invite?: Invite;
  userPreferences?: UserPreferences;
  oviPersonId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
  viewedAppSpaceCodes?: (
    | 'BUSINESS_PROFILE'
    | 'VEHICLES'
    | 'DRIVERS'
    | 'USERS'
    | 'GEOFENCES'
  )[];
  type?: 'USER' | 'APP';
  appSettings?: AppSettings;
  driverProfile?: DriverProfile;
};
export type GmPageProfile = {
  items: Profile[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageProfile = {
  result?: GmPageProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviPersonsResponseEntry = {
  success?: boolean;
  error?: EntryError;
  profileId?: string;
  personId?: string;
  fleetId?: string;
  changeOp?: 'CREATED' | 'UPDATED' | 'RETIRED' | 'NO_CHANGE';
};
export type SyncOviPersonsResponse = {
  persons?: SyncOviPersonsResponseEntry[];
};
export type GmResponseCommonSyncOviPersonsResponse = {
  result?: SyncOviPersonsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviPersonRequestEntry = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  personId: string;
  fleetId?: string;
  roleCode: 'manager' | 'driver';
  statusCode:
    | 'active'
    | 'inactive'
    | 'invited'
    | 'pending'
    | 'retired'
    | 'verified';
  firstName?: string;
  lastName?: string;
  userLanguage?: string;
  timezone?: string;
  licenseNumber?: string;
  accountPersonDataChangeTracking: DataChangeTracking;
  addresses?: OviAddress[];
  contacts?: OviContact[];
};
export type SyncOviPersonsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  persons: SyncOviPersonRequestEntry[];
};
export type DriverProfileResponse = {
  /** Unique identifier of the driver profile */
  id?: string;
  /** Identifier of the fleet */
  fleetId?: string;
  /** Identifier of the organization */
  organizationId?: string;
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's display name */
  displayName?: string;
  /** Driver's address */
  address?: AddressDto2;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Name of the fleet */
  fleetName?: string;
  /** Driver's license number */
  licenseNumber?: string;
  /** State of the driver's license */
  licenseState?: string;
  /** Employee ID */
  employeeId?: string;
  /** Employee start date */
  employeeStartDate?: string;
  /** Additional notes */
  notes?: string;
  /** List of vehicles assigned to this driver */
  assignedVehicles?: DriverAssignedVehicle[];
  /** The invitation status of the driver */
  inviteStatus?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
};
export type BulkGetDriversResponse = {
  /** Map of driver IDs to their corresponding driver profile responses */
  drivers?: {
    [key: string]: DriverProfileResponse;
  };
};
export type GmResponseCommonBulkGetDriversResponse = {
  result?: BulkGetDriversResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BulkGetDriversRequest = {
  /** Driver IDs to fetch (max 100) */
  driverIds: string[];
};
export type OrgAppCreateResponse = {
  id?: string;
  displayName?: string;
  role?: string;
  organization?: HierarchyObjectView;
  appSettings?: AppSettingsDto;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
};
export type GmResponseCommonOrgAppCreateResponse = {
  result?: OrgAppCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrgAppCreateRequest = {
  /** Used as a contact email for App identity. */
  contactEmail: string;
  /** Description of the App identity account. */
  description?: string;
  /** Permissions assigned to the App identity. */
  permissions: string[];
  /** Organization ID the App identity belongs to. */
  organizationId: string;
};
export type DriverVehicleAssignmentRequest = {
  /** Vehicle Identification Number (VIN) */
  vin: string;
};
export type DriverVehicleBulkUnassignRequest = {
  /** Driver IDs (max 100) */
  driverIds: string[];
};
export type AppCreateResponse = {
  id?: string;
  displayName?: string;
  role?: string;
  appSettings?: AppSettingsDto;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
};
export type GmResponseCommonAppCreateResponse = {
  result?: AppCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AppCreateRequest = {
  /** The Contact Email for this App identity. */
  contactEmail: string;
  /** Description of the app identity account. */
  description: string;
  /** The Permissions tied to the App identity account. */
  permissions: string[];
};
export type PaginatedDataResponseDriverProfileResponse = {
  items?: DriverProfileResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseDriverProfileResponse = {
  result?: PaginatedDataResponseDriverProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileCreateResponse = {
  /** Unique identifier of the driver profile */
  id?: string;
  /** Identifier of the fleet */
  fleetId?: string;
  /** Identifier of the organization */
  organizationId?: string;
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's display name */
  displayName?: string;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
};
export type GmResponseCommonDriverProfileCreateResponse = {
  result?: DriverProfileCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileCreateRequest = {
  /** Driver's first name */
  firstName: string;
  /** Driver's last name */
  lastName: string;
  /** Driver's email address */
  email: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Driver's address information */
  address?: Address;
  /** Latitude coordinate of the driver's address location */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location */
  longitudeOfDriverAddress?: number;
  /** Whether the driver is eligible for home charge reimbursement */
  homeChargeReimbursementEnabled?: boolean;
};
export type RecordLastSignedInRequest = {
  /** The profile ID to record the last signed in time for. */
  profileId: string;
  /** The last signed in time to record. */
  lastSignedIn: string;
};
export type CreateAdminUserProfileRequest = {
  firstName: string;
  lastName: string;
  email: string;
  role:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'SYSTEM_READER'
    | 'GMF_ADVISOR';
  phoneNumber?: string;
};
export type CompletedCancelInviteEntry = {
  id?: string;
};
export type FailedCancelInviteEntry = {
  id?: string;
  errors?: EntryError[];
};
export type CancelInvitesResponseDto = {
  completedEntries?: CompletedCancelInviteEntry[];
  failedEntries?: FailedCancelInviteEntry[];
};
export type GmResponseCommonCancelInvitesResponseDto = {
  result?: CancelInvitesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelInviteEntry = {
  /** The ID of the profile to cancel invitation. */
  id: string;
};
export type CancelInvitesRequestDto = {
  /** The list of entries with details about invitation to cancel. */
  entries: CancelInviteEntry[];
};
export type CompletedResendInviteEntry = {
  id?: string;
};
export type FailedResendInviteEntry = {
  id?: string;
  errors?: EntryError[];
};
export type ResendInvitesResponseDto = {
  completedEntries?: CompletedResendInviteEntry[];
  failedEntries?: FailedResendInviteEntry[];
};
export type GmResponseCommonResendInvitesResponseDto = {
  result?: ResendInvitesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ResendInviteEntry = {
  id: string;
};
export type ResendInvitesRequestDto = {
  entries: ResendInviteEntry[];
};
export type GmResponseCommonProfile = {
  result?: Profile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TermsAndConditionsUrls = {
  termsAndConditions: string;
  privacyPolicy: string;
};
export type LegalRequest = {
  urls: TermsAndConditionsUrls;
  accepted?: boolean;
};
export type CompletedInviteEntry = {
  id?: string;
  email?: string;
  role?: string;
  fleetId?: string;
};
export type FailedInviteEntry = {
  email?: string;
  role?: string;
  fleetId?: string;
  errors?: EntryError[];
};
export type InviteUsersResponse = {
  completedEntries?: CompletedInviteEntry[];
  failedEntries?: FailedInviteEntry[];
};
export type GmResponseCommonInviteUsersResponse = {
  result?: InviteUsersResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type InviteUserEntry = {
  email: string;
  /** Role assigned to the invited user. See Profile.Role enumeration. */
  role: string;
  /** First name of the invited user. Only used for creating Driver Profiles. */
  firstName?: string;
  /** Last name of the invited user. Only used for creating Driver Profiles. */
  lastName?: string;
  /** Phone number of the invited user. Only used for creating Driver Profiles. */
  phoneNumber?: string;
  /** Address of the invited user. Only used for creating Driver Profiles. */
  address?: AddressDto2;
  /** Fleet ID to which the invited user is assigned. Only used for creating Driver Profiles. */
  fleetId?: string;
  /** Driver profile information for the invited user, if applicable */
  driverProfile?: DriverProfile;
};
export type InviteUsersRequest = {
  entries: InviteUserEntry[];
};
export type TokenEnrichResponse = {
  /** CS profile id to enrich token with. */
  extension_profileId?: string;
  /** Organization id to enrich token with. */
  extension_organizationId?: string;
};
export type TokenEnrichForSsoRequest = {
  /** Email of the user's SSO account. */
  email?: string;
  /** Unique user ID used to identify them in Azure AD. */
  oid?: string;
};
export type TokenEnrichForCdiRequest = {
  /** Email of the user's CDI account. */
  email: string;
  /** Id of the user's CDI account. */
  cdiId: string;
};
export type GmResponseCommonMapStringSecret = {
  result?: {
    [key: string]: Secret;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type IdentityIdResponse = {
  identityId?: string;
};
export type GmResponseCommonIdentityIdResponse = {
  result?: IdentityIdResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetrieveIdentityIdRequest = {
  deviceCode: string;
  userCode: string;
};
export type GmResponseCommonDriverProfileResponse = {
  result?: DriverProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileUpdateRequest = {
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Driver's license number for identification and verification purposes */
  licenseNumber?: string;
  /** Full state name where the license has been issued */
  licenseState?: string;
  /** ID of the fleet to which the driver will be assigned */
  fleetId?: string;
  /** Unique employee identifier within the organization */
  employeeId?: string;
  /** Date when the driver started employment */
  employeeStartDate?: string;
  /** Additional notes or comments about the driver */
  notes?: string;
  /** Driver's address information */
  address?: Address;
  /** Latitude coordinate of the driver's address location.
    If this is provided, address and longitude of the driver's address location must also be provided.
     */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location.
    If this is provided, address and latitude of the driver's address location must also be provided. */
  longitudeOfDriverAddress?: number;
};
export type GmResponseCommonListTrustedDeviceResponse = {
  result?: TrustedDeviceResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OffboardStatusResponse = {
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  totalUsers?: number;
  processedUsers?: number;
  failedUsers?: number;
};
export type GmResponseCommonOffboardStatusResponse = {
  result?: OffboardStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetrieveResourceCountsResponse = {
  /** Resource counts by resource type. A value of zero means the count completed and no resources were
    found. The fleets count is included only for organization-wide ORG_MANAGER requests. The
    accountAdmins count is included only for ORG_MANAGER profiles. Any applicable count may be omitted
    when it cannot be retrieved, including when the caller lacks the source system's permission.
     */
  counts?: {
    [key: string]: number;
  };
};
export type GmResponseCommonRetrieveResourceCountsResponse = {
  result?: RetrieveResourceCountsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonSetString = {
  result?: string[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AppIdentity = {
  id?: string;
  email?: string;
  displayName?: string;
  clientId?: string;
  description?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
  creationDate?: string;
  updateDate?: string;
};
export type GmPageAppIdentity = {
  items: AppIdentity[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageAppIdentity = {
  result?: GmPageAppIdentity;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverWithAssignedVehicles = {
  /** Driver's profile ID */
  driverProfileId?: string;
  /** Driver's full name */
  name?: string;
  /** Driver's email address */
  email?: string;
  /** List of VINs associated with this driver */
  vins?: string[];
};
export type PaginatedDataResponseDriverWithAssignedVehicles = {
  items?: DriverWithAssignedVehicles[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseDriverWithAssignedVehicles = {
  result?: PaginatedDataResponseDriverWithAssignedVehicles;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PaginatedDataResponseProfile = {
  items?: Profile[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseProfile = {
  result?: PaginatedDataResponseProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListProfileResponse = {
  result?: ProfileResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CdiUserProfile = {
  email?: string;
  cdiProfileId?: string;
  cspProfileId?: string;
  cspOrgId?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  status?: string;
};
export type GmResponseCommonCdiUserProfile = {
  result?: CdiUserProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LocationInfo = {
  locale?: string;
  timeZone?: string;
};
export type ContactInfo = {
  email?: string;
  phoneNumber?: string;
  locationInfo?: LocationInfo;
  firstName?: string;
  lastName?: string;
};
export type GmResponseCommonContactInfo = {
  result?: ContactInfo;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useUpdateSubscriptionByIdVersion2Mutation,
  useGetEventSubscriptionsQuery,
  useValidateOviPersonChannelsMutation,
  useListOviPersonChannelsQuery,
  useSyncOviPersonChannelsMutation,
  useSubmitTicketMutation,
  useUnpinAlertMutation,
  usePinAlertMutation,
  useUpdateAllAlertsToReadAsyncMutation,
  useDismissAlertV20250909Mutation,
  useUpdateNoiseThresholdByOrganizationMutation,
  useUpdateSubscriptionToggleMutation,
  useAddSubscriptionsToUserMutation,
  useGetAllUserSubscriptionsQuery,
  useGetRegistrationsForUserQuery,
  useProcessPendingEmailsQuery,
  useGetAlertsByVinQuery,
  useGetSubscriptionsQuery,
  useGetPinnedAlertsForCurrentUserQuery,
  useGetAlertsAndGroupsForCurrentUserQuery,
  useGetAlertsByGroupIdQuery,
  useGetAlertsForCurrentUserQuery,
  useDeleteSubscriptionMutation,
  useUpdateAssetMutation,
  useDeleteAssetMutation,
  useUpdateSummaryMutation,
  useUpdateSessionMutation,
  useUpdateVehicleMutation,
  useUpdateVehicle1Mutation,
  useUpdateVehicle2Mutation,
  useUpdateVehicleBatchMutation,
  useUpdateVehicle3Mutation,
  useExecuteRemoteCommandsMfaMutation,
  useListVerifiedVehiclesMutation,
  useListMigratedVehiclesQuery,
  useSyncVehiclesMutation,
  useSubscriptionOnboardVehiclesMutation,
  useSubscriptionOffboardVehiclesMutation,
  useExportVehicleListOverviewCsvFromSearchMutation,
  useBulkGetVehicleBasicInfoMutation,
  useGetVehicleOverviewListQuery,
  useExportVehicleDiagnosticsListMutation,
  useGetAssetBatteryReadinessV20260113Mutation,
  useExportAssetBatteryReadinessCsvV20260113Mutation,
  useGetVehiclesWithDriversAndPeripheralsUsingBdQueryMutation,
  useProbeVehicleMutation,
  useGetVehiclesWithDriversAndPeripheralsMutation,
  useChangeFleetForVehiclesMutation,
  useCancelBatchMutation,
  useExportVehicleListOverviewCsvMutation,
  useGetVehicleOverviewList1Mutation,
  useGetVehicleDiagnosticsListQuery,
  useExportVehicleDiagnosticsListV20251104Mutation,
  useExportPendingConnectionVehiclesMutation,
  useExportPendingOnboardingVehiclesMutation,
  useRefreshBatchSummaryMutation,
  useGetAssetReadinessV20250909Mutation,
  useExportAssetReadinessCsvV20250909Mutation,
  useExportAssetFluidReadinessCsvV20250909Mutation,
  useGetAssetBatteryReadinessV20250909Mutation,
  useMigratePreviouslyConnectedVehicleToConnectivityMutation,
  useGetBatchIgnitionStatusMutation,
  useArchiveVehicleBoardingSessionMutation,
  useSendConnectivityRestartRequestMutation,
  useRetryOnboardingVehiclesMutation,
  useTriggerSearchIndexRefreshMutation,
  useCancelSessionsMutation,
  useGetMapAssetDetailsQuery,
  useGetMapLocationSummaryQuery,
  useTerminateVehicleBoardingSessionMutation,
  useBatchOffBoardVehiclesMutation,
  useRefreshVehicleDataMutation,
  useTriggerAddCapabilitiesEventMutation,
  useBatchOnboardVehiclesV2Mutation,
  useTriggerEventMutation,
  useGetActiveFieldActionVehicleSummaryMutation,
  useGetAssetReadinessV20241203Mutation,
  useRejectVehicleProofOfOwnershipMutation,
  useConfirmVehicleProofOfOwnershipMutation,
  useGetFieldActionSummaryReportMutation,
  useUpsertAssetMutation,
  useGetAssetsByPageMutation,
  useDoSubscribeV2Mutation,
  useGetAssetWithTireReadinessMutation,
  useSearchAssetsMutation,
  useUpdateProtectedFieldsForAssetMutation,
  usePatchVehicleProbeMutation,
  useResetOwnershipMutation,
  usePatchVehicleInfoFieldsMutation,
  useUpdateConfigurationMutation,
  useListSummariesQuery,
  useListSessionsQuery,
  useListVehiclesQuery,
  useListVehicles1Query,
  useListVehicles2Query,
  useListVehicles3Query,
  useGetVehicleImageUrlQuery,
  useGetVehicleImageUrlWithParamsQuery,
  useGetPropulsionSummaryQuery,
  useListBatchSummariesQuery,
  useGetBatchSummaryByIdQuery,
  useGetBatchSessionsByIdQuery,
  useGetAssets20250923BoardingBatchesByBatchIdExtendedQuery,
  useExportBatchVehiclesToCsvQuery,
  useListPendingConnectionVehiclesQuery,
  useGetOilLifeSummaryMetricsV20250826Query,
  useGetDiagnosticsSummaryMetricsV20250826Query,
  useGetConnectivityStatusDashboardSummaryMetricsV20250826Query,
  useGetChargeSummaryMetricsV20250826Query,
  useGetSummaryOfBoardingSessionsQuery,
  useSearchAssetQuery,
  useGetVehiclesWithDriversQuery,
  useListVehicleBoardingSessionsQuery,
  useGetOilLifeSummaryMetricsQuery,
  useGetDiagnosticsSummaryMetricsQuery,
  useGetConnectivityStatusSummaryMetricsQuery,
  useGetChargeLevelSummaryMetricsQuery,
  useGetVehiclesBasicDetailsQuery,
  useSearchAsset1Query,
  useListIncompleteOnboardingVehiclesQuery,
  useGetAssetsListQuery,
  useGetVehicleIgnitionStatusQuery,
  useGetAssetStatusWithFilteringQuery,
  useListPendingOnboardingVehiclesQuery,
  useExecuteRemoteCommandsQuery,
  useGetChargeLevelDashboardSummaryQuery,
  useGetFieldActionsForVinQuery,
  useGetAssets20240717ByAssetIdInternalQuery,
  useGetVehicleBoardingProfileQuery,
  useGetCurrentVehicleBoardingSessionQuery,
  useGetVehicleBoardingSessionBySessionIdQuery,
  useGetOrganizationIdByAssetIdQuery,
  useGetOrganizationAssetCountSummaryQuery,
  useGetAssetByIdWithFanQuery,
  useGetComplianceReportV2Query,
  useGetDashboardMetricsQuery,
  useGetMapListItemsQuery,
  useGetAssetWithi8NDetailsQuery,
  usePostAudit20250603ExportSyncMutation,
  useFetchOrganizationNameQuery,
  useFetchFleetQuery,
  useDemoQuery,
  useCreateProductMutation,
  useGetProductsMutation,
  useCreateFeatureMutation,
  useSunsetProductMutation,
  useGetProductByIdQuery,
  useUpdateHomeChargeReimbursementRecordUtilityRateMutation,
  useUpdateDriverUtilityRateMutation,
  useCreateFormattedChargeReimbursementsForReportsMutation,
  useCreateStreamedReportRecordsForHomeChargeReimbursementMutation,
  useCreateOrUpdateFleetUtilityRateSettingsMutation,
  useExportSelectedOrAllHomeChargeReimbursementRecordsMutation,
  useExportSelectedHomeChargeReimbursementRecordsMutation,
  useExportSelectedHomeChargeReimbursementRecordsForCurrentDriverMutation,
  useSearchChargingStationsForDriverQuery,
  useSearchQuery,
  useGetFleetUtilityRateSettingsQuery,
  useRemoveFleetUtilityRateSettingsMutation,
  useExportSingleHomeChargeReimbursementRecordQuery,
  useExportSingleHomeChargeReimbursementRecordForCurrentDriverQuery,
  useExportHomeChargeReimbursementRecordsQuery,
  useExportHomeChargeReimbursementRecordsForCurrentDriverQuery,
  useGetHomeChargingHistoryRecordsQuery,
  useGetChargingHistorySummaryForDriverQuery,
  useGetDriverUtilityPlanCardQuery,
  useGetHomeChargingHistoryRecordsForCurrentDriverQuery,
  useGetChargingHistorySummaryForCurrentDriverQuery,
  useGetDriverUtilityPlanCardForCurrentDriverQuery,
  useDownloadFeedbackImageQuery,
  useUploadFeedbackImageMutation,
  useCreateFeedbackMutation,
  useListFeedbacksQuery,
  useCreateJiraTicketForFeedbackMutation,
  useUpdateFeedbackStatusMutation,
  useEnrollOrUnenrollVehiclesMutation,
  useGetEligibleVehiclesMutation,
  useFindVinsMutation,
  useCreateOrgEnrollmentMutation,
  useValidateCredentialsMutation,
  useGetVehicleDetailsMutation,
  useLookupAuthorizedUserMutation,
  useLookupServicesMutation,
  useLookupOrganizationMutation,
  useValidateLineOfCreditMutation,
  useVerifyEnrollmentMutation,
  useCreateBulkJobMutation,
  useGetVehiclesEnrollmentViewMutation,
  useGetVehicleEnrollmentBatchQuery,
  useGetAllEligibleVinsQuery,
  useListProvidersQuery,
  useProviderIntegrationsStatusQuery,
  useGetOrgEnrollmentQuery,
  useUnlinkOrgEnrollmentMutation,
  useGetCurrentUserQuery,
  useGetBulkJobQuery,
  useGetAccountsQuery,
  useCountRemainingOfQuery,
  useSoftDeleteNextPageOfMutation,
  useListOviBoundariesQuery,
  useSyncBoundariesMutation,
  useValidateBoundariesMutation,
  useGetGeofenceCountByRuleIdsMutation,
  useCreateGeofenceMutation,
  useFetchGeofencesQuery,
  useDeleteGeofenceMutation,
  useUpdateGeofenceMutation,
  useAssignRuleIdsToGeofenceMutation,
  useGetGeofencesIdAndNameByRuleIdQuery,
  useGetOrdersV20260505Mutation,
  useExportOrdersV20260505Mutation,
  useAutoImportMutation,
  useAddOrdersMutation,
  useGetOrdersMutation,
  useExportOrdersMutation,
  useDeleteOrdersMutation,
  useGetOrderFiltersQuery,
  useGetOrderCountQuery,
  useGetOrderQuery,
  useGetOrderSummaryQuery,
  useSoftDeleteOrdersMutation,
  useUpdateVerificationStatusMutation,
  useGetAutoOnboardingSettingsQuery,
  useUpdateAutoOnboardingSettingsMutation,
  useUpdateFleetV20250114Mutation,
  useUpdateOrganizationV20241204Mutation,
  useUpdateOrganizationV20230717Mutation,
  useUpdateFleetsByOrganizationIdAndFleetIdMutation,
  useLookupEnrollmentMutation,
  useSyncOviBusinessAccountMutation,
  useGetOrganizationsInfoV20260120Mutation,
  useLookupOrganizationByInfoMutation,
  useLookupOrganizationByRawAddressInfoMutation,
  useEnrollAutomaticMutation,
  useEnrollForReviewMutation,
  useAcceptTermsMutation,
  useEnrollAsCustomerMutation,
  useDeclineEnrollmentMutation,
  useApproveEnrollmentMutation,
  useEnrollAsAdminMutation,
  useUpdateOrgDefaultFleetMutation,
  useCreateFleetMutation,
  useCheckIfFleetConfigHasChangedMutation,
  useGetOrganizationsInfoMutation,
  useGetOrganizationFanDetailsQuery,
  useCheckEnrollmentInviteQuery,
  useGetOrganizationByOrgIdQuery,
  useGetAllFleetsQuery,
  useGetFleetByIdQuery,
  useGetAllOrganizationsQuery,
  useGetOrgByIdQuery,
  useGetCapDetailsQuery,
  useGetDocumentQuery,
  useGetAllOrganizationsWithTypeQuery,
  useGetOrganizationByIdWithTypeQuery,
  useGetFleetByIdV2Query,
  useGetAllOrganizations1Query,
  useGetAllHubsQuery,
  useGetHubByIdQuery,
  useGetAllFleets1Query,
  useGetFleetById1Query,
  useGetFleetChildrenQuery,
  useGetHubChildrenQuery,
  useGetOrganizationChildrenQuery,
  useGetOrganizationByIdQuery,
  useGetOrganizationStatsByIdQuery,
  useGetAllFleetsByOrganizationIdQuery,
  useGetTopLevelOrganizationsQuery,
  useProcessSurfsightOrderUpdateWebhookMutation,
  useProcessSurfsightWebhookPayloadMutation,
  useFetchRecordingAvailabilityMutation,
  useRetryClipMutation,
  useGetClipsQuery,
  useCreateClipMutation,
  useRetryActivatePeripheralsMutation,
  useExportPeripheralsMutation,
  useProcessOrderUpdateMutation,
  useCleanPeripheralMutation,
  useProcessPlugEventMutation,
  useActivatePeripheralsMutation,
  useGetPeripheralsByVinsMutation,
  useTransferPeripheralsMutation,
  useUnlinkVehicleMutation,
  useMoveFleetMutation,
  useLinkToVehicleMutation,
  useBatchOnboardPeripheralsMutation,
  useUpdateSettingsMutation,
  useGetAccessTokenQuery,
  useGetRecordingsByMonthQuery,
  useGetRecordingsByDateQuery,
  useGetMediaInternalQuery,
  useGetMediaQuery,
  useGetClipDetailsQuery,
  useGetCameraAssignmentsQuery,
  useGetSettingsQuery,
  useGetPeripheralStatusCountsQuery,
  useGetOrderByIdQuery,
  useGetAdapterSupportedFeaturesQuery,
  useGetPeripheralByIdQuery,
  useGetPeripheralsQuery,
  useGetBatchEntityQuery,
  useDeleteClipMutation,
  useUpdateReportMetadataMutation,
  useCreateOrUpdateUserReportFiltersMutation,
  useExportReportMutation,
  useExportReportCsvMutation,
  useCreateReportMetadataMutation,
  useGetFilterDataQuery,
  useGetReportsQuery,
  useAdminExportReportCsvMutation,
  useUpdateRuleMutation,
  useCreateRuleMutation,
  useListOviAlertRulesQuery,
  useSyncAlertRulesMutation,
  useValidateAlertRulesMutation,
  useGetRuleListByCategoryAndEventQuery,
  useGetRulesByIdsMutation,
  useGetUnassignedRulesMutation,
  useGetRulesWithSubscriptionsQuery,
  useDeleteRuleMutation,
  useRetrieveSafetyEventsByTripIdsMutation,
  useGetVehicleSettingsQuery,
  useUpdateVehicleSettingsMutation,
  useRetrieveEmergencyEventSummaryQuery,
  useRetrieveSafetyEventsV2Query,
  useRetrieveSafetyEventDetailsByIdQuery,
  useRetrieveSafetyEventsForSelfV2Query,
  useGetDriverScoreDetailsForSelfQuery,
  useGetVehicleScoresQuery,
  useGetDriverScoresSummaryQuery,
  useGetScoreQuery,
  useGetDriverScoresQuery,
  useGetDriverScoreDetailsQuery,
  useProcessTripsQuery,
  useGetTripEventsQuery,
  useGetRawSafetyEventDetailsQuery,
  useGetRawSafetyEventsQuery,
  useGetSafetyEventDetailsQuery,
  useGetSafetyEventsQuery,
  useGetTripSummariesQuery,
  useRevokeTrustedDeviceMutation,
  useUpdateOrgLevelAppIdentityMutation,
  useUpdateAppIdentityMutation,
  useDeleteAppIdentityMutation,
  useUpdateProfileCustomPermissionsMutation,
  useResetAppSecretMutation,
  useGetProfileByIdQuery,
  useUpdateUserProfileV1Mutation,
  useUpdateMyLegalDocsMutation,
  useUpdateIdentityIdByUserCodeMutation,
  useCheckTenantAssociationMutation,
  useVerifyOtpMutation,
  useSendOtpMutation,
  useVerifyMfaMutation,
  useOffboardOrganizationUsersMutation,
  useShowGettingStartedMutation,
  useDismissGettingStartedMutation,
  useMarkAppSpaceViewedMutation,
  useValidateOviVehicleSchedulesMutation,
  useValidateOviPersonsMutation,
  useActivateOviPersonsMutation,
  useListOviVehicleSchedulesQuery,
  useSyncOviVehicleSchedulesMutation,
  useListOviPersonsQuery,
  useSyncOviPersonsMutation,
  useBulkGetDriversMutation,
  useCreateProfileCustomPermissionsMutation,
  useAssignVehicleMutation,
  useUnassignVehiclesMutation,
  useCreateAppMutation,
  useGetDriverProfilesQuery,
  useCreateDriverProfileMutation,
  useRecordLastSignedInMutation,
  useCreateAdministrativeUserMutation,
  useCancelInvitesMutation,
  useResendInvitesMutation,
  useAcceptInviteMutation,
  useInviteUsersMutation,
  useEnrichTokenMutation,
  useEnrichToken1Mutation,
  useResetAllAppSecretsMutation,
  useGenerateDeviceCodeMutation,
  useGetIdentityIdByDeviceCodeMutation,
  useGetDriverProfileByIdQuery,
  useUpdateDriverProfileMutation,
  useListTrustedDevicesQuery,
  useGetOffboardStatusQuery,
  useRetrieveResourceCountsQuery,
  useGetCustomPermissionsQuery,
  useGetAppIdentitiesQuery,
  useFindDriversByVinsQuery,
  useSearchUserProfilesQuery,
  useFindProfilesByOrgIdAndEmailQuery,
  useGetCdiUserProfileQuery,
  useFindAllProfilesBetaQuery,
  useFindAllProfilesByQuery,
  useGetContactInfoQuery,
  useGetUsers20211115MeQuery,
  useDeleteAdministrativeUserMutation,
  useDeleteUserProfileMutation,
} = injectedRtkApi;
